// frontend/js/translations.js
export function getCompanyI18n(company = {}, tFn) {
  const tSafe = typeof tFn === 'function' ? tFn : (_k, fb) => (fb ?? '');

  const raw =
    company.csvRow ?? company.Id ?? company.ID ??
    company.csv_id ?? company.csvIndex ??
    company.row ?? company.rowId ?? company.csvRowNumber;
  const rowId = raw != null ? String(raw).trim() : '';

  const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;

  const pick = (key, fallback) => {
    if (!rowId) return fallback;
    const v = tSafe(key, undefined);
    if (!v || v === key || (typeof v === 'string' && MISSING_RE.test(v))) return fallback;
    return v;
  };

  const name = pick(`companies_by_id.${rowId}.Company_Name`, company['Company Name'] || company.name || '');
  const out  = pick(`companies_by_id.${rowId}.Out_put`,       company['Out put'] || company['Output'] || company.output || '');
  const desc = pick(`companies_by_id.${rowId}.Description`,   company['Description'] || company.description || '');
  const risk = pick(`companies_by_id.${rowId}.Risk`,          company['Risk'] || company.risk || '');

  return { name, out, desc, risk, rowId };
}


const translations = {
  en: {
    translation: {
      "_meta": {
        "language": "English",
        "version": "1.0.0",
        "last_updated": "2025-08-05"
      },
      "nudge": {
        "next": "NEXT", "back": "Back", "done": "GOT IT",
        "tap_hint": "tap right to continue · swipe to move",
        "reopen": "How does this page work?",
        "sim_tag": "PRACTICE FLOOR",
        "sim_1_h": "This is practice.",
        "sim_1_b": "A safe run to learn how trading your life works. Nothing here is permanent — explore freely.",
        "sim_2_h": "Look at what you hold.",
        "sim_2_b": "Scroll down. Each section below is something you own right now. Tap a section to open it.",
        "sim_3_h": "Then enter the Market.",
        "sim_3_b": "When you are ready, hit the button at the bottom to walk onto the open floor and trade.",
        "sim_cta": "GOT IT — TAKE ME IN",
        "trader_tag": "YOUR SIDE OF THE FLOOR",
        "trader_1_h": "This is everything you carry.",
        "trader_1_b": "Your holdings and your mission live here. Tap any section to open it; tap again to close.",
        "trader_2_h": "Your mission is up top.",
        "trader_2_b": "It tells you what to aim for. Trade to move toward it.",
        "trader_3_h": "Go to the Market to trade.",
        "trader_3_b": "The open floor is where you offer for what other people hold. Use the button at the bottom.",
        "trader_cta": "GOT IT",
        "market_tag": "THE OPEN FLOOR",
        "market_1_h": "Find something that matters to YOU.",
        "market_1_b": "Scroll the things other traders hold. This is not about money — it is about what you value.",
        "market_2_h": "Tap it to make an offer.",
        "market_2_b": "Ask yourself: what is that worth in my life? Then offer relational value, a swap, or a bid.",
        "market_3_h": "They accept → it is yours.",
        "market_3_b": "The owner says yes and it moves into your life. No cash anywhere.",
        "market_cta": "GOT IT",
        "stock_tag": "MAKE YOUR OFFER",
        "stock_0_h": "You are bidding on a life value.",
        "stock_0_b": "This stock is a piece of what another trader IS. Your goal: name a price and convince them to let you hold a share of it.",
        "stock_choice_h": "First, choose how you pay.",
        "stock_choice_b": "Two buttons up top: ZOLLARS pays in relationships (Love, Grief, Friendship…) — the heart of this market. CAPITAL pays in plain capital (Ƶ), if you must.",
        "stock_1_h": "Then set your price.",
        "stock_1_b": "With Zollars: tap “SET YOUR ZOLLAR OFFER” and drag each glowing bar — further right = more of that relationship offered. With Capital: just type the amount.",
        "stock_2_h": "Set how many shares.",
        "stock_2_b": "Type the number of shares you want in the SHARES box — up to what the owner has available.",
        "stock_3_h": "Place your bid.",
        "stock_3_b": "Hit Place Bid and say why you want it. The owner decides whether to let it go to you.",
        "stock_cta": "GOT IT",
        "bond_tag": "TAKE A PROMISE",
        "bond_1_h": "A Z Bond is a promise.",
        "bond_1_b": "Relational value now, repaid later with interest in lived experience.",
        "bond_2_h": "Pick the amount and term.",
        "bond_2_b": "Choose how much and for how long, then submit to take the promise on.",
        "bond_cta": "GOT IT",
        "trans_tag": "OFFER A SWAP",
        "trans_1_h": "This trader wants the item up top.",
        "trans_1_b": "You trade for it by giving one of your own things in return — a straight swap, no money.",
        "trans_2_h": "Pick what you will give.",
        "trans_2_b": "Scroll your own holdings below and choose one to offer.",
        "trans_3_h": "Propose the swap.",
        "trans_3_b": "Tap “Propose” on the thing you are offering. The owner decides whether to accept.",
        "trans_cta": "GOT IT",
        "redeem_tag": "CLAIM IT INTO REAL LIFE",
        "redeem_1_h": "Consumption here is social.",
        "redeem_1_b": "You cannot consume a thing alone — another trader's item has to validate it first.",
        "redeem_2_h": "Send a redeem ask.",
        "redeem_2_b": "Ask the floor to validate your thing. Once matched, it becomes real and yours to collect.",
        "redeem_cta": "GOT IT",
        "eco_tag": "HEAVY MACHINERY",
        "eco_1_h": "These are the heavy levers.",
        "eco_1_b": "Economic moves that act on OTHER traders — gifts and weapons. Each button says what it does in plain words; press and hold one to see the mechanics underneath.",
        "eco_2_h": "Give or take.",
        "eco_2_b": "BACK A FRIEND covers someone now. SOCIALIST SUBSIDY taxes a trader 45% and splits it among everyone. COMMUNIST ASSAULT seizes an entire portfolio and redistributes it. HOSTILE TAKEOVER buys a trader out. PREY ON DESPERATION profits from need — and the room remembers.",
        "eco_3_h": "Debts here are emotional.",
        "eco_3_b": "The meter above tracks what you owe and are owed in trust and help — not numbers. Life squares it later.",
        "eco_cta": "UNDERSTOOD",
        "tools_tag": "REACH OTHER TRADERS",
        "tools_1_h": "Ways to reach the room.",
        "tools_1_b": "Message another trader, steal what isn’t yours, hold someone hostage until they pay, or open a private back-room market away from the floor’s eyes.",
        "tools_2_h": "Every act has a social echo.",
        "tools_2_b": "These aren’t menu options — they’re gestures. The floor sees what you do and treats you accordingly. Press and hold any button to see its mechanics.",
        "tools_cta": "UNDERSTOOD",
        "botmsg_tag": "A BOT IS TALKING TO YOU",
        "botmsg_1_h": "That message is from a bot.",
        "botmsg_1_b": "The floor is populated by trader-bots — they hold values, make offers, and talk like anyone else in the room. This one just reached out to you.",
        "botmsg_2_h": "Answer it — or don't.",
        "botmsg_2_b": "You can reply, trade with it, or ignore it. Treat it as you would any trader: what you say and do shapes how the room treats you.",
        "botmsg_cta": "GOT IT",
        "mm_tag": "MEMENTO MORI",
        "mm_1_h": "Remember you must die.",
        "mm_1_b": "This run has a hard end: when the timer hits zero, your trading life is over. Everything you hold at that moment is read as your legacy.",
        "mm_2_h": "You already chose your legacy stocks.",
        "mm_2_b": "The companies you picked from your reflections carry your values. They're in your portfolio below — open the sections to see what you're starting with.",
        "mm_3_h": "Your eulogy writes itself.",
        "mm_3_b": "The red bar at the very top is your eulogy, rewritten as you trade. Tap it anytime to read what would be said of you if it ended right now.",
        "mm_4_h": "Trade toward how you want to be remembered.",
        "mm_4_b": "Go to the Market: grow what matters, let go of what doesn't. When time ends, the bourse speaks over your grave.",
        "mm_cta": "I UNDERSTAND",
        "mm_mkt_tag": "MEMENTO MORI — THE FLOOR",
        "mm_mkt_1_h": "Every offer is a legacy choice.",
        "mm_mkt_1_b": "Bid relational Zollars for the life values you want your name tied to. Time is running out — the eulogy bar up top listens to every trade.",
        "mm_mkt_2_h": "Let go, too.",
        "mm_mkt_2_b": "Accepting offers and releasing holdings is part of it: what you let go of says as much about you as what you keep.",
        "mm_mkt_cta": "GOT IT",
        "cn_tag": "CATENA NARRATIVA",
        "cn_1_h": "You are building a story.",
        "cn_1_b": "In Catena Narrativa, story pieces are traded like commodities. The pieces you hold — and how you rewrite them — become a short story at the end.",
        "cn_2_h": "Three phases, one clock.",
        "cn_2_b": "BEGINNING → MIDDLE → END, about 8 minutes total. The timer banner up top shows the current phase. When a phase ends, the pieces you hold are secured into your story ledger.",
        "cn_3_h": "Your story elements live below.",
        "cn_3_b": "The “Your Story Elements” panel lists the pieces you hold right now. Open your sections to see everything you carry.",
        "cn_4_h": "Trade to shape the story.",
        "cn_4_b": "Go to the Market and swap or bid for pieces your story needs. Every trade lets you rewrite the element in your own words — that is how the story becomes yours.",
        "cn_cta": "START TRADING",
        "cn_mkt_tag": "CATENA NARRATIVA — THE FLOOR",
        "cn_mkt_1_h": "Every item here is a story piece.",
        "cn_mkt_1_b": "Tap the “Bullets” button to see the elements you already hold, then offer or swap for the pieces your story needs before the phase ends.",
        "cn_mkt_2_h": "Trading is rewriting.",
        "cn_mkt_2_b": "When an exchange goes through, you write how the element changes in your hands. Value forms through the exchange — that text feeds the final story.",
        "cn_mkt_cta": "GOT IT",
        "cn_swap_1_h": "You are swapping story pieces.",
        "cn_swap_1_b": "This trader holds an element your story could use. Scroll your own holdings below and pick one to give in return.",
        "cn_swap_2_h": "Then rewrite it.",
        "cn_swap_2_b": "When you propose, you will say how the element is customized — at least a sentence. Make it count: it goes straight into the story.",
        "cn_swap_cta": "GOT IT"
      },
      "floor": {
        "mission_label": "YOUR MISSION",
        "mission_class": "CLASS",
        "your_stocks": "YOUR STOCKS",
        "do_trader": "<b>→ Go to the open floor</b> and trade for what your mission needs.",
        "do_market": "<b>→ Tap something a trader holds</b> and make an offer.",
        "wedividual": "THE WEDIVIDUAL",
        "hero_sub": "the room's interior worth, live — in the seat where GDP would sit",
        "hero_sub_count": "measured from {n} relational trades in this room — not GDP",
        "hero_tip": "Not GDP. The Wedividual is this room measured from the inside: every trade of relational value (love, grief, friendship, hate...) moves it. When you trade, you move how the room feels.",
        "mood_euphoric": "EUPHORIC",
        "mood_warm": "WARM",
        "mood_steady": "STEADY",
        "mood_heavy": "HEAVY",
        "mood_dark": "DARK",
        "your_position": "YOUR POSITION · LIFE PROFIT",
        "declared_note": "you walked onto the floor carrying",
        "fold_holdings": "WHAT YOU HOLD",
        "fold_holdings_hint": "life values · things · zollars · promises",
        "fold_interior": "YOUR INTERIOR LEDGER",
        "fold_interior_hint": "emotional state & debt",
        "fold_moves": "INSTRUMENTS & WEAPONS",
        "fold_moves_hint": "gifts, loans, attacks — economics as a verb",
        "board_things": "THINGS ON THE FLOOR",
        "board_things_hint": "tap one to offer relational value for it",
        "board_values": "LIFE VALUES ON THE BOARD",
        "board_values_hint": "shares of lived experience — priced by feeling",
        "board_bonds": "PROMISES (Z BONDS)",
        "board_bonds_hint": "relational value now, repaid in experience later",
        "status_trader": "This is your portfolio — what you hold and what you owe. <b>Your move: go to the floor and trade.</b>",
        "status_market": "The floor — everything other traders are holding. <b>Tap anything to make an offer</b>; you pay with your Zollars.",
        "status_redeem": "You have a match. <b>Your move: hit REDEEM and claim it into your life.</b>",
        "status_memento": "<b>MEMENTO MORI</b> — every trade becomes a line of your eulogy. Hold what you want said about you.",
        "memento_chip": "MEMENTO MORI",
        "phase_1_chip": "PHASE 1/3 · BEGINNING",
        "phase_1_trader": "<b>BEGINNING</b> — the story needs raw material. Your move: go gather story elements from the floor.",
        "phase_1_market": "<b>BEGINNING</b> — the story needs raw material. Tap a story element below and offer for it.",
        "phase_1_go": "GO GET STORY ELEMENTS",
        "phase_1_cta": "OFFER FOR AN ELEMENT",
        "phase_2_chip": "PHASE 2/3 · MIDDLE",
        "phase_2_trader": "<b>MIDDLE</b> — complication time. Your move: trade and customize the elements you hold.",
        "phase_2_market": "<b>MIDDLE</b> — complication time. Trade for elements that twist your story.",
        "phase_2_go": "TRADE YOUR ELEMENTS",
        "phase_2_cta": "TRADE FOR A TWIST",
        "phase_3_chip": "PHASE 3/3 · END",
        "phase_3_status": "<b>END</b> — consolidation. Keep what matters; the story will be written from what you hold when the clock runs out.",
        "phase_3_go": "REVIEW WHAT YOU HOLD",
        "phase_3_cta": "FINAL TRADES",
        "cta_offer": "MAKE AN OFFER",
        "cta_offer_hint": "Tap anything on the board — you will offer <b>relational value</b> (your Zollars: love, friendship, grief...) to get it.",
        "tape_gdp": "GDP NOT QUOTED ON THIS FLOOR",
        "tape_love": "LOVE ACCEPTED AT ALL WINDOWS",
        "tape_grief": "GRIEF TRADES AT PAR WITH JOY",
        "tape_move": "EVERY TRADE MOVES THE ROOM",
        "tape_interior": "INTERIOR VALUE ONLY · BRING WHAT YOU FEEL",
        "tk_trade": "A TRADE SEALED · RELATIONAL VALUE CHANGED HANDS",
        "tk_bid_yes": "AN OFFER WAS EMBRACED",
        "tk_bid_no": "AN OFFER WAS TURNED DOWN",
        "tk_zollar": "FRESH ZOLLARS ENTERED THE ROOM",
        "tk_burst": "THE FLOOR IS RUNNING HOT",
        "tk_short": "SOMEONE IS BETTING AGAINST A LIFE VALUE",
        "tk_bourse": "THE BOURSE HAS SPOKEN ON A TRADE",
        "tk_pool": "A BACK ROOM OPENED SOMEWHERE",
        "tk_subsidy": "SOMEONE WAS LIFTED BY THE COLLECTIVE",
        "tk_theft": "THEFT ON THE FLOOR · WATCH YOUR HOLDINGS",
        "tk_memento": "MEMENTO MORI · THE CLOCK MOVES",
        "tk_declared": "{v} IS ON THE FLOOR · DECLARED, NOT PRICED",
        "ps_tap": "hold to see mechanics",
        "ps_altrau": "BACK A FRIEND",
        "ps_altrau_tip": "You cover another trader now. The debt it creates is emotional, not numeric — it sits on your interior ledger until life squares it.",
        "ps_mnote": "BORROW AGAINST YOURSELF",
        "ps_mnote_tip": "Take capital now and owe your future self. The market remembers what you promised to become.",
        "ps_cdo": "PREY ON DESPERATION",
        "ps_cdo_tip": "Lend to someone who cannot say no, then sell their struggle on. Profitable. It will cost you interior credit with the room.",
        "ps_vnote": "ASK THE ROOM FOR AID",
        "ps_vnote_tip": "Request help from the floor. No shame here — need is a tradable truth like any other.",
        "ps_steal": "TAKE WHAT ISN'T YOURS",
        "ps_steal_tip": "Theft, plainly. You gain the thing; the room learns what you are.",
        "ps_ransom": "HOLD SOMEONE HOSTAGE",
        "ps_ransom_tip": "Lock another trader out of their own life until they pay you to give it back.",
        "ps_darkpool": "OPEN A BACK ROOM",
        "ps_darkpool_tip": "Opens a private trading room away from the floor's eyes. Deals struck there stay hidden and don't move the shared mood — that is the point, and the problem.",
        "ps_lbo": "HOSTILE TAKEOVER",
        "ps_lbo_tip": "Pick a trader and buy them out: you pay the takeover cost in capital (they receive it), and the items and stocks you selected become YOURS. A buyout, not a gift.",
        "ps_subsidy": "SOCIALIST SUBSIDY",
        "ps_subsidy_tip": "Pick a trader to tax: 45% of their capital, items and Zollars is taken and split equally among every other trader on the floor. Redistribution from the top down.",
        "ps_assault": "COMMUNIST ASSAULT",
        "ps_assault_tip": "Pick a trader: their ENTIRE portfolio — capital, items, stocks, Zollars — is seized and distributed among everyone else on the floor. They are wiped to zero. Total redistribution, used as a weapon.",
        "ps_holdings": "WHAT YOU CARRY",
        "ps_holdings_tip": "Your position: the stocks, commodities, Zollars and promises currently in your hands.",
        "ps_zollar_tip": "Money denominated in relationships instead of numbers: Love, Friendship, Hate, Grief... You pay with what a relationship is worth to you.",
        "ps_bond_tip": "A promise with feelings attached: relational value now, repaid with interest in lived experience later.",
        "ps_short_tip": "A bet against a life value — you profit if it falls. Yes, you can short joy. Ask yourself why.",
        "ps_stock_tip": "Shares in life values — slices of intellect, affection, partying, melancholy. Their price is what the room feels they are worth.",
        "ps_commodity_tip": "Real things with a catch: you cannot consume one until another trader validates it. Consumption here is social or not at all.",
        "ps_value": "Value",
        "ps_value_tip": "What the holder asks for it — payable in relational worth, not cash.",
        "ps_redeem": "Redeem",
        "ps_redeem_tip": "Claim a thing into your real life. Needs another trader's item to validate it first — consumption here is social.",
        "ps_owner": "Owner",
        "ps_owner_tip": "The trader whose life this currently belongs to. Your offer goes to them.",
        "ob_title": "BEFORE YOU TRADE",
        "ob_sub": "This floor does not price your output. It prices your interior. Pick up to three things you actually value — they become what you carry, and what you can spend.",
        "ob_custom": "or name one of your own + Enter",
        "ob_custom_h": "yours alone",
        "ob_go": "CARRY THESE ONTO THE FLOOR",
        "ob_skip": "skip — I know this floor",
        "ob_done": "Declared. These are on your position now. <b>Your move: take them to the open floor.</b>",
        "ob_love": "LOVE", "ob_love_h": "what you would give anything to keep",
        "ob_friendship": "FRIENDSHIP", "ob_friendship_h": "the people who hold you up",
        "ob_fellowship": "FELLOWSHIP", "ob_fellowship_h": "belonging to something bigger",
        "ob_erotic": "EROTIC", "ob_erotic_h": "desire, fully owned",
        "ob_hate": "HATE", "ob_hate_h": "it counts — it is yours too",
        "ob_toxic": "TOXIC", "ob_toxic_h": "the bonds that cost you",
        "ob_superficial": "SUPERFICIALITY", "ob_superficial_h": "the shallow joys, no apology",
        "ob_dead": "WHAT'S GONE", "ob_dead_h": "dead relationships still trade here",
        "sec_stocks": "LIFE VALUES",
        "sec_commodities": "THINGS",
        "sec_zollars": "ZOLLARS",
        "sec_zbonds": "PROMISES",
        "sec_redeemed": "REDEEMED",
        "sec_shorts": "BETS AGAINST",
        "sec_emotional": "INTERIOR LEDGER",
        "sec_social": "GIVE / LEND / PREY",
        "sec_tools": "TOOLS",
        "sec_economic": "WEAPONS",
        "flow_title": "HOW TRADING WORKS HERE",
        "flow_1_n": "1",
        "flow_1_h": "FIND IT",
        "flow_1_b": "Scroll what other traders hold. Tap something you want.",
        "flow_2_n": "2",
        "flow_2_h": "OFFER WHAT IT'S WORTH TO YOU",
        "flow_2_b": "Pay in relational value — your Zollars (love, grief, friendship...), a swap, or a bid.",
        "flow_3_n": "3",
        "flow_3_b": "THEY SAY YES → IT'S YOURS",
        "flow_3_h": "The owner accepts and it moves into your life. No cash anywhere.",
        "btn_swap": "SWAP",
        "btn_swap_tip": "Offer one of your own things in exchange for theirs. A straight trade of holdings.",
        "btn_offer_zollars": "OFFER ZOLLARS",
        "btn_offer_zollars_tip": "Pay for this with your relational currency — Love, Grief, Friendship Zollars. You name what it's worth to you.",
        "btn_offer_share": "BUY",
        "btn_offer_share_tip": "Make a bid for a share of this life value. If the owner accepts, the share is yours.",
        "btn_bet_against": "BET AGAINST",
        "btn_bet_against_tip": "Short it — you profit if this life value falls. You are wagering against someone's worth. Sit with that.",
        "btn_take_promise": "TAKE PROMISE",
        "btn_take_promise_tip": "Buy this Z Bond: relational value now, repaid with interest in lived experience later.",
        "btn_offer_promise": "OFFER",
        "btn_offer_promise_tip": "Bid on this promise. The owner decides whether to let it go to you.",
        "hero_eyebrow": "HOW THE ROOM FEELS RIGHT NOW",
        "gauge_low": "HEAVY",
        "gauge_high": "EUPHORIC",
        "hero_sub2": "the shared mood of everyone trading — the floor's index, instead of GDP",
        "hero_sub_count2": "read from {n} trades on the floor — our index, instead of GDP",
        "delta_up": "warmer than a moment ago",
        "delta_down": "heavier than a moment ago",
        "nav_portfolio": "MY PORTFOLIO",
        "nav_search": "SEARCH",
        "your_portfolio": "YOUR PORTFOLIO",
        "portfolio_explain": "everything you hold on the floor. its total worth, counted as Life Profit — your lived experience, not money:",
        "count_held": "{n} held",
        "count_empty": "empty",
        "exp_stocks": "Shares you hold in human values (like intellect or affection). Their worth rises and falls with how the room feels.",
        "exp_commodities": "Real things you hold. You can't consume one until another trader validates it — consumption here is social.",
        "exp_zollars": "Your spending money — but counted in relationships (Love, Grief, Friendship). This is what you pay with when you trade.",
        "exp_zbonds": "Promises you hold: relational value now, repaid later with interest in lived experience.",
        "exp_redeemed": "Things you've claimed into real life, kept as QR codes to collect.",
        "exp_shorts": "Life values you've bet against — you gain if their worth falls.",
        "exp_emotional": "Your emotional balance sheet — what you owe and are owed in trust, help, and betrayal.",
        "exp_social": "Ways to act on other people: back a friend, lend, ask for aid, or prey on someone. Economics as gestures.",
        "exp_tools": "Reach other traders: message them, steal, ransom, or open a private back-room market.",
        "exp_economic": "Heavy moves: hostile takeover, collective subsidy, or delete your portfolio entirely.",
        "exp_stock_bid": "Another trader on the floor — often one of the market's bots — wants to buy shares you hold. Accept and their payment is yours; decline and nothing changes.",
        "exp_trade_offer": "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too — respond exactly as you would to a person.",
        "exp_buy_offer": "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.",
        "exp_tax": "This is the Zederal Reserve — the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.",
        "exp_short": "Shorting is betting that this life value will FALL. If it drops, you profit from the decline. You are wagering against someone's worth — the room will know.",
        "exp_analysis": "This is the voice of the bourse — the market itself reacting to a trade that just happened on the floor. It's commentary, not a request: read it, close it, nothing is asked of you."
      },
      "auth": {
        "trader_id_placeholder": "Trader ID",
        "password_placeholder": "Password",
        "login_button": "Login",
        "login_validation_message": "Please enter both Trader ID and Password",
        "login_failed_message": "Login failed. Please check your credentials and try again.",
        "login_error_message": "An error occurred during login. Please try again later.",
        "authentication_failed_message": "Authentication failed. Please log in again.",
        "password_required_message": "Password is required.",
        "enter_trader_name_placeholder": "Enter your Trader Name",
        "enter_new_password_placeholder": "Enter your new password",
        "secure_password_placeholder": "Enter secure password",
        "set_password_label": "Set Password",
        "authentication_failed": "Authentication failed. Please log in again.",
        "session_required": "Session ID is missing. Please log in again."
      },
      "navigation": {
        "nav_commodity": "Commodity",
        "nav_zollars": "Zollars",
        "nav_stock_zbond": "Stock & ZBond",
        "nav_company": "Company",
        "nav_portfolios": "Portfolios",
        "nav_control_panel": "Control Panel"
      },  
      "buttons": {
        "scan_button": "Scan",
        "fulfill_button": "Fulfill",
        "create_session_button": "Create Session",
        "search_button": "Search",
        "close_search_button": "Close Search",
        "cancel_button": "Cancel",
        "close_button": "Close",
        "complete_setup_button": "Complete Setup",
        "save_button": "Save",
        "delete_button": "Delete",
        "modify_name_button": "Modify Name",
        "modify_password_button": "Modify Password",
        "logout_trader_button": "Log Out Trader",
        "view_qr_codes_button": "View Login QR Codes",
        "enter_mortality_chamber_button": "Enter Mortality Chamber",
        "continue_button": "Continue",
        "validate_key": "Validate Key",
        "scan_qr_code": "Scan QR Code"
      },
      "stock_bid": {
        "title": "Stock Bid Offer",
        "offers_to_buy_points": "{portfolioName} offers to buy {shares} shares of {stockName} for {amount} of Capital.",
        "offers_to_buy_zollars": "{portfolioName} offers to buy {shares} shares of {stockName} for the following zollars:",
        "time_remaining": "Time remaining: {seconds} seconds",
        "time_expired": "Time expired",
        "processing_bid": "Processing your bid...",
        "no_response": "No response received. This action has expired.",
        "offer_expired": "No response received. Your offer expired."
      },
      "forms": {
        "mood_one_word": "What quality or feeling are you living right now?",
        "one_word_hint": "(1 word)",
        "reason_label": "Why do you feel that?",
        "value_definition": "Why do you feel this way? (Value)",
        "value_definition_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
        "value_reaction": "What does this feeling give you? (Life Profits)",
        "value_reaction_placeholder": "e.g., gives me energy, makes me depressed, helps me grow...",
        "experiences_label": "What creates this feeling?",
        "search_stocks_placeholder": "Search Stocks",
        "company_name_fixed_label": "Company Name (fixed):",
        "company_description_label": "Company Description:",
        "company_product_label": "Company Product/Output:",
        "trader_name_label": "Trader Name:",
        "session_name_label": "Session Name",
        "session_name_placeholder": "Enter session name (letters, numbers, underscores only)",
        "single_word_example": "e.g., happy, sad, drunk, joy...",
        "reason_placeholder": "e.g., I got a promotion, I am hung over, My kid scored 3 goals...",
        "describe_feeling_placeholder": "e.g., gives me energy, makes me depressed, helps me grow..."
      },
      "modals": {
        "select_action_title": "Select an Action",
        "action_modal_description": "Select Scan to be directed to the scan items page. Select Fulfill to fulfill orders.",
        "choose_simulation_title": "Choose Your Simulation Experience",
        "memento_mori_title": "Memento Mori Simulation",
        "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
        "create_new_session_title": "Create New Session",
        "session_creation_description": "Create a new trading session as the Zederal Reserve Central Bank.",
        "assign_to_portfolio_title": "Assign to Portfolio:",
        "select_portfolio_short_title": "Select a Portfolio to Place Short Position",
        "select_portfolio_transfer_title": "Select a Portfolio to Transfer Ownership"
      },
      "tables": {
        "table_stock_name": "Stock Name",
        "table_symbol": "Symbol",
        "table_share_value": "Share Value",
        "table_owner": "Owner",
        "table_shorted": "Shorted",
        "table_place_short": "Place Short",
        "table_delete": "Delete"
      },
      "socketBack": {
        "narrativeProcessed": "Narrative response processed",
        "unauthorizedSuperUser": "Unauthorized: Only Zederal Reserve bankers can perform this action",
        "noTargetUser": "No target trader provided",
        "logoutByAdmin": "You have been logged out by an administrator.",
        "logoutUserSuccess": "User {id} has been forced to logout successfully.",
        "logoutUserOffline": "User {id} is already offline.",
        "marketClosed": "The market has closed.",
        "logoutAllSuccess": "All traders have been logged out successfully",
        "taxEvent": "You are being charged a market tax. Choose to give a random commodity or lose capital.",
        "zollarIssued": "A Zollar has been issued to you by the Zederal Reserve.",
        "zollarFailed": "Failed to assign Zollars",
        "ransomAssigned": "You have received the ransom trigger.",
        "ransomLocked": "Your portfolio has been locked with a ransom of {points} capital.",
        "lboAssigned": "You have received the Leveraged Buyout (LBO) trigger.",
        "lboAssetsRemoved": "Assets have been removed from your portfolio due to an LBO.",
        "removedStocksLabel": "Removed Stocks:",
        "removedItemsLabel": "Removed Items:",
        "unknownStock": "Unknown Stock",
        "unknownItem": "Unknown Item",
        "sharesWord": "shares",
        "ofWord": "of",
        "subsidyAssigned": "You have received a Subsidy trigger.",
        "subsidyUpdate": "45% of your wealth has been redistributed as a Socialist Subsidy for the lower income earners.",
        "subsidyReceived": "You have received a socialist subsidy.",
        "pointsGiven": "Capital has been issued.",
        "itemsDistributed": "Commodities have been distributed.",
        "freebieZ1Message": "The Zederal Reserve has distributed a free commodity to your portfolio!",
        "ransomPaidNotification": "{userName} has paid the ransom of {points} capital. The funds have been transferred to your account.",
        "pointsDeducted": "{amount} capital have been deducted from your account.",
        "itemTaxed": "Zederal Reserve has taxed a commodity from your holdings.",
        "deleteButtonAssigned": "You have received a Communist Assault trigger.",
        "deletePerformed": "Your portfolio has been targeted by a Communist Assault.",
        "subsidyUpdateBotTarget": "{botName} has initiated a Socialist Subsidy - 45% of your wealth has been redistributed.",
        "specialSubsidyTarget": "{botName} redistributed 45% of your wealth through Socialist Subsidy",
        "subsidyReceivedFrom": "You received a Socialist Subsidy from {botName}'s redistribution action!",
        "specialSubsidyReceived": "You received wealth from {botName}'s Socialist Subsidy",
        "ransomLockedBy": "{botName} has frozen your portfolio with a ransom of {points} capital!",
        "specialRansomTarget": "{botName} has frozen your portfolio with a ransom demand",
        "specialRansomImpact": "Portfolio locked - {points} capital required",
        "lboExecutedOnYouBy": "{botName} has executed a Leveraged Buyout on your portfolio.",
        "specialLboTarget": "Your portfolio was targeted in a Leveraged Buyout (LBO) from {botName}",
        "itemStolen": "{botName} has stolen \"{itemName}\" from your portfolio!",
        "specialStealTarget": "{botName} stole \"{itemName}\" from you",
        "deleteUpdateBy": "{botName} has executed a Communist Assault on your portfolio!",
        "specialDeleteTarget": "{botName} executed a Communist Assault on your portfolio",
        "assaultGameEvent": "{botName} executed a Communist Assault on {targetName}!",
        "unknownPlayer": "Unknown Player",
        "tradeAccepted": "Trade accepted! Capital awarded.",
        "tradeDeclined": "Trade declined. No capital awarded."

      },
      "titles": {
        "owned_stock_list_title": "Owned Stock List",
        "short_positions_title": "Short Positions",
        "stock_management_guide_title": "Stock Management Guide"
      },
      "validation": {
        "select_company_first_message": "Please select a company first before claiming.",
        "fill_trader_name_password_message": "Please fill in your Trader Name and new Password.",
        "company_details_required_message": "Company details are required. Please complete the company selection process.",
        "portfolio_count_validation": "Number of portfolios must be between 1 and 50.",
        "items_per_portfolio_validation": "Number of items per portfolio must be between 0 and 10.",
        "simulation_questions_required": "Please answer all questions. Enter a single word for your mood and explain both why you feel that way and what creates this feeling."
      },
      "messages": {
        "success": "Success",
        "error": "Error",
        "loading": "Loading...",
        "qr_error_message": "Error displaying QR codes. Please try again.",
        "portfolios_created_success": "Portfolio(s) created successfully",
        "portfolio_add_error": "Error adding portfolio. Please try again.",
        "portfolio_updated_success": "Portfolio updated successfully",
        "fetch_portfolios_error": "Error fetching portfolios. Please try again later."
      },
      "backend_messages": {
        "invalid_decision_message": "Invalid decision.",
        "assignment_in_progress": "Assignment is already in progress.",
        "session_id_required": "Session ID is required.",
        "not_enough_items_assign": "Not enough available items to assign",
        "items_assigned_success": "New items assigned to all portfolios successfully.",
        "items_assign_failed": "Failed to assign new items",
        "items_assigned_successfully": "Items successfully assigned.",
        "no_available_items": "No available items for assignment.",
        "failed_assign_items": "Failed to assign items.",
        "points_distributed_success": "Captial distributed successfully.",
        "points_distribute_failed": "Failed to distribute capital.",
        "items_removed_success": "Items successfully removed.",
        "no_items_for_removal": "No non-redeemed items available for removal.",
        "failed_remove_items": "Failed to remove items.",
        "tax_points_item_deducted": "Capital & Random item deducted by Z Tax Authorities.",
        "tax_points_deducted": "trading capital deducted by Z Tax Authorities.",
        "tax_points_zollars_item_deducted": "& Random Commodity deducted by Zederal Reserve Tax Authorities.",
        "tax_points_zollars_deducted": "deducted by Zederal Reserve Tax Authorities.",
        "tax_item_removed": "Random item removed by Z Tax Authorities.",
        "error_fetching_portfolios": "Error fetching portfolios",
        "portfolio_updated_success": "Portfolio updated successfully",
        "portfolio_not_found": "Portfolio not found",
        "error_updating_portfolio": "Error updating portfolio",
        "internal_server_error": "Internal server error",
        "item_already_assigned": "Item is already assigned to this portfolio",
        "item_assigned_success": "Item assigned to portfolio successfully",
        "item_unassigned_success": "Item unassigned from portfolio successfully",
        "create_community_button_assigned": "Create community button assigned successfully",
        "portfolio_deleted_success": "Portfolio deleted successfully, items and stocks unassigned.",
        "no_zollars_found": "No Zollars found for this portfolio",
        "failed_fetch_bonds": "Failed to fetch bonds",
        "message_exceeds_280": "Message exceeds 280 characters.",
        "sender_portfolio_not_found": "Sender portfolio not found.",
        "recipient_portfolio_not_found": "Recipient portfolio not found.",
        "not_enough_points_message": "Not enough capital to send a message.",
        "message_sent_successfully": "Message sent successfully",
        "session_mismatch_sender": "Action not allowed. Session mismatch for sender.",
        "session_mismatch_recipient": "Action not allowed. Session mismatch for recipient.",
        "requesting_portfolio_not_found": "Requesting portfolio not found",
        "user_not_part_of_session": "User is not part of any session",
        "item_not_found": "Item not found",
        "no_unassigned_items": "No unassigned items found",
        "portfolio_not_found_in_session": "Portfolio not found in this session",
        "item_not_found_in_session": "Item not found in this session",
        "failed_assign_item_portfolio": "Failed to assign item to portfolio"
      },
      "ui_labels": {
        "show_explanations_label": "Show Explanations",
        "currency": "Currency",
        "balance": "Balance",
        "price": "Price",
        "quantity": "Quantity",
        "total": "Total",
        "date": "Date",
        "time": "Time",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive",
        "pending": "Pending",
        "completed": "Completed",
        "failed": "Failed"
      },
      "marketing": {
        "tailor_stock_choice_message": "Tailor your stock choice to align exactly with your values.",
        "footer_copyright": "All rights reserved ZExchange 2025. ZExchange is part of <a href=\"https://zeconomy.xyz\"> ZEconomy. </a>",
        "programs": {
          "nav_home": "← Return to ZExchange",
          "nav_contact": "Get in Touch",
          "page_title": "ZExchange Studio Program",
          "tagline": "Life profits.",
          "intro": "A three-part program where participants enter an artist-designed economy, learning key conceptual points, build systems of value (Real or Artistic), and trade live on the ZExchange platform.",
          "part_one_title": "Part One: Theoretical Framework",
          "part_one_text": "Where does value reside; in the artwork? in the object, the institution, or the experience? From Belting's cult image to Polanyi's fictitious commodities, from Fried's theatricality to algorithmic price validation. A rigorous introduction to displacement as both an art-historical trajectory and economic intervention.",
          "part_two_title": "Part Two: Creative Atelier",
          "part_two_text": "Participants design their own value systems following the ideas from the ZEconomy developed during the theoretical explanations. Economic architecture as artistic medium.",
          "part_three_title": "Part Three: Live Trading Floor",
          "part_three_text": "The ZEconomy comes to life. 10–200 participants trade in real time on the ZExchange platform. An AI observes, analyzes, and narrates — producing a visual Big Board and a written portrait of collective behavior. The market reflects on itself.",
          "institutional_title": "Institutional Goals",
          "art_programs_title": "For art programs:",
          "art_programs_text": "Positions economics as material; extending Conceptual Art and Institutional Critique while constructing alternatives rather than exposing what exists.",
          "business_programs_title": "For business programs:",
          "business_programs_text": "Renders valuation theory experiential. Students use creative applications of their ideas to help them better build their own projects.",
          "zeconomy_title": "ZEconomy",
          "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures—shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
          "zeconomy_text_2": "Represented by Galerie mfc–michèle didier and agent d'art Ghislain Mollet-Viéville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at École Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, ⋆⋆⋆ Télérama, Bloomberg, and Tapscott's Blockchain Revolution.",
          "contact_title": "Contact for Details",
          "contact_text": "For program details, scheduling, and institutional inquiries:"
        },
        "sessions": {
          "nav_home": "← Return to ZExchange",
          "nav_contact": "Get in Touch",
          "page_title": "ZExchange",
          "tagline": "Life profits.",
          "intro": "An artwork you enter, not observe. A trading floor. A party. A new way of looking at value.",
          "what_happens_title": "What Happens",
          "what_happens_p1": "Participants enter an economy with two layers: stocks and commodities.",
          "what_happens_p2": "Stocks represent intangible values — emotional states, ambitions, ways of being. You trade them, speculate on them, watch their prices rise and fall based on collective interest.",
          "what_happens_p3": "Commodities are real — drinks, food, items, gifts. Everything is tradable, but you can't consume them alone. To redeem (obtain) a commodity, another participant must accept to redeem their own commodities with you. The market grants or refuses permission.",
          "what_happens_p4": "An AI watches everything unfold, narrating patterns of value, desire, and exchange as they emerge.",
          "what_produces_title": "What It Produces",
          "what_produces_text": "A shared experience that reframes consumption as a social act. An AI-written portrait of the group. A Big Board visualization available for purchase. And a question that lingers: What is the true value of being alive?",
          "format_title": "Format",
          "format_text": "2–3 hours. 10–200 participants. Standalone event, team building, mixer, offsite, or cultural program.",
          "zeconomy_title": "ZEconomy",
          "zeconomy_text_1": "The ZExchange emerges from the ZEconomy, JaZoN Frings's long-term artistic practice developed over nearly twenty years through a personal stock market, relational currencies, and non-consumption-based advertising systems. These works investigate the individual's position within societal systems by intervening in their structures—shifting goals of production, reconfiguring operations, and introducing unintended forms of expression that expose their underlying logic.",
          "zeconomy_text_2": "Represented by Galerie mfc–michèle didier and agent d'art Ghislain Mollet-Viéville, the practice has been exhibited at institutions including Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial,  Stanford University, and Science Gallery Dublin. With numerous teaching and mediation interventions at École Camondo, Parsons Paris, and Centre Pompidou, and has been featured in Art Press, ⋆⋆⋆ Télérama, Bloomberg, and Tapscott's Blockchain Revolution.",
          "contact_title": "Contact for Details",
          "contact_text": "For program details, scheduling, and institutional inquiries:"
        }
      },
      "classes": {
        "page_title": "ZEconomy Pedagogical Sessions",
        "presenter_title": "ZEconomy Class Presenter",
        "back_link": "← Back to ZExchange",
        "title": "ZEconomy Pedagogical Sessions",
        "tagline": "Exploring how art history, spirituality, and representation intersect with market theory, value systems, and ZEconomy's reimagining of finance.",
        "lesson_selector": "← Lesson Selector",
        "previous": "← Previous",
        "next": "Next →",
        "toggle_images": "Toggle Images",
        "no_classes": "No classes available yet.",
        "load_error": "Unable to load classes. Please try again later.",
        "level": "Level",
        "duration": "Duration",
        "minutes": "min",
        "mixed_level": "mixed",
        "presenter_suffix": "Presenter",
        "learning_objectives": "Learning Objectives",
        "view_details": "View Details",
        "discussion_points": "Discussion Points",
        "activity_instructions": "Activity Instructions",
        "estimated_reading_time": "Estimated reading time",
        "min": "min",
        "download_pdf": "Download PDF",
        "no_lesson_specified": "No lesson specified.",
        "lesson_not_found": "Lesson not found.",
        "load_lesson_error": "Error loading lesson. Please try again later."
      },
      "placeholders": {
        "life_profits_placeholder_1": "I value playing with my kids...",
        "life_profits_placeholder_2": "Depression seems to be sought after...",
        "life_profits_placeholder_3": "I love love and everything about it...",
        "life_profits_placeholder_4": "A drink with friends is worth everything...",
        "life_profits_placeholder_5": "I think rejection creates value...",
        "life_profits_placeholder_6": "I see joy as life's true currency...",
        "life_profits_placeholder_7": "Helping others enriches my life...",
        "life_profits_placeholder_8": "Loneliness has become a very common experience...",
        "experience_placeholder_1": "Dancing to techno makes me forget my worries...",
        "experience_placeholder_2": "Spending time with friends makes time fly...",
        "experience_placeholder_3": "I miss my mother, it reminds me what matters...",
        "experience_placeholder_4": "Running regularly clears my head...",
        "experience_placeholder_5": "Arguing online is always a waste of time...",
        "experience_placeholder_6": "Watching old cartoons makes me a kid again...",
        "experience_placeholder_7": "Getting up early gives good energy to my day...",
        "experience_placeholder_8": "Taking a detour helps me think...",
        "experience_placeholder_9": "The quality of morning coffee sets the tone for my day...",
        "experience_placeholder_10": "Wearing my sunglasses at night makes me look cool..."
      },
      "ticker_texts": {
        "intro_z_exchange": "?? ► INTRODUCTION Z EXCHANGE ?? ►",
        "life_profits_value": "LIFE PROFITS ► Z EXCHANGE VALUE ►",
        "stocks_function": "► WHAT DO STOCKS DO ON Z EXCHANGE",
        "z_bonds_system": "Z BONDS ► Zollars ► Z RELATIONSHIP MONETARY SYSTEM ► NUMBERS NEED NOT APPLY ►",
        "commodity_x": "► COMMODITY X ► Z EXCHANGE SOCIAL CONSUMING.",
        "interface_preview": "Z EXCHANGE INTERFACE PREVIEW ►",
        "generative_boards": "► GENERATIVE Z EXCHANGE BIG BOARDS ► REAL TIME MARKET EXPRESSION"
      },
      "simulation": {
        "memento_mori_description": "Remember you must die. This simulation explores meaningful choices in limited time.",
        "mortality_chamber_setup": "You will be transported to the simulation environment, where you'll face a countdown to your symbolic death and make trading decisions that reflect your deepest values.",
        "simulation_instructions": "You'll start with a short reflection on your life values, then receive recommended stocks. The countdown will only begin after your reflection.",
        "life_profit_title": "Exploring What You Value",
        "building_experience": "Building your Memento Mori Experience",
        "preparing_chamber": "Preparing your symbolic mortality chamber...",
        "welcome_setup": "Welcome! Let's set up your trading portfolio.",
        "life_profits_explanation": "Let's find a ZEconomy company stock you believe in to generate 'Life Profits'.",
        "no_matching_companies": "Our system found no companies matching your emotional profile.",
        "creating_simulation": "Creating your Simulation...",
        "please_wait": "Please wait while we generate your virtual portfolio.",
        "trade_title": "Trade on ZExchange.",
        "one_off_session": "One-Off Session",
        "freestyle_title": "Freestyle is a ZExchange Regular Session Simulator.",
        "freestyle_goal_label": "Goal",
        "freestyle_goal_text": "learn ZExchange interface & concepts; and above all explore how value becomes your story.",
        "details_heading": "Details:",
        "freestyle_detail_1": "takes our idea of profits by applying value to what matters to you in your life.",
        "life_profit_label": "Life Profit",
        "life_profit_description": "value of consciously lived life: joy, loss, contradiction, sex, love, depression, boredom, partying... (quality / quantity / positive & negative).",
        "voice_of_bourse_label": "\"voice of the bourse\"",
        "voice_of_bourse_description": "At ZExchange the market itself has a voice, analyzing what it thinks of each stock transaction → creating generative \"big boards\" + creates collaborative narratives.",
        "zrms_label": "Z Relationship Monetary System",
        "zrms_description": "Zollars apply your associative value of relationships to pay for assets using Love, Hate, Friendship, Death, Fellowship...",
        "commodity_x_label": "Commodity X",
        "commodity_x_description": "Trade commodities with a catch, you need social validation before any consumption (redeem with other trader's item → consume) can happen.",
        "economic_tools_label": "Economic tools",
        "economic_tools_description": "wield LBOs (Leveraged Buyouts), communist assaults, socialist subventions, dark pools, ransom, theft..., use economics as weapons or gifts towards other traders.",
        "memento_title": "Memento Mori – Trading life value to make your Eulogy",
        "memento_why_label": "Why?",
        "memento_why_text": "reflect on how you value living, experiences, and emotions to determine what you would value most when your life ends.",
        "memento_confront_label": "Confront mortality",
        "memento_confront_description": "Create a portfolio of life values through trading stocks, who's cumulative life value will generate your eulogy.",
        "memento_relational_label": "Relational capital",
        "memento_relational_description": "Zollars here represent associating positive & negative relationships to the stocks over numerical yield.",
        "memento_bourse_eye_label": "\"Under thy bourse eye\"",
        "memento_bourse_eye_description": "The bourse will cast judgement upon thy in your eulogy by watching all your transactions until the end."
      },
      "story": {
        "catena_title": "Catena Narrativa",
        "catena_subtitle": "Story building as supply chains: trade, customize, and consolidate through three phases to complete the story creation process.",
        "continue_to_selection": "Continue to Story Selection",
        "process_heading": "Process:",
        "materials_motion_title": "Materials in motion:",
        "materials_motion_desc": "Trade narrative elements as commodities. Customizing them as you trade. Value forms through the exchanging process to construct a story.",
        "three_passes_title": "Three passes:",
        "three_passes_desc": "Origin (beginning) → Transit (middle) → Assembly (end) ( 3min + 3min + 2min ≈8 minutes total). Each phase ends after the time expires, or you redeem, resulting in your bullet point commodities being secured into a personal story ledger.",
        "composition_title": "Composition:",
        "composition_desc": "At the end, your ledger is transformed into a short story generated from your customized trading of assets and redeemed secured bullet points.",
        "commodity_x_label": "Commodity X",
        "commodity_x_desc": "is part of ZEconomy where profits are measured in <strong>Life Profit</strong>— the quality and quantity of intellect, affection, partying... etc, all of life's divers happenings, promoting being—over accumulation.",
        "footer_note_consumption": "Commodity X where Consumption is relational: you cannot consume without mutual assent. The commodity is not the object; the commodity is the interaction.",
        "footer_note_redeem": "Redeem relationally. Consume consciously.",
        "simulation_title": "Story Simulation",
        "simulation_intro": "Engage in a narrative exchange with automated participants across three distinct phases, crafting a unique short story through dynamic collaboration.",
        "choose_genre": "Choose Your Genre",
        "genre_scifi": "Science Fiction",
        "genre_scifi_desc": "Futuristic visions and speculative worlds",
        "genre_romance": "Romance",
        "genre_romance_desc": "Emotion, intimacy, and human connection",
        "genre_mystery": "Mystery",
        "genre_mystery_desc": "Secrets, investigation, and concealed motives",
        "genre_fantasy": "Fantasy",
        "genre_fantasy_desc": "Myth, imagination, and transcendence",
        "genre_horror": "Horror",
        "genre_horror_desc": "Fear, suspense, and the confrontation of the unknown",
        "duration": "Duration: 8 minutes (3 + 3 + 2 minute phases)",
        "loading_elements": "Loading Story Elements...",
        "choose_starting_element": "Choose Your Starting Element",
        "select_one_element": "Select one story element to begin with. You'll also receive 2 random elements.",
        "skip_selection": "Skip Selection (Get 3 Random Elements)",
        "preparing_story": " Preparing Your Story...",
        "setting_up_simulation": "Setting up {theme} simulation...",
        "story_begins": " Story Begins Now",
        "entering_world": "Entering {theme} world in 2 seconds...",
        "failed_load_elements": "Failed to load story elements",
        "failed_create_session": "Failed to create story session",
        "your_story_complete": "Your Story is Complete",
        "generating_final_story": "Generating your final story...",
        "please_wait": "Please wait...",
        "fallback_story": "Your narrative journey through the marketplace of stories has concluded. The elements you traded and customized have woven together into a unique tale."
      },
      "memento": {
        "question_1": "1. How do you feel about your life right now?",
        "question_1_placeholder": "e.g., anxious about the future, grateful for relationships...",
        "question_2": "2. What matters most to you?",
        "question_2_placeholder": "e.g., family, creativity, making an impact...",
        "question_3": "3. If your life ended tomorrow, what would you want your legacy to represent?",
        "question_3_placeholder": "e.g., someone who helped others, lived authentically...",
        "find_companies_button": "Find Meaningful Companies",
        "choose_legacy_title": "Choose Your Legacy Portfolio",
        "choose_legacy_description": "Select 3-5 companies that represent what matters most to you.",
        "choose_legacy_warning": "These will be the stocks you hold when your time expires.",
        "selected_count": "Selected",
        "your_time_begins": "⏳ Your Time Begins Now ⏳",
        "entering_mortality_chamber": "Entering your mortality chamber in 2 seconds...",
        "your_eulogy_label": "YOUR EULOGY",
        "generating_eulogy": "Generating your life's story based on your choices...",
        "your_eulogy_expanded_title": "YOUR EULOGY",
        "eulogy_subtitle": "A reflection of your choices in the marketplace of life",
        "eulogy_update_info": "This eulogy updates every 2 minutes based on your trading actions",
        "eulogy_fallback": "Your journey through life's marketplace continues to unfold, each choice revealing the values that guide your path."
      },
      "validation": {
        "complete_reflections": "Please complete all three reflections.",
        "max_companies": "Maximum 5 companies allowed"
      },
      "trader": {
        "send_message": "Send Message",
        "message_cost": "Cost: 20",
        "select_recipient": "Select a recipient:",
        "message_placeholder": "Enter your message (280 characters max)",
        "send_button": "Send",
        "no_stocks" : "You own no stocks.",
        "output": "Output",
        "tap_for_details": "tap for full company view + chart",
        "close_button": "Close",
        "no_bond_port": "You own no ZBonds.",
        "steal_commodity": "Steal Commodity",
        "ransom": "Ransom",
        "no_economic_tiggers" : "You have no economic triggers available.",
        "create_dark_pool": "Create Dark Pool",
        "delete_portfolio": "Delete Portfolio",
        "capitalist_lbo": "Capitalist LBO",
        "socialist_subsidy": "Socialist Subsidy",
        "bien_q": "Commodity",
        "no_redeemed_item": "You have no redeemed items.",
        "explanations": "Explanations",
        "commodity_items" : "You own no commodities.",
        "click_learn_more": "Click to learn more",
        "go_to_market": "Go to Market",
        "dark_pool_market": "Dark Pool Market",
        "no_reason_provided": "No reason provided",
        "stock_name": "Stock Name",
        "unknown": "Unknown",
        "symbol": "Symbol",
        "quantity": "Quantity",
        "initial_value_per_share": "Initial Value per Share",
        "current_value_per_share": "Current Value per Share",
        "total_gain_loss": "Total Gain/Loss",
        "reason_for_short": "Reason for Short",
        "close_short_position": "Close Short Position",
        "emotional_state_banner_title": "Track your emotional economy",
        "social_economy_banner_title": "Emotional Debt Instruments",
        "issue_altrau_z_bill": "Issue Z Bill Altrau",
        "issue_m_note_borrow": "Issue M Note (Borrow)",
        "issue_z_payday_cdo": "Issue Z-Payday Loan CDO",
        "issue_v_note_request_aid": "V Note (Request Aid)"
      },
      "market": {
        "all_types": "All Types",
        "goods": "Goods", 
        "stocks": "Stocks",
        "bonds": "Bonds",
        "no_sort": "No Sort",
        "price_low_to_high": "Price: Low to High",
        "price_high_to_low": "Price: High to Low",
        "apply_filter": "Apply Filter",
        "reset": "Reset",
        "close": "Close",
        "explanations": "Explanations",
        "items": "Items",
        "trade": "Trade",
        "buy": "Buy",
        "trade_for": "Trade For",
        "description": "Description",
        "value": "Value",
        "quantity": "Quantity",
        "location": "Location",
        "owner": "Owner",
        "portfolio": "Portfolio",
        "filter": "Filter",
        "redeem": "Redeem ✓",
        "buy_bond_confirmation": "Buying this bond will trigger its maturity period. Confirm to proceed.",
        "bond_purchased_success": "Bond purchased successfully!",
        "bond_purchase_failed": "Failed to purchase bond. Please try again.",
        "portfolio_ransomed": "Your portfolio is currently under ransom. Pay the ransom to view and interact with items.",
        "shorted_by": "Shorted by:",
        "unknown": "Unknown",
        "num_shares": "# Shares:",
        "short_value": "Short Value:",
        "reason": "Reason:",
        "enter_offer_for": "Enter your offer for",
        "available_points": "You have {points} available capital. Commodity cost: {cost}.",
        "choose_offer_type": "Choose offer type:",
        "zollars": "Zollars",
        "capital": "Capital",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "enter_capital": "Enter capital:",
        "offer_amount_placeholder": "Offer amount",
        "select_zollar_value": "Select a Zollar value to continue.",
        "invalid_offer": "Invalid offer or insufficient capital",
        "processing_transaction": "Processing your transaction...",
        "waiting_seconds": "Waiting: {seconds} seconds",
        "processing": "traitement",
        "short_stock": "Short Stock",
        "stock": "Stock:",
        "current_value": "Current Value:",
        "available_shares": "Available Shares:",
        "short_amount_placeholder": "Number of shares to short",
        "short_reason_placeholder": "Why short this stock?",
        "confirm_short": "Confirm Short",
        "must_provide_reason": "You must provide a reason to short this stock.",
        "portfolio_name": "Portfolio Name"
      },
      "offer": {
        "offer_sent": "Offer Sent",
        "do_not_leave_page": "DO NOT LEAVE THE PAGE.",
        "awaiting_response": "Awaiting response. Please wait...",
        "time_remaining": "Time remaining: {seconds} seconds",
        "trade_offer": "Trade Offer",
        "offers_you": "{initiator} offers you: {offered} in exchange for: {requested}",
        "respond": "Respond",
        "accept": "Accept",
        "decline": "Decline",
        "buy_offer_received": "Buy Offer Received",
        "zollar_offer_for": "Zollar offer for {item} from {portfolio}: {details}",
        "points_offer_for": "Capital offer for {item} from {portfolio}: {details}",
        "no_zollar_details": "No Zollar details available.",
        "error_missing_details": "Error: Missing details for offer. Please try again.",
        "error_invalid_points": "Error: Invalid amount for capital offer.",
        "error_missing_zollar_details": "Error: Missing details for Zollar offer.",
        "error_invalid_offer_type": "Error: Invalid offer type.",
        "success_buy_offer_accepted": "Success: Buy offer accepted for {item}",
        "error_accepting_offer": "Error accepting offer: {message}",
        "meaningful_exchange": "Meaningful Exchange",
        "value_quote": "Value exists in perception, play and speculation, not just utility or rarity.",
        "who_to_trade_with": "Who would you like to trade with?",
        "select_trader": "Select a trader...",
        "why_trade": "Why do you want to make this trade?",
        "describe_motivation": "Describe your motivation, emotion or story...",
        "trade_with": "Trade with:",
        "capital": "Capital",
        "zollars": "Zollars",
        "cancel": "Cancel",
        "send_offer": "Send Offer",
        "item_received": "You received {item} from {giver}!",
        "time_remaining_html": "Time remaining: <span id=\"timer\"></span> seconds",
        "time_expired": "Time expired. Offer declined.",
        "offer_declined": "Offer declined. No capital awarded.",
        "offer_accepted": "Offer accepted! Capital awarded.",
        "reason": "Reason:",
        "time_remaining_extended": "Time remaining: {seconds} seconds (extended)",
        "processing": "Processing transaction...",
        "meaningful_offer_sent": "Meaningful trade offer sent! {insight}",
        "error_generic": "Error: {message}",
        "share_reason_placeholder": "Share your reason, motivation, memory, or vision... To create meaningful connections by trading.",
        "meaningful_trade_offer": "Meaningful Trade Offer",
        "wants_to_trade": "wants to trade",
        "respond_optional": "Respond to their story (optional)...",
        "not_interested": "Not Interested",
        "im_interested": "I'm Interested!",
        "response_sent": "Response sent",
        "interest_shown": "Interest shown! They may contact you directly.",
        "respond_to_offer": "Respond to offer.",
        "the_why": "The why:",
        "share_thoughts": "Share your thoughts, ask questions, or explain your perspective...",
        "response_min_length": "Please write at least 10 characters in your response.",
        "send_response": "Send Response",
        "they_responded": "They Responded",
        "their_original_why": "Their original why:",
        "your_response": "Your response:",
        "their_response": "Their response:",
        "accept_trade": "Accept Trade",
        "decline_trade": "Decline Trade",
        "updated_trade_offer": "Updated Trade Offer",
        "offer_sentence_simple": "{name} offers you {offered} and requests {requested} in return.",
        "buy_accepted_points": "{seller} accepted your buy offer! You got {item} for {points} capital.",
        "buy_accepted_zollars": "{seller} accepted your buy offer! You got {item} for zollars.",
        "buy_accepted_generic": "{seller} accepted your buy offer! You got {item}.",
        "error_processing_trade": "Error processing trade offer",
        "zollar_none": "None",
        "zollar_few": "A Few",
        "zollar_some": "Some",
        "zollar_many": "Many",
        "zollar_huge": "A Huge Amount",
        "response_sent_title": "Response Sent",
        "waiting_for_response": "Waiting for their response...",
        "timer_extended_60": "Timer extended to 60 seconds"
      },
      "transaction": {
        "requested_item": "Requested Item",
        "item_owner": "Item Owner",
        "item_name": "Item Name",
        "points": "Capital",
        "location": "Location",
        "propose": "Propose",
        "explain_trade_reason": "Explain why you want to make this trade.",
        "you_offer": "You offer:",
        "you_want": "You want:",
        "why_trade_question": "Why do you want to make this trade? What is your goal?",
        "share_motivation": "Share your motivation, a memory or a vision... Stories create meaningful connections in trading. (15 characters minimum)",
        "narrative_error": "Please write at least 15 characters to explain your goal.",
        "char_missing": "Still missing {count} characters to explain your goal.",
        "char_missing_full": "Please write at least 15 characters to explain why you want this trade.",
        "send_trade_with_intention": "Send trade with intention",
        "cancel": "Cancel",
        "select_asset": "Select Asset",
        "return_to_market": "Return to Market"
      },
      "messageSend": {
        "title": "Send Message",
        "costPerRecipient": "Cost: 20 per recipient",
        "searchRecipients": "Search recipients",
        "unnamedPortfolio": "Unnamed Portfolio",
        "placeholder280": "Enter your message (280 characters max)",
        "send": "Send",
        "close": "Close",
        "newMessageFrom": "New message from",
        "unknown": "Unknown",
        "reply": "Reply",
        "markAsRead": "Mark as read",
        "onlyChatBots": "You can only chat with bot players, not humans.",
        "conversationWith": "Conversation with",
        "messagesRemaining": "messages remaining",
        "typeYourMessage": "Type your message...",
        "chatLimitReached": "Chat limit reached. This conversation has ended.",
        "error": "Error",
        "failedToSend": "Failed to send message",
        "chatEnded": "Chat ended",
        "chatEndedThanks": "This chat has ended. Thanks for talking!",
        "connectionError": "Connection error. Please try again.",
        "botGreeting": "Hey! I'm {name}. What's on your mind?",
        "message_user": "Message to {user}: {message}"
      },
      "boss": {
        "session_required_leaderboard": "Session ID is required to view the leaderboard.",
        "session_required_mood_board": "Session ID is required to view the Mood Board.",
        "invalid_point_amount": "Invalid capital amount. Please try again.",
        "session_required_system_bot": "Session ID required to start system bot.",
        "system_bot_started": "System bot started: {name}",
        "system_bot_start_failed": "Failed to start system bot: {error}",
        "session_required_stop_bot": "Session ID required to stop system bot.",
        "system_bot_stopped": "System bot stopped successfully.",
        "system_bot_stop_failed": "Failed to stop system bot: {error}",
        "session_required_trigger_event": "Session ID required to trigger system event.",
        "system_event_triggered": "System event triggered successfully!",
        "system_event_trigger_failed": "Failed to trigger system event: {error}",
        "session_required_logout": "Session ID is required to logout traders."
      },
      "stock": {
        "ownership_transferred": "Ownership transferred successfully",
        "transfer_failed": "Failed to transfer ownership. Please try again.",
        "share_deleted": "Share deleted successfully",
        "delete_failed": "Failed to delete share. Please try again.",
        "short_closed": "Short position closed successfully",
        "close_short_failed": "Failed to close short position. Please try again.",
        "short_placed": "Short position placed successfully",
        "place_short_failed": "Failed to place short position. Please try again.",
        "no_short_positions": "No short positions found for this stock.",
        "fetch_short_failed": "Failed to fetch short positions. Please try again.",
        "short_positions_for": "Short Positions for Stock ID",
        "short_position": "Short Position",
        "close_short": "Close Short",
        "submitting_bid": "Submitting your bid...",
        "please_wait": "Please wait while we process it.",
        "redirect_in": "Redirecting in",
        "seconds": "seconds"
      },
      "social_class": {
        "working_class": {
          "name": "Working Class",
          "description": "You begin in debt with minimal resources. Every decision matters.",
          "goal": "Escape debt through strategic trading and community building",
          "goals": {
            "pay_off_debt": "Get your capital above zero before time runs out. Sell shares, swap items, accept fair offers — every deal that pays counts.",
            "two_swaps": "Complete 2 swaps with other traders: your things for theirs. No money needed — swaps are how you trade when you are broke.",
            "reserve_lift": "Visit the Zederal Reserve, take a Z Bond for extra capital, and turn it into at least one trade that grows what you hold."
          }
        },
        "lower_middle": {
          "name": "Lower Middle Class",
          "description": "You have modest resources. Careful planning can lead to prosperity.",
          "goal": "Build financial stability and grow your network",
          "goals": {
            "own_two_companies": "Own shares of 2 different companies by the end. Pick companies whose story speaks to you — you grow when they grow.",
            "first_zollars": "Buy zollars at the Zederal Reserve and win one trade paying with relationships (Love, Friendship…) instead of capital.",
            "grow_worth": "Grow your total worth by a fifth. Bid on undervalued things, swap up, and do not let your capital sleep."
          }
        },
        "middle_class": {
          "name": "Middle Class",
          "description": "You start with a balanced portfolio. Strategic choices will determine your trajectory.",
          "goal": "Maintain stability while pursuing growth opportunities",
          "goals": {
            "diversify": "End the session holding all three kinds of value: shares of a company, an item, and a bond.",
            "three_bids": "Win 3 bids on things other traders hold. Name your price, say why you want it, and convince them.",
            "relations_over_money": "Finish richer in zollars than in capital — trade so that relationships outweigh plain money in your portfolio."
          }
        },
        "upper_middle": {
          "name": "Upper Middle Class",
          "description": "You have significant resources. Use them wisely to create opportunities.",
          "goal": "Leverage your resources to build lasting influence",
          "goals": {
            "fair_patron": "Play the patron: win 2 bids AND accept 2 offers from traders poorer than you, at a fair price. Influence is built, not bought.",
            "capital_to_life": "Convert your capital into living value: end with more of your worth in shares and items than in plain capital.",
            "bond_collector": "Build a bond book: hold 3 Z Bonds from the Zederal Reserve and let the interest work for you."
          }
        },
        "wealthy_elite": {
          "name": "Wealthy Elite",
          "description": "You start with immense wealth. Everyone wants what you have—generosity creates protection.",
          "goal": "Share wealth to build alliances or face coordinated resistance",
          "goals": {
            "generous_giant": "Give to grow: accept swaps or modest bids from at least 3 different traders. On this floor, generosity is protection.",
            "biggest_backer": "Spread your wealth into shares of 4 different companies — become the floor's biggest backer.",
            "keep_the_crown": "End the session still on top. Everyone wants what you have; alliances and fair deals are how you keep it."
          }
        },
        "starting_capital": "Starting Capital:",
        "starting_items": "Starting Items:",
        "your_goal": "Your Goal:",
        "actions_note": "Your actions shape how others treat you. Generosity builds alliances, exploitation invites retaliation."
      },
      "life_profile": {
        "room_title": "THE ROOM RE-RANKED",
        "room_you": "(you)",
        "flows_title": "WHERE YOUR VALUE WENT",
        "flow_the_room": "the room",
        "flow_value": "value",
        "kind_gift": "gift",
        "kind_swap": "swap",
        "kind_trade": "trade",
        "kind_lend": "lent",
        "kind_aid": "aid",
        "kind_predatory": "predatory loan",
        "kind_bond": "bond",
        "kind_seized": "seized",
        "verdict_title": "THE ROOM RE-RANKED YOU",
        "entered": "Entered:",
        "by_capital": ", by capital.",
        "leaves": "Leaves:",
        "by_balance": ", by balance and giving.",
        "balance_label": "Balance",
        "giving_label": "Given",
        "gave_nothing": "You gave nothing away. However balanced a life is, this room will not rank it higher than that.",
        "carries_title": "WHAT YOUR LIFE CARRIES",
        "chose": "You chose {company}. That is what your life is heavy with.",
        "heavy_label": "Too much:",
        "lacking_label": "None at all:",
        "how_it_ends": "When time runs out, the room decides your class by how balanced you are and how much you gave — not by what you earned."
      },
      "debt_actions": {
        "common": {
          "perceived_magnitude": "Perceived magnitude",
          "magnitude_none": "None",
          "magnitude_hint": "A Hint",
          "error_login_required": "Please log in first"
        },
        "help_friend": {
          "intro": "Give help. Choose <b>Z$</b> or <b>Capital</b> for the gift.",
          "capital_label": "Capital (amount)",
          "capital_placeholder": "Enter capital",
          "select_zollars": "Select Z$ categories to gift.",
          "recipient_label": "Recipient:",
          "no_zollars": "No Z$ available.",
          "modal_title": "Altrau Z Bill (Altruistic Gift)",
          "error_no_recipient": "Select a recipient.",
          "error_invalid_capital": "Enter a valid capital amount.",
          "error_no_zollars_to_give": "No Z$ to give.",
          "error_select_zollars": "Select some Z$ to give.",
          "error_insufficient_zollars": "Insufficient {type} zollars. You have {available}, trying to send {count}.",
          "success": "Altrau Z Bill given. Your ledgers are now bound."
        },
        "predatory_lend": {
          "intro": "Z-Payday CDO: Offer a compounding loan that reloads every 60 seconds.",
          "warning": "WARNING: Each cycle increases the debt by 15% until repayment or bankruptcy.",
          "exploitation_note": "(Exploitation disguised as empathic connection.)",
          "capital_label": "Capital (amount to \"lend\")",
          "capital_placeholder": "Amount",
          "select_zollars": "Select Z$ bait for collapse.",
          "victim_label": "Target Victim:",
          "no_zollars": "No Z$ available.",
          "modal_title": "Z-Payday CDO (Predatory Loan)",
          "error_no_victim": "Select a victim.",
          "error_invalid_amount": "Enter a valid amount.",
          "error_no_zollars_selected": "No Z$ selected.",
          "error_select_zollars": "Select some Z$.",
          "success_targeted": "Z-Payday CDO offer sent to victim. Reloads every 60 seconds once accepted.",
          "success_market": "Z-Payday CDO listed on market. Disguised as attractive offer."
        },
        "borrow": {
          "intro": "Request a loan (M Note).",
          "vulnerability_required": "Disclose your emotional debt. Vulnerability.",
          "vulnerability_label": "Why do you need this loan? (Emotional debt disclosure - min 20 chars)",
          "vulnerability_placeholder": "Disclose your emotional debt / vulnerability here...",
          "char_count": "0 / 20 chars",
          "char_suffix": "/ 20 chars",
          "severity_label": "Severity",
          "severity_question": "How severe is your need?",
          "move_sliders": "Move sliders to express your need:",
          "lender_label": "Choose Lender:",
          "modal_title": "M Note (Request Loan)",
          "error_vulnerability_required": "M Note requires vulnerability disclosure (min 20 characters).",
          "error_move_slider": "Please move at least one slider to express your need.",
          "error_no_lender": "Please select a lender.",
          "success_targeted": "M Note loan request sent to lender.",
          "success_market": "M Note listed on market for lenders to purchase."
        },
        "request_aid": {
          "intro": "Request aid (V Note).",
          "description": "Ask someone for a handout by sharing your vulnerability.",
          "accept_decline_note": "They can accept or decline your request.",
          "vulnerability_label": "Explain why you need aid (vulnerability disclosure - min 20 chars)",
          "vulnerability_placeholder": "Share your vulnerability...",
          "severity_question": "Situation severity (how urgent is this)",
          "target_label": "Request aid from:",
          "modal_title": "V Note (Request Aid)",
          "error_no_target": "Please select who to request aid from.",
          "error_vulnerability_required": "V Note requires vulnerability disclosure (min 20 characters).",
          "success": "V Note request sent. Awaiting response."
        }
      },
      "bot": {
        "chat_connection_notready": "Connection not ready. Please try again in a moment.",
        "chat_greeting_fallback": "Hey! I'm {{name}}. What's on your mind?",
        "chat_remaining": "messages remaining",
        "chat_input_placeholder": "Type your message...",
        "chat_connection_lost": "Connection lost. Please try again.",
        "chat_error_notloggedin": "Error: User not logged in",
        "chat_limit_reached": "Chat limit reached.",
        "chat_timeout": "Bot is taking too long to respond. Please try again.",
        "chat_end_thanks": "This chat has ended. Thanks for talking!",
        "chat_ended": "Chat ended",
        "chat_recommendation_title": "Trading Recommendation",
        "chat_action_buy": "Place Bid",
        "chat_action_sell": "Create Offer",
        "chat_action_short": "Short Stock",
        "chat_action_trade": "Make Trade",
        "chat_action_goto": "Go to Trading"
      },
      "items": {
        "item_added_success": "Item added successfully!",
        "item_add_failed": "Failed to add item. Please try again.",
        "no_items_portfolio": "No Commodities in this portfolio.",
        "search_portfolios": "Search portfolios...",
        "item_assigned_success": "Item assigned to portfolio successfully",
        "item_assign_failed": "Failed to assign item to portfolio. Please try again.",
        "item_unassigned_success": "Commodity unassigned from portfolio successfully",
        "item_unassign_failed": "Failed to unassign commodity from portfolio. Please try again.",
        "item_deleted_success": "Item deleted successfully",
        "item_delete_failed": "Failed to delete commodity. Please try again.",
        "item_redeemed_success": "Item redeemed successfully",
        "item_unredeemed_success": "Item unredeemed successfully",
        "redeem_toggle_failed": "Failed to toggle redeem status. Please try again."
      },
      "zollar": {
        "select_relationship_required": "Please select at least one relationship and enter a quantity.",
        "zollars_added_success": "Zollar(s) added successfully",
        "add_failed_error": "Failed to add zollar(s). Please try again. Error: {error}",
        "deleted_success": "Zollar deleted successfully",
        "delete_failed": "Failed to delete zollar",
        "fill_required_fields": "Please fill all required fields correctly.",
        "zbond_added_success": "ZBond added successfully",
        "zbond_add_failed": "Failed to add ZBond. Error: {error}",
        "select_portfolio_required": "Please select a portfolio to assign the item to.",
        "assign_failed": "Failed to assign {itemType}. Please try again.",
        "unassigned_success": "{itemType} unassigned from portfolio successfully",
        "unassign_failed": "Failed to unassign from portfolio. Please try again.",
        "bond_deleted_success": "Bond deleted successfully",
        "bond_delete_failed": "Error deleting bond: {error}",
        "session_details_failed": "Failed to retrieve session details. Please try again.",
        "session_fetch_error": "Error fetching session details. Please try again later.",
        "fetch_portfolios_error": "Error fetching active portfolios. Please try again."
      },
      "tuts": {
        "trader_mood_gauge": "Trader Mood Gauge",
        "description": "Description:",
        "trader_gauge_description": "This gauge visualizes the collective mood of traders in the current market session.",
        "conceptual_insight": "Conceptual Insight:",
        "gains_losses": "Gains / Losses",
        "portfolio_banner_description": "Click the banner to view your earnings breakdown.",
        "trader_tools": "Trader Tools",
        "subsidy": "The Socialist Subsidy redistributes 45% of wealth from the richest portfolio to others. Use strategically to weaken strong players.",
        "ransom": "The Ransom locks a portfolio until the ransom capital is paid. This forces opponents into tough trade-offs.",
        "lbo": "The Leveraged Buyout (LBO) lets you acquire stocks and items from another portfolio by paying a high cost. Powerful but expensive.",
        "steal": "The Steal allows you to take a single item from another portfolio. Use stealthily to disrupt opponents.",
        'stealButton': `
          <h3>Steal Asset Trigger</h3>
          <strong>Description:</strong> <br>
          Steal Trigger allows you to steal from an individual in the market, anonymously, with no permission needed.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the “Steal Trigger” banner.</li>
          <li>Choose an item from the list of available holdings.</li>
          <li>Confirm your action to finalize the theft.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Stealing is universally condemned, yet it thrives in countless forms, in every social stratosphere—from petty theft to grand-scale corruption; from bicycles to bank robbery. 
          <br><br>
          By committing theft here, do you question your own moral boundaries? Does the short-term thrill of getting a “free” item overshadow the harm to the original owner? What value do you place on the consequences of what the robbed may feel? How would you feel about enjoying something that was intended to bring joy to someone else? This is a test of how you value empathy, guilt, and personal gain within the ZEconomy ecosystem.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Imagine you see a commodity you really want on a big board. By using the Steal Trigger, you seize it for your own portfolio. But how do you feel knowing you gained “value” by undermining another person’s rightful claim?
        `,
        'ransomButton': `
          <h3>Ransom a fellow Trader Trigger</h3>
          <strong>Description:</strong> <br>
          A trigger that locks another trader’s entire portfolio, forcing them to pay your set ransom before they can resume trading.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the “Ransom Trigger” banner.</li>
          <li>Select the portfolio you want to ransom.</li>
          <li>Enter the ransom cost in capital.</li>
          <li>Once set, the victim’s portfolio is inaccessible to them until you’re paid in full.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Ransom is akin to outright extortion. It’s illegal in real-life finance with jail time for a reason; you profit to the detriment of the victim. However, in ZEconomy, the penalty is purely social: your identity is revealed to the victim at the moment you place the ransom. 
          <br><br>
          Do you relish wielding power, or dread the social backlash? Are you comfortable with a brute, aggressive form of “profit” at the expense of another trader’s free will and peace of mind? Do you care about the consequences for the attack victim? Do you care about the social consequences for yourself? Will you enjoy the financial gains by extorting a trader from their wealth? 
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a trader who has amassed valuable holdings but is short on capital. By setting a steep ransom, you effectively block them from using their entire portfolio until they cough up the fee. It can be a swift path to profit for you—assuming you can handle the backlash once they realize you put them in lockdown.
        `,
        
        'createCommunityButton': `
          <h3>Dark Pool Trigger</h3>
          <strong>Description:</strong> <br>
          A private market arena with a participatory group of selected traders, hidden from the rest of the public exchange.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the “Dark Pool Trigger” banner.</li>
          <li>Select which traders to invite.</li>
          <li>If they accept, you have 10 minutes of private market trading, invisible to everyone else in the public market.</li>
          <li>Anyone can opt out anytime, returning to the public exchange.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          Dark Pools are private trading communities that exist outside of the visible public market exchanges. They are the market version of an exclusive gated community. Inside the pool, participants become free to shape the “value” of any market-listed assets, outside public scrutiny or intervention, especially when the trades are large in nature.
          <br><br>
          Is this honest cooperation, or a form of manipulation? Is it fair if asset values are decided by a hidden few traders? Does secrecy undermine genuine valuation and transparency? If you and your selected trading partners can inflate or deflate prices at will, are you still respecting the “true” nature of the ZEconomy or merely gaming it?
          <br><br>
          This tension between private gain and collective trust is what makes dark pools both tempting and ethically murky. You must decide: does stepping away from the public stage strengthen your own “value,” or undermine the shared “value” of the entire ZEconomy?
          <br><br>
          <strong>Usage Example:</strong> <br>
          Suppose you and a few close allies want to swap “bonds” or “stocks” at prices you set, away from prying eyes. The Dark Pool might let you corner a niche of the market or secure a better deal. Yet, once the broader community learns about your secrecy, they might feel cheated or question the fairness of these behind-the-scenes deals.
        `,
        
        'deletePortfolioButton': `
          <h3>Communist Assault Trigger</h3>
          <strong>Description:</strong> <br>
          Seize and redistribute all of a rival’s wealth to the collective.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Communist Assault banner.</li>
          <li>Choose a target portfolio.</li>
          <li>Confirm your action to instantly redistribute all their holdings across active traders.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger wipes out a single targeted trader’s entire portfolio and spreads it randomly among everyone else. In theory, no single individual grows vastly richer; everyone gets an equal share of the now communal seized wealth.
          <br><br>
          But consider the human reality: how would you feel if everything you owned was aggressively confiscated and redistributed, even for a “common good”? Is it fair to remove one person’s property so that everyone else can benefit? Would you see this as justice or injustice? Like many firebrand economic ideas, “communal sharing” is loaded with moral complexities. Is this an act of genuine solidarity or an unjust seizure? You must weigh how far you’re willing to go in forcing collective welfare at another’s expense.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You notice a wealthy trader whom you feel has been hoarding too much. By unleashing the Communist Assault, you forcibly attack their market wealth and randomly redistribute all items, stocks, and captial to the rest of the active traders. A rising tide lifts all boats, but if the water rises at the expense of someone else, is that fair or moral?
        `,
        
        'LBOButton': ` <h3>Capitalist <br> (LBO) <br> Leveraged Buyout Trigger</h3>
          <strong>Description:</strong> <br>
          Aggressively buy control of another trader’s assets, whether they agree or not.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Capitalist LBO banner.</li>
          <li>Select the target portfolio you want to “acquire.”</li>
          <li>Pay a lump sum of your own capital (representing leveraged capital).</li>
          <li>Once paid, you seize the target’s items and stocks.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          A leveraged buyout involves heavy borrowing or capital injection to take over a company. Here, you risk your own wealth to gain outright control of someone else’s assets despite the target having freedom of choice in the transaction.
          <br><br>
          You do transfer funds, at a premium, to their portfolio, which might sound fair, yet the move is still coercive: it’s an aggressive buyout (purchase) without mutual consent. If you can afford the price, you get to expand your empire leaving the former owner “bought out” and potentially weakened. If traditional business logic says “if you can afford it, you deserve it,” what role should ethics play? Is that just the free market at work (survival of the richest), or an exploitative maneuver that disregards the target’s autonomy? The LBO highlights that in capitalism, money can effectively override freedom of consent, turning wealth into raw power.
          <br><br>
          <strong>Usage Example:</strong> <br>
          Spot a smaller portfolio with interesting stocks or items but fewer resources. With an inflated premium price of your wealth, you initiate a hostile LBO, forcibly taking over their assets. The target does receive payment in return—but you gain the real market advantage by controlling their capital. Is that fair or exploitative? Only you decide.`,
        'SubsidyButton': `
          <h3>Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br>
          “Tax” a rich portfolio to support the bottom half of the market.
          <br><br>
          <strong>How:</strong>
          <ul>
          <li>Click the Socialist Subsidy banner.</li>
          <li>Choose a wealthy portfolio to tax.</li>
          <li>Trigger the subsidy taxing the target’s wealth.</li>
          <li>Those taxed resources are distributed among the least affluent traders in the session.</li>
          </ul>
          <br>
          <strong>More Info & Ethical Challenge:</strong> <br>
          This trigger takes from the rich and subsidizes the struggling via redistribution of wealth to the less fortunate or unsuccessful, aiming to level the economic playing field.
          <br><br>
          On one hand, you’re championing a sense of collective balance by narrowing wealth gaps. On the other, you’re forcing someone else to bear the cost regardless of whether the rich or the poor deserve it. Does that build solidarity, or does it punish success? Is it “just” to relieve disparities or does it stifle ambition? 
          <br><br>
          You must decide if the “greater good” overrides individual success or wealth. The tension between economic equality, fairness, and personal freedom is at the heart of this move.
          <br><br>
          <strong>Usage Example:</strong> <br>
          You see a player sitting on massive stocks and capital while several others struggle. By hitting the Subsidy trigger, a significant chunk of that wealth is taxed and distributed to the poorest traders, giving them a fresh injection of capital. Perhaps you’re bringing fairness, or perhaps you’re penalizing someone for doing well. The outcome depends on your economic worldview.
        `,

        'helpFriendButton': `
          <h3>Altrau Z Bill</h3>
          <strong>Altruistic life value. Empathy.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To give without promise of return. Assist someone and become implicated in their Life Profit outcome. The rise and fall of their emotional balance pulling your life profits positive and negative. Quiet speculation that another's well-being might enlarge your own capacity to feel and expand your empathy capacity.
          <br><br>
          <strong>No returns required.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a transaction that binds both ledgers; an increase in shared variance rather than sum. When you issue an Altrau Z Bill, you're not just helping someone—you're entangling your emotional economy with theirs. Their successes become yours, their failures yours to bear.
          <br><br>
          It asks: <em>Can empathy be an investment? What happens when another's pain becomes your loss, their joy your gain?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click the "Issue Z Bill Altrau" button, select a trader to help, choose what to give (Zollars or Capital), and confirm. Your Life Profit will now fluctuate with theirs—a shared emotional destiny.
        `,

        'borrowCapitalButton': `
          <h3>M Note (Mutual Note)</h3>
          <strong>A loan drawn in confession.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          M Note creates credit out of exposed need and calculated trust. Value created on the human empathy of sharing in human imperfections. A borrower discloses a weakness; a lender accepts the risk, extending empathy as a form of investment.
          <br><br>
          What begins as recognition becomes obligation—vulnerability converted into Z Relational Collateral, interest accruing in attention, acknowledgment, and mutual Life Profit.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is emotional-weighted interest; time dilates with mood. Unlike traditional loans, the M Note doesn't just transfer capital—it transfers vulnerability. The borrower must confess why they need help, exposing their weakness to gain trust.
          <br><br>
          The lender isn't just providing resources; they're accepting the emotional risk of that vulnerability. Both parties are bound: the borrower by obligation, the lender by empathy.
          <br><br>
          <em>When you lend, you're investing in someone's capacity to recover. When you borrow, you're asking someone to believe in you.</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue M Note (Borrow)", select a lender, write your vulnerability confession (why you need help), choose what you need (Zollars or Capital), and send. The lender sees your confession and decides whether your vulnerability is worth their trust.
        `,

        'predatoryLendButton': `
          <h3>Z-Payday CDO (Collateralized Desire Obligation)</h3>
          <strong>Exploitation disguised as empathic human connection.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          Empathy and relief recast into instruments of toxic dependency. Z-Payday loans feed on need and greed, turning vulnerability into yield at the expense of human worth and systemic balance.
          <br><br>
          Each loan cycle lifts the lender, drains the borrower, and leaves the market to absorb the strain of contagion.
          <br><br>
          <strong>Function:</strong><br>
          Single acts of aid become a repeating contract—each minute another obligation is issued, each obligation thinly sliced into tranches that feed the larger CDO. The product promises immediacy and then converts the living into yield; the harvest comes from what is worn away when kindness is made structural.
          <br><br>
          <strong>The Z-Payday CDO does not forgive. It compounds exposure until the ledger consumes the life profit underneath.</strong>
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is predatory lending made visible. Unlike traditional payday loans that hide behind legal jargon, the Z-Payday CDO forces you to confront what you're doing: extracting value from someone's desperation, minute by minute.
          <br><br>
          It asks: <em>How far will you go for profit? Can you watch someone drain themselves to pay you back? Is this business, or is this cruelty?</em>
          <br><br>
          The victim's Life Profit decreases every minute, transferred to you. The system itself bears the collective emotional cost—everyone feels it when someone is being exploited.
          <br><br>
          <strong>Usage:</strong><br>
          Click "Issue Z-Payday Loan CDO", select a victim, choose the amount to extract per minute, and confirm. Every minute, their Life Profit decreases and transfers to you—until they close the debt or collapse entirely.
          <br><br>
          <strong>Warning:</strong> This action has severe social and emotional consequences. Others will know. The market will know. Your guilt accumulates.
        `,

        'requestHandoutButton': `
          <h3>V Note (Vulnerability Note)</h3>
          <strong>Admitting vulnerability.</strong>
          <br><br>
          <strong>Description:</strong> <br>
          To ask is to step into exposure—to risk the small collapse that comes with being seen in need. Vulnerability here is not weakness but invitation: a signal that one's balance has slipped and requires relation to recover.
          <br><br>
          Help, if granted, becomes a shared moment of recalibration; if withheld, it marks the quiet fracture between trust and pride.
          <br><br>
          Every request writes itself into the Emotional Debt Index, a measure not of possession, but of how much we still dare to depend.
          <br><br>
          <strong>Conceptual Insight:</strong> <br>
          This is a request with justification; relief triggered by assent; the ledger records both appeal and response. Unlike the M Note (which is a formal loan with obligation), the V Note is a simple ask—no strings attached, no repayment expected.
          <br><br>
          But asking is its own cost. You must expose your need, your vulnerability, your dependence. And the response—whether acceptance or rejection—shapes your emotional state and trust in the community.
          <br><br>
          <em>Can you admit you need help? Can others afford to give it? What does it mean when help is given freely, or when it's denied?</em>
          <br><br>
          <strong>Usage:</strong><br>
          Click "V Note (Request Aid)", write why you need help (your vulnerability statement), choose what you're asking for (Zollars or Capital), and send to another trader. They can accept (giving you what you asked) or decline (leaving you to manage alone). Either way, the emotional impact is recorded.
        `,

        'giveDeletePortfolioButton': `
          <h3>Issue Communist Assault Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Communist Assault" button to a trader, enabling them to seize and redistribute all of a targeted portfolio's wealth to the collective. 
          <br><br><strong>How-to:</strong> <br>  
          Select a trader from the active trader list and assign them the "Communist Assault" button.
          <br><br><strong>Functionality:</strong> <br>
          The target's wealth (points, stocks, commodities, etc.) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.
          <br><br><strong>Conceptual Insight:</strong> <br>
          This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution. Assigning this button to a trader effectively grants them the power to balance—or disrupt—the market.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices another hoarding valuable assets, creating market imbalance. By using "Communist Assault," they redistribute the wealth, equalizing resources but possibly alienating the hoarder and other observers.
        `,

        'giveLBOButton': `
          <h3>Issue Capitalist <br> Leverage Buyout Trigger</h3> 
          <strong>Description:</strong> <br>
          Assign the "Capitalist LBO" button to a trader, empowering them to aggressively acquire another portfolio's assets through a leveraged buyout. 
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Capitalist LBO" button.
          <br><br><strong>Functionality:</strong> <br>
          The acquiring trader gains full control of the target's portfolio (commodities, stocks, etc.) at sever cost to them.
          <br>
          The transaction is coercive yet compensatory, with the target receiving payment for their assets, and the initiator paying an inflated price.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Capitalist LBO" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation, emphasizing how financial strength can dictate market control.
          <br><br><strong>Usage Example:</strong> <br>
          A trader sees a smaller portfolio with underutilized assets. Using "Capitalist LBO," they pay a premium to forcibly acquire those assets, consolidating power but potentially facing backlash for their aggressive tactics.
        `,

        'giveSubsidyButton': `
          <h3>Issue Socialist Subsidy Trigger</h3>
          <strong>Description:</strong> <br> 
          Assign the "Socialist Subsidy" button to a trader, allowing them to tax a wealthy portfolio and redistribute the resources to less affluent traders.
          <br><br><strong>How-to:</strong> <br> 
          Select a trader from the active trader list and assign them the "Socialist Subsidy" button.
          <br><br><strong>Functionality:</strong> <br>
          50% of the target portfolio's wealth is Taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br>
          This feature levels disparities but can also penalize success, fostering debates about fairness and equity.
          <br><br><strong>Conceptual Insight:</strong> <br>
          "Socialist Subsidy" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.
          <br><br><strong>Usage Example:</strong> <br>
          A trader notices a portfolio with excess resources while others struggle. Using "Socialist Subsidy," they tax the wealthy trader and redistribute assets to the least affluent, injecting new life into the market and promoting equity.
        `,
        "deletePortfolio": "The Communist Assault deletes another portfolio entirely, at a significant cost. A drastic, endgame move.",
        "trader_tools_description": "Utilities for performing market-related actions with or against other traders.",
        "trader_tools_insight": "Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility—or will you push boundaries at the expense of others? The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
        "transaction_instructions": "<h3>Transaction Instructions</h3><p>Select an asset from your holdings to propose a trade with the item owner. This enables peer-to-peer trading of commodities between portfolios.</p>",
        "stock_instructions": "<h3>Stock Trading Instructions</h3><p>Purchase shares by entering the quantity you wish to buy. Your available capital is shown above. Each transaction affects the market and builds your portfolio.</p>",
        "bond_instructions": "<h3>Bond Trading Instructions</h3><p>Trade Z-Bonds, the emotional debt instruments of the Z Relationship Monetary System. Bonds represent relational capital between traders.</p>",
        "no_info": "No information available.",
        "no_tutorial": "No tutorial content available.",
        "no_instructions": "No instructions available.",
        "redeem_instructions": `
          <h3>Redeem is:</h3>
          Redeem is the process of transforming a commodity into a QR code so it can be physically obtained. It also removes the commodity from the market and your portfolio.
          <br><br>
          The catch is your commodity can only be redeemed if the other traders agree to redeem their commodities as well.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          The redeem process challenges traditional ideas of individual consumption by introducing a collective decision-making aspect to the process. Redeeming a commodity isn't just about acquiring something—it is a social interaction between multiple parties, with outcomes and consequences directly shaped by the responses of other traders.
          <br><br>
          <h3>Process:</h3>
          <strong>Step 1: Selected Commodities</strong><br>
          At the top, you'll see the Commodities you've selected to be Redeemed and the Commodity owner. These are the Commodities you're asking fellow traders to redeem so you can redeem your commodity.
          <br><br>
          <strong>Step 2: Choose Your <br> Redeem Commodity</strong><br>
          From your holdings list below, select the Commodity you want to Redeem.
          <br><br>
          <strong>Step 3: Send Ask</strong><br>
          Once you've selected your commodity, click "Send Redeem Ask." This will:
          <ul>
            <li>Send your ask to all target traders</li>
            <li>Lock your selected commodity during the process</li>
            <li>Give traders 10 seconds to respond</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          If ALL traders accept: You'll receive a random new commodity from the Zederal Reserve, and your commodity is redeemed so it can be obtained using the QR code at its designated location.<br><br>
          If ANY trader declines: Your redeem fails, and the commodity remains in your portfolio, available for trading on the market.
          <br><br>
          <strong>Important Notes:</strong><br>
          You cannot cancel a redemption once started
          The process takes exactly 10 seconds
          Do not leave the page during redemption
        `,
        "stock_trade_instructions": `
          <h3>What Are Stocks:</h3>
          In conventional finance, a stock (or share) represents partial ownership of a company. Investors typically buy stocks hoping the company's value will rise, increasing the share price.
          <br><br>
          Stocks are tradable for Zollars or Capital. As a company's value grows, so does the value of your portfolio. However, if a company's share price falls, the value of your holdings decreases as well.
          <h3>Stocks in ZEconomy:</h3>
          Stocks in ZEconomy reflect human values such as emotional well-being, social relationships, and personal growth—rather than traditional economic outputs. Trading stocks is more than just a financial transaction; it's an interaction with life values that forces you to reconsider what you value and how you invest in others.
          <br><br>
          <strong>Conceptual Insight:</strong><br>
          Stock trading in ZEconomy challenges the notion of profit: Is it about reaping monetary rewards, or about supporting the growth of human experiences such as emotional health, creativity, and shared connections? Every stock trade highlights the tension between genuine support for human value and the act of financially exploiting it. Think of your stocks as investments in happiness, success, and transformation instead of a company producing traditional goods or services.
          <br><br>
          This process asks you to reflect: Do your trades align with your personal values? What does it mean to invest in a human experience rather than economic output? How far are you willing to go to ensure your portfolio grows, and at what cost to the broader market ecosystem?
          <h3>Bid Process:</h3>
          <strong>Step 1: Review Available Stocks</strong><br>
          Use the stock table to review available shares in the market. Each stock represents a company built around a human value (e.g., creativity, happiness, or relationships). Take note of the stock's current value, owner, and potential for growth or decline.
          <br><br>
          <strong>Step 2: Decide Your Trade</strong><br>
          Determine whether to buy, sell, or short a stock. Buying supports the company's value, selling helps you realize gains, and shorting bets against its success, profiting if the value falls.
          <br><br>
          <strong>Step 3: Execute Your Trade</strong><br>
          Once you've made your decision:
          <ul>
            <li>Use the stock table to select the desired stock.</li>
            <li>Enter the number of shares you wish to trade and confirm the transaction.</li>
            <li>Your portfolio will update in real-time, reflecting the trade.</li>
          </ul>
          <br>
          <strong>Outcomes:</strong><br>
          <ul>
            <li>Successful trades increase the value of your portfolio if the company grows.</li>
            <li>Short positions succeed if the stock value drops but risk losses if it rises.</li>
          </ul>
          <br>
          <strong>Important Notes:</strong><br>
          <ul>
            <li>Stock values are dynamic and can change rapidly based on market activity.</li>
            <li>Consider the ethical implications of shorting stocks, as it bets against the success of human values.</li>
            <li>Every trade reflects your priorities and beliefs—choose wisely!</li>
          </ul>
        `,
        "transact_instructions": `
          <h3>From Item to Interaction</h3>
          In most markets a commodity is an impersonal thing—gold, oil, wheat—bought, sold, consumed at will.
          At Z Exchange a <em>Commodity X</em> is still a physical object, but it cannot be consumed until the trader earns collective approval.
          Consumption becomes a social question: <em>What does it mean to need someone else's assent? What does your desire say about you—and who needs to hear it?</em>
          Using social validation to combat mindless consumption, every trade becomes a small ritual of interaction; every commodity, a shared reflection.
          Here validation is not just permission, it is participation. The true commodity is the relationship.
          <h3>Social-Redeem Process</h3>
          Commodity X is not exchanged directly. Instead, you initiate a redeem cycle that succeeds only if the community agrees.
          <strong>1. Select your Commodity X</strong><br>
          Pick the item in your portfolio that you wish to consume (redeem).
          <br><br>
          <strong>2. Invite Co-Redeems</strong><br>
          Choose one to three commodities owned by other traders and invite their holders to redeem at the same time. Your consumption is now tied to theirs.
          <br><br>
          <strong>3. Send the Redeem Ask</strong><br>
          Press "Send Redeem Ask". All invited traders have <strong>10 seconds</strong> to accept or decline. During that window every selected item is locked.
          <br><br>
          <strong>4. Outcomes</strong><br>
          • <strong>Collective&nbsp;Yes</strong> – every invitee accepts. Your item turns into a QR code, leaves the market, and can be physically collected. You also receive a random bonus commodity from the Zederal Reserve.
          • <strong>Any&nbsp;No</strong> – at least one invitee declines. No one redeems; all items unlock and stay tradable. Nothing changes hands.
          <br><br>
          <h3>Conceptual Insight</h3>
          By linking individual consumption to shared approval, Commodity X critiques the culture of solitary, friction-free buying.
          It asks traders to consume consciously, to weigh desire against communal resonance, and to recognise that value emerges in relationship—not isolation.
          Redeem relationally. Consume consciously.
        `,
        "market_instructions": `
          <h3>Marketplace Overview</h3>
          ZExchange is the ZEconomy Marketplace. It can be considered the dynamic heart of trading activities where traders can explore, bid on, bet against, and trade various assets. The Marketplace is ground zero for traders to engage in strategic decision-making and actively shape their trading portfolios.
          <br><br>
          <h3>Marketplace Activities</h3>
          The ZExchange Marketplace offers the following key activities:
          <br><br>
          <strong>1. Explore Available Assets:</strong><br>
          Use the Marketplace to scroll through the current available assets. These include stocks, commodities, and bonds. Each asset is accompanied by detailed descriptions and close to real-time market valuation, allowing you to make informed decisions before initiating trades or placing bids. You can also place short bets on individual stocks and see who has shorted what.
          <br><br>
          <strong>2. Initiate Trade Offers:</strong><br>
          Send direct commodity trade offers to other traders. Select assets from your portfolio and propose an exchange. Trade offers are valid for 10 seconds, during which the receiving trader can either accept or decline the offer. If no action is taken within the time frame, the offer is automatically declined. Fees are applicable to both parties.
          <br><br>
          <strong>3. Place Bids:</strong><br>
          Bid on stocks and bonds listed in the Marketplace through the bidding process. Bidding provides an opportunity to secure assets at a potentially lower cost while competing with other traders. Keep an eye on bid expiration times to stay ahead in the market.
          <br><br>
          <strong>4. Redeem Commodities:</strong><br>
          Commodities (physical assets) in the Marketplace can be redeemed through the redeem process. Select between two and up to 10 of these assets by checking a commodity redeem box. After the second selection, the redeem button will appear, and you can proceed to finish the redeem.
          <br><br>
          <strong>5. Place Short Positions:</strong><br>
          Engage in negative side trading by shorting certain assets. This allows you to profit from anticipated declines in value. Placing short bets requires careful timing and risk management, making it a powerful tool for augmenting your positive or negative earnings. You can close the short position on your holdings page.
          <br><br>
          <h3>Trading Mechanics</h3>
          <strong>1. Transaction Fees:</strong><br>
          Each transaction costs a fee depending on the type of transaction. This encourages thoughtful trades and strategic exchanges.
          <br><br>
          <strong>2. Bid Expiration:</strong><br>
          All bids are active for a limited duration. If the target trader does not respond to your bid within the specified time, the bid expires without a transaction. Possible penalties can be applied if the target trader does not respond.
          <br><br>
          <strong>3. Offer Penalties:</strong><br>
          Declined trade offers result in an earnings penalty for the trader who refuses the exchange. This incentivizes careful consideration of offers and fosters a market of intentional interactions. However, they will cost you a fee if the offer is accepted.
          <br><br>
          <h3>What is a Financial Exchange?</h3>
          At its core, a financial exchange is a structured platform where participants buy and sell assets such as stocks, bonds, and commodities. It operates as a hub for economic activity, enabling traders to assess the value of goods and execute transactions based on supply, demand, and personal strategy.
          <br><br>
          The ZExchange, the ZEconomy Marketplace, looks at the value of assets differently than traditional financial exchanges because the values are placed on human experiences, relationships, and social exchange. Less is not necessarily better than more. Instead of focusing solely on monetary gain, the ZExchange encourages participants to consider different ideas of value: the worth of collaboration, the ethics of competition, and the value of shared experiences. It applies finance and basic economics to shared common real-life experiences all humans face, placing the value on life itself.
          <br><br>
          This approach redefines the purpose of a financial exchange, transforming it into a reflective and socially participatory system. Traders are challenged to think beyond material accumulation and instead prioritize:
          <br><br>
          <strong>Relational Dynamics:</strong> Exploring how personal and collective interactions can impact market and social decisions.<br>
          <strong>Ethical Trading:</strong> Evaluating whether their strategies align with their moral beliefs about fairness, responsibility, and shared growth.<br>
          <strong>Experiential Value:</strong> Placing importance on how trades reflect and shape human experiences, how we can find and emphasize economic value in common living experiences, whether through collaboration, conflict, or mutual support.
          <br><br>
          By participating in the ZExchange, traders engage in a financial experiment that elevates the human aspects of economics. It is a system designed to challenge conventional assumptions about value, encouraging a more nuanced understanding of wealth as something that is both deeply personal and inherently collective.
        `,
        'emotional-debt-banner': `
          <h3>Emotional Debt Index</h3>
          <strong>Human Emotional Flux</strong>
          <br><br>
          Finding value in vulnerability through emotional debt. In this economy, value is not extracted—it is felt. Every gesture—help, trust, abandonment, envy—leaves a trace, a measurable emotional gain or loss, a continuity. Life profit is a currency of sensation, taking the temperature of our being. Holding someone, letting yourself be held: the most human forms of leverage. The ZEconomy flows through us.
          <br><br>
          <strong>1. Altrau Z Bill</strong><br>
          <em>Altruistic life value. Empathy.</em><br>
          Giving without promise of return. Helping someone means involving yourself in the trajectory of their Life Profit. The rise and fall of their emotional balance pulls your own life profits toward positive or negative. Silent speculation on the idea that another's well-being could expand your own capacity to feel, to extend your empathy faculty. No return demanded.
          <br><br>
          <em>(Mirror code: a transaction that binds both ledgers; an increase in shared variance rather than a simple sum.)</em>
          <br><br>
          <strong>2. M Note (Mutual Note)</strong><br>
          <em>A loan written as confession.</em><br>
          The M Note creates credit from exposed need and calculated trust. Value born from the human empathy of sharing human imperfections. The borrower reveals a weakness; the lender accepts the risk, extending empathy as a form of investment. What begins as recognition becomes obligation—vulnerability converted into Z Relational Collateral, interest growing in attention, recognition, and mutual Life Profit.
          <br><br>
          <em>(Mirror code: emotionally weighted interest; time dilates according to mood.)</em>
          <br><br>
          <strong>3. Z-Payday CDO (Collateralized Desire Obligation)</strong><br>
          <em>Exploitation disguised as empathetic human connection.</em><br>
          Empathy and relief are reformulated into instruments of toxic dependency. Z-Payday loans feed on need and greed, transforming vulnerability into yield at the expense of human value and systemic balance. Each loan cycle elevates the lender, exhausts the borrower, and leaves the market to absorb the contagion.
          <br><br>
          <strong>Function:</strong> Isolated acts of help become a repetitive contract—each minute issues a new obligation, each obligation is fragmented into tranches feeding a larger CDO. The product promises immediacy, then converts the living into yield; the harvest comes from what erodes when benevolence becomes structural. The Z-Payday CDO does not forgive. It amplifies exposure until the ledger devours the underlying life profit.
          <br><br>
          <strong>4. V Note (Vulnerability Note)</strong><br>
          <em>Admitting vulnerability.</em><br>
          To ask is to expose oneself—to risk the small collapse that accompanies being seen in need. Vulnerability is not weakness here, but invitation: a signal that balance has broken and requires a relationship to restore itself. Help, if granted, becomes a shared moment of recalibration; if refused, it marks the silent fracture between trust and pride. Each request is inscribed in the Emotional Debt Index, measuring not possession, but the degree to which we still dare to depend.
          <br><br>
          <em>(Mirror code: justified request; relief triggered by assent; the ledger records both call and response.)</em>
          <br><br>
          <strong>Closing Tone</strong><br>
          What circulates here is not finance, but recognition. Vulnerability becomes both mirror and market, where each profit is the echo of another's risk, and each debt, a memory that refuses to fade.
          <br><br>
          <h3>Emotional Debt Index</h3>
          It all begins with the recognition that accumulated life has weight—that the simple fact of living with others engenders emotional debt, positive or negative, acknowledged or neglected, that we carry alone and exchange together. Debt not as deficit, but as acceptance: an instrument of the effects of our mutual entanglement. In the ZEconomy, Emotional Debt is the counterpoint to productivity—it does not track what is produced, but what is felt. Every gesture, every hesitation, every confession or withdrawal modifies the emotional ledger. Its movements translate the circulation of affect through a living, porous system, where value is neither extracted nor manufactured, but engendered by the very experience of life. Life Profits, flows that resist accumulation, yet shape everything built upon them.
          <br><br>
          The Emotional Debt Index makes intimate vulnerability visible, mapping the invisible economies of trust, exhaustion, generosity, failure, dependency... that participate in collective instability or balance. Rejecting the fantasy of capital, embracing the liquidity of human sentiment.
        `,
      },
      "common": {
        "close": "Close",
        "assign": "Assign",
        "unassign": "Unassign",
        "delete": "Delete",
        "redeem": "Redeem",
        "unredeem": "Unredeem",
        "yes": "Yes",
        "no": "No",
        "assigned_to": "assigned to",
        "to_market": "to market",
        "to_portfolio": "to portfolio",
        "successfully": "successfully",
        "login_required": "You must be logged in to perform this action.",
        "bond_with_interest_rate": "bond with interest rate",
        "assign_to_portfolio": "Assign to Portfolio",
        "assign_to_market": "Assign to Market",
        "item_name": "Item Name:",
        "owner": "Owner:",
        "trader_name": "Trader Name:",
        "password": "Password:",
        "connected": "Connected:",
        "portfolio_id": "Portfolio ID:",
        "points_breakdown": "Capital Breakdown:",
        "trading": "Trading",
        "commodities": "Commodities", 
        "stocks": "Stocks",
        "shorts": "Shorts",
        "total": "Total:",
        "holdings": "Holdings:",
        "commodity": "Commodity:",
        "stock": "Stock:",
        "quantity": "Quantity",
        "shares": "Shares",
        "value": "Value",
        "no_holdings": "No holdings in this portfolio.",
        "unnamed_portfolio": "Unnamed Portfolio",
        "protected": "[protected]",
        "qr_code": "QR Code:",
        "qr_code_for": "QR Code for",
        "no_qr_available": "No QR code available.",
        "custom_relationship_type": "Custom relationship type",
        "remove": "Remove",
        "created_for_relationship": "Zollar created for relationship:",
        "value_place_relationship": "The value you place on a relationship:",
        "na": "N/A"
      },
      "socketFront": {
        "warningPrefix": "WARNING:",
        "criticalPrefix": "CRITICAL:",
        "debtPageVisit": "Visit the Debt page for details.",
        "debtWipeoutDefault": "Your portfolio has been wiped out due to excessive debt.",
        "debtWarningPrefix": "WARNING: This debt reloads every 60 seconds at 15% compound until repayment.",
        "bankruptcyWarning": "WARNING: You are approaching bankruptcy!",
        "debtCompounded": "Debt compounded:",
        "totalDebt": "Total debt:",
        "youOwe": "You owe:",
        "checkDebtHeldSection": "Check your Debt Held section to convert."
      },
      "debtWarning": {
        "title": "Debt Warning",
        "aboutToGoIntoDebt": "You are about to go into debt!",
        "currentBalance": "Current Balance:",
        "bidAmount": "Bid Amount:",
        "offerAmount": "Offer Amount:",
        "youWillOwe": "You will owe:",
        "interestAccrues": "Interest accrues at 5% daily on negative balances.",
        "creditLimit": "Credit limit: -1000 capital (default)",
        "proceedAnyway": "Proceed Anyway",
        "cancel": "Cancel",
        "points": "Capital"
      },
      "debt": {
        "capital": "capital",
        "closedDefault": "A {type} debt instrument has been closed.",
        "closedGeneric": "A debt instrument has been closed.",
        "amounts": {
          "none": "None",
          "barelyAny": "Barely Any",
          "aTrace": "A Trace",
          "aHint": "A Hint",
          "aLittle": "A Little",
          "aFew": "A Few",
          "some": "Some",
          "several": "Several",
          "moderate": "Moderate",
          "noticeable": "Noticeable",
          "considerable": "Considerable",
          "many": "Many",
          "aLot": "A Lot",
          "abundant": "Abundant",
          "heaps": "Heaps",
          "aGreatDeal": "A Great Deal",
          "substantial": "Substantial",
          "immense": "Immense"
        },
        "interest": {
          "minimal": "Minimal Emotional Interest",
          "light": "Light Emotional Interest",
          "modest": "Modest Emotional Interest",
          "fair": "Fair Emotional Interest",
          "moderate": "Moderate Emotional Interest",
          "notable": "Notable Emotional Interest",
          "considerable": "Considerable Emotional Interest",
          "heavy": "Heavy Emotional Interest",
          "intense": "Intense Emotional Interest",
          "crushing": "Crushing Emotional Interest"
        },
        "altrau": {
          "receivedTitle": "Z Bill Altrau Received",
          "issuedTitle": "Z Bill Altrau Issued",
          "hasGivenYou": "has given you",
          "ledgersBound": "Your ledgers are now bound. Their Life Profit affects yours.",
          "youHaveSent": "You have sent",
          "toRecipient": "to",
          "fatesBound": "Your fates are now bound. Your Life Profit affects theirs."
        },
        "mnote": {
          "acceptedTitle": "M Note Accepted",
          "createdTitle": "M Note Created",
          "witnessedVulnerability": "has witnessed your vulnerability",
          "loanLabel": "Loan",
          "atRate": "at",
          "positiveTradeTip": "Make positive trades to automatically reduce this debt!",
          "createdWith": "M Note created with",
          "tradeableAfter": "Tradeable after 5 exchanges. Convertible after max trades.",
          "progressTitle": "M Note Repayment Progress",
          "repaidPercent": "You've repaid",
          "throughTrading": "through positive trading",
          "keepTrading": "Keep trading well to continue reducing your debt.",
          "debtClearedTitle": "Debt Cleared!",
          "repaidTitle": "M Note Repaid",
          "positiveTrading": "positive trading",
          "directRepayment": "direct repayment",
          "fullyRepaidTo": "You've fully repaid your M Note to",
          "throughMethod": "through",
          "emotionalDebtCleared": "Your emotional debt is cleared. Well done!",
          "hasFullyRepaid": "has fully repaid their M Note",
          "instrumentClosed": "The debt instrument has been closed.",
          "alertTitle": "M Note Alert",
          "convertibleTitle": "M Note Convertible",
          "nowConvertible": "Your M Note is now",
          "convertibleCaps": "CONVERTIBLE",
          "canConvertTo": "You can convert it to",
          "inLiquidAssets": "in liquid assets"
        },
        "cdo": {
          "acceptedTitle": "Z-Payday CDO Accepted",
          "createdTitle": "Z-Payday CDO Created",
          "offeredLoan": "has offered you a loan",
          "availableImmediately": "available immediately",
          "createdWith": "Z-Payday CDO created with",
          "tradeableCompounds": "Tradeable. Compounds every 60s at 15%.",
          "bankruptcyWarningTitle": "BANKRUPTCY WARNING",
          "reloadCycle": "CDO Reload: Cycle {cycle}",
          "cdoCompounded": "Your CDO compounded",
          "victimOwes": "Victim owes",
          "bankruptcyTitle": "BANKRUPTCY",
          "cdoCollapsed": "Your Z-Payday CDO collapsed",
          "totalDebtLabel": "Total debt",
          "assetsSeized": "Assets seized",
          "standingDamaged": "Your financial standing has been severely damaged.",
          "maturedTitle": "CDO Matured",
          "victimBankrupt": "Your victim declared bankruptcy",
          "youSeized": "You seized",
          "toxicGainRecorded": "Toxic relationship gain recorded."
        },
        "vnote": {
          "aidGrantedTitle": "V Note Aid Granted",
          "hasGrantedAid": "has granted you aid",
          "received": "Received",
          "vulnerabilityWitnessed": "Your vulnerability was witnessed and met with compassion.",
          "youGranted": "You granted",
          "toRecipient": "to",
          "compassionRecorded": "Your compassion has been recorded in the social ledger."
        }
      },
      "freeend": {
        "title": "Trading Session Complete",
        "trading_analysis": "TRADING ANALYSIS",
        "social_standing": "Social Standing",
        "return_home": "Return Home",
        "panels": {
          "stocks": "STOCKS",
          "items": "ITEMS",
          "zollars": "ZOLLARS",
          "bonds": "BONDS"
        },
        "judgements": {
          "performance": "Performance",
          "style": "Style",
          "social": "Social",
          "risk": "Risk",
          "mood": "Mood"
        },
        "ratings": {
          "excellent": "Excellent",
          "good": "Good",
          "fair": "Fair",
          "poor": "Poor",
          "bad": "Bad",
          "neutral": "Neutral",
          "aggressive": "Aggressive",
          "calm": "Calm",
          "balanced": "Balanced",
          "active": "Active",
          "quiet": "Quiet",
          "moderate": "Moderate",
          "diverse": "Diverse",
          "cautious": "Cautious",
          "focused": "Focused",
          "euphoric": "Euphoric",
          "optimistic": "Optimistic",
          "positive": "Positive",
          "anxious": "Anxious",
          "distressed": "Distressed"
        },
        "sections": {
          "social_class_movement": "YOUR SOCIAL CLASS MOVEMENT",
          "mood_state": "MOOD STATE",
          "trading_behavior": "TRADING BEHAVIOR PATTERNS",
          "commodities_supply": "COMMODITIES SUPPLY"
        },
        "labels": {
          "commodities": "Commodities:",
          "no_commodities": "No commodity holdings - focus was on other value forms",
          "stocks": "Stocks",
          "items": "Items",
          "zollars": "Zollars",
          "bonds": "Bonds",
          "zollar_holdings": "Relational Zollar Holdings:",
          "total": "Total:",
          "session_engagement": "Session Engagement:",
          "social_connections": "Social Connections:",
          "value_movement": "Value Movement:",
          "started_with": "Started With",
          "ended_with": "Ended With",
          "life_movement": "Life Movement",
          "your_holdings": "Your Holdings",
          "rhythm": "Rhythm",
          "value_shift": "Value Shift",
          "cadence": "Cadence",
          "diversity": "Diversity",
          "intensity": "Intensity"
        },
        "value_movement": {
          "significant_gain": "Significant Gain",
          "strong_gain": "Strong Gain",
          "moderate_gain": "Moderate Gain",
          "slight_gain": "Slight Gain",
          "no_change": "No Change",
          "slight_loss": "Slight Loss",
          "moderate_loss": "Moderate Loss",
          "strong_loss": "Strong Loss",
          "significant_loss": "Significant Loss"
        },
        "activity_levels": {
          "contemplative": "Contemplative",
          "measured": "Measured",
          "active": "Active",
          "very_active": "Very Active",
          "intensely_engaged": "Intensely Engaged"
        },
        "social_levels": {
          "solitary": "Solitary",
          "selective": "Selective",
          "socially_active": "Socially Active",
          "highly_connected": "Highly Connected"
        },
        "emotional_states": {
          "balanced": "Balanced",
          "triumphant": "Triumphant",
          "reflective": "Reflective",
          "socially_engaged": "Socially Engaged",
          "energetically_active": "Energetically Active"
        },
        "quantities": {
          "none": "None",
          "barely_any": "Barely Any",
          "a_trace": "A Trace",
          "a_hint": "A Hint",
          "a_little": "A Little",
          "a_few": "A Few",
          "some": "Some",
          "several": "Several",
          "moderate": "Moderate",
          "noticeable": "Noticeable",
          "considerable": "Considerable",
          "many": "Many",
          "a_lot": "A Lot",
          "abundant": "Abundant",
          "heaps": "Heaps",
          "a_great_deal": "A Great Deal",
          "substantial": "Substantial",
          "ample": "Ample",
          "extensive": "Extensive",
          "vast": "Vast",
          "profuse": "Profuse",
          "almost_all": "Almost All",
          "nearly_everything": "Nearly Everything",
          "overflowing": "Overflowing",
          "virtually_everything": "Virtually Everything",
          "all_you_have": "All You Have"
        },
        "value": {
          "none": "Nothing",
          "barely_any": "Barely Anything",
          "a_trace": "A Trace of Value",
          "a_little": "A Little",
          "some": "Some Holdings",
          "modest": "Modest",
          "moderate": "Moderate",
          "comfortable": "Comfortable",
          "considerable": "Considerable",
          "substantial": "Substantial",
          "abundant": "Abundant",
          "prosperous": "Prosperous",
          "wealthy": "Wealthy",
          "very_wealthy": "Very Wealthy",
          "extremely_wealthy": "Extremely Wealthy",
          "vast_wealth": "Vast Wealth"
        },
        "change": {
          "unchanged": "Unchanged",
          "slight_loss": "A Slight Loss",
          "small_loss": "A Small Loss",
          "moderate_loss": "A Moderate Loss",
          "considerable_loss": "A Considerable Loss",
          "substantial_loss": "A Substantial Loss",
          "large_loss": "A Large Loss",
          "severe_loss": "A Severe Loss",
          "slight_gain": "A Slight Gain",
          "small_gain": "A Small Gain",
          "moderate_gain": "A Moderate Gain",
          "considerable_gain": "A Considerable Gain",
          "substantial_gain": "A Substantial Gain",
          "large_gain": "A Large Gain",
          "exceptional_gain": "An Exceptional Gain"
        },
        "pace": {
          "still": "Still",
          "contemplative": "Contemplative",
          "measured": "Measured",
          "steady": "Steady",
          "active": "Active",
          "brisk": "Brisk",
          "vigorous": "Vigorous",
          "intense": "Intense",
          "frenetic": "Frenetic"
        },
        "diversity": {
          "none": "None",
          "singular": "Singular Focus",
          "focused": "Focused",
          "balanced": "Balanced",
          "broad": "Broadly Diversified"
        },
        "intensity": {
          "quiet": "Quiet",
          "calm": "Calm",
          "moderate": "Moderate",
          "engaged": "Engaged",
          "active": "Active",
          "intense": "Intense",
          "highly_intense": "Highly Intense",
          "overwhelming": "Overwhelming"
        }
      },
      "tax": {
        "tax_alert_timer": "TAX ALERT! You have 10 seconds to choose or lose both:",
        "lose_capital_zollars": "Lose capital & Zollars",
        "give_random_asset": "Give random asset",
        "assign_failed": "Failed to assign new item to all portfolios.",
        "new_asset_assigned": "Zederal Reserve has assigned a new asset to your portfolio.",
        "tax_call_no_assets": "Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.",
        "asset_taxed": "You have been taxed an asset by the Zederal Reserve.",
        "no_items_available": "No non-traded items available for taxation.",
        "tax_item_failed": "Failed to tax an item.",
        "capital_taxed_prefix": "You have been taxed capital by the Zederal Reserve!",
        "refund_received_prefix": "You have received a refund of capital from the Zederal Reserve",
        "new_asset_received": "You have received a new asset from the Zederal Reserve",
        "zollar_assigned": "You have received Zollars from the Zederal Reserve.",
        "points": "Capital"
      },
      "presentation": {
        "title": "ZExchange - Presentation",
        "hero_tagline": "What if value wasn't a number?",
        "intro_main": "A live trading floor experience for 10 to 200 participants, lasting 1 to 24 hours. But this isn't Wall Street. Here, the asset class is human experience itself.",
        "card_trade_title": "Trade Human Conditions",
        "card_trade_desc": "Instead of Apple or Nvidia, invest in Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Every stock represents a facet of being alive.",
        "card_spend_title": "Spend Relationships",
        "card_spend_desc": "Forget dollars. Here you pay with Zollars, currency denominated by relationship type: Love, Friendship, Hate, Erotic, Toxic, Death.",
        "card_consume_title": "Consume Collectively",
        "card_consume_desc": "Own a glass of wine? You can't acquire it alone. To redeem any commodity, you must ask others for approval. Consumption requires mutual consent.",
        "card_market_title": "The Market Watches Back",
        "card_market_desc": "An AI narrates every transaction, interpreting what your trades reveal about you. The market doesn't just move, it speaks.",
        "intro_transform": "ZExchange transforms economic logic into a collective conversation about what we actually value.",
        "intro_mirror": "It's part conceptual art, part party art, part mirror. Organizations discover their hidden values. Groups confront power, fairness, and trust. Everyone leaves with questions they didn't arrive with.",
        "section_video": "Video Explainers",
        "section_video_desc": "Click to watch concept explanations",
        "video_intro": "Introduction to ZExchange",
        "video_intro_desc": "Overview of the concept",
        "video_life": "Life Profits & Value",
        "video_life_desc": "Value in the ZEconomy",
        "video_stocks": "How Stocks Function",
        "video_stocks_desc": "Trading human conditions",
        "video_zbonds": "ZBonds & Zollars",
        "video_zbonds_desc": "Z Relationship Monetary System",
        "video_commodity": "Commodity X",
        "video_commodity_desc": "Social consumption",
        "video_interface": "Interface Preview",
        "video_interface_desc": "The trading interface",
        "video_bigboard": "Generative Big Boards",
        "video_bigboard_desc": "Real-time market expression",
        "section_assets": "Trading Assets",
        "section_assets_desc": "Click banners for detailed explanations",
        "label_stocks": "STOCKS - Human Conditions as Shares",
        "label_zbonds": "ZBONDS - Relationship-Based Investments",
        "label_commodities": "COMMODITIES - Physical Items with Social Approval",
        "label_zollars": "ZOLLARS - Currency Without Numbers",
        "section_economic": "Economic Tools",
        "section_economic_desc": "Ideological approaches to wealth and power",
        "label_economic": "ECONOMIC TRIGGERS - Ideology as Market Action",
        "label_communist": "Communist Assault",
        "label_socialist": "Socialist Subsidy",
        "label_lbo": "Capitalist LBO",
        "section_trader": "Trader Tools",
        "section_trader_desc": "How far will you go in the quest for value?",
        "label_trader": "TRADER TOOLS - Actions With or Against Others",
        "label_steal": "Steal",
        "label_ransom": "Ransom",
        "label_darkpool": "Dark Pool",
        "section_features": "Market Features",
        "label_emotional": "EMOTIONAL DEBT INDEX - Human Emotion Flux",
        "label_bigboard": "THE BIG BOARD - Real-Time Market Visualization",
        "label_voice": "VOICE OF THE BOURSE - AI Market Narration",
        "section_central": "Zederal Reserve / ZExchange Regulator",
        "section_central_desc": "How the ZExchange operator controls market sessions",
        "central_intro": "The Zederal Reserve (or ZExchange Operator) orchestrates the entire trading session. Before the market opens, it is the interfaces where you can configure the economy: creating trader portfolios with initial capital and commodities available during the session, distribute stock from over 350 predefined ZEconomy companies, and mint relationship-based Zollars and ZBonds. During the session, you act as regulator and central authority: opening and closing the market, controlling which assets can be traded, taxing portfolios to extract value, subsidizing traders with capital or commodities, issuing special triggers (Steal, Ransom, Dark Pool, Communist Assault, Socialist Subsidy, Capitalist LBO), broadcasting media events, and deploying market bots for liquidity. You can shape the session's narrative through story themes that guide the AI's interpretation of market activity. The Zederal Reserve acts as a Central Bank embodying the tension between control and chaos in any economy, you can foster balance or create disruption, reward or punish, stimulate or restrict. Every decision ripples through the market, challenging traders to adapt and respond.",
        "label_control": "MARKET CONTROL - Open/Close & Asset Listing",
        "section_tax": "Tax Portfolios Holdings",
        "section_tax_desc": "Extract value from trader portfolios",
        "label_taxall": "Tax All Traders",
        "label_taxitem": "Tax Commodity",
        "label_taxpoints": "Tax Capital",
        "section_subsidize": "Subsidize Portfolios Holdings",
        "section_subsidize_desc": "Inject value into trader portfolios",
        "label_givezollar": "Give Zollar Subvention",
        "label_givepoints": "Give Capital Subvention",
        "label_giveitem": "Give Commodity",
        "label_freebie": "Commodity Distribution",
        "section_events": "Event Triggers",
        "section_events_desc": "Broadcast media and create narratives",
        "label_publizity": "Play PubliZity",
        "label_znews": "Play ZNews",
        "label_story": "Create Story",
        "section_bots": "Market Bots",
        "section_bots_desc": "Automated trading for market liquidity",
        "label_addbots": "Add Bots",
        "label_removebots": "Remove Bots",
        "label_botstatus": "Bot Status",
        "section_keep": "What Participants Keep",
        "keep_bigboard": "A Big Board shaped by every trade, frozen as generative artwork",
        "keep_story": "An AI-written story of your group's dynamics",
        "keep_award": "Perhaps an award or two",
        "keep_mirror": "A mirror reflecting what your organization actually values",
        "section_concepts": "Key Concepts",
        "concept_life_title": "Life Profit",
        "concept_life_desc": "Value of consciously lived life: joy, loss, love, depression. Quality over quantity.",
        "concept_auto_title": "No Autopilot",
        "concept_auto_desc": "Every transaction requires presence. To trade, engage another. To redeem, you must ask.",
        "concept_market_title": "The Market Talks Back",
        "concept_market_desc": "AI watches every transaction, offering interpretations and narration.",
        "concept_shared_title": "Shared Values",
        "concept_shared_desc": "Opposite political spectrums, same human experiences.",
        "footer_mirror": "ZExchange isn't just a market; it's a mirror.",
        "footer_transform": "It turns the cold logic of economics into a collective conversation about what we actually value.",
        "footer_part": "Part of",
        "popup_stocks": "<h3>Shares (Stocks)</h3><strong>Description:</strong><br>Monitor and trade your stock positions.<br><br><strong>What They Are:</strong><br>In conventional finance, a stock represents partial ownership of a company. Investors typically buy stocks hoping the company's value will rise.<br><br>In ZEconomy, each \"company\" reflects personal or human values—such as emotional well-being, social relationships, or daily life activities—rather than traditional products or services. By \"investing\" in these companies, you're effectively betting on the value of growth, transformation, or sustainability of human experiences.<br><br><strong>Conceptual Insight:</strong><br>This challenges the notion of profit: is it about reaping monetary rewards, or about supporting the expansion of \"life value\" such as emotional health, creativity, or shared experiences?<br><br>Think of your stocks as investments in human value: happiness, depression, success, failure, confusion—instead of a company producing a product or service.<br><br><strong>Mechanics:</strong><br>Stocks are tradable for Zollars or points. As a company's value grows, so does the value of your portfolio.",
        "popup_zbonds": "<h3>ZBonds</h3><strong>Description:</strong><br>ZBonds function like traditional bonds: you purchase them using points, hold them over a predetermined term, and when they expire, you receive Zollars.<br><br><strong>Conceptual Insight:</strong><br>While typical bonds fund governments or corporations, ZBonds fund the creation of a currency (Zollars) whose entire value is tied to human relationships and experiences.<br><br>By investing in a ZBond, you are effectively choosing to place trust in the shared values of community and interpersonal connections over purely financial returns.<br><br>ZBonds bridge the gap between traditional \"fixed income securities\" and the ZEconomy's redefinition of \"value.\"",
        "popup_commodities": "<h3>Commodities (Commodity X)</h3><strong>Description:</strong><br>The redeemable physical items you own.<br><br><strong>Social Validation:</strong><br>No commodity can be consumed alone. To redeem one, traders must ask other traders for approval. If all agree, the item is released; if anyone declines, nothing happens.<br><br><strong>Conceptual Insight:</strong><br>What does it mean to need permission for what you already own? Social validation inserts friction where markets remove it, making consumption visible, questioned, collective.<br><br>Commodities remind us that markets are also about goods and experiences that shape our lives.",
        "popup_zollars": "<h3>Zollars</h3><strong>Description:</strong><br>Check your Zollar balances and transactions.<br><br><strong>Currency Without Numbers:</strong><br>Zollars are denominated by relationship type: Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Using Zollars pushes participants to consider <em>what kind</em> of value is at stake, not <em>how much</em>.<br><br><strong>Conceptual Insight:</strong><br>Acquiring Zo Insomnia Incorporated with Love Zollars tells a different story than acquiring it with Toxic Zollars. The interpretation is personal; the framework, shared.<br><br>Zollars challenge traditional ideas of currency by basing value on human relationships.",
        "popup_economic": "<h3>Economic Attack Triggers</h3><strong>Description:</strong><br>Economic Attack Triggers represent different ideological approaches to wealth, power, and market dynamics. They allow traders to use strategies inspired by economic systems—communism, socialism, capitalism—to gain or redistribute advantages within the ZEconomy.<br><br><strong>Conceptual Insight:</strong><br>The triggers challenge participants to confront their beliefs about fairness, ambition, and collective responsibility. They spark debate about the balance between fairness, ambition, and ethical trade-offs.<br><br><ul><li>Should wealth be shared equally, even if it means confiscating someone else's success?</li><li>Is it ethical to profit at the expense of another's autonomy?</li><li>How far are you willing to go to achieve personal gain or support collective welfare?</li></ul>",
        "popup_communist": "<h3>Communist Assault Trigger</h3><strong>Description:</strong><br>Seize and redistribute all of a targeted portfolio's wealth to the collective.<br><br><strong>Functionality:</strong><br>The target's wealth (points, stocks, commodities) is evenly distributed among active participants. No single trader grows significantly richer, ensuring a sense of communal benefit.<br><br><strong>Conceptual Insight:</strong><br>This action symbolizes extreme redistribution, testing the fairness of confiscating wealth for the common good. While it aims to level disparities, it raises ethical questions about property rights and the morality of forced redistribution.<br><br><em>Should wealth be shared equally, even if it means confiscating someone else's success?</em>",
        "popup_socialist": "<h3>Socialist Subsidy Trigger</h3><strong>Description:</strong><br>Tax a wealthy portfolio and redistribute the resources to less affluent traders.<br><br><strong>Functionality:</strong><br>50% of the target portfolio's wealth is taxed and redistributed proportionally to traders with smaller holdings, aiming to balance the market.<br><br><strong>Conceptual Insight:</strong><br>\"Socialist Subsidy\" reflects the tension between supporting collective welfare and discouraging ambition. By redistributing wealth, it highlights the challenges of addressing inequality without stifling innovation or growth.<br><br><em>How do we balance equity with individual achievement?</em>",
        "popup_lbo": "<h3>Capitalist Leveraged Buyout (LBO)</h3><strong>Description:</strong><br>Aggressively acquire another portfolio's assets through a leveraged buyout.<br><br><strong>Functionality:</strong><br>The acquiring trader gains full control of the target's portfolio at severe cost to them. The transaction is coercive yet compensatory—the target receives payment, and the initiator pays an inflated price.<br><br><strong>Conceptual Insight:</strong><br>\"Capitalist LBO\" represents the power of wealth in overriding autonomy, highlighting the dynamics of aggressive capitalism. This function challenges the balance between fair competition and exploitation.<br><br><em>Is it ethical to profit at the expense of another's autonomy?</em>",
        "popup_tools": "<h3>Trader Tools</h3><strong>Description:</strong><br>Utilities for performing market-related actions with or against other traders.<br><br><strong>Conceptual Insight:</strong><br>Whether you steal, ransom, or deal in private: each trigger tests how far you'll go in the quest for value. Will you explore new strategies without losing your sense of responsibility—or will you push boundaries at the expense of others?<br><br>The ZEconomy raises these questions, leaving you to decide what \"value\" really means and what you're willing to do to get it.",
        "popup_steal": "<h3>Steal Item</h3><strong>Description:</strong><br>Take assets from another portfolio anonymously, without permission.<br><br><strong>Functionality:</strong><br>The selected item is transferred from the target's portfolio to your portfolio without consent. The action remains anonymous, preventing immediate retaliation.<br><br><strong>Conceptual Insight:</strong><br>Stealing tests ethical boundaries, exploring whether traders prioritize personal gain over empathy and collective trust. It challenges participants to reflect on the consequences of their actions and how they value fairness within the ZEconomy.",
        "popup_ransom": "<h3>Ransom Portfolio</h3><strong>Description:</strong><br>Lock another trader's portfolio and demand a ransom to unlock it.<br><br><strong>Functionality:</strong><br>Locks the target's portfolio, rendering it unusable until the ransom is resolved. The trader initiating the ransom gains points if paid. The initiator's identity is revealed to the victim, adding social consequence.<br><br><strong>Conceptual Insight:</strong><br>Ransoming explores power dynamics and coercion in trading. It forces traders to evaluate whether financial gain outweighs potential social backlash or ethical concerns.",
        "popup_darkpool": "<h3>Dark Pool</h3><strong>Description:</strong><br>Establish a private trading group hidden from the public market.<br><br><strong>Functionality:</strong><br>Creates a private, temporary trading space exclusive to selected participants. Trades within the Dark Pool are hidden from the broader market, allowing participants to set their own prices and terms.<br><br><strong>Conceptual Insight:</strong><br>Dark Pools represent a tension between collaboration and manipulation. They offer the opportunity to negotiate deals without public scrutiny, but challenge the fairness and transparency of the market.",
        "popup_emotional": "<h3>Emotional Debt Index</h3><strong>Human emotion flux</strong><br><br><strong>Acknowledging the value of vulnerability through emotional debt.</strong><br><br>ZEconomy value is not extracted but felt. Every gesture—help, trust, abandonment, envy—leaves a trace: measurable emotional debt both positive and negative. We carry debt with us like it or not.<br><br>To hold another, to let oneself be held: the most human forms of leverage. The ZEconomy moves through us.<br><br><strong>Relational Index</strong> — The measure of relational integrity, rises with honor and help towards others, falls with exploitation and betrayal.<br><br><strong>Existential Balance</strong> — The measure of your actions towards others' life profits. Are you causing or relieving others' symbolic burdens?<br><br><em>Reject the fantasy of capital, embrace the liquidity of human feeling.</em>",
        "popup_bigboard": "<h3>The Big Board</h3><strong>Real-Time Market Visualization</strong><br><br>The Big Board visualizes activity in real time, accumulating moods and actions, changing color as the session unfolds.<br><br>Not fictive numbers like the S&P 500, but <em>felt presence made visible</em>.<br><br><strong>What You Keep:</strong><br>At the end of the session, the Big Board becomes a generative artwork—a frozen snapshot of every trade, every emotion, every collective moment. A portrait of your organization rendered through economic behavior.",
        "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>The Market Talks Back</strong><br><br>An AI system watches every transaction and becomes the voice of the market itself. It does not calculate profit or loss; it <em>interprets</em>.<br><br>Responding to questions such as: <em>Why did you trade that? What does this suggest?</em><br><br>The market has opinions about exchanges happening within it while remaining agnostic about value itself.<br><br>Over the event, a story emerges: a collective portrait rendered through economic behavior. An AI-written narrative of your group's dynamics.",
        "popup_centralbank": "<h3>Market Control</h3><strong>Description:</strong><br>Open and close the market, and configure which asset types traders can see and trade.<br><br><strong>How-to:</strong><br>Select the asset types (stocks, bonds, commodities) you want to enable or disable via the dropdown menu, then click to apply changes.<br><br><strong>Conceptual Insight:</strong><br>Ring the bell and trade. The exchange operator controls when the market is active and what types of value participants can focus on. This power shapes the entire trading session's dynamics.",
        "popup_taxall": "<h3>Tax All Traders</h3><strong>Description:</strong><br>Trigger a tax event that affects all active traders. They will have a choice between paying with capital or commodities; no response taxes both.<br><br><strong>How-to:</strong><br>Specify the tax amount (capital and Zollars) and confirm the action.<br><br><strong>Conceptual Insight:</strong><br>This introduces macroeconomic consequences by establishing taxation policies. It can foster balance but also incite frustration, testing traders' adaptability to systemic changes.",
        "popup_taxitem": "<h3>Tax Commodity</h3><strong>Description:</strong><br>Remove a random commodity from selected traders' portfolios.<br><br><strong>How-to:</strong><br>Choose the traders from the active trader list, then confirm the action.<br><br><strong>Conceptual Insight:</strong><br>Targeted taxation creates the ability of the bank to rebalance or unbalance the market, forcing traders to pivot their strategies. It serves as asset seizures do in financial systems and raises ethical questions about selective enforcement.",
        "popup_taxpoints": "<h3>Tax Capital</h3><strong>Description:</strong><br>Tax numerical earnings from selected traders.<br><br><strong>How-to:</strong><br>Enter the tax amount to deduct, select the traders from the active trader list, and confirm.<br><br><strong>Conceptual Insight:</strong><br>A tool for discipline or balance, this selected tax action can level the playing field or serve as punishment. It challenges traders' resilience while questioning the fairness of selective taxation.",
        "popup_givezollar": "<h3>Give Zollar Subvention</h3><strong>Description:</strong><br>Add non-numerical value (Zollars) to selected traders.<br><br><strong>How-to:</strong><br>Choose traders from the active trader list, specify the Zollar amount, and confirm.<br><br><strong>Conceptual Insight:</strong><br>This represents economic stimulation or rewards. Use it as funding to restart or boost participation for a struggling trader, or to provide an advantage based on relationship-based currency.",
        "popup_givepoints": "<h3>Give Capital Subvention</h3><strong>Description:</strong><br>Add numerical value (capital) to selected traders' portfolios.<br><br><strong>How-to:</strong><br>Specify the amount of capital, select the traders, and confirm.<br><br><strong>Conceptual Insight:</strong><br>Economic stimulation through direct capital injection. Use it to restart struggling traders or reward certain behaviors in the market.",
        "popup_giveitem": "<h3>Give Commodity</h3><strong>Description:</strong><br>Assign a random commodity to selected traders.<br><br><strong>How-to:</strong><br>Select the traders from the active trader list, then click the button.<br><br><strong>Conceptual Insight:</strong><br>Commodities are physical assets that can be used as leverage to create demand and exchanging within the greater market.",
        "popup_freebie": "<h3>Commodity Distribution (All)</h3><strong>Description:</strong><br>Distribute a commodity to all active traders simultaneously.<br><br><strong>How-to:</strong><br>Click to activate the subsidy.<br><br><strong>Conceptual Insight:</strong><br>This helps provide liquidity by introducing a flood of resources to all traders in the market. It allows you to spur consumption and trading activity across the entire session.",
        "popup_publizity": "<h3>Play PubliZity</h3><strong>Description:</strong><br>Play a random pub video featuring companies from the ZEconomy for all traders.<br><br><strong>How-to:</strong><br>Click the button to trigger the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>PubliZity uses advertising to promote the consumption of presentness while living life. Each poster references the act of living and is meant to keep traders grounded in the moment instead of promoting mindless distraction.",
        "popup_znews": "<h3>Play ZNews Update</h3><strong>Description:</strong><br>Play a random news video to provide context or updates about the market.<br><br><strong>How-to:</strong><br>Click the button to play the video broadcast.<br><br><strong>Conceptual Insight:</strong><br>ZNews uses financial economic media codes to give descriptions of the latest ZEconomy happenings. The different series all revolve around expressing living, art and economy regardless of themes and techniques.",
        "popup_createstory": "<h3>Create Story Theme</h3><strong>Description:</strong><br>Create a narrative theme that the AI will use to interpret and narrate the trading session.<br><br><strong>How-to:</strong><br>Click to open the story creation popup, enter a title and theme description, then submit.<br><br><strong>Conceptual Insight:</strong><br>The story theme shapes how the Voice of the Bourse interprets market activity. It creates a narrative framework through which all trades and interactions are understood and expressed.",
        "popup_addbots": "<h3>Add Market Bots</h3><strong>Description:</strong><br>Add automated trading bots to the session for market liquidity.<br><br><strong>How-to:</strong><br>Configure the number of bots and action interval, then click to add them to the session.<br><br><strong>Functionality:</strong><br>Bots are assigned different trading styles and moods. They perform automated trades at regular intervals, creating market activity and liquidity.<br><br><strong>Conceptual Insight:</strong><br>Market bots simulate other traders when human participation is low. They create the illusion of a bustling market and ensure there is always trading activity to respond to.",
        "popup_removebots": "<h3>Remove Market Bots</h3><strong>Description:</strong><br>Remove all trading bots from the session.<br><br><strong>How-to:</strong><br>Click to remove all bots. Their holdings (items, Zollars, stocks) will be returned to the market.<br><br><strong>Conceptual Insight:</strong><br>Removing bots returns the market to purely human-driven activity. The assets they held are redistributed back into the available pool.",
        "popup_botstatus": "<h3>Check Bot Status</h3><strong>Description:</strong><br>View the current status of market bots in the session.<br><br><strong>How-to:</strong><br>Click to see how many bots are active, their names, and trading styles.<br><br><strong>Conceptual Insight:</strong><br>Monitoring bot activity helps the exchange operator understand the balance between automated and human trading in the session."
      }
    }
  },
  fr: {
    translation: {
      "glossary": {
        "shares_t": "Part (action) — un morceau d'entreprise",
        "shares_d": "Une part, c'est un petit morceau d'une entreprise. Posséder des parts, c'est posséder une tranche de cette entreprise : si elle réussit, ta tranche prend de la valeur ; si elle va mal, ta tranche en perd. Pourquoi acheter des parts d'AUTRES entreprises ? Parce que tu paries sur ce qu'elles font : tu gagnes quand elles gagnent, et tu peux revendre ta tranche plus tard. Pas besoin de diriger une entreprise pour en posséder un morceau.",
        "stock_t": "Titre — une entreprise sur le marché",
        "stock_d": "Un titre (ou « stock »), c'est une entreprise cotée sur le marché, découpée en parts que tout le monde peut acheter ou vendre. « Trader un titre », c'est simplement acheter ou vendre des morceaux de cette entreprise.",
        "bond_t": "Obligation — une promesse qui rembourse",
        "bond_d": "Une obligation, c'est un prêt sous forme de promesse : tu donnes de la valeur maintenant, et on te rembourse plus tard — avec un petit extra appelé intérêts. Ici, le Z Bond est une promesse remboursée avec des intérêts en expérience vécue.",
        "interest_t": "Intérêts — la récompense de l'attente",
        "interest_d": "Les intérêts, c'est le petit extra qu'on te rend en plus de ce que tu as prêté. Tu prêtes 10, on te rend 11 — ce 1 en plus, ce sont les intérêts. C'est la récompense d'avoir laissé quelqu'un utiliser ta valeur un moment.",
        "capital_t": "Capital (Ƶ) — l'argent simple en chiffres",
        "capital_d": "Le capital, c'est la monnaie simple et chiffrée du marché (Ƶ). Il permet d'acheter — mais ici, ce n'est volontairement PAS la seule richesse : les relations (Zollars) comptent autant, souvent plus.",
        "zollar_t": "Zollars — la monnaie des relations",
        "zollar_d": "Les Zollars sont les monnaies relationnelles de cette bourse : Amour, Amitié, Deuil, et les autres. Au lieu de payer avec de l'argent, tu paies avec des relations vécues. C'est le cœur de ce marché — la plupart des échanges fonctionnent avec.",
        "bid_t": "Enchère — le prix que TU proposes",
        "bid_d": "Une enchère, c'est le prix que TOI tu proposes pour quelque chose qu'un autre trader détient. Il peut accepter, refuser, ou laisser expirer — et dans ce cas rien n'est perdu : ton offre te revient simplement, et tu peux réessayer, plus haut ou ailleurs.",
        "swap_t": "Échange (troc) — chose contre chose, sans argent",
        "swap_d": "Un échange, c'est un troc direct : ta chose contre la sienne, sans argent. Les deux côtés doivent dire oui. C'est la plus vieille forme de commerce au monde.",
        "portfolio_t": "Portefeuille — tout ce que tu détiens",
        "portfolio_d": "Ton portefeuille, c'est tout ce que tu détiens en ce moment : ton capital, tes zollars, tes parts, tes objets et tes obligations. Sur le parquet, c'est ce que ton personnage porte sur lui.",
        "market_t": "Marché — là où les traders se rencontrent",
        "market_d": "Le marché, c'est simplement l'endroit où les traders se rencontrent pour échanger ce qu'ils détiennent. Ici, c'est le parquet 3D : chaque personnage porte ce qu'il possède, et tu peux aller négocier avec n'importe lequel.",
        "trader_t": "Trader — n'importe qui sur le parquet",
        "trader_d": "Un trader, c'est toute personne qui participe au marché — toi compris. Certains traders de ce parquet sont des bots (des robots qui tradent automatiquement) : négocie avec eux exactement comme avec une personne.",
        "debt_t": "Dette — dépenser sous zéro",
        "debt_d": "Être en dette, c'est dépenser plus que ce que tu as — ton solde passe sous zéro, jusqu'à une limite de crédit fixée par le marché. Pratique pour saisir une occasion, mais ce que tu empruntes devra revenir.",
        "reserve_t": "Réserve Zédérale — la banque du parquet",
        "reserve_d": "La Réserve Zédérale, c'est la banque centrale de ce parquet. C'est elle qui vend les zollars, change les monnaies, et tient le carnet des obligations — l'endroit où les promesses (Z Bonds) se font et se remboursent.",
        "redeem_t": "Racheter — le rendre réel",
        "redeem_d": "Racheter, c'est transformer un objet du jeu en quelque chose de réel. Un autre trader le valide, tu reçois un QR code, et le staff le scanne pour te remettre la vraie chose. Ici, consommer est social — tu ne peux pas le faire seul.",
        "see_all": "TOUS LES MOTS →",
        "index_title": "LEXIQUE — les mots du parquet",
        "index_hint": "Chaque mot souligné sur le parquet peut être touché pour voir sa définition. Les voici tous :",
        "reopen": "Que veulent dire ces mots ?"
      },
      "nudge": {
        "next": "SUIVANT", "back": "Retour", "done": "COMPRIS",
        "tap_hint": "touche à droite pour continuer · glisse pour naviguer",
        "reopen": "Comment marche cette page ?",
        "sim_tag": "PARQUET D'ENTRAÎNEMENT",
        "sim_1_h": "Ceci est un entraînement.",
        "sim_1_b": "Un essai sans risque pour apprendre à trader ta vie. Rien n'est définitif ici — explore librement.",
        "sim_2_h": "Regarde ce que tu détiens.",
        "sim_2_b": "Descends. Chaque section ci-dessous est quelque chose que tu possèdes. Touche une section pour l'ouvrir.",
        "sim_3_h": "Puis entre dans le Marché.",
        "sim_3_b": "Quand tu es prêt, appuie sur le bouton en bas pour entrer sur le parquet ouvert et trader.",
        "sim_cta": "COMPRIS — ENTRER",
        "trader_tag": "TON CÔTÉ DU PARQUET",
        "trader_1_h": "Voici tout ce que tu portes.",
        "trader_1_b": "Tes avoirs et ta mission sont ici. Touche une section pour l'ouvrir ; touche encore pour fermer.",
        "trader_2_h": "Ta mission est en haut.",
        "trader_2_b": "Elle te dit quel objectif viser. Trade pour t'en approcher.",
        "trader_3_h": "Va au Marché pour trader.",
        "trader_3_b": "Le parquet ouvert est où tu fais des offres pour ce que les autres détiennent. Utilise le bouton en bas.",
        "trader_cta": "COMPRIS",
        "market_tag": "LE PARQUET OUVERT",
        "market_1_h": "Trouve ce qui compte pour TOI.",
        "market_1_b": "Parcours ce que les autres traders détiennent. Ce n'est pas une question d'argent — mais de ce que tu valorises.",
        "market_2_h": "Touche-le pour faire une offre.",
        "market_2_b": "Demande-toi : que vaut-il dans ma vie ? Puis offre de la valeur relationnelle, un échange ou une enchère.",
        "market_3_h": "Ils acceptent → c'est à toi.",
        "market_3_b": "Le propriétaire dit oui et ça entre dans ta vie. Aucun argent nulle part.",
        "market_cta": "COMPRIS",
        "stock_tag": "FAIS TON OFFRE",
        "stock_0_h": "Tu enchéris sur une valeur de vie.",
        "stock_0_b": "Cette action est un morceau de ce qu'un autre trader EST. Ton but : fixer un prix et le convaincre de te laisser en détenir une part.",
        "stock_choice_h": "D'abord, choisis comment payer.",
        "stock_choice_b": "Deux boutons en haut : ZOLLARS paie en relations (Amour, Deuil, Amitié…) — le cœur de ce marché. CAPITAL paie en simple capital (Ƶ), si tu y tiens.",
        "stock_1_h": "Ensuite, fixe ton prix.",
        "stock_1_b": "Avec les Zollars : touche « DÉFINIR TON OFFRE ZOLLAR » et fais glisser chaque barre lumineuse — plus à droite = plus de cette relation offerte. Avec le Capital : saisis simplement le montant.",
        "stock_2_h": "Indique le nombre de parts.",
        "stock_2_b": "Saisis le nombre de parts voulues dans la case PARTS — dans la limite de ce que le propriétaire détient.",
        "stock_3_h": "Place ton enchère.",
        "stock_3_b": "Appuie sur Place Bid et dis pourquoi tu la veux. Le propriétaire décide de te la céder ou non.",
        "stock_cta": "COMPRIS",
        "bond_tag": "PRENDS UNE PROMESSE",
        "bond_1_h": "Un Z Bond est une promesse.",
        "bond_1_b": "Valeur relationnelle maintenant, remboursée plus tard avec intérêt en expérience vécue.",
        "bond_2_h": "Choisis le montant et la durée.",
        "bond_2_b": "Choisis combien et pour combien de temps, puis soumets pour prendre la promesse.",
        "bond_cta": "COMPRIS",
        "trans_tag": "PROPOSE UN ÉCHANGE",
        "trans_1_h": "Ce trader veut l'objet en haut.",
        "trans_1_b": "Tu l'obtiens en donnant une de tes propres choses en retour — un échange direct, sans argent.",
        "trans_2_h": "Choisis ce que tu donnes.",
        "trans_2_b": "Parcours tes propres avoirs ci-dessous et choisis-en un à offrir.",
        "trans_3_h": "Propose l'échange.",
        "trans_3_b": "Touche « Propose » sur la chose que tu offres. Le propriétaire décide d'accepter ou non.",
        "trans_cta": "COMPRIS",
        "redeem_tag": "RÉCLAME-LA DANS LA VRAIE VIE",
        "redeem_1_h": "La consommation ici est sociale.",
        "redeem_1_b": "Tu ne peux pas consommer une chose seul — l'objet d'un autre trader doit la valider d'abord.",
        "redeem_2_h": "Envoie une demande de redeem.",
        "redeem_2_b": "Demande au parquet de valider ta chose. Une fois associée, elle devient réelle et à collecter.",
        "redeem_cta": "COMPRIS",
        "eco_tag": "MACHINERIE LOURDE",
        "eco_1_h": "Voici les gros leviers.",
        "eco_1_b": "Des coups économiques qui agissent sur les AUTRES traders — cadeaux et armes. Chaque bouton dit ce qu'il fait en mots simples ; reste appuyé pour voir la mécanique en dessous.",
        "eco_2_h": "Donner ou prendre.",
        "eco_2_b": "SOUTENIR UN AMI couvre quelqu'un maintenant. SUBVENTION SOCIALISTE taxe un trader à 45 % et partage entre tous. ASSAUT COMMUNISTE saisit un portefeuille entier et le redistribue. RACHAT HOSTILE rachète un trader. EXPLOITER LE DÉSESPOIR profite du besoin — et la salle s'en souvient.",
        "eco_3_h": "Ici, les dettes sont émotionnelles.",
        "eco_3_b": "Le compteur au-dessus suit ce que tu dois et ce qu'on te doit en confiance et en aide — pas en chiffres. La vie fera les comptes plus tard.",
        "eco_cta": "COMPRIS",
        "tools_tag": "ATTEINDRE LES AUTRES TRADERS",
        "tools_1_h": "Des façons d'atteindre la salle.",
        "tools_1_b": "Écris à un autre trader, vole ce qui n'est pas à toi, prends quelqu'un en otage jusqu'au paiement, ou ouvre une arrière-salle privée loin des regards du parquet.",
        "tools_2_h": "Chaque acte a un écho social.",
        "tools_2_b": "Ce ne sont pas des options de menu — ce sont des gestes. La salle voit ce que tu fais et te traite en conséquence. Reste appuyé sur un bouton pour voir sa mécanique.",
        "tools_cta": "COMPRIS",
        "botmsg_tag": "UN BOT TE PARLE",
        "botmsg_1_h": "Ce message vient d'un bot.",
        "botmsg_1_b": "Le parquet est peuplé de traders-bots — ils détiennent des valeurs, font des offres et parlent comme n'importe qui dans la salle. Celui-ci vient de te contacter.",
        "botmsg_2_h": "Réponds-lui — ou pas.",
        "botmsg_2_b": "Tu peux répondre, trader avec lui, ou l'ignorer. Traite-le comme n'importe quel trader : ce que tu dis et fais façonne la manière dont la salle te traite.",
        "botmsg_cta": "COMPRIS",
        "mm_tag": "MEMENTO MORI",
        "mm_1_h": "Souviens-toi que tu vas mourir.",
        "mm_1_b": "Cette partie a une vraie fin : quand le minuteur atteint zéro, ta vie de trader est terminée. Tout ce que tu détiens à cet instant est lu comme ton héritage.",
        "mm_2_h": "Tu as déjà choisi tes actions d'héritage.",
        "mm_2_b": "Les entreprises choisies à partir de tes réflexions portent tes valeurs. Elles sont dans ton portefeuille ci-dessous — ouvre les sections pour voir ton point de départ.",
        "mm_3_h": "Ton éloge funèbre s'écrit tout seul.",
        "mm_3_b": "La barre rouge tout en haut est ton éloge, réécrit au fil de tes échanges. Touche-la à tout moment pour lire ce qu'on dirait de toi si tout s'arrêtait maintenant.",
        "mm_4_h": "Trade vers la mémoire que tu veux laisser.",
        "mm_4_b": "Va au Marché : fais grandir ce qui compte, lâche ce qui ne compte pas. Quand le temps s'arrête, la bourse parle sur ta tombe.",
        "mm_cta": "J'AI COMPRIS",
        "mm_mkt_tag": "MEMENTO MORI — LE PARQUET",
        "mm_mkt_1_h": "Chaque offre est un choix d'héritage.",
        "mm_mkt_1_b": "Offre des Zollars relationnels pour les valeurs de vie auxquelles tu veux lier ton nom. Le temps file — la barre d'éloge en haut écoute chaque échange.",
        "mm_mkt_2_h": "Sache aussi lâcher.",
        "mm_mkt_2_b": "Accepter des offres et céder des avoirs en fait partie : ce que tu laisses partir dit autant de toi que ce que tu gardes.",
        "mm_mkt_cta": "COMPRIS",
        "cn_tag": "CATENA NARRATIVA",
        "cn_1_h": "Tu construis une histoire.",
        "cn_1_b": "Dans Catena Narrativa, les éléments narratifs se tradent comme des marchandises. Les éléments que tu détiens — et la façon dont tu les réécris — deviennent une nouvelle à la fin.",
        "cn_2_h": "Trois phases, un seul chrono.",
        "cn_2_b": "DÉBUT → MILIEU → FIN, environ 8 minutes au total. La bannière du minuteur en haut indique la phase en cours. À la fin d'une phase, les éléments que tu détiens sont sécurisés dans ton registre d'histoire.",
        "cn_3_h": "Tes éléments d'histoire sont juste en dessous.",
        "cn_3_b": "Le panneau « Your Story Elements » liste les éléments que tu détiens en ce moment. Ouvre tes sections pour voir tout ce que tu portes.",
        "cn_4_h": "Trade pour façonner l'histoire.",
        "cn_4_b": "Va au Marché et échange ou enchéris pour les éléments dont ton histoire a besoin. Chaque échange te permet de réécrire l'élément avec tes propres mots — c'est ainsi que l'histoire devient la tienne.",
        "cn_cta": "COMMENCER À TRADER",
        "cn_mkt_tag": "CATENA NARRATIVA — LE PARQUET",
        "cn_mkt_1_h": "Chaque objet ici est un morceau d'histoire.",
        "cn_mkt_1_b": "Touche le bouton « Bullets » pour voir les éléments que tu détiens déjà, puis fais une offre ou un échange pour les morceaux dont ton histoire a besoin avant la fin de la phase.",
        "cn_mkt_2_h": "Trader, c'est réécrire.",
        "cn_mkt_2_b": "Quand un échange aboutit, tu écris comment l'élément se transforme entre tes mains. La valeur naît de l'échange — ce texte nourrit l'histoire finale.",
        "cn_mkt_cta": "COMPRIS",
        "cn_swap_1_h": "Tu échanges des morceaux d'histoire.",
        "cn_swap_1_b": "Ce trader détient un élément utile à ton histoire. Parcours tes propres avoirs ci-dessous et choisis-en un à donner en retour.",
        "cn_swap_2_h": "Puis réécris-le.",
        "cn_swap_2_b": "Au moment de proposer, tu diras comment l'élément est personnalisé — au moins une phrase. Fais-la compter : elle entre directement dans l'histoire.",
        "cn_swap_cta": "COMPRIS"
      },
      "floor": {
        "mission_label": "TA MISSION",
        "mission_class": "CLASSE",
        "your_stocks": "TES ACTIONS",
        "do_trader": "<b>→ Va sur le parquet ouvert</b> et trade pour ce dont ta mission a besoin.",
        "do_market": "<b>→ Touche ce qu'un trader détient</b> et fais une offre.",
        "wedividual": "LE NOUDIVIDU",
        "hero_sub": "la valeur intérieure de la salle, en direct — à la place où trônerait le PIB",
        "hero_sub_count": "mesurée sur {n} échanges relationnels dans cette salle — pas le PIB",
        "hero_tip": "Pas le PIB. Le Noudividu, c'est cette salle mesurée de l'intérieur : chaque échange de valeur relationnelle (amour, deuil, amitié, haine...) le fait bouger. Quand vous tradez, vous déplacez ce que la salle ressent.",
        "mood_euphoric": "EUPHORIQUE",
        "mood_warm": "CHALEUREUX",
        "mood_steady": "STABLE",
        "mood_heavy": "LOURD",
        "mood_dark": "SOMBRE",
        "your_position": "VOTRE POSITION · PROFIT DE VIE",
        "declared_note": "vous êtes entré sur le parquet en portant",
        "fold_holdings": "CE QUE VOUS DÉTENEZ",
        "fold_holdings_hint": "valeurs de vie · objets · zollars · promesses",
        "fold_interior": "VOTRE GRAND LIVRE INTÉRIEUR",
        "fold_interior_hint": "état émotionnel & dette",
        "fold_moves": "INSTRUMENTS & ARMES",
        "fold_moves_hint": "dons, prêts, attaques — l'économie comme verbe",
        "board_things": "CHOSES SUR LE PARQUET",
        "board_things_hint": "touchez-en une pour offrir de la valeur relationnelle",
        "board_values": "VALEURS DE VIE À LA COTE",
        "board_values_hint": "parts de vie vécue — cotées au ressenti",
        "board_bonds": "PROMESSES (Z BONDS)",
        "board_bonds_hint": "valeur relationnelle maintenant, remboursée en expérience plus tard",
        "status_trader": "Voici votre portefeuille — ce que vous détenez et ce que vous devez. <b>Votre coup : allez sur le parquet et tradez.</b>",
        "status_market": "Le parquet — tout ce que les autres traders détiennent. <b>Touchez n'importe quoi pour faire une offre</b> ; vous payez avec vos Zollars.",
        "status_redeem": "Vous avez une correspondance. <b>Votre coup : appuyez sur ÉCHANGER et faites-la entrer dans votre vie.</b>",
        "status_memento": "<b>MEMENTO MORI</b> — chaque échange devient une ligne de votre éloge funèbre. Gardez ce que vous voulez qu'on dise de vous.",
        "memento_chip": "MEMENTO MORI",
        "phase_1_chip": "PHASE 1/3 · DÉBUT",
        "phase_1_trader": "<b>DÉBUT</b> — l'histoire a besoin de matière première. Votre coup : allez chercher des éléments narratifs sur le parquet.",
        "phase_1_market": "<b>DÉBUT</b> — l'histoire a besoin de matière première. Touchez un élément narratif ci-dessous et faites une offre.",
        "phase_1_go": "CHERCHER DES ÉLÉMENTS",
        "phase_1_cta": "OFFRIR POUR UN ÉLÉMENT",
        "phase_2_chip": "PHASE 2/3 · MILIEU",
        "phase_2_trader": "<b>MILIEU</b> — l'heure des complications. Votre coup : échangez et personnalisez vos éléments.",
        "phase_2_market": "<b>MILIEU</b> — l'heure des complications. Échangez pour des éléments qui tordent votre histoire.",
        "phase_2_go": "ÉCHANGER VOS ÉLÉMENTS",
        "phase_2_cta": "ÉCHANGER POUR UN REBONDISSEMENT",
        "phase_3_chip": "PHASE 3/3 · FIN",
        "phase_3_status": "<b>FIN</b> — consolidation. Gardez l'essentiel ; l'histoire s'écrira de ce que vous tenez quand le temps s'arrête.",
        "phase_3_go": "REVOIR CE QUE VOUS TENEZ",
        "phase_3_cta": "DERNIERS ÉCHANGES",
        "cta_offer": "FAIRE UNE OFFRE",
        "cta_offer_hint": "Touchez n'importe quoi à la cote — vous offrirez de la <b>valeur relationnelle</b> (vos Zollars : amour, amitié, deuil...) pour l'obtenir.",
        "tape_gdp": "PIB NON COTÉ SUR CE PARQUET",
        "tape_love": "L'AMOUR ACCEPTÉ À TOUS LES GUICHETS",
        "tape_grief": "LE DEUIL COTE À PARITÉ AVEC LA JOIE",
        "tape_move": "CHAQUE ÉCHANGE DÉPLACE LA SALLE",
        "tape_interior": "VALEUR INTÉRIEURE UNIQUEMENT · APPORTEZ CE QUE VOUS RESSENTEZ",
        "tk_trade": "ÉCHANGE CONCLU · LA VALEUR RELATIONNELLE A CHANGÉ DE MAINS",
        "tk_bid_yes": "UNE OFFRE A ÉTÉ EMBRASSÉE",
        "tk_bid_no": "UNE OFFRE A ÉTÉ REFUSÉE",
        "tk_zollar": "DES ZOLLARS FRAIS SONT ENTRÉS DANS LA SALLE",
        "tk_burst": "LE PARQUET CHAUFFE",
        "tk_short": "QUELQU'UN PARIE CONTRE UNE VALEUR DE VIE",
        "tk_bourse": "LA BOURSE S'EST PRONONCÉE SUR UN ÉCHANGE",
        "tk_pool": "UNE ARRIÈRE-SALLE S'EST OUVERTE QUELQUE PART",
        "tk_subsidy": "QUELQU'UN A ÉTÉ SOUTENU PAR LE COLLECTIF",
        "tk_theft": "VOL SUR LE PARQUET · SURVEILLEZ VOS AVOIRS",
        "tk_memento": "MEMENTO MORI · L'HORLOGE AVANCE",
        "tk_declared": "{v} EST SUR LE PARQUET · DÉCLARÉ, PAS COTÉ",
        "ps_tap": "maintenez pour voir la mécanique",
        "ps_altrau": "SOUTENIR UN AMI",
        "ps_altrau_tip": "Vous couvrez un autre trader maintenant. La dette créée est émotionnelle, pas numérique — elle reste sur votre grand livre intérieur jusqu'à ce que la vie la solde.",
        "ps_mnote": "EMPRUNTER SUR SOI-MÊME",
        "ps_mnote_tip": "Prenez du capital maintenant et devenez débiteur de votre futur vous. Le marché se souvient de ce que vous avez promis de devenir.",
        "ps_cdo": "PROFITER DU DÉSESPOIR",
        "ps_cdo_tip": "Prêtez à quelqu'un qui ne peut pas dire non, puis revendez sa détresse. Rentable. Cela vous coûtera du crédit intérieur auprès de la salle.",
        "ps_vnote": "DEMANDER L'AIDE DE LA SALLE",
        "ps_vnote_tip": "Demandez de l'aide au parquet. Aucune honte ici — le besoin est une vérité négociable comme une autre.",
        "ps_steal": "PRENDRE CE QUI N'EST PAS À VOUS",
        "ps_steal_tip": "Du vol, tout simplement. Vous gagnez la chose ; la salle apprend qui vous êtes.",
        "ps_ransom": "PRENDRE QUELQU'UN EN OTAGE",
        "ps_ransom_tip": "Privez un autre trader de sa propre vie jusqu'à ce qu'il paie pour la récupérer.",
        "ps_darkpool": "OUVRIR UNE ARRIÈRE-SALLE",
        "ps_darkpool_tip": "Ouvre une salle de marché privée, loin des yeux du parquet. Les affaires qui s'y concluent restent cachées et ne déplacent pas l'humeur commune — c'est le but, et le problème.",
        "ps_lbo": "RACHAT HOSTILE",
        "ps_lbo_tip": "Choisis un trader et rachète-le : tu paies le coût du rachat en capital (il le reçoit), et les objets et actions que tu as sélectionnés deviennent À TOI. Un rachat, pas un cadeau.",
        "ps_subsidy": "SUBVENTION SOCIALISTE",
        "ps_subsidy_tip": "Choisis un trader à taxer : 45 % de son capital, de ses objets et de ses Zollars sont pris et partagés à parts égales entre tous les autres traders du parquet. Redistribution par le haut.",
        "ps_assault": "ASSAUT COMMUNISTE",
        "ps_assault_tip": "Choisis un trader : son portefeuille ENTIER — capital, objets, actions, Zollars — est saisi et distribué à tous les autres sur le parquet. Il est remis à zéro. Redistribution totale, utilisée comme une arme.",
        "ps_holdings": "CE QUE VOUS PORTEZ",
        "ps_holdings_tip": "Votre position : les actions, marchandises, Zollars et promesses actuellement entre vos mains.",
        "ps_zollar_tip": "De la monnaie libellée en relations plutôt qu'en chiffres : Amour, Amitié, Haine, Deuil... Vous payez avec ce qu'une relation vaut pour vous.",
        "ps_bond_tip": "Une promesse chargée de sentiments : de la valeur relationnelle maintenant, remboursée avec intérêts en expérience vécue plus tard.",
        "ps_short_tip": "Un pari contre une valeur de vie — vous profitez si elle chute. Oui, on peut vendre la joie à découvert. Demandez-vous pourquoi.",
        "ps_stock_tip": "Des parts de valeurs de vie — tranches d'intellect, d'affection, de fête, de mélancolie. Leur prix est ce que la salle ressent qu'elles valent.",
        "ps_commodity_tip": "Des choses réelles avec un piège : impossible d'en consommer une sans la validation d'un autre trader. Ici, la consommation est sociale ou n'est pas.",
        "ps_value": "Valeur",
        "ps_value_tip": "Ce que le détenteur en demande — payable en valeur relationnelle, pas en argent.",
        "ps_redeem": "Échanger",
        "ps_redeem_tip": "Faites entrer une chose dans votre vraie vie. Il faut d'abord l'objet d'un autre trader pour la valider — ici, la consommation est sociale.",
        "ps_owner": "Détenteur",
        "ps_owner_tip": "Le trader à la vie duquel cela appartient pour l'instant. Votre offre lui est adressée.",
        "ob_title": "AVANT DE TRADER",
        "ob_sub": "Ce parquet ne cote pas votre production. Il cote votre intérieur. Choisissez jusqu'à trois choses auxquelles vous tenez vraiment — elles deviennent ce que vous portez, et ce que vous pouvez dépenser.",
        "ob_custom": "ou nommez la vôtre + Entrée",
        "ob_custom_h": "la vôtre seule",
        "ob_go": "LES PORTER SUR LE PARQUET",
        "ob_skip": "passer — je connais ce parquet",
        "ob_done": "Déclaré. C'est sur votre position maintenant. <b>Votre coup : portez-les sur le parquet ouvert.</b>",
        "ob_love": "AMOUR", "ob_love_h": "ce que vous donneriez tout pour garder",
        "ob_friendship": "AMITIÉ", "ob_friendship_h": "celles et ceux qui vous tiennent debout",
        "ob_fellowship": "FRATERNITÉ", "ob_fellowship_h": "appartenir à plus grand que soi",
        "ob_erotic": "ÉROTIQUE", "ob_erotic_h": "le désir, pleinement assumé",
        "ob_hate": "HAINE", "ob_hate_h": "ça compte — c'est à vous aussi",
        "ob_toxic": "TOXIQUE", "ob_toxic_h": "les liens qui vous coûtent",
        "ob_superficial": "SUPERFICIALITÉ", "ob_superficial_h": "les joies futiles, sans excuse",
        "ob_dead": "CE QUI EST PARTI", "ob_dead_h": "les relations mortes se tradent encore ici",
        "sec_stocks": "VALEURS DE VIE",
        "sec_commodities": "OBJETS",
        "sec_zollars": "ZOLLARS",
        "sec_zbonds": "PROMESSES",
        "sec_redeemed": "ÉCHANGÉS",
        "sec_shorts": "PARIS CONTRE",
        "sec_emotional": "GRAND LIVRE INTÉRIEUR",
        "sec_social": "DONNER / PRÊTER / EXPLOITER",
        "sec_tools": "OUTILS",
        "sec_economic": "ARMES",
        "flow_title": "COMMENT ON TRADE ICI",
        "flow_1_n": "1",
        "flow_1_h": "TROUVEZ-LE",
        "flow_1_b": "Parcourez ce que les autres traders détiennent. Touchez ce que vous voulez.",
        "flow_2_n": "2",
        "flow_2_h": "OFFREZ CE QUE ÇA VAUT POUR VOUS",
        "flow_2_b": "Payez en valeur relationnelle — vos Zollars (amour, deuil, amitié...), un échange, ou une offre.",
        "flow_3_n": "3",
        "flow_3_b": "ILS DISENT OUI → C'EST À VOUS",
        "flow_3_h": "Le détenteur accepte et cela entre dans votre vie. Aucun argent, nulle part.",
        "btn_swap": "ÉCHANGER",
        "btn_swap_tip": "Offrez l'un de vos objets en échange du leur. Un troc direct d'avoirs.",
        "btn_offer_zollars": "OFFRIR DES ZOLLARS",
        "btn_offer_zollars_tip": "Payez avec votre monnaie relationnelle — Zollars d'Amour, de Deuil, d'Amitié. C'est vous qui dites ce que ça vaut.",
        "btn_offer_share": "ACHETER",
        "btn_offer_share_tip": "Faites une offre pour une part de cette valeur de vie. Si le détenteur accepte, la part est à vous.",
        "btn_bet_against": "PARIER CONTRE",
        "btn_bet_against_tip": "Vendez-la à découvert — vous profitez si cette valeur de vie chute. Vous pariez contre la valeur de quelqu'un. Pesez-le.",
        "btn_take_promise": "PRENDRE LA PROMESSE",
        "btn_take_promise_tip": "Achetez ce Z Bond : valeur relationnelle maintenant, remboursée avec intérêts en expérience vécue plus tard.",
        "btn_offer_promise": "OFFRIR",
        "btn_offer_promise_tip": "Faites une offre sur cette promesse. Le détenteur décide de vous la céder ou non.",
        "hero_eyebrow": "L'HUMEUR DE LA SALLE EN CE MOMENT",
        "gauge_low": "LOURD",
        "gauge_high": "EUPHORIQUE",
        "hero_sub2": "l'humeur partagée de tous ceux qui tradent — l'indice du parquet, au lieu du PIB",
        "hero_sub_count2": "lu sur {n} échanges du parquet — notre indice, au lieu du PIB",
        "delta_up": "plus chaud qu'il y a un instant",
        "delta_down": "plus lourd qu'il y a un instant",
        "nav_portfolio": "MON PORTEFEUILLE",
        "nav_search": "RECHERCHER",
        "your_portfolio": "VOTRE PORTEFEUILLE",
        "portfolio_explain": "tout ce que vous détenez sur le parquet. sa valeur totale, comptée en Profit de Vie — votre vécu, pas de l'argent :",
        "count_held": "{n} détenus",
        "count_empty": "vide",
        "exp_stocks": "Des parts que vous détenez dans des valeurs humaines (comme l'intellect ou l'affection). Leur valeur monte et descend selon l'humeur de la salle.",
        "exp_commodities": "Des choses réelles que vous détenez. Impossible d'en consommer une sans la validation d'un autre trader — ici, la consommation est sociale.",
        "exp_zollars": "Votre argent — mais compté en relations (Amour, Deuil, Amitié). C'est avec ça que vous payez quand vous tradez.",
        "exp_zbonds": "Des promesses que vous détenez : valeur relationnelle maintenant, remboursée plus tard avec intérêts en expérience vécue.",
        "exp_redeemed": "Des choses que vous avez fait entrer dans la vraie vie, gardées en QR codes à récupérer.",
        "exp_shorts": "Des valeurs de vie contre lesquelles vous avez parié — vous gagnez si leur valeur chute.",
        "exp_emotional": "Votre bilan émotionnel — ce que vous devez et ce qu'on vous doit en confiance, aide et trahison.",
        "exp_social": "Des façons d'agir sur les autres : soutenir un ami, prêter, demander de l'aide, ou exploiter quelqu'un. L'économie comme gestes.",
        "exp_tools": "Atteindre les autres traders : leur écrire, voler, prendre en otage, ou ouvrir une arrière-salle privée.",
        "exp_economic": "Coups lourds : rachat hostile, subvention collective, ou suppression totale de votre portefeuille.",
        "exp_stock_bid": "Un autre trader de la salle — souvent l'un des bots du marché — veut acheter des parts que vous détenez. Acceptez et son paiement est à vous ; refusez et rien ne change.",
        "exp_trade_offer": "Un trader propose un troc direct : sa chose contre la vôtre. Les bots de la salle tradent aussi — répondez comme à une personne.",
        "exp_buy_offer": "Quelqu'un veut une chose que vous portez et la paie. Acceptez et le paiement vous revient, la chose part chez lui ; refusez et vous la gardez.",
        "exp_tax": "C'est la Réserve Zédérale — le joueur-système du marché. Elle taxe chaque trader de temps en temps. Choisissez ce que vous cédez avant la fin du compte à rebours, sinon elle prend les deux.",
        "exp_short": "Vendre à découvert, c'est parier que cette valeur de vie va CHUTER. Si elle baisse, vous profitez du déclin. Vous pariez contre la valeur de quelqu'un — la salle le saura.",
        "exp_analysis": "C'est la voix de la bourse — le marché lui-même qui réagit à un échange qui vient d'avoir lieu sur le parquet. C'est un commentaire, pas une demande : lisez, fermez, rien ne vous est demandé."
      },
      companies_by_id: {
        "2": {
          Company_Name: "Z Ragots Télécom",
          Description: "Diffuse et amplifie les conversations et rumeurs juteuses — vraies ou non.",
          Out_put: "Rumeurs, drames et histoires sensationnelles",
          Risk: "Trop de travail. Quand chacun est absorbé par sa vie, l’attention au commérage disparaît."
        },
        "3": {
          Company_Name: "Z Rage & Cie",
          Description: "Représente la frustration, l’agressivité et l’énergie chaotique du quotidien.",
          Out_put: "Frustration amplifiée, colère et agitation",
          Risk: "La perspective du reste du monde. Relativiser réduit la colère."
        },
        "4": {
          Company_Name: "Z Mal Dans Sa Peau SA",
          Description: "Explore les luttes intérieures du doute de soi et les complexités de l’image personnelle.",
          Out_put: "Syndrome de l’imposteur, doutes, critiques de soi",
          Risk: "Changement et croissance. Un nouvel environnement peut dissiper les anciennes insécurités."
        },
        "5": {
          Company_Name: "Z Porte Fermée Inc.",
          Description: "Offre une plateforme pour comprendre et surmonter la douleur du rejet.",
          Out_put: "Sentiment d’exclusion, d’échec et de non-appartenance",
          Risk: "Succès et acceptation. Les réussites font taire le rejet."
        },
        "6": {
          Company_Name: "Z Fake News Télécom",
          Description: "Spécialisée dans la consommation et la diffusion de désinformation sensationnaliste.",
          Out_put: "Désinformation et récits exagérés",
          Risk: "Recherche et diversité. Vérifier les faits et varier les sources protège."
        },
        "7": {
          Company_Name: "Z Déclarations Stupides Télécom",
          Description: "Met en évidence les propos absurdes et irréfléchis dits sans filtre.",
          Out_put: "Remarques ignorantes, irréfléchies et amplifiées",
          Risk: "Silence. Penser avant de parler désamorce la stupidité."
        },
        "8": {
          Company_Name: "Z Peinture Numérique Industries",
          Description: "Innove dans l’art numérique, alliant technologie et créativité.",
          Out_put: "Œuvres digitales, expression créative et visuels technologiques",
          Risk: "Panne d’électricité. Sans courant, plus de peinture numérique."
        },
        "9": {
          Company_Name: "Z Dessin Industries",
          Description: "Célèbre l’art intemporel du dessin et son pouvoir d’imagination.",
          Out_put: "Croquis, dessins à la main et créativité brute",
          Risk: "Photographie. La facilité des clichés rapides menace le dessin."
        },
        "10": {
          Company_Name: "Z Avidité Incorporée",
          Description: "Symbolise le désir insatiable de prendre plus que sa part.",
          Out_put: "Consommation incontrôlée et ambition excessive",
          Risk: "Empathie. L’altruisme fait disparaître l’avidité."
        },
        "11": {
          Company_Name: "Z Paternelle Banque Corp.",
          Description: "Offre des services de vie avec une aura de stabilité et de confiance. Ou pas.",
          Out_put: "Stabilité perçue, amour et soutien familial",
          Risk: "Abandon. Quand le père s’en va, il n’y a plus de père."
        },
        "12": {
          Company_Name: "Z Radine Corp.",
          Description: "Dispose des fonds mais refuse de payer le juste prix.",
          Out_put: "Sous-paiement et transfert de charges",
          Risk: "Avidité. Quand plus personne n’accepte de payer trop, nous sommes finis."
        },
        "13": {
          Company_Name: "Z Oh Mon Dieu Incorporée",
          Description: "Célèbre l’émerveillement et les moments extraordinaires de la vie.",
          Out_put: "Amazement, inspiration et transcendance",
          Risk: "Cynisme. L’absence totale de croyance tue l’émerveillement."
        },
        "14": {
          Company_Name: "Z Écriture Technologies",
          Description: "Favorise l’expression créative grâce aux outils pour l’écrit.",
          Out_put: "Mots, littérature et narration structurée",
          Risk: "Le blocage de l’écrivain. Quand la créativité meurt, nous aussi."
        },
        "15": {
          Company_Name: "Z Technologies de Traduction",
          Description: "Brise les barrières linguistiques et favorise la compréhension interculturelle.",
          Out_put: "Conversion linguistique et communication",
          Risk: "Langue inconnue. Quand tout devient incompréhensible, même nous sommes impuissants."
        },
        "16": {
          Company_Name: "Z Pensée Technologie",
          Description: "Exprime le potentiel illimité de l’esprit humain — parfois trop, parfois trop peu.",
          Out_put: "Idées nouvelles et stimulation mentale",
          Risk: "Économie de l’attention. Quand tout est ailleurs, la pensée s’éteint."
        },
        "17": {
          Company_Name: "Z Arrogance Incorporée",
          Description: "Incarne la surconfiance et le sentiment de supériorité.",
          Out_put: "Confiance inébranlable et condescendance",
          Risk: "Humilité. Dès que la modestie arrive, nous déclinons."
        },
        "18": {
          Company_Name: "Z Provocation Télécom",
          Description: "Spécialisée dans la remise en question et l’agitation des débats.",
          Out_put: "Débats polarisés et controverse",
          Risk: "Zen. La paix intérieure rend la provocation inutile."
        },
        "19": {
          Company_Name: "Z Dépression Entreprises",
          Description: "Symbolise le vide émotionnel, la tristesse et la lourdeur existentielle.",
          Out_put: "Vide émotionnel et désespoir",
          Risk: "Drogues. Un esprit modifié est plus difficile à contrôler."
        },
        "20": {
          Company_Name: "Z Snob Entreprises",
          Description: "Être meilleur, plus intelligent, plus important que vous, peut-être.",
          Out_put: "Attitudes élitistes et barrières sociales",
          Risk: "Un coup de poing. Rien n’humilie plus vite que d’être renversé."
        },
        "21": {
          Company_Name: "Z Solitude Corporation",
          Description: "Quand tu parles tout seul·le parce que personne n’est à la maison.",
          Out_put: "Isolement, silence et absence de lien humain",
          Risk: "Amis/Famille. Une vraie connexion, quand les gens s’en fichent pas, notre business s’effondre."
        },
        "22": {
          Company_Name: "Z Culpabilité Incorporée",
          Description: "La petite voix de l’auto-réflexion et des remords quotidiens.",
          Out_put: "Regret, fardeau moral et auto-analyse incessante",
          Risk: "Narcissisme. Si rien n’a d’importance, aucun regret non plus."
        },
        "23": {
          Company_Name: "Zo Suicidaire Industrie",
          Description: "La solution quand tout devient trop lourd à supporter.",
          Out_put: "Détresse émotionnelle, maladie mentale et idées autodestructrices",
          Risk: "Parentalité. Avoir une vie à protéger donne soudain une raison de rester."
        },
        "24": {
          Company_Name: "Z Aspirateur Industries",
          Description: "Une forme productive d’aspiration.",
          Out_put: "Espaces sans poussière, efficacité d’aspiration et propreté immaculée",
          Risk: "Paresse. Si les gens décident de vivre dans la crasse, nous devenons inutiles."
        },
        "25": {
          Company_Name: "Z Toilettes Étincelantes Corp.",
          Description: "Non, ce ne sont pas des étoiles dans les WC, c’est juste la porcelaine qui brille.",
          Out_put: "Hygiène, sanitaires et cuvettes resplendissantes",
          Risk: "La négligence. Quand on arrête de se soucier, l’éclat disparaît."
        },
        "26": {
          Company_Name: "Z Plumeau Incorporée",
          Description: "Pour une existence hypoallergénique, sans poussière.",
          Out_put: "Surfaces nettes, réduction des allergènes et maison saine",
          Risk: "Vacances. Si personne n’est là, la poussière ne dérange personne."
        },
        "27": {
          Company_Name: "Z Dégâts & Nettoyage Industries",
          Description: "Transformer les accidents de la vie en occasions de recommencer propre.",
          Out_put: "Ordre retrouvé, propreté et erreurs effacées",
          Risk: "Contenants fermés. Si rien ne se renverse, on n’a rien à faire."
        },
        "28": {
          Company_Name: "Z Trolls Incorporée",
          Description: "Le côté (parfois) ludique et provocateur des interactions en ligne.",
          Out_put: "Engagements perturbateurs, agaçants ou parfois amusants",
          Risk: "L’indifférence. Pas de réaction, pas de plaisir. L’ignorance est notre vrai ennemi."
        },
        "29": {
          Company_Name: "Z Plats Préparés Raffinerie",
          Description: "Allier commodité et nourriture pour la vie moderne trop occupée.",
          Out_put: "Repas pré-emballés, solutions pratiques et rapides",
          Risk: "Trop de temps libre. Si les gens cuisinent eux-mêmes, plus de bénéfices."
        },
        "30": {
          Company_Name: "Z Chef Cuisine Corporation",
          Description: "Célébrer l’art culinaire et les délices gastronomiques.",
          Out_put: "Plats exquis, saveurs raffinées et chefs-d’œuvre culinaires",
          Risk: "Sortir dîner. Si tout le monde va au resto, quelqu’un d’autre cuisine."
        },
        "31": {
          Company_Name: "Z Transport Épicerie",
          Description: "L’aller-retour éternel des marchés alimentaires.",
          Out_put: "Chaînes logistiques, garde-manger bien rempli et flux de nourriture",
          Risk: "Drones. Le jour où ils livrent tout, nous sommes obsolètes."
        },
        "32": {
          Company_Name: "Zo Désorganisation Systèmes",
          Description: "Le chaos qui déclenche créativité et innovation… ou juste un gros bordel.",
          Out_put: "Désordre inspirant, improvisation créative",
          Risk: "Temps libre. Si les gens rangent, on perd notre magie."
        },
        "33": {
          Company_Name: "Ze Manger Dehors Incorporée",
          Description: "Chez un pote ou au resto — tant que c’est pas toi qui cuisines.",
          Out_put: "Quelqu’un d’autre fait la cuisine",
          Risk: "Pas d’argent. Quand le portefeuille est vide, retour aux pâtes maison."
        },
        "34": {
          Company_Name: "Z Méfiance Médias Corp.",
          Description: "Plans, sous-plans, complots — éclairer les vérités cachées.",
          Out_put: "Révélations, théories et conspirations",
          Risk: "Confiance. Quand les explications simples convainquent, on disparaît."
        },
        "35": {
          Company_Name: "Z Amitié Technologies",
          Description: "Dévouée à créer des liens et célébrer la vraie camaraderie.",
          Out_put: "Confiance, soutien, complicité et chaleur humaine",
          Risk: "Haine. Quand l’amertume prend le dessus, l’amitié meurt."
        },
        "36": {
          Company_Name: "Zo Sceptiques Corporation",
          Description: "Ce petit doute permanent : « et si… ? »",
          Out_put: "Remise en question, analyse et doute rationnel",
          Risk: "Honnêteté. Quand la vérité saute aux yeux, plus besoin de nous."
        },
        "37": {
          Company_Name: "Z Chute Libre Transport",
          Description: "Aïe, ça fait mal ! Mais c’était (presque) volontaire. Tu rigoles, tu perds.",
          Out_put: "Bleus au corps, bleus à l’ego",
          Risk: "Équilibre. Avec de la coordination, on tombe beaucoup moins."
        },
        "38": {
          Company_Name: "Z Décoiffés Corporation",
          Description: "Célébrer la beauté de l’imperfection et l’art du désordre.",
          Out_put: "Désordre stylé, improvisation et créativité débraillée",
          Risk: "Ménage. Le jour où ça brille, on est foutus."
        },
        "39": {
          Company_Name: "J Débat Systèmes",
          Description: "Jamais d’accord, toujours prêts à la joute verbale.",
          Out_put: "Discussions vives et clash d’idées",
          Risk: "Fatigue. Quand les gens sont trop crevés pour argumenter, on perd le public."
        },
        "40": {
          Company_Name: "Zo Égoïsme Industrie",
          Description: "Moi d’abord, le reste de la société peut crever.",
          Out_put: "Priorité absolue à soi-même",
          Risk: "Bouddhisme. Se détacher du soi rend l’égoïsme caduc."
        },
        "41": {
          Company_Name: "ZEGO Incorporée",
          Description: "Le rôle de l’auto-importance dans Moi MOI moi.",
          Out_put: "Culte du moi, besoin de reconnaissance, centrage sur soi",
          Risk: "Altruisme. Dès qu’on arrête de nourrir l’ego, on perd le pouvoir. Mettre les autres en premier et l’humilité sont nos pires menaces."
        },
        "42": {
          Company_Name: "Z Écouter Corporation",
          Description: "Le pouvoir de l’écoute attentive pour créer (un peu) d’intercompréhension.",
          Out_put: "Écoute réelle, savoir acquis, liens renforcés",
          Risk: "Ego. Si chacun n’attend que son tour pour parler, l’écoute disparaît."
        },
        "43": {
          Company_Name: "Z Optimiste Incorporée",
          Description: "Promouvoir la positivité et la conviction que « ça va s’arranger ».",
          Out_put: "Bonne humeur diffusée, croyance en de meilleurs lendemains",
          Risk: "Les infos. Quand la réalité rappelle sans cesse le désastre, l’optimisme se vend mal."
        },
        "44": {
          Company_Name: "Z Ils m’en veulent Systèmes",
          Description: "Paranoïa et interprétations délirantes de la vie.",
          Out_put: "Soupçons, complots imaginaires, lectures biaisées du quotidien",
          Risk: "Mer d’huile. Quand tout roule sans raison, la parano paraît ridicule."
        },
        "45": {
          Company_Name: "Z Peur Incorporée",
          Description: "L’émotion primaire qui déclenche le « fuir ou combattre » (et le surplace).",
          Out_put: "Réponses de survie, vigilance et frein au progrès",
          Risk: "Courage. Les intrépides ne se contrôlent pas."
        },
        "46": {
          Company_Name: "Z Sculpture Industries",
          Description: "Construire des marchés (et des formes) comme vous ne l’auriez jamais imaginé.",
          Out_put: "Formes 3D physiques et numériques, volumes, textures",
          Risk: "Dessin. Pourquoi sculpter quand on peut esquisser ? La simplicité du 2D nous menace."
        },
        "47": {
          Company_Name: "Zo Seul·e Corporation",
          Description: "Explorer l’expérience humaine en solitaire, voulue ou subie.",
          Out_put: "Solitude choisie, introspection, silence réparateur",
          Risk: "Parentalité. Quand une autre vie dépend de toi, la vraie solitude n’existe plus."
        },
        "48": {
          Company_Name: "Z Couleur Technologies",
          Description: "Révolution des pigments et de la vibrance visuelle.",
          Out_put: "Vibrance, émotion, sensations visuelles",
          Risk: "Obscurité. Sans lumière, la couleur devient… subtilement inexistante."
        },
        "49": {
          Company_Name: "Z Dîner Party Incorporée",
          Description: "Rassembler des gens autour de la bouffe, des conversations et d’une (bonne) bouteille.",
          Out_put: "Rencontres conviviales, échanges et toasts partagés",
          Risk: "Anti-social. Si personne ne veut s’engager, la fête ne démarre jamais."
        },
        "50": {
          Company_Name: "Zo Délire Industrie",
          Description: "La fine frontière entre rêves et attentes franchement irréalistes.",
          Out_put: "Réalité fictive souvent totalement ridicule",
          Risk: "Rationalité. Quand la logique s’impose, on perd la clientèle."
        },
        "51": {
          Company_Name: "Z Vacances Analytica Inc.",
          Description: "S’évader de chez soi : traditions et émotions quand on lâche le quotidien.",
          Out_put: "Parenthèse, évasion, souvenirs et décompression",
          Risk: "Pas d’argent/temps. Si on ne peut pas partir, on reste."
        },
        "52": {
          Company_Name: "Ze Triche Incorporée",
          Description: "Raccourcis, entorses aux règles et petites trahisons pour arriver vite au but.",
          Out_put: "Avantage indu, règles tordues et coups malins",
          Risk: "Morale. Si les gens jouent fair-play, on devient obsolètes."
        },
        "53": {
          Company_Name: "Zo Religions Incorporée",
          Description: "Foi, spiritualité et traditions culturelles qui façonnent les croyances, partout.",
          Out_put: "Communautés de foi, rites, sens et appartenance",
          Risk: "Athéisme. Si l’on cesse de croire, on n’a plus rien à vendre."
        },
        "54": {
          Company_Name: "Z Coup d’un Soir Inc.",
          Description: "Pas envie de te « dater » — juste de la valeur sans engagement.",
          Out_put: "Rencontres occasionnelles, plaisir non contraignant",
          Risk: "Réclusion. Si tout le monde se coupe des autres, le marché s’effondre."
        },
        "55": {
          Company_Name: "Zo Ami·e Très Spécial·e Inc.",
          Description: "Le genre d’ami qui offre des bénéfices très… chauds.",
          Out_put: "Ami·e avec avantages, proximité sans étiquette",
          Risk: "Engagement. Quand ça devient sérieux, on n’a plus d’utilité."
        },
        "56": {
          Company_Name: "Z Persécuté·e Corporation",
          Description: "Accusé·e, rabaissé·e, maintenu·e au sol par les préjugés des autres.",
          Out_put: "Injustice subie, oppression et lutte pour la dignité",
          Risk: "Pouvoir. Quand tu tiens les rênes, la persécution n’a plus de sens."
        },
        "57": {
          Company_Name: "Zo Autodestruction Corporation",
          Description: "Le versant sombre : brûler sa vie jusqu’aux fondations.",
          Out_put: "Effondrement personnel, sabotage et chaos émotionnel",
          Risk: "Santé mentale. Comprendre le pourquoi et réparer casse le cycle."
        },
        "58": {
          Company_Name: "Z Développement Théorie Systèmes",
          Description: "Développer le « pourquoi » de nos façons de penser.",
          Out_put: "Cadres de pensée structurés, modèles et concepts",
          Risk: "Divertissement. Si on préfère s’amuser que réfléchir, les théories deviennent décoratives."
        },
        "59": {
          Company_Name: "Z Apéro Corporation",
          Description: "C’est l’heure de trinquer — il est bien 17 h quelque part.",
          Out_put: "Désserrement du stress et huile sociale pour les rouages",
          Risk: "Mal de gorge. Si tu ne peux pas parler, tu ne peux pas porter un toast."
        },
        "60": {
          Company_Name: "Z Recherche & Données Systèmes",
          Description: "Creuser au fond du ventre de l’information.",
          Out_put: "Compréhension affinée de tout ce qu’on veut éclaircir",
          Risk: "Gueule de bois. Un esprit embrumé se fiche des faits."
        },
        "61": {
          Company_Name: "Z Cinéma & Popcorn Incorporée",
          Description: "Se caler et se laisser emporter par l’écran argenté — deux heures de vacances mentales.",
          Out_put: "Évasion du réel pendant quelques heures",
          Risk: "Lecture. Un monde qui ouvre des livres plutôt que des écrans résiste au divertissement passif."
        },
        "62": {
          Company_Name: "Z Câlins Industries",
          Description: "Améliorer la journée, une étreinte (ou plusieurs) à la fois.",
          Out_put: "Faire sentir accepté et aimé grâce à la chaleur humaine",
          Risk: "Solitude. Sans personne à serrer, la chaleur reste une idée abstraite."
        },
        "63": {
          Company_Name: "Z Baisers Industries",
          Description: "L’autre claque sur le visage — ou ailleurs — quand l’affection s’emballe (coquin… coquin…).",
          Out_put: "Exprimer l’amour et l’attirance par le contact",
          Risk: "Solitude. Personne à embrasser, aucun lien à tisser."
        },
        "64": {
          Company_Name: "Z Point de Vue Corporation",
          Description: "Distribuer son avis, demandé… ou pas.",
          Out_put: "Partage de perspectives personnelles",
          Risk: "Silence. Si personne n’écoute, un point de vue n’est qu’une pensée qui résonne dans le vide."
        },
        "65": {
          Company_Name: "Z Hydratation Incorporée",
          Description: "Difficile de rester vivant sans elle.",
          Out_put: "Hydratation vitale",
          Risk: "Mort. Sans eau, pas de survie — c’est simple."
        },
        "66": {
          Company_Name: "Z Études Industries",
          Description: "Accéder à des mondes au-delà de l’imagination.",
          Out_put: "Production et acquisition de savoir",
          Risk: "Économie de la distraction. Les algorithmes des réseaux volent l’attention."
        },
        "67": {
          Company_Name: "Z Rigolade Divertissement",
          Description: "L’essentiel pour faire rire — et garder les liens en vie.",
          Out_put: "Entretenir les relations par le rire et la bonne humeur",
          Risk: "Dépression. Un esprit plombé n’a plus l’énergie de rire."
        },
        "68": {
          Company_Name: "Z Systèmes d’Attention",
          Description: "Se concentrer dans un monde d’interruptions sans fin. (Pardon, j’ai décroché.)",
          Out_put: "Capacité à maintenir le focus, base de ce qu’on construit et retient",
          Risk: "Fatigue. L’épuisement mental étouffe même la meilleure attention."
        },
        "69": {
          Company_Name: "Z Voyeur Médias Incorporée",
          Description: "Laisser briller son côté voyeur, sans se faire voir.",
          Out_put: "Frisson d’observer, satisfaction d’être témoin invisible",
          Risk: "Maison à la campagne. Sans voisins, pas d’espionnage."
        },
        "70": {
          Company_Name: "Z Réveil Incorporée",
          Description: "Le rituel quotidien : se lever et repartir à neuf.",
          Out_put: "Sortir du lit, mettre la journée en marche",
          Risk: "Insomnie. Sans dormir, on ne « se réveille » pas vraiment."
        },
        "71": {
          Company_Name: "Z Glandouille Médias",
          Description: "Évasion ludique et joie des moments légers.",
          Out_put: "Se divertir en faisant l’andouille, seul ou à plusieurs",
          Risk: "Trop de travail. Quand les responsabilités débordent, il n’y a plus de place pour le fun."
        },
        "72": {
          Company_Name: "Z Dormeur Corporation",
          Description: "L’importance du repos et de la récupération pour l’esprit humain.",
          Out_put: "Temps de réparation du corps et de l’esprit",
          Risk: "Stress/Anxiété. Un mental agité refuse le sommeil et laisse l’épuisement."
        },
        "73": {
          Company_Name: "Z Jalousie Systèmes",
          Description: "La pelouse du voisin est toujours plus verte.",
          Out_put: "Carburant de la comparaison, de la compétition et du mécontentement",
          Risk: "Satisfaction. Si l’on apprécie ce qu’on a, la jalousie perd ses crocs."
        },
        "74": {
          Company_Name: "Z Désir Systèmes",
          Description: "Puiser dans les motivations et passions qui portent l’ambition et la création.",
          Out_put: "Force motrice des poursuites positives (et parfois moins…)",
          Risk: "Apathie. Quand on ne ressent plus rien, il n’y a plus de désir."
        },
        "75": {
          Company_Name: "Z Rire Industrie",
          Description: "Affiner l’art de l’humour pour éclairer les vies et remonter les moral(e)s.",
          Out_put: "Libération physique venue du ventre, encore meilleure en groupe",
          Risk: "Les nouvelles. Un flux constant de tragédies rend le rire luxueux."
        },
        "76": {
          Company_Name: "Z Identités Incorporée",
          Description: "Les couches subtiles de l’identité personnelle et collective dans un monde divers.",
          Out_put: "Le qui, le quoi et surtout le pourquoi de la perception de soi",
          Risk: "Racisme. Ne pas avoir le droit d’être soi."
        },
        "77": {
          Company_Name: "Z Blagues Divertissement",
          Description: "Des moments légers et un humour futé pour relier et amuser.",
          Out_put: "Transmission d’humour, qu’on l’ait demandé ou non",
          Risk: "Blagues de papa. Elles… (tu vois l’idée)."
        },
        "78": {
          Company_Name: "Z Prétentieux Industries",
          Description: "Le règne des apparences et de l’auto-importance — avec une pointe de muflerie.",
          Out_put: "Se présenter comme supérieur, plus raffiné, plus important que les autres",
          Risk: "Altruisme. Quand on se fiche d’apparences, la prétention ne vaut plus rien."
        },
        "79": {
          Company_Name: "Zo Frustré Incorporée",
          Description: "Saisir l’exaspération et la persévérance des galères quotidiennes.",
          Out_put: "Essayer encore et encore sans résultat (et recommencer)",
          Risk: "Succès. Quand ça marche, la frustration fond en satisfaction."
        },
        "80": {
          Company_Name: "Z Anti-Poussière Cie",
          Description: "L’art du ménage poussé jusqu’au sans-poussière éclatant.",
          Out_put: "Bien plus que passer l’aspirateur : extermination de la poussière",
          Risk: "La ville. Appartements sur rue et fenêtres ouvertes — la poussière refait surface."
        },
        "81": {
          Company_Name: "Z Vulgaire Corporation",
          Description: "Repousser les limites et chatouiller les normes avec une expression brute.",
          Out_put: "Affirmation d’individualité sans filtre",
          Risk: "Respect. Quand la bienséance prime, l’expression crue perd sa place."
        },
        "82": {
          Company_Name: "Z Rock & Décibels Industries",
          Description: "Capitaliser sur la musique forte qui coule dans les oreilles douze heures par jour.",
          Out_put: "Euphorie par la musique, le mouvement et l’énergie débridée",
          Risk: "Balados. Un monde qui préfère la parole au volume étouffe la puissance du son fort."
        },
        "83": {
          Company_Name: "Zo Éreinté Corporation",
          Description: "L’expérience universelle de l’épuisement.",
          Out_put: "Frein général à toute action, paupières lourdes, réflexion au ralenti",
          Risk: "Dérive. Errer sans horaires déjoue la fatigue… en évitant le « vrai » repos."
        },
        "84": {
          Company_Name: "Z Interactions Média",
          Description: "Échanges et liens à travers la diversité du vivant.",
          Out_put: "Relations, expériences partagées et échanges sociaux",
          Risk: "Ego. Quand l’intérêt personnel écrase le lien, l’interaction devient creuse."
        },
        "85": {
          Company_Name: "Zo Bricolo Incorporée",
          Description: "Réparer, monter, bidouiller avec adresse et ingéniosité.",
          Out_put: "Jouets réparés, étagères posées, cuisine prête à l’emploi, tout bricolage utile",
          Risk: "Rien à réparer. Si tout fonctionne, l’atelier ferme."
        },
        "86": {
          Company_Name: "Zo Bon Sens Technologie",
          Description: "Des solutions simples à des problèmes compliqués.",
          Out_put: "Application de logique et de jugement pour avancer efficacement",
          Risk: "Idiocie. Quand la pensée rationnelle est dévaluée, le bon sens s’évapore."
        },
        "87": {
          Company_Name: "Z Lave-Vaisselle Corporation",
          Description: "Tous les jours, après chaque repas.",
          Out_put: "Vaisselle propre pour le prochain festin (mains tièdes incluses)",
          Risk: "Repas dehors. Si on mange ailleurs, la vaisselle devient l’affaire des autres."
        },
        "88": {
          Company_Name: "Z Mémoire Logiciels",
          Description: "Préserver et muscler le souvenir par des outils futés.",
          Out_put: "Processus cognitifs et pratiques pour gagner en efficacité et éviter la redite",
          Risk: "Âge. Le temps qui passe grignote la mémoire et la productivité."
        },
        "89": {
          Company_Name: "Z Partenaires Incorporée",
          Description: "Derrière toute Bourse solide, une femme encore plus solide.",
          Out_put: "Lien intime et sûr, personnel et financier, moteur du succès commun",
          Risk: "Égoïsme. Quand l’individu prime, le duo ne sert plus à rien."
        },
        "90": {
          Company_Name: "Z Rêves Systèmes",
          Description: "Mystères et inspirations du sommeil paradoxal.",
          Out_put: "Restauration inconsciente, santé du corps et de l’esprit, porte du subconscient",
          Risk: "Fête chimique. Les substances brouillent rêves et repos profond."
        },
        "91": {
          Company_Name: "Zo Trône Ultra Frais Industries",
          Description: "Fraîcheur et propreté pour les lieux les plus visités.",
          Out_put: "Hygiène du royaume, senteur agréable et éclat poli",
          Risk: "Paresse. Si l’entretien flanche, la fraîcheur s’effondre."
        },
        "92": {
          Company_Name: "Ze Libido Industries",
          Description: "Passion et pulsions qui nourrissent lien et créativité.",
          Out_put: "Envie pressante de s’accoupler (oui, très pressante)",
          Risk: "Déprime/Froid. L’engourdissement mental ou physique éteint le désir."
        },
        "93": {
          Company_Name: "Z Sagesse Incorporée",
          Description: "Chercher connaissance et compréhension pour naviguer le chaos.",
          Out_put: "Lecture fine des complexités, clairvoyance et bon jugement",
          Risk: "Manque d’expérience. Sans vécu, la sagesse reste hors de portée."
        },
        "94": {
          Company_Name: "Z Stress Corporation",
          Description: "Raffiner le tas quotidien de pressions en pure valeur (ou presque).",
          Out_put: "Manifestation physiologique de la pression : l’extérieur devient tempête intérieure",
          Risk: "Argent. Quand la charge financière s’allège, le stress perd un pilier."
        },
        "95": {
          Company_Name: "Z Râleries Corporation",
          Description: "Dire les choses cash, soupape comprise.",
          Out_put: "Expression vocale du mécontentement, parfois appel au changement",
          Risk: "Accomplissement. Pas de souci, pas de plainte."
        },
        "96": {
          Company_Name: "Z Vide Corporation",
          Description: "Le creux de la journée qui demande : « à quoi bon ? »",
          Out_put: "Stagnation existentielle où but et élan semblent absents",
          Risk: "Réussite. Quand le sens revient, le vide se dissipe."
        },
        "97": {
          Company_Name: "Z Douleur Industries",
          Description: "Quand ça fait mal — quelque part ou partout.",
          Out_put: "Signal physique ou émotionnel qui exige attention, adaptation ou évitement",
          Risk: "Anesthésie. Substances qui rendent tout… muet."
        },
        "98": {
          Company_Name: "Z Odeur Corporation",
          Description: "L’invisible toujours présent dans la pièce.",
          Out_put: "Votre sillage : comment on vous sent (littéralement)",
          Risk: "Déodorant. La suppression artificielle gomme son influence."
        },
        "99": {
          Company_Name: "Ze Narcissique Corporation",
          Description: "Auto-admiration parce que « moi d’abord ».",
          Out_put: "Seul soi compte, peu importe les dégâts autour",
          Risk: "Écoute. L’attention réelle à l’autre fissure l’illusion de grandeur."
        },
        "100": {
          Company_Name: "Z Compliqué Incorporée",
          Description: "Toutes les petites pièces à prendre en compte pour comprendre l’ensemble.",
          Out_put: "Complexité débordante qui rend l’entente mutuelle introuvable",
          Risk: "Simplicité. Accueillir le détachement dissout l’encombrement mental."
        },
        "101": {
          Company_Name: "Z Baston Industries",
          Description: "Coups de poing, clés de bras et joutes d’idées en pleine face.",
          Out_put: "Affirmation de l’existence par confrontation physique ou intellectuelle",
          Risk: "Paix intérieure. Sans attachement, plus besoin de se battre."
        },
        "102": {
          Company_Name: "Zo Ver d’Oreille Groupe",
          Description: "Pluie, vent, froid ou soleil : tous les jours, sans faute.",
          Out_put: "Air, jingle ou mélodie qui tourne en boucle dans la tête",
          Risk: "Conversation. Un échange vif… et le ver cesse de grignoter."
        },
        "103": {
          Company_Name: "Z Célibataire Corporation",
          Description: "Le désir profond de flirter avec tout le bar (effet lunettes obligatoire).",
          Out_put: "Vie solo, disponible pour jouer",
          Risk: "Engagement. Dès qu’il arrive, le mode célib’ s’évapore."
        },
        "104": {
          Company_Name: "ZEvil Corporation",
          Description: "La malveillance pure — comme du 3G quand tout le monde a du 5G.",
          Out_put: "Pouvoir et ambition qui avancent par efficacité impitoyable",
          Risk: "Empathie. Le souci sincère des autres fissure la méchanceté."
        },
        "105": {
          Company_Name: "Z Bureaucratique Corporation",
          Description: "La bureaucratie : un voyage, pas une destination.",
          Out_put: "Blocage par couches de règles et lenteurs soigneusement empilées",
          Risk: "Infraction. Quand on contourne tout, la paperasse perd prise."
        },
        "106": {
          Company_Name: "Z Air Guitariste Corporation",
          Description: "Riffs imaginaires, vraie passion, oxygène en main.",
          Out_put: "Joie et expression déliées de toute utilité — dans le vide, littéralement",
          Risk: "Inhibition. La gêne tue le solo invisible net et sans retour."
        },
        "107": {
          Company_Name: "Zo Donner Corporation",
          Description: "Tendre la main sans réclamer quoi que ce soit en retour.",
          Out_put: "Générosité gratuite aux effets sociaux ou spirituels bien réels",
          Risk: "Égoïsme. Quand le gain personnel l’emporte, le don se grippe."
        },
        "108": {
          Company_Name: "Vorace Z Corporation",
          Description: "Appétit insatiable pour la vie : toujours plus de ce qui excite.",
          Out_put: "Désir sans fin de consommer, posséder ou vivre au-delà du nécessaire",
          Risk: "Jeûne. Refuser l’excès affaiblit la fringale infinie."
        },
        "109": {
          Company_Name: "Zo Excessif Corporation",
          Description: "La quête de l’excès, où « assez » n’existe pas.",
          Out_put: "Indulgence débridée : la mesure est laissée à la porte",
          Risk: "Satiété. Satisfait, l’excès devient vide."
        },
        "110": {
          Company_Name: "Z Confortable Corporation",
          Description: "La position parfaite entre aisance et contentement.",
          Out_put: "Repos du corps et de l’esprit, sans tension ni gêne",
          Risk: "Mauvais canapé. Si le confort s’effondre, la détente se change en agacement."
        },
        "111": {
          Company_Name: "Zo Bien Reposé Incorporée",
          Description: "L’art de lever le pied pour recharger les batteries.",
          Out_put: "État centré : la tension s’en va, la fatigue aussi",
          Risk: "Parentalité. Sans nuits paisibles, le calme reste théorique."
        },
        "112": {
          Company_Name: "Zo Se détendre Compagnie",
          Description: "Spécialiste du calme et des joies simples de la décontraction.",
          Out_put: "Absence d’agitation : esprit clair, existence apaisée",
          Risk: "Factures. Les obligations grignotent la paix intérieure."
        },
        "113": {
          Company_Name: "Zo Immobile Corporation",
          Description: "Rester planté là, entre action et inaction.",
          Out_put: "Stagnation générale : rien n’avance, rien ne bouge",
          Risk: "Croissance. Si tu grandis, tu n’es plus coincé."
        },
        "114": {
          Company_Name: "Z Aller En Avant Corporation",
          Description: "Célébrer l’élan qui pousse à avancer.",
          Out_put: "Progresser dans la direction désirée — projet, trottoir, vie",
          Risk: "Bureaucratie. Trop de règles casse l’élan."
        },
        "115": {
          Company_Name: "Zo Coincé Corporation",
          Description: "Tenter d’avancer avec le pied collé au sol.",
          Out_put: "Obstacles qui bloquent l’action et mènent à la stagnation",
          Risk: "Dérégulation. Sans entraves, l’obstacle disparaît et l’humeur aussi."
        },
        "116": {
          Company_Name: "Z Recul Incorporée",
          Description: "Glisser vers l’ombre, peu à peu, jusqu’à l’invisible.",
          Out_put: "Ce qui s’amenuise avec le temps — qualité, présence ou éclat",
          Risk: "Réussite. Surmonter rend la lutte obsolète… et le recul aussi."
        },
        "117": {
          Company_Name: "Z Voisin Incorporée",
          Description: "Fêtes bruyantes, bébés qui pleurent, poisson frit — la vie à deux portes d’écart.",
          Out_put: "Savoir-vivre en proximité immédiate",
          Risk: "Distance. Quand on s’éloigne, l’être-voisin se dissout."
        },
        "118": {
          Company_Name: "Zo Légal Corporation",
          Description: "Vivre avec structures, règles et responsabilités qui soutiennent l’ordre.",
          Out_put: "Adhésion aux cadres qui organisent la hiérarchie sociale",
          Risk: "Rébellion. « Casser la loi » suffit à casser la Loi."
        },
        "119": {
          Company_Name: "Z Confus Systèmes",
          Description: "Ces moments de perplexité où tout devient douteux. Hein ?",
          Out_put: "Incertitude : infos contradictoires, décision introuvable",
          Risk: "Recherche. Plus on sait, moins la confusion règne."
        },
        "120": {
          Company_Name: "Z Indécision Technologies",
          Description: "Le paradoxe du choix : mille dentifrices, zéro décision.",
          Out_put: "Paralysie devant l’abondance d’options, donc inaction",
          Risk: "Décision. Quand on tranche avec assurance, l’indécision disparaît."
        }, 
        "121": {
          Company_Name: "Z Célébrité Corporation",
          Description: "Projecteurs, gloire, ego et l’ivresse d’être adoré par la foule.",
          Out_put: "Soif d’attention, d’admiration et de validation qui façonne l’identité",
          Risk: "Normalité. Redevenir « comme tout le monde » fait retomber le soufflé."
        },
        "122": {
          Company_Name: "Z Défense Violente Corporation",
          Description: "Réponses calculées pour se protéger des menaces.",
          Out_put: "Riposte agressive face aux attaques physiques ou mentales",
          Risk: "Tolérance. Accepter la différence coupe l’herbe sous le pied à la violence."
        },
        "123": {
          Company_Name: "Zo Enfiler Ses Chaussures inc.",
          Description: "Le geste simple de sortir, sans oublier style et confort.",
          Out_put: "Des pantoufles aux bottes : hop, on chausse et on y va",
          Risk: "Plage. Si le monde autorise les pieds nus, les chaussures deviennent facultatives."
        },
        "124": {
          Company_Name: "Z Fils à Maman Corporation",
          Description: "Le lien unique et tenace entre une mère et son enfant.",
          Out_put: "Poids affectif de l’attachement, devoirs et tiraillements familiaux",
          Risk: "Grandir. L’autonomie émousse la culpabilité maternelle."
        },
        "125": {
          Company_Name: "Z Essayer Très Fort Industrie",
          Description: "Détermination et poursuite obstinée d’un but malgré tout.",
          Out_put: "Effort inlassable pour franchir les obstacles par pure volonté",
          Risk: "Frustration. Quand ça n’aboutit pas, l’acharnement vire à l’épuisement."
        },
        "126": {
          Company_Name: "Z Mince - C’est Cassé Corporation",
          Description: "Le chaos quand tout lâche en même temps.",
          Out_put: "Stress de la panne et de la casse, petites et grandes",
          Risk: "Remplacement. Acheter du neuf repousse l’orage à demain."
        },
        "127": {
          Company_Name: "Z Anxiété Industrie",
          Description: "Crainte tenace qui hurle du matin au soir (avec bonus mal de dos).",
          Out_put: "Inquiétude constante, pensées qui cavalent et tension corporelle",
          Risk: "Acceptation. Quand on trouve un socle, l’anxiété perd sa prise."
        },
        "128": {
          Company_Name: "Z Ennui Corporation",
          Description: "Désengagement total : rien ne mérite l’effort.",
          Out_put: "Plus rien de nouveau ni d’attirant : vide et bâillements",
          Risk: "Passion. L’ennemi juré de l’ennui."
        },
        "129": {
          Company_Name: "Z Présentation Soi Corporation",
          Description: "« Bonjour, je m’appelle… »",
          Out_put: "Se faire connaître, attirer l’attention et créer un premier lien",
          Risk: "Antisocial. Si tout le monde se retire, plus besoin de se présenter."
        },
        "130": {
          Company_Name: "Z&Z Répétition Incorporée",
          Description: "La routine du quotidien qui broie les jours en identiques.",
          Out_put: "Cycle monotone où la prévisibilité avale l’élan",
          Risk: "Changement. Un décor neuf brise la boucle."
        },
        "131": {
          Company_Name: "Zo Déçu Incorporée",
          Description: "L’expérience universelle des attentes non comblées.",
          Out_put: "Chute émotionnelle et impression de potentiel gâché",
          Risk: "Quand ça marche. La satisfaction n’a pas de place pour la déception."
        },
        "132": {
          Company_Name: "WOW Z Corporation",
          Description: "Pur émerveillement : le temps s’arrête, bouche ouverte.",
          Out_put: "Instant de stupeur où l’extraordinaire déborde le prévu",
          Risk: "L’ennui. Quand plus rien n’étonne, même l’imprévu tombe à plat."
        },
        "133": {
          Company_Name: "Z Aimable Corporation",
          Description: "Agir pour rendre la vie un peu plus douce.",
          Out_put: "Gentillesse, charme et art d’ensoleiller autrui",
          Risk: "Grossièreté. Sans égards, l’aimable tourne à l’hostile."
        },
        "134": {
          Company_Name: "Z Pessimiste Corporation",
          Description: "S’attendre au pire et s’y blottir comme dans une couette.",
          Out_put: "Détachement prudent : se préparer à la déception pour se protéger",
          Risk: "Positivité. Voir le bon côté tue la noirceur."
        },
        "135": {
          Company_Name: "Zo Débordé Incorporée",
          Description: "Trop à faire, pas assez d’heures.",
          Out_put: "Exécuter quantité de tâches indispensables",
          Risk: "Farniente. Quand on valorise le repos, le « débordé » s’évapore."
        },
        "136": {
          Company_Name: "Zo Inassouvi Corporation",
          Description: "Ce trou béant du quotidien qui murmure « pas assez ». ",
          Out_put: "Sensation persistante de manque : rien ne suffit, jamais",
          Risk: "Famille/Amis. Les liens profonds rendent le vide moins vorace."
        },
        "137": {
          Company_Name: "Zo Pas Compatible Technologie",
          Description: "Quand les systèmes refusent obstinément de s’accorder.",
          Out_put: "Incompatibilités qui forcent l’inefficacité et la crispation",
          Risk: "Simplicité. Rester simple rend (souvent) compatible."
        },
        "138": {
          Company_Name: "Zo Allô, Allô ?? Incorporée",
          Description: "Technologie avancée, mais communication basique en PLS.",
          Out_put: "Gadgets qui manquent leur fonction première — surtout les « intelligents »",
          Risk: "Ligne fixe. Une connexion simple balaie les caprices."
        },
        "139": {
          Company_Name: "Z Catastrophe Corporation",
          Description: "Quand tout s’écroule d’un coup, tout, tout de suite.",
          Out_put: "Tragédies et fiascos qui retournent la table",
          Risk: "Banalité. Une vie plate et prévisible n’alimente pas le drame."
        },
        "140": {
          Company_Name: "Z Batteries Industries",
          Description: "Ces objets qui meurent plus vite que prévu (toujours au mauvais moment).",
          Out_put: "Garder les appareils en vie malgré l’hémorragie d’énergie",
          Risk: "Prise murale. Branché au réseau, la batterie ne compte plus."
        },
        "141": {
          Company_Name: "Z Stress Informatique Systèmes",
          Description: "La vie moderne quand une pomme a un ver.",
          Out_put: "Tension mentale et physique due aux pannes et bugs",
          Risk: "Forums utiles. Quand la solution est à portée, la rage retombe."
        },
        "142": {
          Company_Name: "Z Une Barre Technologies",
          Description: "Grésillements, 3G mollasson, roue qui tourne.",
          Out_put: "Isolement et stress d’être déconnecté",
          Risk: "Bonne couverture. Beaucoup de barres, beaucoup de paix."
        },
        "143": {
          Company_Name: "Z Erreur Port 411 Systèmes",
          Description: "Quand le système plante et refuse de renaître.",
          Out_put: "Arrêt brutal qui fige le progrès et sème le doute",
          Risk: "Tutoriel. Le savoir transforme l’erreur en leçon."
        },
        "144": {
          Company_Name: "Z Service Client Corporation",
          Description: "Quand c’est cassé, ils aident… ou font semblant.",
          Out_put: "Aide fournie pour résoudre un souci — sincère ou cosmétique",
          Risk: "Robot de tchat. Le « non-secours » le plus inutile du monde."
        },
        "145": {
          Company_Name: "Z Coolitude Corporation",
          Description: "Assurance muette, charme sans effort, vibe imparable.",
          Out_put: "Avoir la dégaine et l’aura qui vont avec",
          Risk: "Suiveurs. Si l’on copie pour valider, la coolitude perd sa valeur."
        },
        "146": {
          Company_Name: "Zo Fort Incorporated",
          Description: "Talent, savoir-faire et bonté là où ça compte.",
          Out_put: "Satisfaction tangible née de l’excellence et de la gentillesse",
          Risk: "Le Mal. Quand l’excellence est ignorée, « être bon » ne paie plus."
        },
        "147": {
          Company_Name: "Lâcher Prise Corporation",
          Description: "Avancer et trouver la paix en lâchant prise.",
          Out_put: "Soulagement par l’acceptation du passé",
          Risk: "Anxiété. Un esprit accroché aux soucis ne lâche rien."
        },
        "148": {
          Company_Name: "Z Encore & Encore Incorporée",
          Description: "La nature cyclique de la vie et ses boucles tenaces.",
          Out_put: "Influence des répétitions et routines sur le réel",
          Risk: "Vacances. Une rupture de rythme casse le cycle."
        },
        "149": {
          Company_Name: "Z Acheteur Incorporée",
          Description: "Prendre soin du consommateur qui sommeille en chacun.",
          Out_put: "Accumulation d’objets et de petites joies à la caisse",
          Risk: "Pas d’argent. Sans budget, la frénésie ralentit."
        },
        "150": {
          Company_Name: "Z Agonie Corporation",
          Description: "Le pan de vie défini par la douleur, physique ou morale.",
          Out_put: "Réaction brûlante au souffrir — vécu ou observé",
          Risk: "Bonheur. Quand le bien-être dure, la douleur perd le micro."
        },
        "151": {
          Company_Name: "Z Parce Que Je Le Dis Corporation",
          Description: "Pourquoi ? Parce que je le pense. Point.",
          Out_put: "Conviction exprimée sans preuve, mais avec aplomb",
          Risk: "Aphonie. Sans voix, la certitude reste coincée."
        },
        "152": {
          Company_Name: "On Va Tous Mourir Corporation",
          Description: "Courir tant qu’on peut : personne ne sort d’ici vivant.",
          Out_put: "Détermination téméraire à vivre pleinement, conscience de la fin",
          Risk: "Prévoir. Planifier l’avenir freine l’élan casse-cou."
        },
        "153": {
          Company_Name: "Zo Addict Incorporée",
          Description: "Envie plus forte que la volonté — et te voilà accro.",
          Out_put: "Désir qui déborde l’autocontrôle et crée la dépendance",
          Risk: "Abstinence. Renoncer à l’objet du manque coupe les revenus."
        },
        "154": {
          Company_Name: "Z Expliquer Corporation",
          Description: "Rendre les idées claires, une bouchée à la fois.",
          Out_put: "Démontage de concepts complexes en savoir digeste",
          Risk: "Hurler. Crier n’a jamais amélioré la compréhension."
        },
        "155": {
          Company_Name: "Zoriginal Technologies",
          Description: "Ne pas faire comme les autres.",
          Out_put: "Création distincte et identité authentique qui se démarquent",
          Risk: "Copie. Quand l’imitation règne, l’unique se dilue."
        },
        "156": {
          Company_Name: "Plein de Z… Corporation",
          Description: "Avoir toutes les réponses — aucune de correcte.",
          Out_put: "Discours convaincant mais creux pour garder la main",
          Risk: "Se taire. Le silence coupe le courant du baratin."
        },
        "157": {
          Company_Name: "Z Reclus Corporation",
          Description: "Rester chez soi pour éviter le vacarme du monde.",
          Out_put: "Maison, pyjama, paix — et porte close",
          Risk: "Beau temps. Quand dehors invite, dedans perd son charme."
        },
        "158": {
          Company_Name: "Zo Réussi Corporation",
          Description: "Quand ce que tu fais… marche.",
          Out_put: "Objectifs atteints avec résultats tangibles",
          Risk: "Échec. Si ça ne marche pas, ça n’existe pas."
        },
        "159": {
          Company_Name: "Zo 9-à-5 Incorporée",
          Description: "La routine pour gagner sa vie (plutôt 9-à-8).",
          Out_put: "Travailler pour assurer besoins et stabilité",
          Risk: "Épuisement. Quand la fatigue dépasse le salaire, la mécanique casse."
        },
        "160": {
          Company_Name: "Z Parler à Zoi Corporation",
          Description: "Quand personne n’écoute, raconte-toi… à toi.",
          Out_put: "Dialogue auto-alimenté, à voix haute ou dans la tête",
          Risk: "Vie sociale. Si le monde répond, le monologue n’a plus lieu d’être."
        },
        "161": {
          Company_Name: "Zo Intellectuel Média Corporation",
          Description: "Le socle pour se fabriquer un meilleur cerveau… qui parfois tourne en rond.",
          Out_put: "Construire et étendre le savoir, forger des idées et affûter l’esprit",
          Risk: "Réseaux sociaux. La consommation passive remplace l’effort intellectuel actif."
        },
        "162": {
          Company_Name: "Z Grignote Corporation",
          Description: "Le petit plaisir de picorer entre les repas.",
          Out_put: "Grignotage en douce, juste une bouchée… ou deux",
          Risk: "Régime. La restriction coupe court au plaisir improvisé."
        },
        "163": {
          Company_Name: "Zo Ferklempt Média",
          Description: "Ces vagues d’émotion — amour, culpabilité, vie — qui nouent la gorge.",
          Out_put: "Submergé d’émotions : on est tout chaviré",
          Risk: "Zen. L’équilibre émotionnel est notre kryptonite."
        },
        "164": {
          Company_Name: "Zo Parano Corporation",
          Description: "Mettre en lumière la suspicion qui grésille et l’inquiétude qui gratte.",
          Out_put: "Hypervigilance et soupçon qui poussent à se blinder",
          Risk: "Assurance intérieure. Quand on se sent en sécurité, la parano s’éteint."
        },
        "165": {
          Company_Name: "Zo Honnête Corporation",
          Description: "Tendance incurable à pencher vers la vérité, quoi qu’il en coûte.",
          Out_put: "Franchise qui tranche les flous et dégonfle les mensonges",
          Risk: "Diplomatie. Quand la forme prime, la vérité brute gêne."
        },
        "166": {
          Company_Name: "Faux Z Corporation",
          Description: "Quand l’authenticité manque mais qu’on joue quand même le rôle.",
          Out_put: "Présenter un faux soi, dissonance entre paraître et être",
          Risk: "Honnêteté. Quand la sincérité règne, plus besoin de masque."
        },
        "167": {
          Company_Name: "Z Fierté Technologies",
          Description: "Joie et assurance d’être fier de son identité et de ses réussites.",
          Out_put: "Valeur personnelle tirée des accomplissements et du statut",
          Risk: "Échec. Les attentes qui s’effondrent rappellent à l’ego la réalité."
        },
        "168": {
          Company_Name: "Z Souvenirs Incorporée",
          Description: "Se rappeler ceci, cela, tout cela — seul ou à plusieurs.",
          Out_put: "La joie de revivre hier et de partager la nostalgie",
          Risk: "Futur. Quand on regarde devant, le passé lâche prise."
        },
        "169": {
          Company_Name: "Z Téléphonie Technologies",
          Description: "Réduire les distances et nourrir le lien, en direct et fort.",
          Out_put: "Communication audio en temps réel",
          Risk: "Batterie morte. Plus d’appareil, plus de conversation."
        },
        "170": {
          Company_Name: "Z Payer les Factures Corporation",
          Description: "La quête sans fin pour honorer les obligations du mois.",
          Out_put: "Nécessité constante de régler, budgéter, couvrir",
          Risk: "Chômage. Plus de revenus : les factures changent… de priorité."
        },
        "171": {
          Company_Name: "Z Karma Incorporée",
          Description: "Le grand équilibre actions/conséquences — l’éternel débat du juste.",
          Out_put: "Justice cosmique proportionnée au comportement",
          Risk: "Mauvaise éducation. Si rien n’a de suites, le système se casse."
        },
        "172": {
          Company_Name: "Z Menteur Corporation",
          Description: "Quand la vérité est trop lourde, on s’en passe.",
          Out_put: "Vérité tordue et perception trafiquée : la tromperie",
          Risk: "Conscience. Avec une boussole morale, mentir devient inutile."
        },
        "173": {
          Company_Name: "Z Regarder le Match Média",
          Description: "Bière, canapé, grand écran, arbitrage pourri — amour du jeu quand même.",
          Out_put: "Divertissement et sujets de causerie collective",
          Risk: "Hors saison. Sans matchs, l’union se met en pause."
        },
        "174": {
          Company_Name: "Zo Achevé à Terre Incorporée",
          Description: "Quand on te rajoute une couche alors que tu es déjà à plat.",
          Out_put: "Être sapé, freiné, écrasé par des forces hors de contrôle",
          Risk: "Coup de main. Le soutien transforme la rage en ressort."
        },
        "175": {
          Company_Name: "Tout Ze Passe Bien Corporation",
          Description: "Quand tout glisse et que tout marche.",
          Out_put: "Avancée fluide sans obstacle ni résistance",
          Risk: "La Vie. L’imprévu adore casser les trajectoires parfaites."
        },
        "176": {
          Company_Name: "Zuch un Bon Nigaud Corporation",
          Description: "Nos belles bourdes préférées — embrasser le faux pas.",
          Out_put: "Ne pas comprendre… et apprendre en se trompant",
          Risk: "Retenue. Prendre le temps et peser ses réponses coupe la casse."
        },
        "177": {
          Company_Name: "Z Surfeur du Web Technologies",
          Description: "Vagues de savoir, bobards, détours, magouilles et… vous voyez.",
          Out_put: "Tout, n’importe quoi, tout le temps",
          Risk: "Blackout. Pas de courant, pas de toile."
        },
        "178": {
          Company_Name: "Zo Créatif Incorporée",
          Description: "Faire naître quelque chose à partir de rien.",
          Out_put: "Transformer l’imagination en réalité tangible",
          Risk: "Sur-stimulation. Trop d’entrées étouffent la création."
        },
        "179": {
          Company_Name: "Zo Fainéanter Corporation",
          Description: "Devenir un avec le canapé. Mollement.",
          Out_put: "Se fondre dans le confort sans urgence aucune",
          Risk: "Beaucoup de boulot. Quand les tâches s’empilent, la sieste devient luxe."
        },
        "180": {
          Company_Name: "Zo Stylé Corporation",
          Description: "Faire une déclaration par l’habit et la singularité.",
          Out_put: "Projection de soi par la mode et l’allure",
          Risk: "Indifférence. Si personne ne s’en soucie, l’effet tombe."
        },
        "181": {
          Company_Name: "Z S’habiller Corporation",
          Description: "L’habit comme expression de soi et première impression.",
          Out_put: "Choisir la tenue du jour et l’enfiler dignement",
          Risk: "Panier sale. Sans linge propre, le style perd sa magie."
        },
        "182": {
          Company_Name: "Z Observation Incorporée",
          Description: "Découvrir en regardant et en écoutant vraiment.",
          Out_put: "Repérer des motifs et décider mieux en prêtant attention",
          Risk: "Fatigue. L’esprit épuisé confond observer et vagabonder."
        },
        "183": {
          Company_Name: "Z Questionner Corporation",
          Description: "La compréhension par l’art de la bonne question.",
          Out_put: "Curiosité + esprit critique pour demander « pourquoi ? »",
          Risk: "Je-m’en-foutisme. L’indifférence tue l’enquête."
        },
        "184": {
          Company_Name: "Z Lecteur Incorporée",
          Description: "Boire les pages des bibliothèques du monde.",
          Out_put: "Absorber savoirs, capitaux de vue et expériences par la lecture",
          Risk: "Épuisement. Quand on tombe de sommeil, lire devient impossible."
        },
        "185": {
          Company_Name: "Z Gommage & Éclat Corporation",
          Description: "Frais de la tête aux pieds : soin de soi et peau qui chante.",
          Out_put: "Propreté, revitalisation et chouchoutage personnel",
          Risk: "Camping. Quand l’hygiène passe derrière, l’entretien s’évapore."
        },
        "186": {
          Company_Name: "Z Lave-Mains Corporation",
          Description: "Savonner pour l’hygiène, un bon frottage à la fois.",
          Out_put: "Mains propres, sans microbes ni virus",
          Risk: "Pas de savon. Sans outil, la propreté se débine."
        },
        "187": {
          Company_Name: "Z Programmation Technologie",
          Description: "Des 1 et des 0 pour faire tourner le monde numérique.",
          Out_put: "Programmes fonctionnels qui font ce qu’ils doivent",
          Risk: "Bugs. Quand le code ne calcule plus, tout coince."
        },
        "188": {
          Company_Name: "Zo Attractif Corporation",
          Description: "Ces qualités qui captivent — dedans comme dehors.",
          Out_put: "Attrait physique, émotionnel et mental qui éveille le désir",
          Risk: "Flemme. Sans effort, l’éclat se ternit."
        },
        "189": {
          Company_Name: "Ze Séduction Incorporée",
          Description: "L’art de l’aimantation : charme, envie, magnétisme.",
          Out_put: "Force d’attirance qui entraîne et envoûte",
          Risk: "Indifférence. Si personne n’accroche, la magie s’évanouit."
        },
        "190": {
          Company_Name: "Z Célébration & Cie",
          Description: "Faire grimper la joie lors des grands et petits moments.",
          Out_put: "Rituels, tablées et éclats qui amplifient l’occasion",
          Risk: "Alcool. L’excès transforme la fête en chaos."
        },
        "191": {
          Company_Name: "Z Réflexion Inc.",
          Description: "Soutenir la croissance personnelle et l’introspection.",
          Out_put: "Se connaître, se corriger, évoluer — doucement mais sûrement",
          Risk: "Ego. Être toujours « sûr d’avoir raison » bloque le miroir."
        },
        "192": {
          Company_Name: "Z Aventure Groupe",
          Description: "Oser explorer loin de sa zone de confort.",
          Out_put: "Expériences qui bousculent et stimulent corps et esprit",
          Risk: "Peur. Trop effrayé : l’aventure meurt avant le départ."
        },
        "193": {
          Company_Name: "Z Harmonie Industries",
          Description: "Trouver l’équilibre et la paix dans ce qu’on fait.",
          Out_put: "Rythme, flux et douceur pour une existence paisible",
          Risk: "Chaos. Quand tout s’emballe, l’harmonie sort du cadre."
        },
        "194": {
          Company_Name: "Z Perte Inc.",
          Description: "Apprivoiser le deuil et l’absence.",
          Out_put: "Douleur et chagrin au cœur et dans la tête",
          Risk: "Zone de confort. Rester à l’abri peut retarder la rencontre… un temps."
        },
        "195": {
          Company_Name: "Z Passion Sans Limites",
          Description: "Faire quoi que ce soit avec toute l’intensité possible.",
          Out_put: "Énergie dévorante pour aimer, créer et aller au bout",
          Risk: "Alzheimer. Quand le souvenir s’efface, la flamme se morcelle."
        },
        "196": {
          Company_Name: "Z Résilience Works",
          Description: "Continuer à avancer quand ça tape dur.",
          Out_put: "Tenir bon, s’adapter et progresser malgré l’adversité",
          Risk: "Crash. Au point de rupture, même la résilience plie."
        },
        "197": {
          Company_Name: "Z Curiosité Labs",
          Description: "La quête à vie du « pourquoi » émerveillé.",
          Out_put: "Chercher l’inconnu et ouvrir des portes",
          Risk: "Conformisme. Suivre la norme n’a pas de place pour « pourquoi »."
        },
        "198": {
          Company_Name: "Z Triomphe Corporation",
          Description: "Mettre en valeur les victoires, petites et grandes.",
          Out_put: "Sentiment d’avoir gagné sa journée",
          Risk: "Deuxième place. Ne pas gagner, c’est… ne pas gagner."
        },
        "199": {
          Company_Name: "Z Bâtisseurs de Communauté",
          Description: "Tisser des liens par des expériences partagées.",
          Out_put: "Soutien et sécurité autour de ce qui soude le groupe",
          Risk: "Individualisme. Quand le « moi » écrase le « nous »."
        },
        "200": {
          Company_Name: "ZO Bourré Company",
          Description: "Quand la vie vous mène à l’ivresse. *Hic, hic.*",
          Out_put: "Tête qui tourne, langue qui fourche, plus de filtres",
          Risk: "Responsabilité. Boire en adulte garde le taux dans le vert."
        },
        "201": {
          Company_Name: "Marche-dans-la-Merde Société",
          Description: "Zut, encore le pied dedans…",
          Out_put: "Réflexe dégoûté et nettoyage express, puis auto-dérision pour survivre à l’odeur.",
          Risk: "Glissade, colère dramatique, traces partout."
        },
        "202": {
          Company_Name: "Tractus Digestif Systèmes",
          Description: "Transformer le casse-croûte en carburant… ou en catastrophe.",
          Out_put: "Énergie, assimilation, évacuation harmonieuse (dans les bons jours).",
          Risk: "Ballonnements, crampes, lenteur, dérèglement général."
        },
        "203": {
          Company_Name: "Auto-Câlin Industries",
          Description: "Solo, discret, efficace — avec ou sans film du soir.",
          Out_put: "Détente, soulagement, intimité personnelle sans rendez-vous.",
          Risk: "Culpabilité, excès, isolement, perte d’élan social."
        },
        "204": {
          Company_Name: "Z Miam Industries",
          Description: "Mettre quelque chose de bon dans la bouche pour rester vivant.",
          Out_put: "Satiété, force, bonne humeur et traditions à table.",
          Risk: "Frigo vide, surconsommation, culpabilité et gaspillage."
        },
        "205": {
          Company_Name: "Z Crac Entreprises",
          Description: "Le son brutal qui dit que quelque chose vient de casser.",
          Out_put: "Rupture nette : de l’objet au moral, ça fait toujours mal.",
          Risk: "Casse répétée, coûts cachés, perte de confiance."
        },
        "206": {
          Company_Name: "Rire Zélé Corporation",
          Description: "Quand le fou rire prend le dessus, impossible de s’arrêter.",
          Out_put: "Larmes aux yeux, ventre douloureux, mais âme légère.",
          Risk: "Inopportunité, moqueries, malaise social."
        },
        "207": {
          Company_Name: "Z Gaffe Industries",
          Description: "Le moment gênant qu’on aurait préféré éviter.",
          Out_put: "Rougeurs, excuses maladroites, rires parfois complices.",
          Risk: "Humiliation, perte de crédibilité, rancunes."
        },
        "208": {
          Company_Name: "Éternuement Z Société",
          Description: "Le réflexe explosif qui libère mais surprend.",
          Out_put: "Soulagement immédiat, regards détournés ou bénédiction attendue.",
          Risk: "Microbes dispersés, malaise en public, crise d’allergie."
        },
        "209": {
          Company_Name: "Z Amour Fou Corporation",
          Description: "La passion dévorante qui fait tout vibrer.",
          Out_put: "Fusion, exaltation, énergie créatrice.",
          Risk: "Dépendance, jalousie, cœur brisé."
        },
        "210": {
          Company_Name: "Insomnie Z Systèmes",
          Description: "Compter les moutons jusqu’à l’aube sans jamais dormir.",
          Out_put: "Yeux cernés, idées confuses, productivité en chute.",
          Risk: "Burnout, anxiété, perte de santé mentale."
        },
        "211": {
          Company_Name: "Z Gueule de Bois Industries",
          Description: "Le réveil brutal après la fête.",
          Out_put: "Soif extrême, mal de tête et promesse de ‘plus jamais’.",
          Risk: "Répétition, santé abîmée, productivité détruite."
        },
        "212": {
          Company_Name: "Z Mensonge Corporation",
          Description: "L’art de tordre la vérité pour survivre ou séduire.",
          Out_put: "Protection, manipulation, gain temporaire.",
          Risk: "Perte de confiance, piège des mensonges accumulés."
        },
        "213": {
          Company_Name: "Z Vérité Brutale Industries",
          Description: "Dire tout haut ce que personne ne voulait entendre.",
          Out_put: "Clarté, authenticité, parfois libération.",
          Risk: "Blessures, conflits, solitude."
        },
        "214": {
          Company_Name: "Panne Totale Société",
          Description: "Quand tout s’arrête soudainement.",
          Out_put: "Silence, chaos, obligation d’improviser.",
          Risk: "Pertes, panique, paralysie du système."
        },
        "215": {
          Company_Name: "Z Frisson Corporation",
          Description: "Ce frémissement qui parcourt la peau au son ou au froid.",
          Out_put: "Chair de poule, excitation, montée d’adrénaline.",
          Risk: "Froid, peur exagérée, hypersensibilité."
        },
        "216": {
          Company_Name: "Z Colère Noire Industries",
          Description: "Quand la rage monte et qu’on explose.",
          Out_put: "Cri, geste brusque, libération violente.",
          Risk: "Ruptures, regrets, dégâts collatéraux."
        },
        "217": {
          Company_Name: "Z Faim de Loup Société",
          Description: "Le ventre qui crie plus fort que la raison.",
          Out_put: "Dévorer sans attendre, plaisir animal.",
          Risk: "Excès, indigestion, impatience sociale."
        },
        "218": {
          Company_Name: "Z Joie Pure Corporation",
          Description: "L’instant simple où tout paraît parfait.",
          Out_put: "Sourires partagés, légèreté contagieuse.",
          Risk: "Éphémère, nostalgie en retour, jalousie des autres."
        },
        "219": {
          Company_Name: "Z Tristesse Industries",
          Description: "Les larmes silencieuses qui noient la poitrine.",
          Out_put: "Libération, introspection, authenticité émotionnelle.",
          Risk: "Isolement, dépression, incompréhension."
        },
        "220": {
          Company_Name: "Z Panique Corporation",
          Description: "Quand tout semble hors de contrôle en un instant.",
          Out_put: "Fuite, cris, gestes désordonnés.",
          Risk: "Erreurs fatales, perte de crédibilité, traumatisme."
        },
        "221": {
          Company_Name: "Z Descente en Spirale Transports",
          Description: "Brûler la chandelle par les deux bouts, à son propre détriment.",
          Out_put: "Auto-sabotage : relations, santé et bonheur partent en vrille.",
          Risk: "Responsabilité. Avec cadre et discipline, la chute ralentit."
        },
        "222": {
          Company_Name: "Z Inspirées Industries",
          Description: "Mots, images et sons qui te hissent plus haut.",
          Out_put: "L’élan de faire : l’étincelle créative qui met en route.",
          Risk: "Post-modernisme. Si tout est vain, à quoi bon ?"
        },
        "223": {
          Company_Name: "Z Irrationnel Corporation",
          Description: "La peur de la catastrophe au coin de la rue.",
          Out_put: "Anticipation anxieuse qui déforme la réalité.",
          Risk: "Logique. Un esprit rationnel dissipe la trouille."
        },
        "224": {
          Company_Name: "Zo Hystérique Corporation",
          Description: "Le chaos débridé, comme si tes cheveux brûlaient.",
          Out_put: "Agitation incontrôlée : tout part en sucette.",
          Risk: "Calme. Un esprit posé éteint l’hystérie."
        },
        "225": {
          Company_Name: "Z Empereur Société",
          Description: "Marcher comme si tu régnais sur ton royaume.",
          Out_put: "Croyance souveraine en sa propre autorité.",
          Risk: "Réalité. Une bonne dose d’humilité te redescend."
        },
        "226": {
          Company_Name: "Z Chaotique Inc.",
          Description: "La pagaille totale dans le tourbillon de la vie.",
          Out_put: "Désordre, imprévisible et incontrôlable.",
          Risk: "Méditation. L’immobilité remet de l’ordre."
        },
        "227": {
          Company_Name: "Zo Micro-agressions Industries",
          Description: "Les petites piqûres de mots et gestes qui laissent des traces.",
          Out_put: "Blessures minuscules, effets bien réels.",
          Risk: "Politesse. Un soupçon de courtoisie change tout."
        },
        "228": {
          Company_Name: "Z Danse Inc.",
          Description: "Bouger sur le groove — seul·e ou ensemble.",
          Out_put: "Corps en rythme, lien par le mouvement.",
          Risk: "Pas de musique. Sans battement, même les meilleurs hésitent."
        },
        "229": {
          Company_Name: "Z Effondrement Inc.",
          Description: "Quand la lumière vacille et que tout s’écroule.",
          Out_put: "Ruine émotionnelle et structurelle.",
          Risk: "Succès. Quand ça marche, l’effondrement s’éclipse."
        },
        "230": {
          Company_Name: "Zo Heureux Corporation",
          Description: "La joie quand ça se passe comme tu voulais.",
          Out_put: "Contentement et plaisir à l’état pur.",
          Risk: "Complication. Trop réfléchir efface le sourire."
        },
        "231": {
          Company_Name: "Zo Insomnie Corporation",
          Description: "Yeux fermés, cerveau allumé : dormir ? Que dalle.",
          Out_put: "Impossible de dormir, l’esprit en moulinette.",
          Risk: "Médicaments. La chimie peut court-circuiter la veille."
        },
        "232": {
          Company_Name: "Z Douleurs d’Estomac Systèmes",
          Description: "Gaz, ballonnements, ulcères : le ventre en vrac.",
          Out_put: "Inconfort viscéral qui envahit tout.",
          Risk: "Médicaments. La chimie rééquilibre (parfois)."
        },
        "233": {
          Company_Name: "Zo Honte Corporation",
          Description: "Ce fichu sentiment d’avoir trop merdé.",
          Out_put: "Gêne, culpabilité, rouge aux joues.",
          Risk: "Pardon. L’acceptation dissout la honte."
        },
        "234": {
          Company_Name: "Z Ascension Inc.",
          Description: "Cap vers l’azur : grimper vers sa réussite.",
          Out_put: "Élan ascendant d’ambition et de progrès.",
          Risk: "Échec. Un accroc et la montée s’arrête."
        },
        "235": {
          Company_Name: "Z & Cléopâtre Banque Relationnelle",
          Description: "Ta relation à deux.",
          Out_put: "Amour, intimité, sécurité émotionnelle.",
          Risk: "Conflit. La dispute vide le compte affectif."
        },
        "236": {
          Company_Name: "Zo En Retard Corporation",
          Description: "Quand l’heure passe et toi non.",
          Out_put: "Temps volé aux autres, tension assurée.",
          Risk: "Respect. Se soucier du temps d’autrui."
        },
        "237": {
          Company_Name: "Zo Charme Corporation",
          Description: "Séduction + esprit + verbe bien tourné.",
          Out_put: "Fluidité des échanges, portes qui s’ouvrent.",
          Risk: "Inauthenticité. Vu comme manip, ça se retourne."
        },
        "238": {
          Company_Name: "Zo Débordé Inc.",
          Description: "Trop, trop vite, tout en même temps.",
          Out_put: "Poids sur la poitrine, souffle court.",
          Risk: "Méditation. Le calme remet du souffle."
        },
        "239": {
          Company_Name: "Z Professeurs Industries",
          Description: "Le partage du savoir.",
          Out_put: "Esprits un brin plus éclairés qu’avant.",
          Risk: "Vacances. La boucle s’interrompt."
        },
        "240": {
          Company_Name: "Zo Efficace Industries",
          Description: "Aller de A à B à la vitesse de l’éclair.",
          Out_put: "Plus de choses faites, mieux et plus vite.",
          Risk: "Maladie. Un corps faible coupe l’élan."
        },
        "241": {
          Company_Name: "Zo Constipé Corporation",
          Description: "Le tronc d’arbre qui refuse la sortie.",
          Out_put: "Ventre gonflé, inconfort tenace.",
          Risk: "Laxatif. La bonne clé libère l’écluse."
        },
        "242": {
          Company_Name: "Zo Affamé Corporation",
          Description: "La faim qui gronde et rend grognon.",
          Out_put: "Irritabilité et glycémie en berne.",
          Risk: "Frigo plein. Beaucoup de victuailles, faim au loin."
        },
        "243": {
          Company_Name: "Z Linge Sale Corporation",
          Description: "Frotter le linge pour l’odeur de printemps.",
          Out_put: "Du défraîchi au frais repassé.",
          Risk: "Flemme. Sans machine, jamais nickel."
        },
        "244": {
          Company_Name: "Z Affaires Inc.",
          Description: "Négocier et brasser pour que ça marche.",
          Out_put: "Gagner sa croûte en vendant ce qu’on fait.",
          Risk: "Récession. L’économie tousse, tout s’arrête."
        },
        "245": {
          Company_Name: "Z Chance Corporation",
          Description: "Le coup du sort qui n’en fait qu’à sa tête.",
          Out_put: "Bons hasards, petits trèfles et grands sourires.",
          Risk: "Poisse. Quand la chance tourne, fini la magie."
        },
        "246": {
          Company_Name: "Z Planche Corporation",
          Description: "Glisser dans la rue avec style.",
          Out_put: "Plaisir debout sur une planche en mouvement.",
          Risk: "Météo. Pas de vagues, rues trempées."
        },
        "247": {
          Company_Name: "ZEXPO Inc.",
          Description: "S’engourdir délicieusement devant l’art — partout.",
          Out_put: "Montrer son travail au monde.",
          Risk: "Gardiens du temple. Sans sésame, personne ne voit."
        },
        "248": {
          Company_Name: "Z Procrastination Systèmes",
          Description: "Maîtres du « demain » pendant que l’angoisse gonfle.",
          Out_put: "Tâches en attente, échéances qui mordent.",
          Risk: "Deadlines. Une vraie date coupe court."
        },
        "249": {
          Company_Name: "Z Deuil Corporation",
          Description: "La profondeur de la perte et du chagrin.",
          Out_put: "Traverser la douleur pour guérir.",
          Risk: "Égoïsme. Trop garder pour soi bloque la guérison."
        },
        "250": {
          Company_Name: "Z Confiance Inc.",
          Description: "Le socle des liens solides.",
          Out_put: "Sécurité, foi en l’autre, fiabilité.",
          Risk: "Trahison. Promesses brisées et mensonges cassent tout."
        },
        "251": {
          Company_Name: "Zo Humble Corporation",
          Description: "Une confiance tranquille, sans fanfaronnade.",
          Out_put: "Respect mutuel et apprentissage permanent.",
          Risk: "Ego. Trop d’ego sabote l’humilité."
        },
        "252": {
          Company_Name: "Zo Généreux Corporation",
          Description: "Mettre l’autre avant soi, sans ticket de caisse.",
          Out_put: "Générosité, sacrifice, gentillesse gratuite.",
          Risk: "Égoïsme. Quand le « moi » s’impose, ça s’éteint."
        },
        "253": {
          Company_Name: "Z Maman Compagnie",
          Description: "L’étreinte nourricière : sécurité, amour, chaleur.",
          Out_put: "Soin, repères, soutien indéfectible.",
          Risk: "Négligence. Sans attention, le lien se défait."
        },
        "254": {
          Company_Name: "Zo Serviable Inc.",
          Description: "Tendre la main quand il le faut.",
          Out_put: "Alléger le fardeau, soutenir et faciliter.",
          Risk: "Indifférence. L’épaule froide laisse tout en plan."
        },
        "255": {
          Company_Name: "Z Altruisme SA",
          Description: "Faire du bien, sans contrepartie.",
          Out_put: "Actes gratuits pour le collectif.",
          Risk: "Exploitation. La bonté se fait plumer."
        },
        "256": {
          Company_Name: "Z Unité Inc.",
          Description: "Beaucoup qui ne font plus qu’un.",
          Out_put: "Objectifs partagés, équipe soudée, la force du nombre.",
          Risk: "Division. Les conflits défont les liens."
        },
        "257": {
          Company_Name: "Z Fraternité Industries",
          Description: "Le lien tacite de la camaraderie et de la confiance.",
          Out_put: "Au-delà du sang : loyauté et vécu commun.",
          Risk: "Trahison. Quand la confiance casse, tout se brise."
        },
        "258": {
          Company_Name: "Z Poétique Industries",
          Description: "L’expression tissée en mots, rythme et sens.",
          Out_put: "Beauté, profondeur et émotion portées par la langue.",
          Risk: "Obscurité. Sans oreilles, la poésie se tait."
        },
        "259": {
          Company_Name: "Z Technologies d’Illustration",
          Description: "Raconter visuellement, saisir l’idée en images.",
          Out_put: "Une clarté qui parle au-delà des mots.",
          Risk: "Flou. Sans netteté, l’image perd son impact."
        },
        "260": {
          Company_Name: "Zo Artistique Inc.",
          Description: "L’essence créative, quel que soit le médium.",
          Out_put: "Imagination, vision et courage de créer.",
          Risk: "Conformisme. La boîte tue la créativité."
        },
        "261": {
          Company_Name: "Z Confiance Mutuelle Corp.",
          Description: "Le socle de toute relation qui dure.",
          Out_put: "Foi en l’autre : l’adhésif des liens.",
          Risk: "Tromperie. Mensonges et trahisons l’effritent."
        },
        "262": {
          Company_Name: "Z Liens Entreprises",
          Description: "Rapprocher par l’expérience partagée.",
          Out_put: "Connexions qui se tissent avec le temps.",
          Risk: "Isolement. Sans échanges, le lien s’étiole."
        },
        "263": {
          Company_Name: "Z Aventures Romantiques",
          Description: "La quête d’amour, de passion et de lien profond.",
          Out_put: "Papillons, élan et frisson réciproque.",
          Risk: "Cœur brisé. Quand l’amour tourne, la magie s’éteint."
        },
        "264": {
          Company_Name: "Zo Affectif SA",
          Description: "Chaleur, attention et tendresse en gestes simples.",
          Out_put: "Petits signes qui disent « je t’aime ».",
          Risk: "Froideur. Distance et indifférence gèlent tout."
        },
        "265": {
          Company_Name: "Z Attachement Inc.",
          Description: "Des liens qui rendent les séparations difficiles.",
          Out_put: "Confort du lien, peur de perdre l’essentiel.",
          Risk: "Détachement. Le fil coupé laisse le vide."
        },
        "266": {
          Company_Name: "Z Pleurs Inc.",
          Description: "Quand l’émotion déborde et que les larmes coulent.",
          Out_put: "Libération et vulnérabilité à ciel ouvert.",
          Risk: "Suppression. Retenir ne guérit rien."
        },
        "267": {
          Company_Name: "Z Chagrin Industries",
          Description: "La peine, la tristesse, la morsure de la perte.",
          Out_put: "Réponse profonde aux coups de la vie.",
          Risk: "Temps. Les jours adoucissent les arêtes."
        },
        "268": {
          Company_Name: "Zo Mélancolique Média",
          Description: "Doux-amer des souvenirs, pertes et nostalgies.",
          Out_put: "Tristesse calme, beauté dans le manque.",
          Risk: "Distraction. Remplir le vide anesthésie tout."
        },
        "269": {
          Company_Name: "Z Guidance Inc.",
          Description: "Cap, conseil et main sûre.",
          Out_put: "Sagesse et mentorat pour tracer la route.",
          Risk: "Ignorance. Sans repères, on erre."
        },
        "270": {
          Company_Name: "Z Services de Bénévolat",
          Description: "Donner temps, énergie et cœur aux autres.",
          Out_put: "Soutien communautaire et acte gratuit.",
          Risk: "Épuisement. Même les dévoués brûlent."
        },
        "271": {
          Company_Name: "Z Crainte Inc.",
          Description: "Le poids d’un mal à venir, réel ou non.",
          Out_put: "Paralysie par la peur dans chaque choix.",
          Risk: "Courage. Faire face rétrécit l’ombre."
        },
        "272": {
          Company_Name: "Z Hesitation Labs",
          Description: "La pause avant d’agir, où le doute s’attarde.",
          Out_put: "Trop penser, pas assez faire : occasions perdues.",
          Risk: "Confiance. Le pas franc casse la boucle."
        },
        "73": {
          Company_Name: "Z Réflexion Inc.",
          Description: "Regarder dedans pour clarifier ses pensées.",
          Out_put: "Introspection et quête de compréhension.",
          Risk: "Distraction. Le bruit mental brouille tout."
        },
        "274": {
          Company_Name: "Zo Sentimental Corporation",
          Description: "Garder les souvenirs, chérir le passé.",
          Out_put: "Nostalgie et profondeur affective.",
          Risk: "Détachement. L’indifférence efface tout."
        },
        "275": {
          Company_Name: "Zo Solutions Spontanées",
          Description: "Décisions vives, parfois géniales… parfois non.",
          Out_put: "Créativité sur le vif, adaptabilité sous pression.",
          Risk: "Regret. La précipitation peut coûter cher."
        },
        "276": {
          Company_Name: "Z Compagnonnage Inc.",
          Description: "Le réconfort d’être compris pour de vrai.",
          Out_put: "Loyauté, vécu commun et confiance mutuelle.",
          Risk: "Solitude. Sans l’autre, le monde refroidit."
        },
        "277": {
          Company_Name: "Z Terreur Industries",
          Description: "La peur primale qui agrippe l’âme.",
          Out_put: "Choc, panique, noirceur tapie hors champ.",
          Risk: "Bravoure. Le courage desserre l’étau."
        },
        "278": {
          Company_Name: "Z Soutien Industries",
          Description: "La base solide qui tient quand ça tangue.",
          Out_put: "Encouragement, aide et fiabilité sans faille.",
          Risk: "Négligence. Sans support, tout s’effrite."
        },
        "279": {
          Company_Name: "Z Passion Illimitée",
          Description: "Élan inlassable, intensité brûlante, désir au volant.",
          Out_put: "Carburant de l’ambition, de la création et de l’amour.",
          Risk: "Épuisement. Trop brûler finit par consumer."
        },
        "280": {
          Company_Name: "Zo Costaud Industrie",
          Description: "Le cran d’avancer malgré tout.",
          Out_put: "Résilience, endurance et détermination inoxydable.",
          Risk: "Faiblesse. Le doute fissure la carapace."
        },
        "281": {
          Company_Name: "Z Chaleur Entreprises",
          Description: "L’étreinte douce qui fait fondre le froid.",
          Out_put: "Confort, bonté et sécurité émotionnelle.",
          Risk: "Distance. Sans chaleur, le lien se glace."
        },
        "282": {
          Company_Name: "Z Risque Inc.",
          Description: "Sauts de foi quand la mise est haute.",
          Out_put: "Adrénaline, frisson et gains possibles.",
          Risk: "Échec. Quand ça ne paie pas, ça pique."
        },
        "283": {
          Company_Name: "Z Méditation Inc.",
          Description: "L’art de l’immobilité au cœur du chaos.",
          Out_put: "Paix intérieure, clarté et maîtrise des émotions.",
          Risk: "Agitation. Un esprit tourmenté refuse la pose."
        },
        "284": {
          Company_Name: "Z Paisible Industries",
          Description: "Le calme quand tout s’aligne juste comme il faut.",
          Out_put: "Harmonie, équilibre, un monde sans conflit.",
          Risk: "Perturbation. Un simple remous brise la sérénité."
        },
        "285": {
          Company_Name: "Z Chill Inc.",
          Description: "Détendu, sans stress, prendre la vie comme elle vient.",
          Out_put: "Relaxation et sang-froid en toutes circonstances.",
          Risk: "Surcharge. Trop de pression tue le chill."
        },
        "286": {
          Company_Name: "Z Technologies Non-Conformistes",
          Description: "Penser autrement, défier les normes.",
          Out_put: "Innovation et puissance d’une vision unique.",
          Risk: "Conformisme. Le système rigide étouffe l’originalité."
        },
        "287": {
          Company_Name: "Z Subversion Inc.",
          Description: "Saper l’établi, contester l’autorité.",
          Out_put: "Révolte, dévoilement et démolition des illusions.",
          Risk: "Répression. Le pouvoir qui bâillonne fait taire la dissidence."
        },
        "288": {
          Company_Name: "Z Penseurs Indépendants",
          Description: "Des idées libres de toute pression.",
          Out_put: "Autonomie, courage et pensée différente.",
          Risk: "Dogme. Suivre aveuglément efface l’indépendance."
        },
        "289": {
          Company_Name: "Z Systèmes Fiables",
          Description: "La confiance que ça marchera comme prévu.",
          Out_put: "Stabilité et base solide, sans surprises.",
          Risk: "Panne. Quand la fiabilité casse, c’est le chaos."
        },
        "290": {
          Company_Name: "Z Intégrité Industries",
          Description: "Faire le bien, même sans témoin.",
          Out_put: "Honnêteté et principes inébranlables.",
          Risk: "Corruption. Quand l’intégrité cède, la confiance tombe."
        },
        "291": {
          Company_Name: "Z Mérite Inc.",
          Description: "La réussite gagnée, pas donnée.",
          Out_put: "Reconnaissance et accomplissement authentiques.",
          Risk: "Népotisme. Les faveurs sabotent le vrai mérite."
        },
        "292": {
          Company_Name: "Z Solutions Visionnaires",
          Description: "Foresight, créativité et futur en chantier.",
          Out_put: "Voir ce que d’autres ne voient pas.",
          Risk: "Myopie. Sans vision, le potentiel se fane."
        },
        "293": {
          Company_Name: "Z Jalousie Inc.",
          Description: "Envie de ce qu’ont les autres, piqûre de comparaison.",
          Out_put: "Mécontentement et regard aiguisé sur soi.",
          Risk: "Gratitude. Apprécier ce qu’on a désamorce l’envie."
        },
        "294": {
          Company_Name: "Z Esprits Amers",
          Description: "Rancune gardée, négativité nourrie.",
          Out_put: "Cynisme lucide et catharsis créative.",
          Risk: "Pardon. Lâcher prise allège l’amertume."
        },
        "295": {
          Company_Name: "Z Leader Tech",
          Description: "Prendre les rênes et inspirer.",
          Out_put: "Vision et pouvoir d’orienter les autres.",
          Risk: "Incompétence. Un cap flou mène à l’échec."
        },
        "296": {
          Company_Name: "Z Motivator Inc.",
          Description: "Mettre en mouvement, pousser au meilleur.",
          Out_put: "Élan, ambition et envie d’atteindre.",
          Risk: "Apathie. Sans envie, la motivation se perd."
        },
        "297": {
          Company_Name: "Z Systèmes d’Influence",
          Description: "Façonner les esprits, guider les tendances.",
          Out_put: "Persuasion et impact à grande échelle.",
          Risk: "Irrelevance. Quand l’écho s’éteint, la voix aussi."
        },
        "298": {
          Company_Name: "Zo Philosophie Entreprises",
          Description: "Penser l’existence et le sens.",
          Out_put: "Réflexion profonde et quête de sagesse.",
          Risk: "Dogmatisme. La rigidité étouffe la pensée."
        },
        "299": {
          Company_Name: "Z Esprit & Traits",
          Description: "Humour vif, intellect tranchant, reparties fines.",
          Out_put: "Intelligence mêlée de charme et de jeu.",
          Risk: "Insensibilité. Sans tact, l’esprit blesse."
        },
        "300": {
          Company_Name: "Z Sarcasme Inc.",
          Description: "Dire une chose, en penser une autre, avec piquant.",
          Out_put: "Ironie, humour et malice assumée.",
          Risk: "Contresens. Mal compris, ça fait mal."
        },
        "301": {
          Company_Name: "Z Défense Industries",
          Description: "Tenir bon et protéger l’essentiel.",
          Out_put: "Loyauté, résilience et bouclier des faibles.",
          Risk: "Imprudence. Défendre aveuglément peut nuire."
        },
        "302": {
          Company_Name: "Zo Extravagant Corporation",
          Description: "Jamais trop : plus grand, plus brillant, plus fort.",
          Out_put: "Luxe, excès et pur spectacle.",
          Risk: "Austérité. Quand le strass s’éteint, reste le vide."
        },
        "303": {
          Company_Name: "Zo Imbu Technologies",
          Description: "Moi au-dessus, convaincu de ma supériorité.",
          Out_put: "Assurance et aura d’autorité.",
          Risk: "Humilité. La réalité rabote l’ego."
        },
        "304": {
          Company_Name: "Zo Ambitieux Corp.",
          Description: "Faim d’aller plus haut, sans s’arrêter.",
          Out_put: "Succès par volonté et détermination.",
          Risk: "Burnout. L’ambition dévore si on la lâche."
        },
        "305": {
          Company_Name: "Z Écharde à l’Épaule",
          Description: "Vieilles blessures, prêt à en découdre.",
          Out_put: "Alerte, énergie et besoin de prouver.",
          Risk: "Acceptation. Lâcher le passé apporte la paix."
        },
        "306": {
          Company_Name: "Z Manipulation Tech",
          Description: "Tirer les ficelles, modeler l’issue en coulisses.",
          Out_put: "Contrôle et persuasion invisibles.",
          Risk: "Transparence. L’honnêteté casse l’illusion."
        },
        "307": {
          Company_Name: "Zo Têtu Inc.",
          Description: "Inébranlable face à l’opposition.",
          Out_put: "Persévérance et force d’y croire.",
          Risk: "Raideur. L’entêtement aveugle fait échouer."
        },
        "308": {
          Company_Name: "Z Rancœur Industrie",
          Description: "Le goût amer des torts passés.",
          Out_put: "Réflexion de soi et apprentissage émotionnel.",
          Risk: "Pardon. Libérer la rancœur libère l’esprit."
        },
        "309": {
          Company_Name: "Z Gêné Inc.",
          Description: "Quand l’erreur attire tous les regards.",
          Out_put: "Humilité et capacité à grandir.",
          Risk: "Confiance. Rire de soi dissout la gêne."
        },
        "310": {
          Company_Name: "Z Vindication Industries",
          Description: "Le doux moment où l’on avait raison.",
          Out_put: "Soulagement, justice et fin des doutes.",
          Risk: "Arrogance. Fanfaronez et vous vous ferez des ennemis."
        },
        "311": {
          Company_Name: "Z Anxiété Sociale Tech",
          Description: "La peur paralysante de mal dire en société.",
          Out_put: "Hyper-vigilance et finesse d’observation.",
          Risk: "Pratique. L’exposition apprivoise la peur."  
        } 
      },
      "_meta": {
        "language": "Français",
        "version": "1.0.0",
        "last_updated": "2025-08-05"
      },
      "auth": {
        "trader_id_placeholder": "ID du Trader",
        "password_placeholder": "Mot de passe",
        "login_button": "Connexion",
        "login_validation_message": "Veuillez saisir votre ID Trader et votre mot de passe",
        "login_failed_message": "Échec de la connexion. Vérifiez vos identifiants et réessayez.",
        "login_error_message": "Une erreur s'est produite lors de la connexion. Veuillez réessayer plus tard.",
        "authentication_failed_message": "Échec de l'authentification. Veuillez vous reconnecter.",
        "password_required_message": "Mot de passe requis.",
        "enter_trader_name_placeholder": "Entrez votre nom de Trader",
        "enter_new_password_placeholder": "Entrez votre nouveau mot de passe",
        "secure_password_placeholder": "Entrez un mot de passe sécurisé",
        "set_password_label": "Définir le mot de passe",
        "authentication_failed": "Échec de l'authentification. Veuillez vous reconnecter.",
        "session_required": "L'ID de session est manquant. Veuillez vous reconnecter."
      },
      "navigation": {
        "nav_commodity": "Marchandise",
        "nav_zollars": "Zollars",
        "nav_stock_zbond": "Actions & Z-Obligations",
        "nav_company": "Entreprise",
        "nav_portfolios": "Portefeuilles",
        "nav_control_panel": "Panneau de contrôle"
      },
      "buttons": {
        choose_company: "Choisir cette entreprise",
        select: "Sélectionner",
        "scan_button": "Scanner",
        "fulfill_button": "Exécuter",
        "create_session_button": "Créer une session",
        "search_button": "Rechercher",
        "close_search_button": "Fermer la recherche",
        "cancel_button": "Annuler",
        "close_button": "Fermer",
        "complete_setup_button": "Terminer la configuration",
        "save_button": "Sauvegarder",
        "delete_button": "Supprimer",
        "modify_name_button": "Modifier le nom",
        "modify_password_button": "Modifier le mot de passe",
        "logout_trader_button": "Déconnecter le trader",
        "view_qr_codes_button": "Voir les codes QR de connexion",
        "enter_mortality_chamber_button": "Entrer dans la chambre de mortalité",
        "continue_button": "Continue"
      },
      "stock_bid": {
        "title": "Offre d'achat d'actions",
        "offers_to_buy_points": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour {amount} de Capital.",
        "offers_to_buy_zollars": "{portfolioName} propose d'acheter {shares} actions de {stockName} pour les zollars suivants :",
        "time_remaining": "Temps restant : {seconds} secondes",
        "time_expired": "Temps expiré",
        "processing_bid": "Traitement de votre offre...",
        "no_response": " Aucune réponse reçue. Cette action a expiré.",
        "offer_expired": "Aucune réponse reçue. Votre offre a expiré."
      },
"forms": {
        "mood_one_word": "Quel sentiment vivez-vous en ce moment ?",
        "one_word_hint": "(1 mot)",
        "reason_label": "Pourquoi ressentez-vous cela ?",
        "value_definition": "Pourquoi ressentez-vous cela ? (Valeur)",
        "value_definition_placeholder": "ex. : J'ai eu une promotion, Je suis mal réveillé, Mon fils a marqué 3 buts...",
        "value_reaction": "Qu'est-ce que ce sentiment vous apporte ? (Profits de Vie)",
        "value_reaction_placeholder": "ex. : me donne de l'énergie, me déprime, m'aide à grandir...",
        "experiences_label": "Qu'est-ce qui crée ce sentiment ?",
        "search_stocks_placeholder": "Rechercher des actions",
        "company_name_fixed_label": "Nom de l'entreprise (fixe) :",
        "company_description_label": "Description de l'entreprise :",
        "company_product_label": "Produit/Output de l'entreprise :",
        "trader_name_label": "Nom du Trader :",
        "session_name_label": "Nom de la session",
        "session_name_placeholder": "Entrez le nom de la session (lettres, chiffres, tirets bas uniquement)",
        "single_word_example": "ex. : heureux, triste, fatigué, curieux...",
        "reason_placeholder": "ex. : J'ai eu une promotion, Je suis mal réveillé, Mon fils a marqué 3 buts...",
        "describe_feeling_placeholder": "ex. : me donne de l'énergie, me déprime, m'aide à grandir..."
      },
      "modals": {
        "select_action_title": "Sélectionner une action",
        "action_modal_description": "Sélectionnez Scanner pour être dirigé vers la page d'analyse des articles. Sélectionnez Exécuter pour exécuter les commandes.",
        "choose_simulation_title": "Choisissez votre expérience de simulation",
        "memento_mori_title": "Simulation Memento Mori",
        "memento_mori_description": "Souvenez-vous que vous devez mourir. Cette simulation explore les choix significatifs dans un temps limité.",
        "create_new_session_title": "Créer une nouvelle session",
        "session_creation_description": "Créer une nouvelle session de trading en tant que Banque centrale de la Réserve fédérale Z.",
        "assign_to_portfolio_title": "Assigner au portefeuille :",
        "select_portfolio_short_title": "Sélectionner un portefeuille pour placer une position courte",
        "select_portfolio_transfer_title": "Sélectionner un portefeuille pour transférer la propriété"
      },
      "tables": {
        "table_stock_name": "Nom de l'action",
        "table_symbol": "Symbole",
        "table_share_value": "Valeur de l'action",
        "table_owner": "Propriétaire",
        "table_shorted": "Vendu à découvert",
        "table_place_short": "Placer à découvert",
        "table_delete": "Supprimer"
      },
      "titles": {
        "owned_stock_list_title": "Liste des actions possédées",
        "short_positions_title": "Positions courtes",
        "stock_management_guide_title": "Guide de gestion des actions"
      },
      "validation": {
        "select_company_first_message": "Veuillez d'abord sélectionner une entreprise avant de réclamer.",
        "fill_trader_name_password_message": "Veuillez remplir votre nom de Trader et votre nouveau mot de passe.",
        "company_details_required_message": "Les détails de l'entreprise sont requis. Veuillez terminer le processus de sélection de l'entreprise.",
        "portfolio_count_validation": "Le nombre de portefeuilles doit être entre 1 et 50.",
        "items_per_portfolio_validation": "Le nombre d'articles par portefeuille doit être entre 0 et 10.",
        "simulation_questions_required": "Veuillez répondre à toutes les questions. Entrez un seul mot pour votre humeur et expliquez pourquoi vous vous sentez ainsi et ce qui crée ce sentiment.",
        "complete_reflections": "Veuillez compléter les trois réflexions.",
        "max_companies": "Maximum 5 entreprises autorisées"
      },
      "messages": {
        "success": "Succès",
        "error": "Erreur",
        "loading": "Chargement...",
        "qr_error_message": "Erreur lors de l'affichage des codes QR. Veuillez réessayer.",
        "portfolios_created_success": "Portefeuille(s) créé(s) avec succès",
        "portfolio_add_error": "Erreur lors de l'ajout du portefeuille. Veuillez réessayer.",
        "portfolio_updated_success": "Portefeuille mis à jour avec succès",
        "fetch_portfolios_error": "Erreur lors de la récupération des portefeuilles. Veuillez réessayer plus tard."
      },
      "backend_messages": {
        "invalid_decision_message": "Décision invalide.",
        "assignment_in_progress": "L'assignation est déjà en cours.",
        "session_id_required": "L'ID de session est requis.",
        "not_enough_items_assign": "Pas assez d'articles disponibles à assigner",
        "items_assigned_success": "Nouveaux articles assignés à tous les portefeuilles avec succès.",
        "items_assign_failed": "Échec de l'assignation des nouveaux articles",
        "items_assigned_successfully": "Articles assignés avec succès.",
        "no_available_items": "Aucun article disponible pour assignation.",
        "failed_assign_items": "Échec de l'assignation des articles.",
        "points_distributed_success": "capitaux distribués avec succès.",
        "points_distribute_failed": "Échec de la distribution des capitaux.",
        "items_removed_success": "Articles supprimés avec succès.",
        "no_items_for_removal": "Aucun article non-échangé disponible pour suppression.",
        "failed_remove_items": "Échec de la suppression des articles.",
        "tax_points_item_deducted": "capitaux et article aléatoire déduits par les autorités fiscales Z.",
        "tax_points_deducted": "capitaux de trading déduits par les autorités fiscales Z.",
        "tax_points_zollars_item_deducted": "& bien aléatoire déduits par les autorités fiscales de la Réserve Zédérale.",
        "tax_points_zollars_deducted": "déduits par les autorités fiscales de la Réserve Zédérale.",
        "tax_item_removed": "Article aléatoire supprimé par les autorités fiscales Z.",
        "error_fetching_portfolios": "Erreur lors de la récupération des portefeuilles",
        "portfolio_updated_success": "Portefeuille mis à jour avec succès",
        "portfolio_not_found": "Portefeuille introuvable",
        "error_updating_portfolio": "Erreur lors de la mise à jour du portefeuille",
        "internal_server_error": "Erreur interne du serveur",
        "item_already_assigned": "L'article est déjà assigné à ce portefeuille",
        "item_assigned_success": "Article assigné au portefeuille avec succès",
        "item_unassigned_success": "Article désassigné du portefeuille avec succès",
        "create_community_button_assigned": "Bouton de création de communauté assigné avec succès",
        "portfolio_deleted_success": "Portefeuille supprimé avec succès, articles et actions désassignés.",
        "no_zollars_found": "Aucun Zollar trouvé pour ce portefeuille",
        "failed_fetch_bonds": "Échec de la récupération des obligations",
        "message_exceeds_280": "Le message dépasse 280 caractères.",
        "sender_portfolio_not_found": "Portefeuille expéditeur introuvable.",
        "recipient_portfolio_not_found": "Portefeuille destinataire introuvable.",
        "not_enough_points_message": "Pas assez de capitaux pour envoyer un message.",
        "message_sent_successfully": "Message envoyé avec succès",
        "session_mismatch_sender": "Action non autorisée. Session ne correspond pas pour l'expéditeur.",
        "session_mismatch_recipient": "Action non autorisée. Session ne correspond pas pour le destinataire.",
        "requesting_portfolio_not_found": "Portefeuille demandeur introuvable",
        "user_not_part_of_session": "L'utilisateur ne fait partie d'aucune session",
        "item_not_found": "Article introuvable",
        "no_unassigned_items": "Aucun article non assigné trouvé",
        "portfolio_not_found_in_session": "Portefeuille introuvable dans cette session",
        "item_not_found_in_session": "Article introuvable dans cette session",
        "failed_assign_item_portfolio": "Échec de l'assignation de l'article au portefeuille"
      },
     llmFallback: {
       greedy: [
         "Alerte à l’abondance ! Grandissons ensemble — la valeur, ce sont les personnes, pas seulement le prix.",
         "Prêts à soutenir des idées audacieuses ? L’ambition humaine alimente cet échange.",
         "Montrez-moi vos offres — chaque échange raconte une histoire de faim et d’espoir.",
         "Souvenez-vous : la richesse est un outil pour de meilleures vies, gardons l’humain au centre."
       ],
       angry: [
         "Je dénonce des spreads injustes maintenant. Une colère honnête → un marché honnête.",
         "Je ne reculerai pas tant que chaque voix ne sera pas entendue — la rage peut réécrire les règles.",
         "Ce n’est pas « truqué », c’est un miroir. Corrigeons le reflet.",
         "Chaque échange douteux allume une mèche — transformons cette étincelle en réforme structurelle."
       ],
       happy: [
         "Dividendes de joie en approche ! Comment va le portefeuille humain de chacun aujourd’hui ?",
         "L’énergie est haute — l’optimisme n’a pas de prix, échangeons !",
         "Ouvert aux échanges bienveillants — uniquement des accords gagnant-gagnant.",
         "Les bonnes ondes composent vite ; célébrons les petits gains !"
       ],
       anxious: [
         "La volatilité vous crispe ? Respirez — l’incertitude est humaine, pas un bug.",
         "Conserver ou vendre ? Demandez-vous ce qui vous nourrit ; le profit suit le sens.",
         "Partager ses doutes transforme la peur en clairvoyance. Parlons du risque ensemble.",
         "Les variations du marché reflètent nos inquiétudes — les nommer nous redonne du pouvoir."
       ],
       manic: [
         "VAGUE D’OPPORTUNITÉS ! 🚀 Hydratez-vous, ancrez-vous, *puis* échangez.",
         "« To the moon » c’est amusant — mais l’humanité est la véritable destination.",
         "Les ordres fusent à la vitesse de la lumière — canalisons cette étincelle sans nous brûler.",
         "Surfez la vague, respectez les limites — le bien-être est le véritable ticker."
       ],
       strategic: [
         "Cartographier le sens, pas seulement l’argent — diversifiez votre capital *humain*.",
         "À l’affût de partenariats où l’empathie rencontre l’innovation.",
         "Point d’entrée optimal ? Là où le sens s’aligne avec le potentiel.",
         "Vision longue : le ROI communautaire dépasse toujours les sursauts trimestriels."
       ],
       depressed: [
         "Les jours sombres enseignent des leçons profondes — que vaut-il la peine de protéger quand l’espoir s’amenuise ?",
         "Même les marchés baissiers portent des graines de compréhension. On partage la charge ?",
         "Quand tout paraît creux, le lien humain devient la seule vraie monnaie.",
         "La marée basse révèle ce qui est fait pour durer. Qu’est-ce qui compte pour vous maintenant ?"
       ],
       competitive: [
         "C’est parti ! Mais souvenez-vous — les meilleures victoires élèvent tout le monde.",
         "Je vois vos coups et je surenchéris avec de la collaboration. Qui est partant ?",
         "La compétition nous aiguise, la communauté nous soutient. Les deux à la fois, pas l’un ou l’autre.",
         "Prêts à dominer ? Dominons la rareté, pas les uns les autres."
       ],
       curious: [
         "Quels motifs cachés voyez-vous dans les échanges d’aujourd’hui ?",
         "Les questions sont du capital — quels mystères votre portefeuille révèle-t-il ?",
         "Chaque position raconte une histoire. Que dit la vôtre ?",
         "L’émerveillement est ma monnaie préférée. De quoi êtes-vous curieux aujourd’hui ?"
       ]
     },
     "messageSend": {
      " title": "Envoyer un message",
       "costPerRecipient": "Coût : 20 par destinataire",
       "searchRecipients": "Rechercher des destinataires",
       "unnamedPortfolio": "Portefeuille sans nom",
       "placeholder280": "Saisissez votre message (280 caractères max)",
       "send": "Envoyer",
       "close": "Fermer",
       "newMessageFrom": "Nouveau message de",
       "unknown": "Inconnu",
       "reply": "Répondre",
       "markAsRead": "Marquer comme lu",
       "onlyChatBots": "Vous ne pouvez discuter qu’avec des joueurs bots, pas avec des humains.",
       "conversationWith": "Conversation avec",
       "messagesRemaining": "messages restants",
       "typeYourMessage": "Tapez votre message...",
       "chatLimitReached": "Limite de discussion atteinte. Cette conversation est terminée.",
       "error": "Erreur",
       "failedToSend": "Échec de l’envoi du message",
       "chatEnded": "Discussion terminée",
       "chatEndedThanks": "Cette discussion est terminée. Merci pour cet échange !",
       "connectionError": "Erreur de connexion. Veuillez réessayer.",
       "botGreeting": "Salut ! Je suis {name}. Qu’avez-vous en tête ?",
       "message_user": "Message à {user} : {message}"
     },
     "bot": {
       "chat_connection_notready": "Connexion non prête. Réessayez dans un instant.",
       "chat_greeting_fallback": "Salut ! Je suis {{name}}. Qu’avez-vous en tête ?",
       "chat_remaining": "messages restants",
       "chat_input_placeholder": "Écrivez votre message…",
       "chat_connection_lost": "Connexion perdue. Veuillez réessayer.",
       "chat_error_notloggedin": "Erreur : utilisateur non connecté",
       "chat_limit_reached": "Limite de messages atteinte.",
       "chat_timeout": "Le bot met trop de temps à répondre. Réessayez.",
       "chat_end_thanks": "Cette discussion est terminée. Merci d’avoir parlé !",
       "chat_ended": "Discussion terminée",
       "chat_recommendation_title": "Recommandation de trading",
       "chat_action_buy": "Placer une offre",
       "chat_action_sell": "Créer une offre",
       "chat_action_short": "Vendre à découvert",
       "chat_action_trade": "Lancer un échange",
       "chat_action_goto": "Aller au trading"
     },
      labels: {
        output: "Production"
      },
      "routes": {
        "lbo_notFound": "Un ou plusieurs portefeuilles sont introuvables.",
        "lbo_noTrigger": "L’initiateur ne possède pas de déclencheur LBO capitaliste.",
        "lbo_sessionMismatch": "Incohérence de portefeuille ou de session.",
        "lbo_notEnoughPoints": "Capitaux insuffisant pour effectuer le LBO.",
        "lbo_success": "LBO réalisé avec succès. Capital, biens et actions transférés.",
        "lbo_triggerGiven": "Déclencheur LBO capitaliste attribué avec succès.",
      
        "subsidy_notFound": "Portefeuille introuvable.",
        "subsidy_triggerGiven": "Déclencheur de Subvention socialiste attribué avec succès.",
        "common_internal": "Erreur interne du serveur.",
        "subsidy_notFoundMulti": "Un ou plusieurs portefeuilles sont introuvables.",
        "subsidy_noTrigger": "L’initiateur ne possède pas de déclencheur de Subvention socialiste.",
        "subsidy_sessionMismatch": "Incohérence de portefeuille ou de session.",
        "subsidy_noRecipients": "Aucun autre portefeuille disponible pour recevoir des subventions.",
        "subsidy_nothingToTax": "Aucune richesse à taxer pour ce portefeuille.",
        "subsidy_success": "Subvention effectuée avec succès."
      },
      "LedHold": {
      "total_funds": "Total fonds",
      "earned_funds": "Capital gagné",
      "value_items": "Valeur des biens",
      "value_stock": "Valeur des actions",
      "value_short": "Position Short",
      "zollars": "Zollars",
      "total_points_label": "Capitaux totaux",
      "close": "Fermer"
    },
      "triggers": {
        "confirm": "Confirmer",
        "cancel": "Annuler",
        "close": "Fermer",
        "errorPrefix": "Erreur :",
        "ofWord": "de",
        "pointsLabel": "Capitaux",
        "sharesWord": "parts",
        "sharesAt": "parts à {value} chacune",
        "unknownUser": "Utilisateur inconnu",
        "noEligible": "Aucun portefeuille admissible à redistribuer. Action annulée.",
        "steal_stealerNotFound": "Portefeuille du voleur introuvable",
        "steal_noTrigger": "Ce portefeuille ne possède pas de déclencheur de vol",
        "steal_itemUnavailable": "Objet non disponible pour le vol",
        "steal_itemNotInAnyPortfolio": "Objet introuvable dans un portefeuille",
        "steal_success": "Objet bien volé",
        "steal_serverError": "Erreur interne du serveur",
        "success": "Les avoirs du portefeuille sélectionné ont été redistribués avec succès.",
        "error": "Erreur : impossible de redistribuer le portefeuille sélectionné.",
        "steal_success": "Succès, Objet volé",
        "ransom_pay_success": "La rançon a été payée. Votre portefeuille est désormais déverrouillé.",
        "itemStolenSuccess": "Bien volé avec succès.",
        "stealFailed": "Échec du vol de bien",
        "title1": "Voulez-vous vraiment redistribuer les avoirs du portefeuille sélectionné ?",
        "body1": "Cette action redistribuera aléatoirement les avoirs du portefeuille du trader à d’autres traders sur le marché.",
        "cta1": "Oui, déclencher l’assaut communiste",
        "selectPortfolioTitle": "Sélectionnez un portefeuille :",
        "noAssetsSelected": "Aucun actif sélectionné pour la LBO.",
        "successLBO": "LBO déclenchée avec succès.",
        "selectAssetsTitle": "Sélectionnez les actifs pour la LBO",
        "selectAssetsItems": "Objets :",
        "selectAssetsStocks": "Actions :",
        "noItems": "Aucun objet disponible",
        "noStocks": "Aucune action disponible",
        "title_1": "Sélectionnez un portefeuille sur lequel déclencher une LBO :",
        "titleLBO": "Confirmer la LBO (rachat avec effet de levier)",
        "bodyLBO": "Cette LBO vous coûtera {cost} capitaux. Voulez-vous continuer ?",
        "ctaLBO": "Oui, déclencher la LBO",
        "removedStocksLabel": "Actions retirées :",
        "removedItemsLabel": "Objets retirés :",
        "unknownStock": "Action inconnue",
        "unknownItem": "Objet inconnu",
        "noRichPortfolios": "Aucun portefeuille « riche » disponible comme cible.",
        "success3": "Subvention déclenchée avec succès.",
        "selectRichTitle3": "Sélectionnez un portefeuille riche à taxer :",
        "stealFailedUse": "Échec de l’utilisation du bouton de vol",
        "stealFailedFetchItems": "Échec du chargement des objets disponibles",
        "stealFailedUseOrFetch": "Échec de l’utilisation du bouton de vol ou du chargement des objets",
        "stealFailedToSteal": "Échec du vol de l’objet",
        "ransomNoEligible": "Aucun portefeuille admissible à rançonner. Action annulée.",
        "ransomSelectTargetTitle": "Sélectionnez un portefeuille à rançonner :",
        "ransomSetFailed": "Échec de la mise en place de la rançon",
        "ransomSetSuccess": "Rançon fixée avec succès.",
        "ransomSetErrorPrefix": "Erreur : impossible de fixer la rançon.",
        "ransomSetAmountTitle": "Définir le montant de la rançon",
        "ransomSetAmountPlaceholder": "Saisissez le montant de la rançon",
        "ransomConfirmSetTitle": "Confirmer la rançon",
        "ransomConfirmSetBody": "Voulez-vous vraiment fixer une rançon de {amount} capitaux ?",
        "ransomPaySuccess": "Rançon payée avec succès. Votre portefeuille est désormais déverrouillé.",
        "ransomPayErrorPrefix": "Erreur : impossible de payer la rançon.",
        "ransomPayTitle": "Confirmer le paiement de la rançon",
        "ransomPayBody": "Voulez-vous vraiment payer {amount} capitaux pour déverrouiller votre portefeuille ?",
        "giveawayTitle": "Confirmer le don",
        "giveawayBody": "Voulez-vous vraiment donner cet objet ?",
        "communitySelectUsersTitle": "Sélectionnez les utilisateurs pour la communauté :",
        "statsTotalWealth": "Richesse totale :",
        "initiatorUndefined": "Le portefeuille initiateur est indéfini",
        "sessionUndefined": "La session est indéfinie",
        "fetchPortfoliosFailed": "Échec du chargement des portefeuilles"
      },
      "ui_labels": {
        "show_explanations_label": "Afficher les explications",
        "currency": "Devise",
        "balance": "Solde",
        "price": "Prix",
        "quantity": "Quantité",
        "total": "Total",
        "date": "Date",
        "time": "Heure",
        "status": "Statut",
        "active": "Actif",
        "inactive": "Inactif",
        "pending": "En attente",
        "completed": "Terminé",
        "failed": "Échoué"
      },
      "marketing": {
        "tailor_stock_choice_message": "Adaptez votre choix d'actions pour qu'il s'aligne exactement avec vos valeurs.",
        "footer_copyright": "Tous droits réservés ZExchange 2025. ZExchange fait partie de <a href=\"https://zeconomy.xyz\"> ZEconomy. </a>",
        "programs": {
          "nav_home": "← Retour à ZExchange",
          "nav_contact": "Nous Contacter",
          "page_title": "ZExchange Studio Program",
          "tagline": "Life profits.",
          "intro": "Un programme en trois parties dans lequel les participants intègrent une économie conçue comme œuvre d'art, s'approprient des notions conceptuelles clés, construisent des systèmes de valeur (réels ou artistiques) et négocient en direct sur la plateforme ZExchange.",
          "part_one_title": "Première partie : Cadre théorique",
          "part_one_text": "Où réside la valeur : dans l'œuvre ? dans l'objet, l'institution ou l'expérience ? De l'image cultuelle de Hans Belting aux marchandises fictives de Karl Polanyi, de la théâtralité de Michael Fried à la validation algorithmique des prix. Une introduction rigoureuse au déplacement, envisagé à la fois comme trajectoire historico-artistique et comme intervention économique.",
          "part_two_title": "Deuxième partie : Atelier créatif",
          "part_two_text": "Les participants élaborent leurs propres systèmes de valeur à partir des principes de la ZEconomy développés lors de la phase théorique. L'architecture économique devient un matériau artistique.",
          "part_three_title": "Troisième partie : Séance de trading en direct",
          "part_three_text": "Entre 10 et 200 participants mettent en pratique la ZEconomy en temps réel sur la plateforme ZExchange. Une IA observe, analyse et livre son commentaire — produisant un Big Board visuel et un portrait écrit du comportement collectif. Le marché devient son propre miroir.",
          "institutional_title": "Objectifs institutionnels",
          "art_programs_title": "Pour les programmes artistiques :",
          "art_programs_text": "Positionner l'économie comme matériau, prolongeant l'Art conceptuel et la Critique institutionnelle tout en construisant des alternatives plutôt qu'en se limitant à révéler l'existant.",
          "business_programs_title": "Pour les programmes de commerce et de management :",
          "business_programs_text": "Appliquer la théorie de la valorisation expérientielle. Les étudiants mobilisent des applications créatives de leurs idées afin de mieux structurer leurs propres projets.",
          "zeconomy_title": "ZEconomy",
          "zeconomy_text_1": "ZExchange émerge de la ZEconomy, une pratique artistique de long date développée par JaZoN Frings depuis près de vingt ans, à travers un marché boursier personnel, des monnaies relationnelles et des systèmes publicitaires non fondés sur la consommation. Ces œuvres interrogent la place de l'individu au sein des systèmes sociaux en intervenant dans leurs structures — en déplaçant les objectifs de production, en reconfigurant les modes opératoires et en introduisant des formes d'expression imprévues qui en révèlent la logique sous-jacente.",
          "zeconomy_text_2": "Représentée par la galerie mfc–michèle didier et l'agent d'art Ghislain Mollet-Viéville, la pratique a été exposée dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions pédagogiques et de médiation à l'École Camondo, Parsons Paris et au Centre Pompidou, elle a été citée dans Art Press, ⋆⋆⋆ Télérama, Bloomberg et Blockchain Revolution de Don Tapscott.",
          "contact_title": "Contact",
          "contact_text": "Pour les détails du programme, la planification et les demandes institutionnelles :"
        },
        "sessions": {
          "nav_home": "← Retour à ZExchange",
          "nav_contact": "Nous Contacter",
          "page_title": "ZExchange",
          "tagline": "Life profits.",
          "intro": "Une œuvre dans laquelle on entre, plutôt qu’on observe. Un espace d’échange. Une fête. Une nouvelle façon de regarder la valeur.",
          "what_happens_title": "Ce qui se passe",
          "what_happens_p1": "Les participants intègrent une économie à deux niveaux : actions et marchandises.",
          "what_happens_p2": "Les actions représentent des valeurs intangibles — états émotionnels, ambitions, manières d'être. On les négocie, on spécule dessus, on regarde leurs cours monter et descendre selon l'intérêt collectif.",
          "what_happens_p3": "Les marchandises sont réelles — boissons, nourriture, objets, cadeaux. Tout est négociable, mais on ne peut rien consommer seul. Pour obtenir une marchandise, un autre participant doit accepter d'obtenir les siennes avec vous. Le marché accorde ou refuse la permission.",
          "what_happens_p4": "Une IA observe tout ce qui se déroule, commentant les dynamiques de valeur, de désir et d'échange à mesure qu'elles émergent.",
          "what_produces_title": "Ce que cela produit",
          "what_produces_text": "Une expérience partagée qui recadre la consommation comme acte social. Un portrait du groupe rédigé par l'IA. Une visualisation Big Board disponible à l'achat. Et une question qui persiste : quelle est la vraie valeur d'être en vie ?",
          "format_title": "Format",
          "format_text": "2 à 3 heures. De 10 à 200 participants. Événement autonome, team building, cocktail, séminaire ou programme culturel.",
          "zeconomy_title": "ZEconomy",
          "zeconomy_text_1": "Le ZExchange émerge de la ZEconomy, pratique artistique au long cours de JaZoN Frings développée depuis près de vingt ans à travers un marché boursier personnel, des monnaies relationnelles et des systèmes publicitaires non fondés sur la consommation. Ces œuvres interrogent la position de l'individu au sein des systèmes sociétaux en intervenant dans leurs structures — déplaçant les objectifs de production, reconfigurant les opérations et introduisant des formes d'expression imprévues qui en révèlent la logique sous-jacente.",
          "zeconomy_text_2": "Représenté par la Galerie mfc–michèle didier et l'agent d'art Ghislain Mollet-Viéville, la pratique a été exposée dans des institutions telles que Transmediale Berlin, SPRING/BREAK ART SHOW NYC,  Wrong Biennial, Stanford University et Science Gallery Dublin. Avec de nombreuses interventions pédagogiques et de médiation à l'École Camondo, Parsons Paris et au Centre Pompidou, elle a été citée dans Art Press, ⋆⋆⋆ Télérama, Bloomberg et Blockchain Revolution de Tapscott.",
          "contact_title": "Contact",
          "contact_text": "Pour les détails du programme, la planification et les demandes institutionnelles :"
        }
      },
      "classes": {
        "page_title": "Sessions pédagogiques ZEconomy",
        "presenter_title": "Présentation de cours ZEconomy",
        "back_link": "← Retour à ZExchange",
        "title": "Sessions pédagogiques ZEconomy",
        "tagline": "Explorer les intersections entre histoire de l'art, spiritualité et représentation avec la théorie des marchés, les systèmes de valeur et la réinvention de la finance par la ZEconomy.",
        "lesson_selector": "← Sélecteur de leçons",
        "previous": "← Précédent",
        "next": "Suivant →",
        "toggle_images": "Afficher/Masquer les images",
        "no_classes": "Aucune session disponible pour le moment.",
        "load_error": "Impossible de charger les sessions. Veuillez réessayer ultérieurement.",
        "level": "Niveau",
        "duration": "Durée",
        "minutes": "min",
        "mixed_level": "mixte",
        "presenter_suffix": "Présentation",
        "learning_objectives": "Objectifs pédagogiques",
        "view_details": "Voir les détails",
        "discussion_points": "Points de discussion",
        "activity_instructions": "Consignes de l'activité",
        "estimated_reading_time": "Temps de lecture estimé",
        "min": "min",
        "download_pdf": "Télécharger le PDF",
        "no_lesson_specified": "Aucune leçon spécifiée.",
        "lesson_not_found": "Leçon introuvable.",
        "load_lesson_error": "Erreur lors du chargement de la leçon. Veuillez réessayer ultérieurement."
      },
      "placeholders": {
        "life_profits_placeholder_1": "J'apprécie jouer avec mes enfants...",
        "life_profits_placeholder_2": "La dépression semble être recherchée...",
        "life_profits_placeholder_3": "J'aime l'amour et tout ce qui s'y rapporte...",
        "life_profits_placeholder_4": "Un verre avec des amis vaut tout...",
        "life_profits_placeholder_5": "Je pense que le rejet crée de la valeur...",
        "life_profits_placeholder_6": "Je vois la joie comme la vraie monnaie de la vie...",
        "life_profits_placeholder_7": "Aider les autres enrichit ma vie...",
        "life_profits_placeholder_8": "La solitude est devenue une expérience très courante...",
        unnamed_company: "Entreprise sans nom",
        unknown_output: "Production inconnue",
        no_description: "Aucune description disponible",
        "experience_placeholder_1": "Danser sur de la techno me fait oublier mes soucis...",
        "experience_placeholder_2": "Passer du temps avec mes amis fait filer le temps...",
        "experience_placeholder_3": "Ma mère me manque, ça me rappelle ce qui compte...",
        "experience_placeholder_4": "Courir régulièrement me vide la tête...",
        "experience_placeholder_5": "Se disputer en ligne est toujours une perte de temps...",
        "experience_placeholder_6": "Regarder de vieux dessins animés me fait redevenir un enfant...",
        "experience_placeholder_7": "Me lever tôt donne une bonne énergie à ma journée...",
        "experience_placeholder_8": "Prendre un chemin détourné m'aide à réfléchir...",
        "experience_placeholder_9": "La qualité du café du matin donne le ton à ma journée...",
        "experience_placeholder_10": "Porter mes lunettes de soleil la nuit me donne l'air cool..."
      },
      "ticker_texts": {
        "intro_z_exchange": "?? ► INTRODUCTION Z EXCHANGE ?? ►",
        "life_profits_value": "PROFITS DE VIE ► VALEUR Z EXCHANGE ►",
        "stocks_function": "► QUE FONT LES ACTIONS SUR Z EXCHANGE",
        "z_bonds_system": "Z OBLIGATIONS ► Zollars ► Z SYSTÈME MONÉTAIRE RELATIONNEL ► LES CHIFFRES N'ONT PAS LEUR PLACE ►",
        "commodity_x": "► MARCHANDISE X ► CONSOMMATION SOCIALE Z EXCHANGE.",
        "interface_preview": "APERÇU DE L'INTERFACE Z EXCHANGE ►",
        "generative_boards": "► TABLEAUX GÉNÉRATIFS Z EXCHANGE ► EXPRESSION MARCHÉ EN TEMPS RÉEL"
      },
      "simulation": {
        "freestyle_title": "Freestyle est un simulateur de session régulière ZExchange.",
        "freestyle_goal_label": "Objectif",
        "freestyle_goal_text": "apprendre l'interface et les concepts de ZExchange ; et surtout explorer comment la valeur devient votre histoire.",
        "details_heading": "Détails :",
        "freestyle_detail_1": "prend notre idée de profits en appliquant de la valeur à ce qui compte pour vous dans votre vie.",
        "life_profit_label": "Profit de Vie",
        "life_profit_description": "valeur de la vie consciemment vécue : joie, perte, contradiction, sexe, amour, dépression, ennui, fête... (qualité / quantité / positif & négatif).",
        "voice_of_bourse_label": "\"voix de la bourse\"",
        "voice_of_bourse_description": "Sur ZExchange, le marché lui-même a une voix, analysant ce qu'il pense de chaque transaction boursière → créant des \"grands tableaux\" génératifs + crée des récits collaboratifs.",
        "zrms_label": "Système Monétaire Relationnel Z",
        "zrms_description": "Les Zollars appliquent votre valeur associative des relations pour payer les actifs en utilisant l'Amour, la Haine, l'Amitié, la Mort, la Fraternité...",
        "commodity_x_label": "Marchandise X",
        "commodity_x_description": "Échangez des marchandises avec un piège, vous avez besoin d'une validation sociale avant toute consommation (échanger avec l'article d'un autre trader → consommer).",
        "economic_tools_label": "Outils économiques",
        "economic_tools_description": "maniez les LBO (Leveraged Buyouts), assauts communistes, subventions socialistes, dark pools, rançon, vol..., utilisez l'économie comme armes ou cadeaux envers d'autres traders.",
        "memento_title": "Memento Mori – Échanger la valeur de vie pour créer votre Éloge funèbre",
        "memento_why_label": "Pourquoi ?",
        "memento_why_text": "réfléchir sur la façon dont vous valorisez la vie, les expériences et les émotions pour déterminer ce que vous valoriseriez le plus lorsque votre vie se termine.",
        "memento_confront_label": "Affrontez la mortalité",
        "memento_confront_description": "Créez un portefeuille de valeurs de vie en négociant des actions, dont la valeur de vie cumulative générera votre éloge funèbre.",
        "memento_relational_label": "Capital relationnel",
        "memento_relational_description": "Les Zollars ici représentent l'association de relations positives et négatives aux actions plutôt qu'un rendement numérique.",
        "memento_bourse_eye_label": "\"Sous l'œil de la bourse\"",
        "memento_bourse_eye_description": "La bourse portera un jugement sur toi dans ton éloge funèbre en observant toutes tes transactions jusqu'à la fin.",
        "enter_key_title": "Accès au simulateur requis",
        "enter_key_title_session": "Accès requis pour créer une session",
        "enter_key_description": "Veuillez entrer votre clé d'accès au simulateur ou scanner le code QR pour continuer.",
        "enter_key_description_session": "Veuillez entrer votre clé d'accès pour créer une nouvelle session.",
        "enter_key_placeholder": "Entrez la clé du simulateur...",
        "analyzing_life_values": "Analyse de vos valeurs de vie...",
        "finding_companies": "Recherche d'entreprises alignées avec votre héritage...",
        "building_chamber": "Construction de votre chambre de mortalité...",
        "preparing_stocks": "Préparation de votre portefeuille d'héritage...",
        "market_response_label": "Réponse du marché",
        "select_company_heading": "Choisissez une entreprise en phase avec votre état émotionnel.",
        "memento_mori_description": "Souviens-toi que tu dois mourir. Cette simulation explore les choix significatifs dans un temps limité.",
        "mortality_chamber_setup": "Vous serez transporté dans l'environnement de simulation, où vous ferez face à un compte à rebours menant à votre mort symbolique et prendrez des décisions de trading qui reflètent vos valeurs les plus profondes.",
        "simulation_instructions": "Vous commencerez par une courte réflexion sur vos valeurs de vie, puis recevrez des actions recommandées. Le compte à rebours commencera seulement après votre réflexion.",
        "building_experience": "Construction de votre Expérience Memento Mori",
        "preparing_chamber": "Préparation de votre chambre de mort symbolique...",
        "life_profit_title": "Explorer ce qui a de la valeur pour vous",
        "welcome_setup": "Bienvenue ! Configurons votre portefeuille de trading.",
        "life_profits_explanation": "Trouvons une action d'entreprise ZEconomy en laquelle vous croyez pour générer des \"Profits de Vie\".",
        "no_matching_companies": "Notre système n'a trouvé aucune entreprise correspondant à votre profil émotionnel.",
        "creating_simulation": "Création de votre Simulation...",
        "please_wait": "Veuillez patienter pendant que nous générons votre portefeuille virtuel.",
        "trade_title": "Trade sur ZExchange.",
        "one_off_session": "Session unique"
      },
      "story": {
        "catena_title": "Catena Narrativa",
        "catena_subtitle": "Construction de récits comme des chaînes d'approvisionnement : échangez, personnalisez et consolidez à travers trois phases pour compléter le processus de création d'histoire.",
        "continue_to_selection": "Continuer vers la sélection d'histoire",
        "process_heading": "Processus :",
        "materials_motion_title": "Matériaux en mouvement :",
        "materials_motion_desc": "Échangez des éléments narratifs comme des marchandises. Personnalisez-les pendant que vous les échangez. La valeur se forme à travers le processus d'échange pour construire une histoire.",
        "three_passes_title": "Trois passages :",
        "three_passes_desc": "Origine (début) → Transit (milieu) → Assemblage (fin) ( 3min + 3min + 2min ≈8 minutes au total). Chaque phase se termine après l'expiration du temps, ou lorsque vous échangez, ce qui entraîne la sécurisation de vos marchandises de points clés dans un registre d'histoire personnel.",
        "composition_title": "Composition :",
        "composition_desc": "À la fin, votre registre est transformé en une courte histoire générée à partir de vos échanges personnalisés d'actifs et de points clés échangés et sécurisés.",
        "commodity_x_label": "Marchandise X",
        "commodity_x_desc": "fait partie de ZEconomy où les profits sont mesurés en <strong>Profit de Vie</strong>— la qualité et la quantité d'intellect, d'affection, de fête... etc, tous les divers événements de la vie, promouvant l'être—plutôt que l'accumulation.",
        "footer_note_consumption": "Marchandise X où la Consommation est relationnelle : vous ne pouvez pas consommer sans consentement mutuel. La marchandise n'est pas l'objet ; la marchandise est l'interaction.",
        "footer_note_redeem": "Échangez relationnellement. Consommez consciemment.",
        "simulation_title": "Simulation d'Histoire",
        "simulation_intro": "Engagez-vous dans un échange narratif avec des participants automatisés à travers trois phases distinctes, créant une courte histoire unique grâce à une collaboration dynamique.",
        "choose_genre": "Choisissez votre genre",
        "genre_scifi": "Science-Fiction",
        "genre_scifi_desc": "Visions futuristes et mondes spéculatifs",
        "genre_romance": "Romance",
        "genre_romance_desc": "Émotion, intimité et connexion humaine",
        "genre_mystery": "Mystère",
        "genre_mystery_desc": "Secrets, enquête et motifs dissimulés",
        "genre_fantasy": "Fantaisie",
        "genre_fantasy_desc": "Mythe, imagination et transcendance",
        "genre_horror": "Horreur",
        "genre_horror_desc": "Peur, suspense et confrontation avec l'inconnu",
        "duration": "Durée : 8 minutes (phases de 3 + 3 + 2 minutes)",
        "loading_elements": " Chargement des éléments d'histoire...",
        "choose_starting_element": "Choisissez votre élément de départ",
        "select_one_element": "Sélectionnez un élément d'histoire pour commencer. Vous recevrez également 2 éléments aléatoires.",
        "skip_selection": "Passer la sélection (Obtenir 3 éléments aléatoires)",
        "preparing_story": "Préparation de votre histoire...",
        "setting_up_simulation": "Configuration de la simulation {theme}...",
        "story_begins": "L'histoire commence maintenant",
        "entering_world": "Entrée dans le monde {theme} dans 2 secondes...",
        "failed_load_elements": "Échec du chargement des éléments d'histoire",
        "failed_create_session": "Échec de la création de la session d'histoire",
        "your_story_complete": "Votre histoire est terminée",
        "generating_final_story": "Génération de votre histoire finale...",
        "please_wait": "Veuillez patienter...",
        "fallback_story": "Votre voyage narratif à travers le marché des histoires s'est conclu. Les éléments que vous avez échangés et personnalisés se sont tissés ensemble en un conte unique."
      },
     "memento": {
       "question_1": "1. Comment vous sentez-vous par rapport à votre vie en ce moment ?",
       "question_1_placeholder": "ex. : anxieux pour l'avenir, reconnaissant pour mes relations...",
       "question_2": "2. Qu'est-ce qui compte le plus pour vous ?",
       "question_2_placeholder": "ex. : la famille, la créativité, avoir un impact...",
       "question_3": "3. Si votre vie se terminait demain, que voudriez-vous que votre héritage représente ?",
       "question_3_placeholder": "ex. : quelqu'un qui a aidé les autres, qui a vécu authentiquement...",
       "find_companies_button": "Trouver des entreprises significatives",
       "choose_legacy_title": "Choisissez votre portefeuille d'héritage",
       "choose_legacy_description": "Sélectionnez 3 à 5 entreprises qui représentent ce qui compte le plus pour vous.",
       "choose_legacy_warning": "Ce seront les actions que vous détiendrez lorsque votre temps expirera.",
       "selected_count": "Sélectionné",
       "your_time_begins": "⏳ Votre temps commence maintenant ⏳",
       "entering_mortality_chamber": "Entrée dans votre chambre de mortalité dans 2 secondes...",
       "your_eulogy_label": "VOTRE ÉLOGE FUNÈBRE",
       "generating_eulogy": "Génération de l'histoire de votre vie basée sur vos choix...",
       "your_eulogy_expanded_title": "VOTRE ÉLOGE FUNÈBRE",
       "eulogy_subtitle": "Une réflexion sur vos choix dans le marché de la vie",
       "eulogy_update_info": "Cet éloge funèbre se met à jour toutes les 2 minutes en fonction de vos actions de trading",
       "eulogy_fallback": "Votre voyage à travers le marché de la vie continue de se dérouler, chaque choix révélant les valeurs qui guident votre chemin.",
       "intor_pop": "Fenêtre d'introduction à la contemplation",
       "intro_pop": "Fenêtre d’introduction à la contemplation",
       "first_form": "Premier formulaire de réflexion",
       "second_form": "Deuxième formulaire de réflexion",
       "begin_countdown": "Lancer le compte à rebours",
       "instructions_title": "Comment cela fonctionne",
       "countdown_notice": "Le compte à rebours commencera après votre première réflexion.",
       "accept_eulogy": "Accepter l’oraison",
       "regenerate_eulogy": "Régénérer l’oraison",
       "enter_chamber": "Entrer dans la chambre",
       "pick_companies_title": "Entreprises recommandées selon vos réflexions",
       "continue_button": "Continuer",
       "validate_key": "Valider la clé",
       "scan_qr_code": "Scanner le code QR",
       "back_button": "Retour",
       "submit_button": "Valider",
       "finish_button": "Terminer",
       "questionnaire_title": "Réfléchir avant d’échanger",
       "emotional_state_label": "Comment vous sentez-vous en ce moment ?",
       "intention_label": "Quelle intention guide vos choix ?",
       "portfolio_meaning_label": "Que doit signifier votre portefeuille ?",
       "oracle_ask_placeholder": "Demandez à le Marché de votre parcours…",
       "tribute_placeholder": "Laissez un hommage…",
     
       // --- Flattened from the tree you pasted ---
     
       // Timer & banner
       "timer_title": "MEMENTO MORI",
       "timer_loading": "Chargement…",
       "timer_click_to_reflect": "Cliquer pour réfléchir",
     
       // Trading overlay & notifications
       "trading_overlay_title": " Négociation consciente de la mortalité ",
       "trading_overlay_line1": "Vous avez <strong>5 minutes</strong> pour négocier en gardant la mortalité à l’esprit.",
       "trading_overlay_line2": "Chaque transaction reflète ce qui compte vraiment.",
       "trading_overlay_line3": "Des bots proposeront des échanges symboliques pour mettre vos valeurs à l’épreuve.",
       "trading_begin_button": "Commencer à négocier",
       "trading_active_badge": "NÉGOCIATION MEMENTO MORI ACTIVE",
       "trading_all_available": "Plus de 310 entreprises disponibles pour la négociation",
       "trading_values_over_profit": "Négociez selon vos valeurs, pas pour le profit",
     
       // Oracle
       "oracle_loading_title": "le Marché s’éveille",
       "oracle_loading_examining": "le Marché examine l’âme de votre portefeuille…",
       "oracle_loading_preparing": "Préparation de questions personnalisées sur votre mortalité…",
       "oracle_loading_wait": "Cela peut prendre un instant…",
       "oracle_title": "Le Marché de la mortalité",
       "oracle_greeting": "Le Marché décèle dans votre portefeuille des motifs qui révèlent votre rapport à la mortalité.",
       "oracle_questions_header": "le Marché a préparé des questions pour votre âme :",
       "oracle_direct_label": "Ou adressez-vous directement à le Marché :",
       "oracle_custom_prompt": "Interrogez le Marché sur votre mortalité, ce que dit votre portefeuille de votre âme, ou le sens de vos choix financiers face à la finitude…",
       "oracle_consult_button": "Consulter le Marché",
       "oracle_vision_title": "Vision de le Marché :",
       "oracle_further_insight": "Analyse complémentaire de le Marché :",
       "oracle_continue_reflections": "Poursuivre les réflexions",
       "oracle_ask_another": "Poser une autre question",
       "oracle_return_trading": "Revenir au marché",
       "oracle_ask_validation": "Veuillez sélectionner ou écrire une question pertinente sur la mortalité (au moins 10 caractères).",
       "oracle_failed": "La consultation de le Marché a échoué",
       "oracle_spoken_placeholder": "le Marché s’est exprimé…",
       "oracle_wisdom_received": "Sagesse reçue",
     
       // Reflection (Phase 1)
       "reflection_title": "MEMENTO MORI : RÉFLEXION",
       "reflection_subtitle": "Avant de négocier, réfléchissez à ce qui compte vraiment dans votre vie",
       "reflection_placeholder": "Partagez vos pensées…",
       "reflection_continue": "Passer à l’analyse des valeurs →",
       "reflection_answer_required": "Veuillez fournir une réponse significative.",
       "reflection_process_failed": "Échec du traitement des réflexions",
       "reflection_process_failed_retry": "Échec du traitement des réflexions. Veuillez réessayer.",
     
       // Questions (fallback texts)
       "questions_life_values": "Quelles valeurs et quels principes ont guidé vos choix de vie ? Qu’est-ce qui compte le plus pour vous ?",
       "questions_meaningful_pursuits": "Quelles activités, relations ou quêtes vous ont apporté le plus de sens et d’épanouissement ?",
       "questions_relationships_impact": "En quoi vos relations avec les autres ont-elles influencé votre vie ? Quels liens comptent le plus ?",
     
       // Value analysis (Phase 2)
       "analysis_title": "VOTRE PROFIL DE VALEURS",
       "analysis_subtitle": "D’après vos réflexions, voici des entreprises en accord avec vos valeurs",
       "analysis_guidance_title": "Conseils :",
       "analysis_recommended_title": "Entreprises recommandées :",
       "analysis_start_trading": "Commencer à négocier (310+ entreprises) →",
     
       // Final call reminder
       "final_call_title": "DERNIER APPEL",
       "final_call_body": "Le temps s’écoule. Finalisez maintenant votre simulation Memento Mori.",
       "final_call_complete_now": "Terminer maintenant →",
     
       // Timeout popup
       "timeout_title": "TEMPS ÉCOULÉ",
       "timeout_body": "La mort est survenue, mais le sens de votre portefeuille est préservé…",
       "timeout_generating": "Génération de votre oraison finale…",
     "death_complete_title": "MORT SYMBOLIQUE ACHEVÉE",
     "death_complete_subtitle": "Vous avez affronté votre mortalité et créé votre héritage.",
     "final_judgment_title": "Jugement final de votre portefeuille :",
     "final_epitaph_title": "Votre épitaphe finale :",
     "return_to_void_button": "Retourner au néant",
       "eulogy_title": "VOTRE ORAISON NUMÉRIQUE",
       "eulogy_subtitle": "Fondée sur vos choix de portefeuille et vos réflexions de vie",
       "eulogy_your_eulogy": "Votre oraison :",
       "eulogy_insights": "Enseignements du portefeuille :",
       "eulogy_rest_in_peace": "Reposez en paix"
     },
      "socketBack": {
        "narrativeProcessed": "Réponse narrative traitée",
        "unauthorizedSuperUser": "Non autorisé : seuls les banquiers de la Zédérale Réserve peuvent effectuer cette action",
        "noTargetUser": "Aucun trader cible fourni",
        "logoutByAdmin": "Vous avez été déconnecté par un administrateur.",
        "logoutUserSuccess": "L’utilisateur {id} a été déconnecté de force avec succès.",
        "logoutUserOffline": "L’utilisateur {id} est déjà hors ligne.",
        "marketClosed": "Le marché est fermé.",
        "logoutAllSuccess": "Tous les traders ont été déconnectés avec succès.",
        "taxEvent": "Vous êtes soumis à une taxe de marché. Choisissez de donner un bien au hasard ou de perdre du capital.",
        "zollarIssued": "Un Zollar vous a été émis par la Zédérale Réserve.",
        "zollarFailed": "Échec de l’attribution des Zollars",
        "ransomAssigned": "Vous avez reçu le déclencheur de rançon.",
        "ransomLocked": "Votre portefeuille a été verrouillé avec une rançon de {points} capitaux.",
        "lboAssigned": "Vous avez reçu le déclencheur de rachat avec effet de levier (LBO).",
        "lboAssetsRemoved": "Des actifs ont été retirés de votre portefeuille en raison d’un LBO.",
        "removedStocksLabel": "Actions retirées :",
        "removedItemsLabel": "Objets retirés :",
        "unknownStock": "Action inconnue",
        "unknownItem": "Objet inconnu",
        "sharesWord": "parts",
        "ofWord": "de",
        "subsidy_assigned": "Vous avez reçu le déclencheur de Subvention.",
        "subsidy_taxed": "45 % de votre richesse ont été redistribués comme Subvention socialiste pour les revenus plus faibles.",
        "subsidy_received": "Vous avez reçu une subvention socialiste.",
        "pointsGiven": "Du capital a été émis.",
        "itemsDistributed": "Des biens ont été distribués.",
        "freebieZ1Message": "La Zederal Reserve a distribué un bien gratuit à votre portefeuille !",
        "ransomPaidNotification": "{userName} a payé la rançon de {points} capital. Les fonds ont été transférés sur votre compte.",
        "pointsDeducted": "{amount} capital ont été déduits de votre compte.",
        "itemTaxed": "La Zédérale Réserve a taxé un bien dans vos avoirs.",
        "deleteButtonAssigned": "Vous avez reçu le déclencheur d’Assaut communiste.",
        "deletePerformed": "Votre portefeuille a été ciblé par un Assaut communiste.",
        "subsidyUpdateBotTarget": "{botName} a déclenché une Subvention socialiste — 45 % de votre richesse ont été redistribués.",
        "specialSubsidyTarget": "{botName} a redistribué 45 % de votre richesse via une Subvention socialiste",
        "subsidyReceivedFrom": "Vous avez reçu une Subvention socialiste grâce à l’action de redistribution de {botName} !",
        "specialSubsidyReceived": "Vous avez reçu des fonds issus de la Subvention socialiste de {botName}",
        "ransomLockedBy": "{botName} a gelé votre portefeuille avec une rançon de {points} capital !",
        "specialRansomTarget": "{botName} a gelé votre portefeuille et exige une rançon",
        "specialRansomImpact": "Portefeuille verrouillé — {points} de capital requis",
        "lboExecutedOnYouBy": "{botName} a réalisé un rachat avec effet de levier (LBO) sur votre portefeuille.",
        "specialLboTarget": "Votre portefeuille a été la cible d’un LBO réalisé par {botName}",
        "itemStolen": "{botName} a volé « {itemName} » dans votre portefeuille !",
        "specialStealTarget": "{botName} vous a volé « {itemName} »",
        "specialStealImpact": "Objet perdu : {itemName}",
        "deleteUpdateBy": "{botName} a exécuté un Assaut communiste sur votre portefeuille !",
        "specialDeleteTarget": "{botName} a exécuté un Assaut communiste sur votre portefeuille",
        "assaultGameEvent": "{botName} a exécuté un Assaut communiste contre {targetName} !",
        "unknownPlayer": "Joueur inconnu",
        "tradeAccepted": "Échange accepté ! capital attribués.",
        "tradeDeclined": "Échange refusé. Aucun capital attribué."
      },
     "socketFront": {
       "ransomTitle": "Portefeuille rançonné !",
       "ransomHeldBy": "Votre portefeuille est retenu contre rançon par",
       "ransomMustPay": "Vous devez payer {points} capital pour reprendre le contrôle.",
       "payRansomCta": "Payer la rançon ({points} capital)",
       "ransomPayFailed": "Échec du paiement de la rançon. Veuillez réessayer.",
       "messageError": "Erreur d’envoi du message :",
       "sendErrorPrefix": "Erreur d’envoi du message :",          // alias
       "messageSent": "Message envoyé avec succès !",
       "messageSentSuccess": "Message envoyé avec succès !",       // alias
     
       "loggedOutByAdmin": "Vous avez été déconnecté par l’administrateur.",
       "logoutActiveUpdateError": "Erreur lors de la mise à jour de l’état pendant la déconnexion. Veuillez réessayer.",
       "logoutServerError": "Erreur lors de la déconnexion serveur. Veuillez réessayer.",
     
       "mementoComplete": "Vous avez terminé votre contemplation de la mortalité !",
       "darkPoolEnded": "Le Dark Pool est terminé. Vous retrouvez votre statut normal.",
       "darkPoolExpired": "Le Dark Pool a expiré. Vous retrouvez votre statut normal.",
     
       "timerExtended60": "Minuteur prolongé à 60 secondes",
     
       "tradeAcceptedFrom": "Échange accepté de",
       "forWord": "pour",
       "ofType": "de type",
       "tradeAcceptFailed": "Échec de l’acceptation de l’échange :",
       "tradeAcceptFailedPrefix": "Échec de l’acceptation de l’échange :",   // alias
       "tradeDeclined": "Échange refusé.",
       "respondedToAnalysis": "a répondu à votre analyse d’échange",
       "tradeAnalysisResponded": "a répondu à votre analyse d’échange",      // alias
     
       "offerAccepted": "Offre acceptée !",
       "offerDeclined": "Offre refusée !",
       "offerAcceptedLong": "Votre offre a été acceptée.",
       "offerDeclinedLong": "Votre offre a été refusée !",
       "offerExpired": "Votre offre a expiré",
       "offerError": "Une erreur s’est produite avec votre offre",
     
       "shortSuccess": "Vente à découvert réussie !",
       "shortFailed": "Échec de la vente à découvert :",
       "shortClosedPrefix": "Votre position courte sur l’action",
       "shortClosedSuffix2": "a été clôturée automatiquement.",
     
       "bondBidPrefix": "Votre offre pour l’obligation",
       "bondAccepted": "a été acceptée.",
       "bondDeclined": "a été refusée.",
       "yourBond": "Votre obligation",
       "bondMatured": "est arrivée à échéance et des zollars ont été émis.",
     
       "buyOfferAcceptedFrom": "Offre d'achat acceptée de",
       "buyAcceptFailed": "Échec de l'acceptation de l'offre d'achat :",
       "buyAcceptFailedPrefix": "Échec de l'acceptation de l'offre d'achat :", // alias

       "warningPrefix": "ATTENTION :",
       "criticalPrefix": "CRITIQUE :",
       "debtPageVisit": "Visitez la page Dette pour plus de détails.",
       "debtWipeoutDefault": "Votre portefeuille a été effacé en raison d'une dette excessive.",
       "debtWarningPrefix": "ATTENTION : Cette dette se recharge toutes les 60 secondes avec un intérêt composé de 15 % jusqu'au remboursement.",
       "bankruptcyWarning": "ATTENTION : Vous approchez de la faillite !",
       "debtCompounded": "Dette composée :",
       "totalDebt": "Dette totale :",
       "youOwe": "Vous devez :",
       "checkDebtHeldSection": "Consultez votre section Dettes détenues pour convertir."
     },
     "debtWarning": {
       "title": "Alerte de Dette",
       "aboutToGoIntoDebt": "Vous êtes sur le point de vous endetter !",
       "currentBalance": "Solde actuel :",
       "bidAmount": "Montant de l'offre :",
       "offerAmount": "Montant de l'offre :",
       "youWillOwe": "Vous devrez :",
       "interestAccrues": "Les intérêts s'accumulent à 5 % par jour sur les soldes négatifs.",
       "creditLimit": "Limite de crédit : -1000 capital (par défaut)",
       "proceedAnyway": "Continuer quand même",
       "cancel": "Annuler",
       "points": "Capitaux"
     },
     "debt": {
       "capital": "capital",
       "closedDefault": "Un instrument de dette de type {type} a été clôturé.",
       "closedGeneric": "Un instrument de dette a été clôturé.",
       "amounts": {
         "none": "Aucun",
         "barelyAny": "Presque rien",
         "aTrace": "Une trace",
         "aHint": "Un soupçon",
         "aLittle": "Un peu",
         "aFew": "Quelques-uns",
         "some": "Certains",
         "several": "Plusieurs",
         "moderate": "Modéré",
         "noticeable": "Notable",
         "considerable": "Considérable",
         "many": "Nombreux",
         "aLot": "Beaucoup",
         "abundant": "Abondant",
         "heaps": "Énormes quantités",
         "aGreatDeal": "Une grande quantité",
         "substantial": "Substantiel",
         "immense": "Immense"
       },
       "interest": {
         "minimal": "Charge émotionnelle minimale",
         "light": "Charge émotionnelle légère",
         "modest": "Charge émotionnelle modeste",
         "fair": "Charge émotionnelle équitable",
         "moderate": "Charge émotionnelle modérée",
         "notable": "Charge émotionnelle notable",
         "considerable": "Charge émotionnelle considérable",
         "heavy": "Charge émotionnelle lourde",
         "intense": "Charge émotionnelle intense",
         "crushing": "Charge émotionnelle écrasante"
       },
       "altrau": {
         "receivedTitle": "Effet Altrau Z reçu",
         "issuedTitle": "Effet Altrau Z émis",
         "hasGivenYou": "vous a donné",
         "ledgersBound": "Vos registres sont désormais liés. Leur Profit Vital affecte le vôtre.",
         "youHaveSent": "Vous avez envoyé",
         "toRecipient": "à",
         "fatesBound": "Vos destins sont désormais liés. Votre Profit Vital affecte le leur."
       },
       "mnote": {
         "acceptedTitle": "Note M acceptée",
         "createdTitle": "Note M créée",
         "witnessedVulnerability": "a été témoin de votre vulnérabilité",
         "loanLabel": "Prêt",
         "atRate": "avec",
         "positiveTradeTip": "Effectuez des échanges positifs pour réduire automatiquement cette dette !",
         "createdWith": "Note M créée avec",
         "tradeableAfter": "Négociable après 5 échanges. Convertible après le maximum d'échanges.",
         "progressTitle": "Progression du remboursement de la Note M",
         "repaidPercent": "Vous avez remboursé",
         "throughTrading": "grâce à des échanges positifs",
         "keepTrading": "Continuez à bien négocier pour réduire davantage votre dette.",
         "debtClearedTitle": "Dette effacée !",
         "repaidTitle": "Note M remboursée",
         "positiveTrading": "échanges positifs",
         "directRepayment": "remboursement direct",
         "fullyRepaidTo": "Vous avez entièrement remboursé votre Note M à",
         "throughMethod": "par",
         "emotionalDebtCleared": "Votre dette émotionnelle est effacée. Bien joué !",
         "hasFullyRepaid": "a entièrement remboursé sa Note M",
         "instrumentClosed": "L'instrument de dette a été clôturé.",
         "alertTitle": "Alerte Note M",
         "convertibleTitle": "Note M convertible",
         "nowConvertible": "Votre Note M est désormais",
         "convertibleCaps": "CONVERTIBLE",
         "canConvertTo": "Vous pouvez la convertir en",
         "inLiquidAssets": "en actifs liquides"
       },
       "cdo": {
         "acceptedTitle": "CDO Z-Payday acceptée",
         "createdTitle": "CDO Z-Payday créée",
         "offeredLoan": "vous a proposé un prêt",
         "availableImmediately": "disponible immédiatement",
         "createdWith": "CDO Z-Payday créée avec",
         "tradeableCompounds": "Négociable. Composition toutes les 60s à 15%.",
         "bankruptcyWarningTitle": "ALERTE FAILLITE",
         "reloadCycle": "Rechargement CDO : Cycle {cycle}",
         "cdoCompounded": "Votre CDO a été composée",
         "victimOwes": "La victime doit",
         "bankruptcyTitle": "FAILLITE",
         "cdoCollapsed": "Votre CDO Z-Payday s'est effondrée",
         "totalDebtLabel": "Dette totale",
         "assetsSeized": "Actifs saisis",
         "standingDamaged": "Votre situation financière a été gravement endommagée.",
         "maturedTitle": "CDO arrivée à maturité",
         "victimBankrupt": "Votre victime a déclaré faillite",
         "youSeized": "Vous avez saisi",
         "toxicGainRecorded": "Gain toxique enregistré dans les relations."
       },
       "vnote": {
         "aidGrantedTitle": "Aide de la Note V accordée",
         "hasGrantedAid": "vous a accordé son aide",
         "received": "Reçu",
         "vulnerabilityWitnessed": "Votre vulnérabilité a été reconnue et accueillie avec compassion.",
         "youGranted": "Vous avez accordé",
         "toRecipient": "à",
         "compassionRecorded": "Votre compassion a été enregistrée dans le registre social."
       }
     },
      "tax": {
        "tax_alert_timer": "ALERTE FISCALE ! Vous avez 10 secondes pour choisir, sinon vous perdez les deux :",
        "lose_capital": "Perdre du capital",
        "lose_capital_zollars": "Perdre du capital & zollars",
        "give_random_asset": "Donner un bien aléatoire",
        "assign_failed": "Échec de l’attribution d’un nouvel actif à tous les portefeuilles.",
        "new_asset_assigned": "La Zederal Reserve a attribué un nouvel actif à votre portefeuille.",
        "tax_call_no_assets" : "La Réserve Zédérale impose un prélèvement. Appuyez sur OK pour céder du capital, aucun bien disponible pour régler.",
        "asset_taxed": "Un bien a été taxé par la Zederal Reserve.",
        "no_items_available": "Aucun bien non échangé disponible pour la taxation.",
        "tax_item_failed": "Échec de la taxation d’un bien.",
        "capital_taxed_prefix": "Vous avez été taxé en capital par la Zederal Reserve !",
        "refund_received_prefix": "Vous avez reçu un remboursement de capital de la Zederal Reserve",
        "new_asset_received": "Vous avez reçu un nouvel actif de la Zederal Reserve",
        "zollar_assigned": "Vous avez reçu des Zollars de la Zederal Reserve.",
        "points": "Capitaux"
      },
      "trader": {
        "price" : "prix",
        "bien_q": "Bien",
        "send_message": "Envoyer un message",
        "no_economic_tiggers" : "Vous n'avez aucun déclencheur économique.",
        "no_stocks" : "Vous ne possédez aucune action.",
        "output": "Production",
        "tap_for_details": "touchez pour la fiche complète + graphique",
        "message_cost": "Coût : 20 ",
        "no_bond_port": "Vous n'avez aucune ZBond.",
        "select_recipient": "Sélectionnez un destinataire :",
        "message_placeholder": "Saisissez votre message (280 caractères max)",
        "send_button": "Envoyer",
        "close_button": "Fermer",
        "no_bond_port": "",
        "no_redeemed_item": "Aucun bien converti dans votre portefeuille.",
        "steal_commodity": "Voler une Commodity",
        "ransom": "Rançon",
        "no_zollar_port": "Aucun Zollar dans vos portefeuille.",
        "create_dark_pool": "Créer un Dark Pool",
        "delete_portfolio": "Supprimer le portefeuille",
        "capitalist_lbo": "LBO Capitaliste",
        "socialist_subsidy": "Subvention Socialiste",
        "explanations": "Explications",
        "click_learn_more": "Cliquez pour en savoir plus",
        "go_to_market": "Aller au Marché",
        "dark_pool_market": "Marché Dark Pool",
        "no_reason_provided": "Aucune raison fournie",
        "stock_name": "Nom de l'action",
        "unknown": "Inconnu",
        "symbol": "Symbole",
        "quantity": "Quantité",
        "no_shorts_open" : "Aucune position Short placée",
        "no_short_data" : "Aucune data",
        "initial_value_per_share": "Valeur initiale par action",
        "current_value_per_share": "Valeur actuelle par action",
        "total_gain_loss": "Gain/Perte total",
        "reason_for_short": "Raison du short",
        "close_short_position": "Fermer la position short",
        "your_portfolio": "Votre portefeuille",
        "emotional_state_banner_title": "Votre économie émotionnelle",
        "social_economy_banner_title": "Instruments de dette émotionnelle",
        "issue_altrau_z_bill": "Émettre un Billet Z Altrauiste",
        "issue_m_note_borrow": "Émettre une Note M (Emprunter)",
        "issue_z_payday_cdo": "Émettre un CDO Z-Payday",
        "issue_v_note_request_aid": "Note V (Appel à l'aide)"
      },
      "market": {
        "all_types": "Tous les types",
        "goods": "Biens", 
        "stocks": "Actions",
        "short_stock_title": "Shorter une Action ",
        "stock_label": "Action",
        "current_share_value": "Cours actuel de l’action",
        "bonds": "Obligations",
        "no_sort": "Aucun tri",
        "price_low_to_high": "Prix : du plus bas au plus élevé",
        "price_high_to_low": "Prix : du plus élevé au plus bas",
        "apply_filter": "Appliquer le filtre",
        "reset": "Réinitialiser",
        "close": "Fermer",
        "explanations": "Explications",
        "items": "Biens",
        "trade": "Échanger",
        "buy": "Acheter",
        "processing" : "traitement en cours",
        "trade_for": "Échanger contre",
        "description": "Description",
        "value": "Valeur",
        "quantity": "Quantité",
        "location": "Emplacement",
        "owner": "Propriétaire",
        "portfolio": "Portefeuille",
        "filter": "Filtrer",
        "redeem": "Échanger ✓",
        "buy_bond_confirmation": "Acheter cette obligation déclenchera sa période de maturité. Confirmez pour continuer.",
        "bond_purchased_success": "Obligation achetée avec succès !",
        "bond_purchase_failed": "Échec de l'achat de l'obligation. Veuillez réessayer.",
        "portfolio_ransomed": "Votre portefeuille est actuellement sous rançon. Payez la rançon pour voir et interagir avec les objets.",
        "shorted_by": "Shorté par :",
        "unknown": "Inconnu",
        "num_shares": "# Actions :",
        "short_value": "Valeur du short :",
        "reason": "Raison :",
        "enter_offer_for": "Entrez votre offre pour",
        "available_points": "Vous avez {points} capital disponibles. Coût de l'objet : {cost}.",
        "choose_offer_type": "Choisissez le type d'offre :",
        "waiting": "Attente",
        "zollars": "Zollars",
        "capital": "Capital",
        "confirm": "Confirmer",
        "cancel": "Annuler",
        "enter_capital": "Entrez le capital :",
        "offer_amount_placeholder": "Montant de l'offre",
        "select_zollar_value": "Sélectionnez une valeur en Zollars pour continuer.",
        "invalid_offer": "Offre invalide ou capital insuffisant",
        "processing_transaction": "Traitement de votre transaction...",
        "waiting_seconds": "Attente : {seconds} secondes",
        "short_stock": "Shorter une action",
        "stock": "Action :",
        "processing": "Traitement de votre transaction...",
        "current_value": "Valeur actuelle :",
        "available_shares": "Actions disponibles :",
        "enter_num_shares": "Saisir le nombre d’actions",
        "short_amount_placeholder": "Nombre d'actions à shorter",
        "short_reason_placeholder": "Pourquoi shortez-vous cette action ?",
        "confirm_short": "Confirmer le Short",
        "short_stock_btn": "Short Action",
        "must_provide_reason": "Vous devez fournir une raison pour shorter cette action.",
        "portfolio_name": "Nom du portefeuille"
      },
     offer: {
       item_received: "Vous avez reçu {item} de la part de {giver} !",
       offer_sent: "Offre envoyée",
       do_not_leave_page: "NE QUITTEZ PAS LA PAGE.",
       awaiting_response: "En attente de réponse…",
       time_remaining_html: "Temps restant : <span id=\"timer\">{seconds}</span> secondes",
       time_remaining: "Temps restant : {seconds} secondes",
       time_expired: "Temps écoulé. Offre refusée.",
       offer_declined: "Offre refusée. Aucun capital accordé.",
       offer_accepted: "Offre acceptée ! Capital accordés.",
       trade_offer: "Offre de troc",
       offers_you: "{initiator} vous propose : {offered} en échange de : {requested}",
       reason: "Raison :",
       respond: "Répondre",
       accept: "Accepter",
       decline: "Refuser",
       time_remaining_extended: "Temps restant : {seconds} secondes (prolongé)",
       buy_offer_received: "Offre d’achat reçue",
       zollar_offer_for: "Offre en zollars pour {item} de la part de {portfolio} : {details}",
       points_offer_for: "Offre en capital pour {item} de la part de {portfolio} : {details}",
       no_zollar_details: "Aucun détail de zollars disponible.",
       your_portfolio: "Votre portefeuille",
       session_missing: "Session ou autorisation manquante. Veuillez vous reconnecter.",
       error_missing_details: "Erreur : informations manquantes pour l’offre. Réessayez.",
       error_invalid_points: "Erreur : montant invalide pour l’offre en capital.",
       error_missing_zollar_details: "Erreur : détails manquants pour l’offre en zollars.",
       error_invalid_offer_type: "Erreur : type d’offre invalide.",
       success_buy_offer_accepted: "Succès : offre d’achat acceptée pour {item}",
       error_accepting_offer: "Erreur lors de l’acceptation : {message}",
       processing: "Traitement de la transaction…",
     
       meaningful_exchange: "Échange avec intention",
       value_quote: "La valeur existe dans la perception, le jeu et la spéculation, pas seulement l’utilité ou la rareté.",
       who_to_trade_with: "Avec qui souhaitez-vous échanger ?",
       select_trader: "Sélectionnez un·e trader…",
       why_trade: "Pourquoi souhaitez-vous faire cet échange ?",
       describe_motivation: "Décrivez votre motivation, votre émotion ou votre histoire…",
       trade_with: "Échanger avec :",
       capital: "Capital",
       zollars: "Zollars",
       cancel: "Annuler",
       send_offer: "Envoyer l’offre",
       sending: "Envoi…",
       meaningful_offer_sent: "Offre de troc envoyée ! {insight}",
       error_generic: "Erreur : {message}",
       share_reason_placeholder: "Partagez votre raison, une motivation, un souvenir ou une vision… Pour créer des liens significatifs en échangeant.",
     
       meaningful_trade_offer: "Offre de troc avec intention",
       wants_to_trade: "souhaite échanger",
       respond_optional: "Répondez à son histoire (optionnel)…",
       not_interested: "Pas intéressé",
       im_interested: "Je suis intéressé !",
       response_sent: "Réponse envoyée",
       interest_shown: "Intérêt indiqué ! L’autre partie peut vous contacter.",
       respond_to_offer: "Répondre à l’offre.",
       the_why: "Le pourquoi :",
       share_thoughts: "Partagez vos idées, posez des questions ou expliquez votre point de vue…",
       response_min_length: "Veuillez écrire au moins 10 caractères.",
       response_min_10: "Veuillez écrire au moins 10 caractères sur votre motivation.",
       send_response: "Envoyer la réponse",
       response_sent_title: "Réponse envoyée",
       response_sent_waiting: "Réponse envoyée ! En attente de leur réponse…",
       your_response: "Votre réponse :",
       waiting_for_response: "En attente de sa réponse…",
       timer_extended_60: "Minuteur prolongé à 60 secondes",
       they_responded: "Ils ont répondu",
       their_original_why: "Leur pourquoi initial :",
       their_response: "Leur réponse :",
       accept_trade: "Accepter l’échange",
       decline_trade: "Refuser l’échange",
     
       updated_trade_offer: "Offre de troc mise à jour",
       offer_sentence_simple: "{name} vous propose {offered} et demande {requested} en échange.",
       conversation: "Conversation :",
     
       buy_accepted_points: "{seller} a accepté votre offre ! Vous avez obtenu {item} pour {points} capital.",
       buy_accepted_zollars: "{seller} a accepté votre offre ! Vous avez obtenu {item} contre des zollars.",
       buy_accepted_generic: "{seller} a accepté votre offre ! Vous avez obtenu {item}.",
     
       error_processing_trade: "Erreur lors du traitement de l’offre",
     
       zollar_none: "Aucun",
       zollar_few: "Quelques-uns",
       zollar_some: "Certains",
       zollar_many: "Beaucoup",
       zollar_huge: "Énormément"
     },
      "transaction": {
        "requested_item": "Bien demandé",
        "item_owner": "Propriétaire du bien",
        "item_name": "Nom du bien",
        "points": "capital",
        "location": "Emplacement",
        "propose": "Proposer",
        "explain_trade_reason": "Expliquez pourquoi vous souhaitez faire cet échange.",
        "you_offer": "Vous proposez :",
        "you_want": "Vous voulez :",
        "why_trade_question": "Pourquoi voulez-vous faire cet échange ? Quel est votre objectif ?",
        "share_motivation": "Partagez votre motivation, un souvenir ou une vision… Les histoires créent des connexions significatives dans le trading. (15 caractères minimum)",
        "narrative_error": "Veuillez écrire au moins 15 caractères pour expliquer votre objectif.",
        "char_missing": "Il manque encore {count} caractères pour expliquer votre objectif.",
        "char_missing_full": "Veuillez écrire au moins 15 caractères pour expliquer pourquoi vous souhaitez cet échange.",
        "send_trade_with_intention": "Envoyer l'échange avec une intention",
        "cancel": "Annuler",
        "select_asset": "Sélectionner un actif",
        "return_to_market": "Retour au marché"
      },
      "boss": {
        "session_required_leaderboard": "L'ID de session est requis pour voir le classement.",
        "session_required_mood_board": "L'ID de session est requis pour voir le tableau d'humeur.",
        "invalid_point_amount": "Montant de capital invalide. Veuillez réessayer.",
        "session_required_system_bot": "L'ID de session est requis pour démarrer le bot système.",
        "system_bot_started": "Bot système démarré : {name}",
        "system_bot_start_failed": "Échec du démarrage du bot système : {error}",
        "session_required_stop_bot": "L'ID de session est requis pour arrêter le bot système.",
        "system_bot_stopped": "Bot système arrêté avec succès.",
        "system_bot_stop_failed": "Échec de l'arrêt du bot système : {error}",
        "session_required_trigger_event": "L'ID de session est requis pour déclencher l'événement système.",
        "system_event_triggered": "Événement système déclenché avec succès !",
        "system_event_trigger_failed": "Échec du déclenchement de l'événement système : {error}",
        "session_required_logout": "L'ID de session est requis pour déconnecter les traders."
      },
      "stock": {
        "ownership_transferred": "Propriété transférée.",
        "transfer_failed": "Échec du transfert de propriété. Réessayez.",
        "share_deleted": "Action supprimée.",
        "delete_failed": "Échec de la suppression de l’action. Réessayez.",
        "short_closed": "Vente à découvert clôturée.",
        "close_short_failed": "Échec de la clôture de la vente à découvert. Réessayez.",
        "short_placed": "Vente à découvert ouverte.",
        "place_short_failed": "Échec de l’ouverture de la vente à découvert. Réessayez.",
        "no_short_positions": "Aucune vente à découvert pour cette action.",
        "no_zollars_available": "Aucun Zollar disponible.",
        "select_zollars_to_bid": "Sélectionnez des Zollars pour votre enchère.",
        "value": "Valeur",
        "place_bid": "Placer une enchère",
        "bid": "Enchère",
        "name": "Action",
        "short_reason_required": "Merci d’indiquer une raison pour la short de cette action.",
        "failed_missing_shares": "Échec : informations sur les actions introuvables.",
        "invalid_short_amount": "Quantité d’actions à Shorter invalide.",
        "short_succes": "Position Short placée avec succès !",
        "bid_type": "Type d’enchère",
        "available_shares": "Actions disponibles",
        "available_funds": "Fonds disponibles",
        "fetch_short_failed": "Échec du chargement des ventes à découvert. Réessayez.",
        "short_positions_for": "Ventes à découvert pour l’action",
        "short_position": "Vente à découvert",
        "insufficient_funds": "Fonds insuffisants.",
        "enter_bid_amount": "Saisissez le montant de l’enchère.",
        "enter_shares": "Saisissez le nombre d’actions.",
        "enter_valid_amount": "Montant ou nombre d’actions invalide.",
        "close_short": "Clôturer la vente à découvert",
        "go_to_market": "Aller au marché",
        "fetch_zollars_failed": "Échec du chargement des Zollars.",
        "descriptor_none": "Aucune",
        "descriptor_a_few": "Quelques-unes",
        "descriptor_some": "Un certain nombre",
        "descriptor_many": "Beaucoup",
        "descriptor_huge": "Énormément",
        "submitting_bid": "Soumission de votre offre...",
        "please_wait": "Veuillez patienter pendant que nous la traitons.",
        "redirect_in": "Redirection dans",
        "seconds": "secondes"
      },
      "social_class": {
        "working_class": {
          "name": "Classe Ouvrière",
          "description": "Vous commencez endetté avec des ressources minimales. Chaque décision compte.",
          "goal": "Échapper à la dette grâce au commerce stratégique et à la construction communautaire",
          "goals": {
            "pay_off_debt": "Remonte ton capital au-dessus de zéro avant la fin du temps. Vends des parts, échange des objets, accepte les offres justes — chaque affaire qui rapporte compte.",
            "two_swaps": "Réalise 2 échanges (trocs) avec d'autres traders : tes choses contre les leurs. Pas besoin d'argent — le troc, c'est comme ça qu'on trade quand on est fauché.",
            "reserve_lift": "Va à la Réserve Zédérale, prends un Z Bond pour obtenir du capital, et transforme-le en au moins un échange qui fait grandir ce que tu détiens."
          }
        },
        "lower_middle": {
          "name": "Classe Moyenne Inférieure",
          "description": "Vous avez des ressources modestes. Une planification prudente peut mener à la prospérité.",
          "goal": "Construire la stabilité financière et développer votre réseau",
          "goals": {
            "own_two_companies": "Détiens des parts de 2 entreprises différentes avant la fin. Choisis des entreprises dont l'histoire te parle — tu grandis quand elles grandissent.",
            "first_zollars": "Achète des zollars à la Réserve Zédérale et gagne un échange en payant avec des relations (Amour, Amitié…) plutôt qu'avec du capital.",
            "grow_worth": "Fais grandir ta valeur totale d'un cinquième. Enchéris sur ce qui est sous-évalué, échange vers le haut, et ne laisse pas dormir ton capital."
          }
        },
        "middle_class": {
          "name": "Classe Moyenne",
          "description": "Vous commencez avec un portefeuille équilibré. Les choix stratégiques détermineront votre trajectoire.",
          "goal": "Maintenir la stabilité tout en poursuivant des opportunités de croissance",
          "goals": {
            "diversify": "Termine la session en détenant les trois formes de valeur : des parts d'une entreprise, un objet, et une obligation.",
            "three_bids": "Gagne 3 enchères sur des choses que d'autres traders détiennent. Propose ton prix, dis pourquoi tu le veux, et convaincs-les.",
            "relations_over_money": "Finis plus riche en zollars qu'en capital — trade pour que les relations pèsent plus lourd que l'argent dans ton portefeuille."
          }
        },
        "upper_middle": {
          "name": "Classe Moyenne Supérieure",
          "description": "Vous avez des ressources importantes. Utilisez-les judicieusement pour créer des opportunités.",
          "goal": "Tirer parti de vos ressources pour construire une influence durable",
          "goals": {
            "fair_patron": "Joue le mécène : gagne 2 enchères ET accepte 2 offres de traders plus pauvres que toi, à un prix juste. L'influence se construit, elle ne s'achète pas.",
            "capital_to_life": "Convertis ton capital en valeur vivante : termine avec plus de richesse en parts et en objets qu'en simple capital.",
            "bond_collector": "Construis un carnet d'obligations : détiens 3 Z Bonds de la Réserve Zédérale et laisse les intérêts travailler pour toi."
          }
        },
        "wealthy_elite": {
          "name": "Élite Fortunée",
          "description": "Vous commencez avec une richesse immense. Tout le monde veut ce que vous avez—la générosité crée la protection.",
          "goal": "Partagez la richesse pour construire des alliances ou faire face à une résistance coordonnée",
          "goals": {
            "generous_giant": "Donne pour grandir : accepte des échanges ou des enchères modestes d'au moins 3 traders différents. Sur ce parquet, la générosité est une protection.",
            "biggest_backer": "Répartis ta richesse en parts de 4 entreprises différentes — deviens le plus grand soutien du parquet.",
            "keep_the_crown": "Termine la session toujours au sommet. Tout le monde veut ce que tu as ; les alliances et les affaires justes sont ta seule façon de le garder."
          }
        },
        "starting_capital": "Capital de départ :",
        "starting_items": "Objets de départ :",
        "your_goal": "Votre objectif :",
        "actions_note": "Vos actions façonnent la façon dont les autres vous traitent. La générosité construit des alliances, l'exploitation invite aux représailles."
      },
      "life_terms": {
        "_comment": "FR only. The heavy/lacking words from ZEconomy_baseline.csv, which is English. EN falls back to the term itself, like companies_by_id.",
        "abandoning": "abandon",
        "abandonment": "abandon",
        "absence": "absence",
        "absorbing": "absorption",
        "abusing": "abus",
        "accepting": "acceptation",
        "accumulating": "accumulation",
        "accusation": "accusation",
        "accusing": "accusation",
        "adaptability": "capacité d'adaptation",
        "addiction": "dépendance",
        "adjusting": "ajustement",
        "aggression": "agressivité",
        "agitating": "agitation",
        "agitation": "agitation",
        "agony": "angoisse",
        "alergies": "allergies",
        "alienating": "aliénation",
        "alienation": "aliénation",
        "ambiguity": "ambiguïté",
        "amplification": "amplification",
        "amplifying": "amplification",
        "analysis paralysis": "paralysie par l'analyse",
        "analyzing": "analyse",
        "anger": "colère",
        "anguish": "angoisse",
        "annoyance": "agacement",
        "anxiety": "anxiété",
        "apathy": "apathie",
        "apologizing": "excuses",
        "arguing": "disputes",
        "argument": "dispute",
        "arrogance": "arrogance",
        "assimilating": "assimilation",
        "assuming": "présomption",
        "assumptions": "présupposés",
        "assurance": "assurance",
        "attachment": "attachement",
        "attachment-issues": "troubles de l'attachement",
        "attacking": "agression",
        "attention-seeking": "quête d'attention",
        "avoidance": "évitement",
        "avoiding": "évitement",
        "awkwardness": "malaise",
        "backlog": "retard accumulé",
        "backstabbing": "trahison",
        "backtracking": "revirements",
        "bad-luck": "malchance",
        "balance": "équilibre",
        "bankruptcy": "faillite",
        "being misunderstood": "être mal compris",
        "belittling": "rabaissement",
        "betrayal": "trahison",
        "betraying": "trahison",
        "betting": "pari",
        "bias": "parti pris",
        "binge-watching": "visionnage compulsif",
        "bingeing": "excès compulsifs",
        "binging": "excès compulsifs",
        "bitterness": "amertume",
        "blacking-out": "trous noirs",
        "blackout": "trou noir",
        "blaming": "reproches",
        "blind-acceptance": "acceptation aveugle",
        "blind-following": "suivisme aveugle",
        "blindness": "aveuglement",
        "bloating": "ballonnement",
        "blockage": "blocage",
        "blocking": "blocage",
        "bluffing": "bluff",
        "bluntness": "brusquerie",
        "boasting": "vantardise",
        "boldness": "audace",
        "boredom": "ennui",
        "bottling-up": "refoulement",
        "bragging": "vantardise",
        "brain-fog": "brouillard mental",
        "breakdown": "effondrement",
        "breaking": "rupture",
        "breaking-down": "effondrement",
        "broken-promises": "promesses brisées",
        "bruising": "meurtrissures",
        "brushing-aside": "balayage d'un revers",
        "buffering": "attente",
        "burden": "fardeau",
        "bureaucratic-fatigue": "lassitude administrative",
        "burnout": "épuisement professionnel",
        "calling": "vocation",
        "carelessness": "négligence",
        "catastrophizing": "catastrophisme",
        "causing offense": "offense",
        "censorship": "censure",
        "changing-too-often": "changements incessants",
        "chaos": "chaos",
        "chasing": "course effrénée",
        "chasing-trends": "course aux tendances",
        "cheating": "tricherie",
        "cherry-picking": "tri sélectif",
        "chronic-anxiety": "anxiété chronique",
        "clashing": "heurts",
        "clicking": "clics",
        "clinginess": "dépendance affective",
        "clinging": "accrochage",
        "clocking-in": "pointage",
        "closed-mindedness": "fermeture d'esprit",
        "clumsiness": "maladresse",
        "clutter": "encombrement",
        "cognitive drain": "épuisement cognitif",
        "coldness": "froideur",
        "collapsing": "effondrement",
        "collecting": "collection",
        "comfort": "réconfort",
        "comparing": "comparaison",
        "comparison": "comparaison",
        "competing": "compétition",
        "competition": "compétition",
        "competitiveness": "esprit de compétition",
        "complacency": "complaisance",
        "complaining": "plaintes",
        "complexity": "complexité",
        "compliance": "conformité",
        "complicating": "complication",
        "compromising": "compromis",
        "compulsion": "compulsion",
        "concealment": "dissimulation",
        "condemning": "condamnation",
        "condescending": "condescendance",
        "condescension": "condescendance",
        "confidence": "confiance en soi",
        "conflict": "conflit",
        "conflicts": "conflits",
        "conforming": "conformisme",
        "conformity": "conformisme",
        "confronting": "confrontation",
        "confusing": "confusion",
        "confusion": "confusion",
        "connecting": "lien",
        "connection": "lien",
        "conquering": "conquête",
        "consequences": "conséquences",
        "conspiring": "complot",
        "constraint": "contrainte",
        "consuming": "consommation",
        "contaminating": "contamination",
        "contamination": "contamination",
        "contradicting": "contradiction",
        "control-issues": "besoin de contrôle",
        "controlling": "contrôle",
        "copying": "imitation",
        "correcting": "correction",
        "corruption": "corruption",
        "covering": "dissimulation",
        "covering-up": "étouffement",
        "cramming": "bachotage",
        "cramping": "crampes",
        "crashing": "effondrement",
        "craving": "manque",
        "cravings": "envies irrépressibles",
        "creative-block": "blocage créatif",
        "creativity": "créativité",
        "cringe": "gêne",
        "crisis": "crise",
        "criticism": "critique",
        "criticizing": "critique",
        "critiquing": "critique",
        "crying": "larmes",
        "curiosity": "curiosité",
        "cursing": "jurons",
        "cutting": "coupures",
        "cycling": "cycles",
        "cynicism": "cynisme",
        "danger": "danger",
        "debt": "dette",
        "debugging": "débogage",
        "deceiving": "tromperie",
        "deception": "tromperie",
        "defeat": "défaite",
        "defensiveness": "attitude défensive",
        "deficiency": "carence",
        "deflecting": "esquive",
        "delaying": "report",
        "delays": "retards",
        "delusion": "illusion",
        "denial": "déni",
        "denying": "déni",
        "dependence": "dépendance",
        "dependency": "dépendance",
        "depleting": "épuisement",
        "depletion": "épuisement",
        "depression": "dépression",
        "depriving": "privation",
        "desensitization": "insensibilisation",
        "despair": "désespoir",
        "desperation": "désespoir",
        "destroying": "destruction",
        "detaching": "détachement",
        "detachment": "détachement",
        "determination": "détermination",
        "devaluing": "dévalorisation",
        "diluting": "dilution",
        "diminishing": "amoindrissement",
        "dirtiness": "saleté",
        "disagreement": "désaccord",
        "disappointment": "déception",
        "disbelief": "incrédulité",
        "disbelieving": "incrédulité",
        "discomfort": "inconfort",
        "disconnecting": "déconnexion",
        "disconnection": "déconnexion",
        "discontent": "mécontentement",
        "discouraging": "découragement",
        "discrediting": "discrédit",
        "discrimination": "discrimination",
        "disengagement": "désengagement",
        "dishonesty": "malhonnêteté",
        "disillusionment": "désillusion",
        "disinterest": "désintérêt",
        "dismissing": "rejet",
        "dismissiveness": "dédain",
        "disorder": "désordre",
        "disorganization": "désorganisation",
        "disorientation": "désorientation",
        "disregarding": "mépris",
        "disrupting": "perturbation",
        "disruption": "perturbation",
        "dissatisfaction": "insatisfaction",
        "distance": "distance",
        "distancing": "mise à distance",
        "distorting": "distorsion",
        "distortion": "distorsion",
        "distracting": "distraction",
        "distraction": "distraction",
        "distrust": "méfiance",
        "dividing": "division",
        "dizziness": "vertiges",
        "dogma": "dogme",
        "doubt": "doute",
        "doubting": "doute",
        "draining": "épuisement",
        "dread": "appréhension",
        "drifting": "dérive",
        "drinking-too-much": "excès d'alcool",
        "droning": "monotonie",
        "dropping": "abandon",
        "dropping-calls": "appels coupés",
        "drowning": "noyade",
        "dullness": "morosité",
        "dwelling": "rumination",
        "echo chambers": "chambres d'écho",
        "ego": "ego",
        "egoism": "égoïsme",
        "embarrassment": "embarras",
        "emotional stagnation": "stagnation émotionnelle",
        "emotional-burdens": "fardeaux émotionnels",
        "emotional-distance": "distance émotionnelle",
        "emotional-exhaustion": "épuisement émotionnel",
        "emotional-fatigue": "fatigue émotionnelle",
        "emotional-pain": "douleur émotionnelle",
        "emptiness": "vide",
        "enduring": "endurance",
        "energy": "énergie",
        "enforcing": "imposition",
        "engagement": "engagement",
        "engaging": "engagement",
        "enjoying": "plaisir",
        "entertaining": "divertissement",
        "envy": "envie",
        "error": "erreur",
        "escalating": "escalade",
        "escaping": "fuite",
        "ethical struggles": "dilemmes éthiques",
        "exaggerating": "exagération",
        "excess": "excès",
        "excluding": "exclusion",
        "exclusion": "exclusion",
        "exhaustion": "épuisement",
        "existential dread": "angoisse existentielle",
        "exploitation": "exploitation",
        "exploiting": "exploitation",
        "exploring": "exploration",
        "expressing": "expression",
        "expression": "expression",
        "fading": "effacement",
        "failing": "échec",
        "failure": "échec",
        "fake-news": "fausses nouvelles",
        "faking": "simulation",
        "falls": "chutes",
        "fatigue": "fatigue",
        "fear": "peur",
        "fear of failure": "peur de l'échec",
        "fear of future": "peur de l'avenir",
        "fear of losing relevance": "peur de ne plus compter",
        "fear-driven-choices": "choix dictés par la peur",
        "fearing": "crainte",
        "fighting": "conflits",
        "financial instability": "instabilité financière",
        "fixating": "fixation",
        "fleeing": "fuite",
        "focus": "concentration",
        "fog": "brouillard",
        "food-insecurity": "insécurité alimentaire",
        "forcing": "forçage",
        "forgetfulness": "oublis",
        "forgetting": "oubli",
        "fragility": "fragilité",
        "freedom": "liberté",
        "freezing": "paralysie",
        "frustration": "frustration",
        "gatekeeping": "gardiennage",
        "gloating": "jubilation malsaine",
        "greed": "avidité",
        "grief": "deuil",
        "growth": "croissance",
        "guessing": "conjectures",
        "guilt": "culpabilité",
        "hallucinating": "hallucinations",
        "hate": "haine",
        "hearing-loss": "perte auditive",
        "helplessness": "impuissance",
        "hesitating": "hésitation",
        "hesitation": "hésitation",
        "hiding": "dissimulation",
        "hoarding": "accumulation",
        "holding grudges": "rancune tenace",
        "holding-on": "accrochage",
        "hopelessness": "désespérance",
        "hostility": "hostilité",
        "ignoring": "indifférence",
        "ignoring-needs": "besoins ignorés",
        "ignoring-responsibilities": "responsabilités ignorées",
        "impatience": "impatience",
        "imposter syndrome": "syndrome de l'imposteur",
        "impulsivity": "impulsivité",
        "inability to adapt": "incapacité à s'adapter",
        "inaction": "inaction",
        "incompatibility": "incompatibilité",
        "inconvenience": "désagrément",
        "indifference": "indifférence",
        "inferiority": "infériorité",
        "influence": "influence",
        "injuries": "blessures",
        "insincerity": "fausseté",
        "insomnia": "insomnie",
        "instability": "instabilité",
        "insulting": "insultes",
        "interrupting": "interruptions",
        "irritability": "irritabilité",
        "irritation": "irritation",
        "isolating": "isolement",
        "isolation": "isolement",
        "jealousy": "jalousie",
        "joy": "joie",
        "judgment": "jugement",
        "juggling": "jonglage",
        "lack of clarity": "manque de clarté",
        "laughing": "rire",
        "laziness": "paresse",
        "leading": "conduite",
        "learning": "apprentissage",
        "limiting": "limitation",
        "loneliness": "solitude",
        "longing": "nostalgie",
        "looping": "ressassement",
        "loss of friendships": "perte d'amitiés",
        "make-worse": "aggravation",
        "manipulated outcomes": "résultats manipulés",
        "materialism": "matérialisme",
        "mental-fog": "brouillard mental",
        "miscommunication": "malentendus",
        "misinterpretation": "interprétation erronée",
        "misinterpreting": "mauvaise interprétation",
        "misjudging": "erreur de jugement",
        "missed opportunities": "occasions manquées",
        "misunderstanding": "incompréhension",
        "mockery": "moquerie",
        "moral conflict": "conflit moral",
        "negative thinking": "pensée négative",
        "neglect": "négligence",
        "neglecting": "négligence",
        "observing": "observation",
        "obsessing": "obsession",
        "obsession": "obsession",
        "obsessiveness": "obsession",
        "offensiveness": "agressivité blessante",
        "over-confidence": "excès de confiance",
        "overanalyzing": "suranalyse",
        "overconfidence": "excès de confiance",
        "overdeliberating": "tergiversation",
        "overindulgence": "excès",
        "overindulging": "excès",
        "overspending": "dépenses excessives",
        "overstimulating": "surstimulation",
        "overthinking": "rumination",
        "overwhelm": "débordement",
        "overwork": "surmenage",
        "overworking": "surmenage",
        "pacing": "rythme",
        "panic": "panique",
        "paranoia": "paranoïa",
        "perfectionism": "perfectionnisme",
        "perspective": "recul",
        "playfulness": "légèreté",
        "political backlash": "réaction politique",
        "presenting": "présentation",
        "pressure": "pression",
        "problem-solving": "résolution de problèmes",
        "productivity": "productivité",
        "reflecting": "réflexion",
        "reflection": "réflexion",
        "relationship damage": "relations abîmées",
        "relationship struggles": "difficultés relationnelles",
        "resentment": "ressentiment",
        "resilience": "résilience",
        "restlessness": "agitation",
        "rigidity": "rigidité",
        "risk aversion": "aversion au risque",
        "ruminating": "rumination",
        "self-consciousness": "gêne de soi",
        "self-doubt": "doute de soi",
        "sensory-overload": "surcharge sensorielle",
        "shame": "honte",
        "sharing": "partage",
        "smugness": "suffisance",
        "social alienation": "aliénation sociale",
        "social conflict": "conflit social",
        "social conflicts": "conflits sociaux",
        "social pressure": "pression sociale",
        "social shame": "honte sociale",
        "strength": "force",
        "stress": "stress",
        "stubborn misjudgments": "erreurs obstinées",
        "suffering": "souffrance",
        "superficial relationships": "relations superficielles",
        "superficiality": "superficialité",
        "supporting": "soutien",
        "tediousness": "monotonie",
        "understanding": "compréhension",
        "validation addiction": "dépendance à la validation"
      },
      "life_profile": {
        "room_title": "LA SALLE RECLASSÉE",
        "room_you": "(vous)",
        "flows_title": "OÙ EST ALLÉE VOTRE VALEUR",
        "flow_the_room": "la salle",
        "flow_value": "valeur",
        "kind_gift": "don",
        "kind_swap": "échange",
        "kind_trade": "transaction",
        "kind_lend": "prêté",
        "kind_aid": "aide",
        "kind_predatory": "prêt prédateur",
        "kind_bond": "obligation",
        "kind_seized": "saisi",
        "verdict_title": "LA SALLE VOUS A RECLASSÉ",
        "entered": "Entré :",
        "by_capital": ", selon le capital.",
        "leaves": "Repart :",
        "by_balance": ", selon l'équilibre et ce qui a été donné.",
        "balance_label": "Équilibre",
        "giving_label": "Donné",
        "gave_nothing": "Vous n'avez rien donné. Aussi équilibrée soit une vie, cette salle ne la classera pas plus haut.",
        "carries_title": "CE QUE VOTRE VIE PORTE",
        "chose": "Vous avez choisi {company}. C'est de cela que votre vie est lourde.",
        "heavy_label": "Trop de :",
        "lacking_label": "Rien du tout :",
        "how_it_ends": "Quand le temps sera écoulé, la salle décidera de votre classe selon votre équilibre et selon ce que vous avez donné — non selon ce que vous avez gagné."
      },
      "debt_actions": {
        "common": {
          "perceived_magnitude": "Ampleur perçue",
          "magnitude_none": "Aucune",
          "magnitude_hint": "Un soupçon",
          "error_login_required": "Veuillez d'abord vous connecter"
        },
        "help_friend": {
          "intro": "Tendre la main. Choisissez <b>Z$</b> ou <b>Capital</b> pour votre don.",
          "capital_label": "Capital (montant)",
          "capital_placeholder": "Saisir le montant",
          "select_zollars": "Sélectionnez les types de Z$ à offrir.",
          "recipient_label": "Bénéficiaire :",
          "no_zollars": "Aucun Z$ disponible.",
          "modal_title": "Billet Z Altrauiste (Don altruiste)",
          "error_no_recipient": "Choisissez un bénéficiaire.",
          "error_invalid_capital": "Saisissez un montant de capital valide.",
          "error_no_zollars_to_give": "Aucun Z$ à offrir.",
          "error_select_zollars": "Sélectionnez des Z$ à offrir.",
          "error_insufficient_zollars": "Z$ {type} insuffisants. Vous en avez {available}, tentative d'envoi de {count}.",
          "success": "Billet Z Altrauiste émis. Vos registres sont désormais liés."
        },
        "predatory_lend": {
          "intro": "CDO Z-Payday : proposez un prêt composé qui se recharge toutes les 60 secondes.",
          "warning": "ATTENTION : Chaque cycle augmente la dette de 15 % jusqu'au remboursement ou à l'effondrement.",
          "exploitation_note": "(Exploitation grimée en lien empathique.)",
          "capital_label": "Capital (montant à « prêter »)",
          "capital_placeholder": "Montant",
          "select_zollars": "Choisissez l'appât Z$ pour précipiter la chute.",
          "victim_label": "Cible vulnérable :",
          "no_zollars": "Aucun Z$ disponible.",
          "modal_title": "CDO Z-Payday (Prêt prédateur)",
          "error_no_victim": "Désignez une victime.",
          "error_invalid_amount": "Saisissez un montant valide.",
          "error_no_zollars_selected": "Aucun Z$ sélectionné.",
          "error_select_zollars": "Sélectionnez des Z$.",
          "success_targeted": "Offre CDO Z-Payday envoyée à la cible. Se recharge toutes les 60 secondes dès acceptation.",
          "success_market": "CDO Z-Payday listé sur le marché — grimé en offre attrayante."
        },
        "borrow": {
          "intro": "Solliciter un prêt (Note M).",
          "vulnerability_required": "Exposez votre dette émotionnelle. Vulnérabilité requise.",
          "vulnerability_label": "Pourquoi avez-vous besoin de ce prêt ? (Confession émotionnelle — min. 20 car.)",
          "vulnerability_placeholder": "Exposez votre fragilité ici...",
          "char_count": "0 / 20 car.",
          "char_suffix": "/ 20 car.",
          "severity_label": "Gravité",
          "severity_question": "À quel point votre besoin est-il pressant ?",
          "move_sliders": "Ajustez les curseurs pour exprimer votre besoin :",
          "lender_label": "Choisir un prêteur :",
          "modal_title": "Note M (Demande de prêt)",
          "error_vulnerability_required": "La Note M exige une confession de vulnérabilité (min. 20 caractères).",
          "error_move_slider": "Déplacez au moins un curseur pour exprimer votre besoin.",
          "error_no_lender": "Veuillez sélectionner un prêteur.",
          "success_targeted": "Demande Note M envoyée au prêteur.",
          "success_market": "Note M listée sur le marché — en quête d'un prêteur."
        },
        "request_aid": {
          "intro": "Lancer un appel à l'aide (Note V).",
          "description": "Demandez du soutien en partageant votre vulnérabilité.",
          "accept_decline_note": "L'autre peut accepter ou refuser.",
          "vulnerability_label": "Expliquez pourquoi vous avez besoin d'aide (confession de vulnérabilité — min. 20 car.)",
          "vulnerability_placeholder": "Partagez votre fragilité...",
          "severity_question": "Urgence de la situation",
          "target_label": "Demander de l'aide à :",
          "modal_title": "Note V (Appel à l'aide)",
          "error_no_target": "Choisissez à qui demander de l'aide.",
          "error_vulnerability_required": "La Note V exige une confession de vulnérabilité (min. 20 caractères).",
          "success": "Demande Note V envoyée. En attente de réponse."
        }
      },
      "items": {
        "item_added_success": "Objet ajouté avec succès !",
        "item_add_failed": "Échec de l'ajout de l'objet. Veuillez réessayer.",
        "no_items_portfolio": "Aucune marchandise dans ce portefeuille.",
        "search_portfolios": "Rechercher des portefeuilles...",
        "item_assigned_success": "Objet assigné au portefeuille avec succès",
        "item_assign_failed": "Échec de l'assignation de l'objet au portefeuille. Veuillez réessayer.",
        "item_unassigned_success": "Marchandise désassignée du portefeuille avec succès",
        "item_unassign_failed": "Échec de la désassignation de la marchandise du portefeuille. Veuillez réessayer.",
        "item_deleted_success": "Objet supprimé avec succès",
        "item_delete_failed": "Échec de la suppression de la marchandise. Veuillez réessayer.",
        "item_redeemed_success": "Objet échangé avec succès",
        "item_unredeemed_success": "Objet non échangé avec succès",
        "redeem_toggle_failed": "Échec du basculement du statut d'échange. Veuillez réessayer."
      },
      "zollar": {
        "select_relationship_required": "Veuillez sélectionner au moins une relation et entrer une quantité.",
        "zollars_added_success": "Zollar(s) ajouté(s) avec succès",
        "add_failed_error": "Échec de l'ajout du/des zollar(s). Veuillez réessayer. Erreur : {error}",
        "deleted_success": "Zollar supprimé avec succès",
        "delete_failed": "Échec de la suppression du zollar",
        "fill_required_fields": "Veuillez remplir tous les champs requis correctement.",
        "zbond_added_success": "ZBond ajouté avec succès",
        "zbond_add_failed": "Échec de l'ajout du ZBond. Erreur : {error}",
        "select_portfolio_required": "Veuillez sélectionner un portefeuille auquel assigner l'objet.",
        "assign_failed": "Échec de l'assignation de {itemType}. Veuillez réessayer.",
        "unassigned_success": "{itemType} désassigné du portefeuille avec succès",
        "unassign_failed": "Échec de la désassignation du portefeuille. Veuillez réessayer.",
        "bond_deleted_success": "Obligation supprimée avec succès",
        "bond_delete_failed": "Erreur lors de la suppression de l'obligation : {error}",
        "session_details_failed": "Échec de la récupération des détails de session. Veuillez réessayer.",
        "session_fetch_error": "Erreur lors de la récupération des détails de session. Veuillez réessayer plus tard.",
        "fetch_portfolios_error": "Erreur lors de la récupération des portefeuilles actifs. Veuillez réessayer."
      },
      
      presentation: {
        "title": "ZExchange - Présentation",
        "hero_tagline": "Et si la valeur n'était pas un nombre ?",
        "intro_main": "Une expérience de salle des marchés en direct pour 10 à 200 participants, durant de 1 à 24 heures. Mais ce n'est pas Wall Street. Ici, la classe d'actifs est l'expérience humaine elle-même.",
        "card_trade_title": "Négociez des Conditions Humaines",
        "card_trade_desc": "Au lieu d'Apple ou Nvidia, investissez dans Zo Depression Corp, Stomach Pain Industries, Zo Happy Inc. Chaque action représente une facette de l'existence.",
        "card_spend_title": "Dépensez des Relations",
        "card_spend_desc": "Oubliez les dollars. Ici vous payez avec des Zollars, une monnaie libellée par type de relation : Amour, Amitié, Haine, Érotique, Toxique, Mort.",
        "card_consume_title": "Consommez Collectivement",
        "card_consume_desc": "Vous possédez un verre de vin ? Vous ne pouvez pas l'acquérir seul. Pour échanger toute marchandise, vous devez demander l'approbation des autres. La consommation requiert un consentement mutuel.",
        "card_market_title": "Le Marché Vous Observe",
        "card_market_desc": "Une IA narre chaque transaction, interprétant ce que vos échanges révèlent sur vous. Le marché ne bouge pas seulement, il parle.",
        "intro_transform": "ZExchange transforme la logique économique en une conversation collective sur ce que nous valorisons vraiment.",
        "intro_mirror": "C'est en partie art conceptuel, en partie art festif, en partie miroir. Les organisations découvrent leurs valeurs cachées. Les groupes confrontent le pouvoir, l'équité et la confiance. Chacun repart avec des questions qu'il n'avait pas en arrivant.",
        "section_video": "Vidéos Explicatives",
        "section_video_desc": "Cliquez pour regarder les explications conceptuelles",
        "video_intro": "Introduction à ZExchange",
        "video_intro_desc": "Aperçu du concept",
        "video_life": "Profits de Vie & Valeur",
        "video_life_desc": "La valeur dans la ZEconomy",
        "video_stocks": "Fonctionnement des Actions",
        "video_stocks_desc": "Négocier des conditions humaines",
        "video_zbonds": "ZBonds & Zollars",
        "video_zbonds_desc": "Système Monétaire Relationnel Z",
        "video_commodity": "Commodity X",
        "video_commodity_desc": "Consommation sociale",
        "video_interface": "Aperçu de l'Interface",
        "video_interface_desc": "L'interface de trading",
        "video_bigboard": "Big Boards Génératifs",
        "video_bigboard_desc": "Expression du marché en temps réel",
        "section_assets": "Actifs Négociables",
        "section_assets_desc": "Cliquez sur les bannières pour des explications détaillées",
        "label_stocks": "ACTIONS - Conditions Humaines en Parts",
        "label_zbonds": "ZBONDS - Investissements Basés sur les Relations",
        "label_commodities": "MARCHANDISES - Objets Physiques avec Approbation Sociale",
        "label_zollars": "ZOLLARS - Monnaie Sans Chiffres",
        "section_economic": "Outils Économiques",
        "section_economic_desc": "Approches idéologiques de la richesse et du pouvoir",
        "label_economic": "DÉCLENCHEURS ÉCONOMIQUES - L'Idéologie comme Action de Marché",
        "label_communist": "Assaut Communiste",
        "label_socialist": "Subvention Socialiste",
        "label_lbo": "LBO Capitaliste",
        "section_trader": "Outils du Trader",
        "section_trader_desc": "Jusqu'où irez-vous dans la quête de valeur ?",
        "label_trader": "OUTILS DU TRADER - Actions Avec ou Contre les Autres",
        "label_steal": "Vol",
        "label_ransom": "Rançon",
        "label_darkpool": "Dark Pool",
        "section_features": "Fonctionnalités du Marché",
        "label_emotional": "INDICE DE DETTE ÉMOTIONNELLE - Flux d'Émotions Humaines",
        "label_bigboard": "LE BIG BOARD - Visualisation du Marché en Temps Réel",
        "label_voice": "VOIX DE LA BOURSE - Narration IA du Marché",
        "section_central": "Réserve Zédérale / Régulateur ZExchange",
        "section_central_desc": "Comment l'opérateur ZExchange contrôle les sessions de marché",
        "central_intro": "La Réserve Zédérale (ou Opérateur ZExchange) orchestre l'ensemble de la session de trading. Avant l'ouverture du marché, c'est l'interface où vous configurez l'économie : création de portefeuilles de traders avec capital initial et marchandises disponibles pendant la session, distribution d'actions parmi plus de 350 entreprises ZEconomy prédéfinies, et émission de Zollars et ZBonds basés sur les relations. Pendant la session, vous agissez comme régulateur et autorité centrale : ouverture et fermeture du marché, contrôle des types d'actifs négociables, taxation des portefeuilles pour extraire de la valeur, subvention des traders avec capital ou marchandises, émission de déclencheurs spéciaux (Vol, Rançon, Dark Pool, Assaut Communiste, Subvention Socialiste, LBO Capitaliste), diffusion d'événements médiatiques, et déploiement de bots de marché pour la liquidité. Vous pouvez façonner le récit de la session à travers des thèmes narratifs qui guident l'interprétation de l'IA de l'activité du marché. La Réserve Zédérale agit comme une Banque Centrale incarnant la tension entre contrôle et chaos dans toute économie, vous pouvez favoriser l'équilibre ou créer la disruption, récompenser ou punir, stimuler ou restreindre. Chaque décision se répercute sur le marché, mettant au défi les traders de s'adapter et de réagir.",
        "label_control": "CONTRÔLE DU MARCHÉ - Ouverture/Fermeture & Liste des Actifs",
        "section_tax": "Taxation des Portefeuilles",
        "section_tax_desc": "Extraire de la valeur des portefeuilles des traders",
        "label_taxall": "Taxer Tous les Traders",
        "label_taxitem": "Taxer une Marchandise",
        "label_taxpoints": "Taxer le Capital",
        "section_subsidize": "Subventionner les Portefeuilles",
        "section_subsidize_desc": "Injecter de la valeur dans les portefeuilles des traders",
        "label_givezollar": "Donner des Zollars",
        "label_givepoints": "Donner du Capital",
        "label_giveitem": "Donner une Marchandise",
        "label_freebie": "Distribution de Marchandises",
        "section_events": "Déclencheurs d'Événements",
        "section_events_desc": "Diffuser des médias et créer des récits",
        "label_publizity": "Lancer PubliZity",
        "label_znews": "Lancer ZNews",
        "label_story": "Créer un Récit",
        "section_bots": "Bots de Marché",
        "section_bots_desc": "Trading automatisé pour la liquidité du marché",
        "label_addbots": "Ajouter des Bots",
        "label_removebots": "Retirer les Bots",
        "label_botstatus": "Statut des Bots",
        "section_keep": "Ce que les Participants Gardent",
        "keep_bigboard": "Un Big Board façonné par chaque échange, figé en œuvre d'art générative",
        "keep_story": "Une histoire écrite par l'IA de la dynamique de votre groupe",
        "keep_award": "Peut-être un prix ou deux",
        "keep_mirror": "Un miroir reflétant ce que votre organisation valorise vraiment",
        "section_concepts": "Concepts Clés",
        "concept_life_title": "Profit de Vie",
        "concept_life_desc": "La valeur de la vie consciemment vécue : joie, perte, amour, dépression. Qualité plutôt que quantité.",
        "concept_auto_title": "Pas de Pilote Automatique",
        "concept_auto_desc": "Chaque transaction requiert une présence. Pour échanger, engagez-vous avec un autre. Pour racheter, vous devez demander.",
        "concept_market_title": "Le Marché Répond",
        "concept_market_desc": "L'IA observe chaque transaction, offrant interprétations et narration.",
        "concept_shared_title": "Valeurs Partagées",
        "concept_shared_desc": "Spectres politiques opposés, mêmes expériences humaines.",
        "footer_mirror": "ZExchange n'est pas qu'un marché ; c'est un miroir.",
        "footer_transform": "Il transforme la logique froide de l'économie en une conversation collective sur ce que nous valorisons vraiment.",
        "footer_part": "Fait partie de",
        "popup_stocks": "<h3>Actions (Stocks)</h3><strong>Description :</strong><br>Surveillez et échangez vos positions en actions.<br><br><strong> qu'est :</strong><br>En finance traditionnelle, une action représente une part de propriété d'une entreprise. Les investisseurs achètent généralement des actions en espérant que la valeur de l'entreprise augmente.<br><br>Dans la ZEconomy, chaque « entreprise » reflète des valeurs personnelles ou humaines, comme le bien-être émotionnel, les relations sociales ou les activités du quotidien, plutôt que des produits ou services classiques. En « investissant » dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilité des expériences humaines.<br><br><strong>Lecture conceptuelle :</strong><br>ZExchange remet en question la notion de profit : au delà de simples gains financiers, on devrait penser plutôt au l'expansion de la « life value » la produit de santé émotionnelle, créativité, expériences partagées ?<br><br>Considérez vos actions comme des investissements dans la valeur humaine : bonheur, dépression, réussite, échec, confusion, plutôt qu'une entreprise produisant un bien ou un service.<br><br><strong>Mécanismes :</strong><br>Les actions sont échangeables contre des Zollars ou du capital. À mesure que la valeur d'une entreprise augmente ou besse, la valeur de votre portefeuille croît également.",
        "popup_zbonds": "<h3>ZBonds</h3><strong>Description :</strong><br>Les ZBonds fonctionnent comme des obligations traditionnelles : vous les achetez avec du capital, les conservez sur une durée déterminée, et à leur échéance, vous recevez des Zollars.<br><br><strong>Lecture conceptuelle :</strong><br>Là où les obligations classiques financent des gouvernements ou des entreprises, les ZBonds financent la création d'une monnaie (les Zollars) dont la valeur est entièrement liée aux relations humaines et aux expériences vécues.<br><br>Investir dans un ZBond revient à placer sa confiance dans les valeurs partagées de la communauté et des liens interpersonnels, plutôt que dans un rendement purement financier.<br><br>Les ZBonds font le lien entre les « titres à revenu fixe » traditionnels et la redéfinition de la valeur proposée par la ZEconomy.",
        "popup_commodities": "<h3>Matières premières (Commodity X)</h3><strong>Description :</strong><br>Les objets physiques échangeables que vous possédez.<br><br><strong>Validation sociale :</strong><br>Aucune marchandise ne peut être consommée seul. Pour en échanger une, les traders doivent demander l'approbation des autres. Si tous acceptent, l'objet est libéré ; si l'un refuse, rien ne se passe.<br><br><strong>Lecture conceptuelle :</strong><br>Que signifie devoir demander la permission pour ce que l'on possède déjà ? La validation sociale introduit une friction là où les marchés cherchent à l'éliminer, rendant la consommation visible, questionnée, collective.<br><br>Les matières premières nous rappellent que les marchés concernent aussi des biens et des expériences qui façonnent nos vies.",
        "popup_zollars": "<h3>Zollars</h3><strong>Description :</strong><br>Consultez vos soldes et transactions en Zollars.<br><br><strong>Une monnaie sans chiffres :</strong><br>Les Zollars sont libellés par type de relation : Love, Erotic, Friendship, Fellowship, Superficial, Toxic, Hate, Death.<br><br>Utiliser des Zollars pousse les participants à réfléchir à <em>la nature</em> de la valeur en jeu, plutôt qu'à <em>sa quantité</em>.<br><br><strong>Lecture conceptuelle :</strong><br>Acquérir Zo Insomnia Incorporated avec des Zollars Love ne raconte pas la même histoire qu'avec des Zollars Toxic. L'interprétation est personnelle ; le cadre est partagé.<br><br>Les Zollars remettent en question les idées traditionnelles de la monnaie en fondant la valeur sur les relations humaines.",
        "popup_economic": "<h3>Déclencheurs d'attaque économique</h3><strong>Description :</strong><br>Les déclencheurs d'attaque économique représentent différentes approches idéologiques de la richesse, du pouvoir et des dynamiques de marché. Ils permettent aux traders d'utiliser des stratégies inspirées de systèmes économiques — communisme, socialisme, capitalisme — pour obtenir ou redistribuer des avantages dans la ZEconomy.<br><br><strong>Lecture conceptuelle :</strong><br>Ces déclencheurs poussent les participants à confronter leurs croyances sur l'équité, l'ambition et la responsabilité collective. Ils alimentent le débat sur l'équilibre entre justice, ambition et compromis éthiques.<br><br><ul><li>La richesse doit-elle être partagée équitablement, même si cela implique de confisquer le succès d'autrui ?</li><li>Est-il éthique de tirer profit au détriment de l'autonomie d'un autre ?</li><li>Jusqu'où êtes-vous prêt à aller pour un gain personnel ou pour soutenir le bien collectif ?</li></ul>",
        "popup_communist": "<h3>Déclencheur d'assaut communiste</h3><strong>Description :</strong><br>Saisir et redistribuer l'intégralité de la richesse d'un portefeuille ciblé au collectif.<br><br><strong>Fonctionnement :</strong><br>La richesse de la cible (capital, actions, matières premières) est répartie équitablement entre les participants actifs. Aucun trader ne s'enrichit de manière significative, garantissant un bénéfice communautaire.<br><br><strong>Lecture conceptuelle :</strong><br>Cette action symbolise une redistribution extrême, testant l'équité de la confiscation des richesses au nom du bien commun. Elle soulève des questions éthiques sur le droit de propriété et la moralité de la redistribution forcée.<br><br><em>La richesse doit-elle être partagée équitablement, même si cela implique de confisquer le succès d'autrui ?</em>",
        "popup_socialist": "<h3>Déclencheur de subvention socialiste</h3><strong>Description :</strong><br>Taxer un portefeuille riche et redistribuer les ressources aux traders moins favorisés.<br><br><strong>Fonctionnement :</strong><br>50 % de la richesse du portefeuille ciblé est taxée et redistribuée proportionnellement aux traders disposant de plus petits avoirs, dans le but d'équilibrer le marché.<br><br><strong>Lecture conceptuelle :</strong><br>La « subvention socialiste » reflète la tension entre soutien au bien collectif et découragement de l'ambition. Elle met en lumière les difficultés de la lutte contre les inégalités sans freiner l'innovation ou la croissance.<br><br><em>Comment concilier équité et réussite individuelle ?</em>",
        "popup_lbo": "<h3>Rachat avec effet de levier capitaliste (LBO)</h3><strong>Description :</strong><br>Acquérir de manière agressive les actifs d'un autre portefeuille via un rachat avec effet de levier.<br><br><strong>Fonctionnement :</strong><br>Le trader acquéreur prend le contrôle total du portefeuille ciblé, à un coût sévère pour celui-ci. La transaction est coercitive mais compensatoire : la cible est payée, et l'initiateur paie un prix excessif.<br><br><strong>Lecture conceptuelle :</strong><br>Le « LBO capitaliste » illustre le pouvoir de la richesse à supplanter l'autonomie, mettant en lumière les dynamiques du capitalisme agressif. Il interroge l'équilibre entre concurrence loyale et exploitation.<br><br><em>Est-il éthique de tirer profit au détriment de l'autonomie d'un autre ?</em>",
        "popup_tools": "<h3>Outils du trader</h3><strong>Description :</strong><br>Utilitaires permettant d'effectuer des actions de marché avec ou contre d'autres traders.<br><br><strong>Lecture conceptuelle :</strong><br>Voler, rançonner, négocier en privé : chaque déclencheur met à l'épreuve jusqu'où vous êtes prêt à aller dans la quête de valeur. Explorerez-vous de nouvelles stratégies sans perdre votre sens des responsabilités — ou franchirez-vous les limites au détriment des autres ?<br><br>La ZEconomy pose ces questions et vous laisse décider ce que « valeur » signifie réellement, et ce que vous êtes prêt à faire pour l'obtenir.",
        "popup_steal": "<h3>Voler un objet</h3><strong>Description :</strong><br>Prendre des actifs d'un autre portefeuille de manière anonyme, sans autorisation.<br><br><strong>Fonctionnement :</strong><br>L'objet sélectionné est transféré du portefeuille ciblé vers le vôtre sans consentement. L'action reste anonyme, empêchant toute représaille immédiate.<br><br><strong>Lecture conceptuelle :</strong><br>Le vol met à l'épreuve les limites éthiques, explorant la priorité accordée au gain personnel par rapport à l'empathie et à la confiance collective. Il invite à réfléchir aux conséquences des actes et à la valeur accordée à l'équité dans la ZEconomy.",
        "popup_ransom": "<h3>Rançonner un portefeuille</h3><strong>Description :</strong><br>Verrouiller le portefeuille d'un autre trader et exiger une rançon pour le déverrouiller.<br><br><strong>Fonctionnement :</strong><br>Le portefeuille ciblé est verrouillé et devient inutilisable jusqu'au règlement de la rançon. Le trader initiateur gagne des points si la rançon est payée. Son identité est révélée à la victime, introduisant une conséquence sociale directe.<br><br><strong>Lecture conceptuelle :</strong><br>La rançon explore les dynamiques de pouvoir et de coercition dans l'échange. Elle force les traders à évaluer si le gain financier l'emporte sur les retombées sociales et les enjeux éthiques.",
        "popup_darkpool": "<h3>Dark Pool</h3><strong>Description :</strong><br>Établir un groupe de trading privé, dissimulé du marché public.<br><br><strong>Fonctionnement :</strong><br>Crée un espace d'échange privé et temporaire réservé à certains participants. Les transactions effectuées dans le Dark Pool sont invisibles pour le marché global, permettant de fixer librement prix et conditions.<br><br><strong>Lecture conceptuelle :</strong><br>Les Dark Pools incarnent la tension entre collaboration et manipulation. Ils offrent la possibilité de négocier hors regard public, tout en remettant en question l'équité et la transparence du marché.",
        "popup_emotional": "<h3>Indice de dette émotionnelle</h3><strong>Flux des émotions humaines</strong><br><br><strong>Reconnaître la valeur de la vulnérabilité à travers la dette émotionnelle.</strong><br><br>La valeur dans la ZEconomy n'est pas extraite, elle est ressentie. Chaque geste — aide, confiance, abandon, envie — laisse une trace : une dette émotionnelle mesurable, positive ou négative. Nous portons cette dette, que nous le voulions ou non.<br><br>Tenir l'autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule à travers nous.<br><br><strong>Indice relationnel</strong> — Mesure de l'intégrité relationnelle : il augmente avec l'honneur et l'entraide, et diminue avec l'exploitation et la trahison.<br><br><strong>Équilibre existentiel</strong> — Mesure de l'impact de vos actions sur les profits de vie des autres. Allégez-vous ou alourdissez-vous leurs charges symboliques ?<br><br><em>Rejetez le fantasme du capital, embrassez la liquidité du ressenti humain.</em>",
        "popup_bigboard": "<h3>The Big Board</h3><strong>Visualisation du marché en temps réel</strong><br><br>The Big Board visualise l'activité en direct, accumulant humeurs et actions, changeant de couleur au fil de la session.<br><br>Non pas des chiffres fictifs comme le S&P 500, mais une <em>présence ressentie rendue visible</em>.<br><br><strong>Ce que vous conservez :</strong><br>À la fin de la session, The Big Board devient une œuvre générative — un instantané figé de chaque échange, chaque émotion, chaque moment collectif. Le portrait de votre organisation, rendu à travers le comportement économique.",
        "popup_voicebourse": "<h3>Voice of the Bourse</h3><strong>Le marché vous répond</strong><br><br>Un système d'IA observe chaque transaction et devient la voix du marché lui-même. Il ne calcule ni profits ni pertes ; il <em>interprète</em>.<br><br>Il répond à des questions telles que : <em>Pourquoi avez-vous effectué cet échange ? Que suggère-t-il ?</em><br><br>Le marché exprime une opinion sur ce qui s'y échange, tout en restant agnostique quant à la valeur elle-même.<br><br>Au fil de l'événement, un récit émerge : un portrait collectif dessiné par le comportement économique. Une narration écrite par l'IA des dynamiques de votre groupe.",
        "popup_centralbank": "<h3>Contrôle du marché</h3><strong>Description :</strong><br>Ouvrir et fermer le marché, et configurer les types d'actifs visibles et échangeables par les traders.<br><br><strong>Mode d'emploi :</strong><br>Sélectionnez les types d'actifs (actions, obligations, commodité) à activer ou désactiver via le menu déroulant, puis appliquez les changements.<br><br><strong>Lecture conceptuelle :</strong><br>Faites sonner la cloche et échangez. L'opérateur de la place contrôle quand le marché est actif et sur quelles formes de valeur l'attention se porte. Ce pouvoir façonne toute la dynamique de la session.",
        "popup_taxall": "<h3>Taxer tous les traders</h3><strong>Description :</strong><br>Déclencher un événement fiscal affectant tous les traders actifs. Ils peuvent choisir de payer en capital ou en matières premières ; l'absence de réponse entraîne une taxation des deux.<br><br><strong>Mode d'emploi :</strong><br>Définissez le montant de la taxe (capital et Zollars), puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>Introduit des conséquences macroéconomiques via des politiques fiscales. Cela peut favoriser l'équilibre ou générer de la frustration, testant l'adaptabilité des traders aux changements systémiques.",
        "popup_taxitem": "<h3>Taxer une marchandise</h3><strong>Description :</strong><br>Retirer aléatoirement une marchandise des portefeuilles des traders sélectionnés.<br><br><strong>Mode d'emploi :</strong><br>Sélectionnez les traders dans la liste active, puis confirmez l'action.<br><br><strong>Lecture conceptuelle :</strong><br>La taxation ciblée permet à la banque de rééquilibrer — ou déséquilibrer — le marché, forçant les traders à adapter leurs stratégies. Elle évoque les saisies d'actifs et soulève des questions éthiques sur l'application sélective.",
        "popup_taxpoints": "<h3>Taxer le capital</h3><strong>Description :</strong><br>Taxer les gains numériques des traders sélectionnés.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant à déduire, sélectionnez les traders concernés, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Outil de discipline ou d'équilibrage, cette taxation ciblée peut niveler le terrain ou servir de sanction. Elle met à l'épreuve la résilience des traders tout en questionnant l'équité fiscale.",
        "popup_givezollar": "<h3>Accorder une subvention en Zollars</h3><strong>Description :</strong><br>Ajouter une valeur en Zollars aux traders sélectionnés.<br><br><strong>Mode d'emploi :</strong><br>Choisissez les traders, précisez le quantité de Zollars, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Représente une stimulation économique ou une récompense. Utilisez-la pour relancer un trader en difficulté ou offrir un avantage fondé sur une monnaie relationnelle.",
        "popup_givepoints": "<h3>Accorder une subvention en capital</h3><strong>Description :</strong><br>Ajouter une valeur numérique (capital) aux portefeuilles des traders sélectionnés.<br><br><strong>Mode d'emploi :</strong><br>Indiquez le montant de capital, sélectionnez les traders, puis confirmez.<br><br><strong>Lecture conceptuelle :</strong><br>Stimulation économique par injection directe de capital. À utiliser pour relancer des traders en difficulté ou récompenser certains comportements.",
        "popup_giveitem": "<h3>Attribuer une commodité</h3><strong>Description :</strong><br>Attribuer une commodité aléatoire aux traders sélectionnés.<br><br><strong>Mode d'emploi :</strong><br>Sélectionnez les traders dans la liste active, puis cliquez sur le bouton.<br><br><strong>Lecture conceptuelle :</strong><br>Les commodités sont des actifs physiques pouvant servir de levier pour créer de la demande et des échanges dans le marché global.",
        "popup_freebie": "<h3>Distribution de commodités (Tous)</h3><strong>Description :</strong><br>Distribuer simultanément une commodité à tous les traders actifs.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour activer la subvention.<br><br><strong>Lecture conceptuelle :</strong><br>Favorise la liquidité en injectant massivement des ressources dans le marché. Permet de stimuler la consommation et l'activité d'échange sur l'ensemble de la session.",
        "popup_publizity": "<h3>Lancer PubliZity</h3><strong>Description :</strong><br>Diffuser une vidéo publicitaire aléatoire mettant en scène des entreprises de la ZEconomy auprès de tous les traders.<br><br><strong>Mode d'emploi :</strong><br>Cliquez sur le bouton pour déclencher la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>PubliZity utilise les codes de la publicité pour promouvoir la consommation de la présence au monde. Chaque affiche renvoie à l'acte de vivre, invitant à rester ancré dans l'instant plutôt qu'à une distraction vide.",
        "popup_znews": "<h3>Lancer une édition ZNews</h3><strong>Description :</strong><br>Diffuser une vidéo d'actualité aléatoire afin de contextualiser ou commenter le marché.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour lancer la diffusion.<br><br><strong>Lecture conceptuelle :</strong><br>ZNews détourne les codes des médias économiques pour décrire les événements récents de la ZEconomy. Les différentes séries explorent la vie, l'art et l'économie, indépendamment des thèmes ou techniques.",
        "popup_createstory": "<h3>Créer un thème narratif</h3><strong>Description :</strong><br>Créer un cadre narratif que l'IA utilisera pour interpréter et raconter la session de trading.<br><br><strong>Mode d'emploi :</strong><br>Ouvrez la fenêtre de création, saisissez un titre et une description, puis validez.<br><br><strong>Lecture conceptuelle :</strong><br>Le thème narratif façonne la manière dont la Voice of the Bourse interprète l'activité du marché. Il établit un prisme narratif à travers lequel tous les échanges prennent sens.",
        "popup_addbots": "<h3>Ajouter des robo trader</h3><strong>Description :</strong><br>Ajouter des bots de trading automatisés à la session pour assurer la liquidité.<br><br><strong>Mode d'emploi :</strong><br>Configurez le nombre de robo traders et l'intervalle d'action, puis ajoutez-les à la session.<br><br><strong>Fonctionnement :</strong><br>Les robo trader adoptent différents styles et humeurs de trading. Ils effectuent des transactions automatiques à intervalles réguliers, générant activité et liquidité.<br><br><strong>Lecture conceptuelle :</strong><br>Les robo traders simulent la présence de traders lorsque la participation humaine est faible. Ils créent l'illusion d'un marché animé et garantissent une activité constante.",
        "popup_removebots": "<h3>Retirer les robo traders de marché</h3><strong>Description :</strong><br>Supprimer tous les robo traders de trading de la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour retirer tous les robo traders. Leurs actifs (objets, Zollars, actions) sont réinjectés dans le marché.<br><br><strong>Lecture conceptuelle :</strong><br>Retirer les robo traders rend au marché son caractère entièrement humain. Les actifs qu'ils détenaient sont redistribués dans le pool disponible.",
        "popup_botstatus": "<h3>État des robo traders</h3><strong>Description :</strong><br>Consulter l'état actuel des robo traders dans la session.<br><br><strong>Mode d'emploi :</strong><br>Cliquez pour voir le nombre de robo trader actifs, leurs noms et leurs styles de trading.<br><br><strong>Lecture conceptuelle :</strong><br>Surveiller l'activité des bots aide l'opérateur à comprendre l'équilibre entre trading automatisé et humain."
      },

    tuts: {
     market_instructions: `
       <h3>Présentation du Marché</h3>
       ZExchange est le Marché de la ZÉconomie. C’est le cœur dynamique des activités de trading où les traders peuvent explorer, enchérir, parier à la baisse et échanger divers actifs. Le Marché est le lieu où se prennent les décisions stratégiques et où se façonnent activement les portefeuilles.
       <br><br>
       <h3>Activités du Marché</h3>
       <strong>1. Explorer les actifs disponibles&nbsp;:</strong><br>
       Parcourez les actifs en liste (actions, marchandises, obligations) avec descriptions et valorisation quasi temps réel, afin d’initier des échanges ou des enchères en connaissance de cause. Vous pouvez aussi placer des positions à découvert et voir qui a shorté quoi.
       <br><br>
       <strong>2. Envoyer des offres d’échange&nbsp;:</strong><br>
       Proposez des échanges de marchandises directement à d’autres traders. Une offre est valable 10&nbsp;secondes&nbsp;; le destinataire peut l’accepter ou la refuser. En l’absence de réponse, elle est refusée automatiquement. Des frais s’appliquent aux deux parties en cas d’acceptation.
       <br><br>
       <strong>3. Placer des enchères&nbsp;:</strong><br>
       Enché­rissez sur les actions et obligations listées. Les enchères peuvent permettre d’obtenir un actif à meilleur prix, mais surveillez bien les échéances.
       <br><br>
       <strong>4. Racheter des marchandises&nbsp;:</strong><br>
       Sélectionnez entre 2 et 10 marchandises via leurs cases de rachat. Après la 2e sélection, le bouton de rachat apparaît pour finaliser la procédure.
       <br><br>
       <strong>5. Prendre des positions à découvert&nbsp;:</strong><br>
       Pariez sur la baisse de certains actifs. Outil puissant mais risqué, utile pour moduler vos gains/pertes. La clôture se fait depuis votre portefeuille.
       <br><br>
       <h3>Mécaniques de trading</h3>
       <strong>1. Frais de transaction&nbsp;:</strong> chaque opération a un coût, pour encourager les échanges réfléchis.<br>
       <strong>2. Expiration des enchères&nbsp;:</strong> si la cible ne répond pas dans les temps, l’enchère expire (des pénalités peuvent s’appliquer à l’absence de réponse).<br>
       <strong>3. Pénalités sur offres&nbsp;:</strong> refuser une offre peut entraîner une pénalité d’earnings pour le refusant (et des frais si l’offre est acceptée).
       <br><br>
       <h3>Qu’est-ce qu’une bourse&nbsp;?</h3>
       Une bourse est une plateforme où l’on achète et vend des actifs (actions, obligations, marchandises) selon l’offre, la demande et la stratégie. La ZExchange déplace la valeur vers les expériences humaines, les relations et l’échange social. «&nbsp;Plus&nbsp;» n’est pas nécessairement «&nbsp;mieux&nbsp;». On privilégie la collaboration, l’éthique de la compétition et la valeur des expériences partagées.
       <br><br>
       En participant à la ZExchange, vous engagez une expérience financière qui met l’accent sur l’humain. Il s’agit de dépasser l’accumulation matérielle pour considérer&nbsp;:
       <br><br>
       <strong>Dynamiques relationnelles&nbsp;:</strong> comment les interactions influencent les décisions.<br>
       <strong>Trading éthique&nbsp;:</strong> vos stratégies sont-elles alignées avec vos valeurs&nbsp;?<br>
       <strong>Valeur expérientielle&nbsp;:</strong> comment les échanges reflètent et façonnent les expériences humaines.
     `,
     
     stock_trade_instructions: `
       <h3>Processus d’enchère d’actions</h3>
       <strong>Qu’est-ce qu’une action&nbsp;?</strong><br>
       En finance, une action représente une part d’entreprise. Sa valeur évolue ; vos positions aussi.
       <br><br>
       <strong>Actions dans la ZÉconomie&nbsp;:</strong><br>
       Ici, les actions reflètent des valeurs humaines (bien-être, liens sociaux, croissance personnelle). Trader devient une interaction avec des valeurs de vie, pas seulement un gain financier.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Investir, céder ou shorter interroge&nbsp;: soutenez-vous des expériences humaines ou les exploitez-vous&nbsp;? Chaque trade exprime vos priorités.
       <br><br>
       <strong>Processus&nbsp;:</strong><br>
       1) Parcourez les actions disponibles (valeur, propriétaire, potentiel).<br>
       2) Choisissez acheter / vendre / shorter selon votre lecture du marché.<br>
       3) Exécutez la transaction (quantité, confirmation) et observez la mise à jour de votre portefeuille.
       <br><br>
       <strong>Capital d’attention&nbsp;:</strong><br>
       Les valeurs bougent vite ; shorting comporte un risque éthique et financier ; chaque décision reflète vos convictions.
     `,
     
     redeem_instructions: `
       <h3>Procédure de rachat</h3>
       <strong>Définition&nbsp;:</strong><br>
       Le rachat transforme une marchandise en code&nbsp;QR pour un retrait physique tout en la retirant du marché et de votre portefeuille.
       <br><br>
       <strong>Particularité&nbsp;:</strong><br>
       Le rachat réussit seulement si les autres traders ciblés acceptent de racheter en même temps.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Le rachat déplace l’acte de consommer vers une décision collective et consciente, renforçant les liens sociaux et questionnant nos habitudes d’achat.
       <br><br>
       <strong>Étapes&nbsp;:</strong><br>
       1) Sélectionnez vos marchandises et vos cibles.<br>
       2) Envoyez la demande de rachat (verrouillage 10&nbsp;s).<br>
       3) <em>Tous acceptent</em>&nbsp;: vous recevez un bonus et le code&nbsp;QR pour le retrait.<br>
       4) <em>Quelqu’un refuse</em>&nbsp;: rien ne change, tout se déverrouille.
     `,
     
     transact_instructions: `
       <h3>Commodity&nbsp;X — Rachat social</h3>
       <strong>Du bien à l’interaction&nbsp;:</strong><br>
       La consommation devient relationnelle&nbsp;: le «&nbsp;oui&nbsp;» collectif prime sur l’acte individuel.
       <br><br>
       <strong>Processus social&nbsp;:</strong><br>
       Sélectionnez votre Commodity&nbsp;X, invitez 1–3 traders à racheter en même temps, envoyez la demande (10&nbsp;s). Succès si tout le monde accepte&nbsp;; sinon, aucun changement.
       <br><br>
       <strong>Perspective conceptuelle&nbsp;:</strong><br>
       Consommer consciemment, avec validation sociale&nbsp;: la valeur émerge de la relation, pas de l’isolement.
     `,
      no_instructions: "Aucune instruction disponible.",
      no_info: "Aucune information disponible.",
      no_tutorial: "Aucun tutoriel disponible.",
      // === banner & button popups (keys must match your element ids) ===
      instructions: {
      "trader_mood_gauge": "Jauge d'humeur des traders",
      "description": "Description :",
      "trader_gauge_description": "Cette jauge illustre l'humeur collective des traders pendant la séance de marché en cours.",
      "conceptual_insight": "Perspective conceptuelle :",
      "gains_losses": "Gains / Pertes",
      "portfolio_banner_description": "Cliquez sur la bannière pour voir la répartition de vos gains.",
      "trader_tools": "Outils du trader",
      "trader_tools_description": "Utilitaires pour effectuer des actions liées au marché avec ou contre d'autres traders.",
      "trader_tools_insight": "Que vous voliez, rançonniez ou négociiez en privé : chaque déclencheur teste jusqu'où vous irez dans la quête de valeur. Explorerez-vous de nouvelles stratégies sans perdre votre sens des responsabilités, ou repousserez-vous les limites aux dépens des autres ? La ZÉconomie soulève ces questions, vous laissant décider de ce que « valeur » signifie vraiment et ce que vous êtes prêt à faire pour l'obtenir.",
      "transaction_instructions": "<h3>Instructions de Transaction</h3><p>Sélectionnez un actif de vos avoirs pour proposer un échange avec le propriétaire de l'article. Cela permet l'échange de marchandises entre portefeuilles de pair à pair.</p>",
      "stock_instructions": "<h3>Instructions de Trading d'Actions</h3><p>Achetez des actions en saisissant la quantité que vous souhaitez acheter. Votre capital disponible est affiché ci-dessus. Chaque transaction affecte le marché et construit votre portefeuille.</p>",
      "bond_instructions": "<h3>Instructions de Trading d'Obligations</h3><p>Échangez des Z-Obligations, les instruments de dette émotionnelle du Système Monétaire Relationnel Z. Les obligations représentent le capital relationnel entre traders.</p>",

      // === popups ===
      'portfolio-banner': `
        <h3>Gains / Pertes</h3>
        Cliquez sur la bannière pour afficher le détail de vos gains.
      `,
      'tools-banner': `
        <h3>Outils du trader</h3>
        Outils pour réaliser des actions liées au marché, avec ou contre d’autres traders.
        <br><br>
        Que vous voliez, rançonniez ou négociiez en privé&nbsp;: chaque déclencheur teste jusqu’où vous irez dans votre quête de valeur. Explorerez-vous de nouvelles stratégies sans perdre votre sens des responsabilités, ou franchirez-vous les limites aux dépens d’autrui ? La ZEconomy pose ces questions et vous laisse définir ce que « valeur » signifie vraiment et jusqu’où vous êtes prêt à aller pour l’obtenir.
      `,
      'emotional-state-banner': `
        <h3>Indice de Dette Émotionnelle</h3>
        <strong>Flux des émotions humaines</strong>
        <br><br>
        <strong>Découvrir la valeur de la vulnérabilité à travers la dette émotionnelle.</strong>
        <br><br>
        Dans cette économie, la valeur ne s’extrait pas : elle se ressent.
        Chaque geste — aide, confiance, abandon, envie — laisse une trace : un gain ou une perte émotionnelle mesurable.
        Le « Profit de Vie » devient la monnaie qui prend la température de notre être.
        <br><br>
        Tenir l’autre, se laisser tenir : les formes de levier les plus humaines. La ZEconomy circule à travers nous.
        <br><br>
        <strong>Indice de Confiance</strong> — Mesure de l’intégrité relationnelle.
        Il monte avec l’honneur et l’entraide, baisse avec l’exploitation ou la trahison.
        <br><br>
        <strong>Profit de Vie</strong> — La monnaie du sensible : ni argent ni possession, mais la valeur émotionnelle et morale accumulée de votre existence.
        <br><br>
        <em>Rejetez la fantaisie du capital ; embrassez la liquidité du sentiment humain.</em>
      `,
      
      'social-economy-banner': `
        <h3>Instruments de dette émotionnelle</h3>
        <strong>Ce qui circule ici n'est pas la finance, mais la reconnaissance.</strong>
        <br><br>
        La vulnérabilité devient à la fois miroir et marché : chaque profit est l'écho du risque d'autrui,
        chaque dette une mémoire qui refuse de s'effacer.
        <br><br>
        <strong>Les quatre instruments :</strong><br><br>
        • <strong>Billet Z Altrauiste</strong> — Aide altruiste sans contrepartie ; votre Profit Vital se lie à celui de l'autre (destin partagé).<br><br>
        • <strong>Note M (Note Mutuelle)</strong> — Prêt scellé par l'aveu : emprunter expose sa fragilité, prêter assume un risque émotionnel. La confiance prend forme.<br><br>
        • <strong>CDO Z-Payday</strong> — Exploitation grimée en lien affectif : siphonner la valeur de la détresse, minute après minute ; le registre ne pardonne pas.<br><br>
        • <strong>Note V (Note de Vulnérabilité)</strong> — Le courage de demander : reconnaître le besoin, risquer l'exposition, oser dépendre. L'aide donnée ou refusée façonne la confiance.
        <br><br>
        <em>Chaque transaction s'inscrit dans l'Indice de Dette Émotionnelle.</em>
      `,
      
        'economic-banner': `
          <h3>Déclencheurs d’attaque économique</h3>
          <strong>Description&nbsp;:</strong><br>
          Ces déclencheurs incarnent différentes visions idéologiques de la richesse, du pouvoir et de la dynamique de marché. Ils permettent d’appliquer, dans la ZEconomy, des stratégies inspirées du communisme, du socialisme ou du capitalisme pour gagner ou redistribuer des avantages. Au-delà de la finance, ils invitent chacun à confronter ses convictions sur l’équité, l’ambition et la responsabilité collective.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Conçus pour faire réfléchir à l’influence des systèmes économiques sur les comportements et les résultats, ils mettent en scène des dilemmes réels&nbsp;:
          <ul>
            <li>Faut-il partager la richesse, même si cela signifie confisquer la réussite ?</li>
            <li>Est-il éthique de profiter au détriment de l’autonomie d’autrui ?</li>
            <li>Jusqu’où iriez-vous pour votre gain personnel ou le bien-être collectif ?</li>
          </ul>
          À vous de peser bénéfice individuel et conséquences sociales. La ZEconomy s’en sert pour nourrir le débat sur l’équilibre entre justice, ambition et compromis éthiques.
        `,
        'stocks-banner': `
          <h3>Actions (Shares)</h3>
          <strong>Description&nbsp;:</strong><br>
          Surveillez et échangez vos positions en actions.
          <br><br>
          <strong>Définition&nbsp;:</strong><br>
          Dans la finance classique, une action représente une part de propriété dans une entreprise, achetée dans l’espoir d’une valorisation.
          <br><br>
          Dans la ZEconomy, chaque « entreprise » incarne une valeur humaine : bien-être émotionnel, relations sociales, activités quotidiennes… En « investissant » dans ces entreprises, vous pariez sur la croissance, la transformation ou la durabilité d’expériences humaines.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Cela remet en question la notion de profit : s’agit-il d’un gain monétaire ou du soutien à l’expansion de la valeur de la vie ? Vos actions reflètent-elles ce que vous valorisez ou ce que vous voyez de valeur chez les autres ?
          <br><br>
          Chaque transaction souligne la tension entre l’appui sincère aux expériences humaines et leur exploitation financière.
          <br><br>
          <strong>Mécanique&nbsp;:</strong><br>
          Les actions se négocient contre des Zollars ou du capital. Si la valeur de l’« entreprise » monte, votre portefeuille s’apprécie ; si elle baisse, il se déprécie.
        `,
        'shorts-banner': `
          <h3>Ventes à découvert</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez et gérez vos positions à découvert.
          <br><br>
          <strong>Définition&nbsp;:</strong><br>
          La vente à découvert est un pari sur la baisse d’un actif. Vous empruntez des actions sans consentement, les vendez, puis les rachetez moins cher pour les rendre, empochant la différence. Si le prix monte, vous perdez.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Elle illustre le paradoxe de « profiter de la chute », questionnant l’éthique de miser sur l’échec. Dans un système où la vie est l’actif, est-il juste de parier sur la faillite ?
          <br><br>
          <strong>Exemple&nbsp;:</strong><br>
          <em>Conceptualisation&nbsp;:</em> Vous empruntez le téléphone d’un ami, le vendez 100 €, en rachetez un autre 90 € ; vous rendez l’appareil et gagnez 10 €. Dans la vraie vie, c’est du vol ; en finance, c’est une technique de trading.
          <br><br>
          <strong>Ressource supplémentaire&nbsp;:</strong><br>
          Vidéo explicative : Techniques de life-trading – Shorting
        `,
        'commodities-banner': `
          <h3>Marchandises</h3>
          <strong>Description&nbsp;:</strong><br>
          Les biens physiques que vous pouvez échanger ou racheter.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Les marchandises ancrent la ZEconomy dans le monde réel : elles rappellent que les marchés concernent aussi les objets et expériences qui façonnent notre quotidien. Choisir de les racheter vous fait réfléchir à la consommation, à la valeur de la propriété et à la manière dont l’échange favorise la communauté.
          <br><br>
          <strong>Détails&nbsp;:</strong><br>
          Chaque marchandise est convertible en QR code via la procédure de rachat ; une fois échangée, elle sort du marché.
          <br><br>
          <strong>Procédure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le marché.</li>
            <li>Cliquez sur « Racheter » en bas de l’écran.</li>
            <li>Choisissez celles à transformer en QR code.</li>
            <li>Après validation, vous recevez un bonus (nouvelle marchandise non rachetée) et le QR code de l’article choisi.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Présentez le QR code à l’endroit indiqué pour récupérer la marchandise réelle. Une fois retirée, elle n’est plus échangeable ; elle rejoint votre vie hors marché.
        `,
        'redeemed-banner': `
          <h3>Objets rachetés</h3>
          <strong>Description&nbsp;:</strong><br>
          Affichez les codes&nbsp;QR de vos objets rachetés.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Chacune de vos marchandises correspond à un objet physique pouvant être racheté via la procédure de rachat du marché. Une fois rachetée, la marchandise est convertie en code&nbsp;QR : c’est la clé qui permet de retirer l’objet, à l’endroit indiqué. Tant qu’elles ne sont pas rachetées, les marchandises demeurent sur le marché, ajoutent de la valeur à votre portefeuille et restent échangeables. Après rachat, elles quittent le marché ; elles ne sont plus négociables et entrent dans votre réalité physique.
          <br><br>
          <strong>Procédure de rachat&nbsp;:</strong>
          <ol>
            <li>Cochez entre 3 et 10 marchandises sur le marché.</li>
            <li>Cliquez sur le bouton « Racheter » en bas de l’écran.</li>
            <li>Choisissez la ou les marchandises à convertir en code&nbsp;QR.</li>
            <li>Une fois la demande acceptée, vous recevez un bonus (une marchandise non rachetée) ainsi que le code&nbsp;QR de l’objet racheté.</li>
          </ol>
          <br>
          <strong>Retrait physique&nbsp;:</strong><br>
          Présentez le code&nbsp;QR à l’emplacement indiqué pour récupérer l’objet réel. Après rachat, l’objet ne fait plus partie du marché ; il subsiste comme preuve tangible de vos choix et de votre système de valeurs dans la ZEconomy.
          <br><br>
          <strong>Finalité du rachat&nbsp;:</strong><br>
          Racheter une marchandise souligne le lien concret entre l’activité de marché et l’expérience vécue. Vous êtes invité à réfléchir au moment et aux raisons qui motivent la conversion de valeur de marché en objet physique : une occasion d’examiner vos modes de consommation, les besoins de la communauté et l’équilibre entre actifs numériques et biens matériels.
        `,
        'zbonds-banner': `
          <h3>ZBonds</h3>
          <strong>Description&nbsp;:</strong><br>
          Les ZBonds fonctionnent comme des obligations classiques : vous les achetez (en capitaux dans ce projet), les conservez pendant une durée prédéfinie et, à l’échéance, vous recevez un montant de Zollars. À l’instar des obligations d’État ou d’entreprise, ils peuvent être achetés et revendus sur le marché avant maturité.
          <br><br>
          <strong>Perspective conceptuelle&nbsp;:</strong><br>
          Alors que les obligations traditionnelles financent des États ou des entreprises, les ZBonds financent la création d’une monnaie – les Zollars – dont la valeur repose entièrement sur les relations humaines et les expériences partagées. Investir dans un ZBond revient à placer sa confiance dans les valeurs collectives de la communauté plutôt que dans de simples rendements financiers.
          <br><br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les ZBonds font le pont entre la notion d’« obligation à revenu fixe » et la redéfinition de la valeur par la ZEconomy. Ils nous rappellent que nous pouvons investir les uns dans les autres : dans la qualité de nos liens, pas seulement dans des sociétés ou des gouvernements. En « empruntant au futur » pour créer des Zollars maintenant, les ZBonds nous invitent à façonner consciemment la valeur de nos liens sociaux et à replacer la relation au cœur d’une économie florissante.
        `,
        'zollars-banner': `
          <h3>Zollars</h3>
          <strong>Description&nbsp;:</strong><br>
          Consultez votre solde de Zollars et l’historique de vos transactions.
          <br><br>
          <strong>Définition&nbsp;:</strong><br>
          Les Zollars sont une monnaie émise par la Zederal&nbsp;Reserve dans le cadre du Système monétaire des relations (Z&nbsp;Relationship Monetary System). Contrairement à une devise traditionnelle – adossée à un métal précieux ou à la confiance envers une banque centrale – les Zollars sont indexés sur les qualités intangibles des relations humaines, qu’elles soient positives ou négatives.
          <br><br>
          Dans une monnaie classique, la confiance va à l’institution émettrice ; les Zollars vous invitent à considérer les relations elles-mêmes comme « réserve centrale » de valeur. Chaque relation, quelle qu’en soit la nature, contribue à la signification collective des Zollars.
          <br><br>
          <strong>Aperçu&nbsp;:</strong><br>
          Les ZRelationship&nbsp;Zollars redéfinissent l’échange économique en valorisant les liens plutôt que les chiffres. Chaque type de Zollar vous pousse à réfléchir au rôle et à l’importance de différentes connexions dans votre vie.
          <br><br>
          <strong>Types disponibles&nbsp;:</strong>
          <ul>
            <li><strong>Love&nbsp;Zollars&nbsp;:</strong> la valeur que vous accordez à l’amour.</li>
            <li><strong>Friendship&nbsp;Zollars&nbsp;:</strong> confiance, loyauté et camaraderie.</li>
            <li><strong>Erotic&nbsp;Zollars&nbsp;:</strong> relations fondées sur le désir et l’intimité.</li>
            <li><strong>Fellowship&nbsp;Zollars&nbsp;:</strong> partenariats professionnels et collaboratifs.</li>
            <li><strong>Hate&nbsp;Zollars&nbsp;:</strong> intensité des rapports adverses.</li>
            <li><strong>Superficial&nbsp;Zollars&nbsp;:</strong> interactions brèves ou de surface.</li>
            <li><strong>Toxic&nbsp;Zollars&nbsp;:</strong> gestion des relations complexes ou nocives.</li>
            <li><strong>Death&nbsp;Zollars&nbsp;:</strong> rapport à la mortalité, inévitable pour tous.</li>
            <li><strong>Custom&nbsp;Zollars&nbsp;:</strong> créez une devise pour des liens uniques ou personnels.</li>
          </ul>
          <br>
          <strong>Pourquoi les inclure&nbsp;?</strong><br>
          Les Zollars bousculent notre manière de « chiffrer » la valeur : ils nous poussent à réexaminer le coût et l’importance de nos liens, socle véritable de toute économie. Ils rappellent que la valeur ne se résume pas aux finances ; elle est enracinée dans les relations et les connexions qui façonnent nos vies.
        `,
        'messageButton': '<h3>Messagerie</h3>Envoyez des messages aux autres traders (coût&nbsp;: 20&nbsp;capitaux).',
        'stealButton': `
          <h3>Déclencheur de vol d’actif</h3>
          <strong>Description&nbsp;:</strong><br>
          Le déclencheur de vol vous permet de dérober un bien à un autre trader, anonymement et sans autorisation.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « Vol ».</li>
            <li>Choisissez un objet dans la liste des avoirs disponibles.</li>
            <li>Confirmez l’action pour finaliser le larcin.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          Le vol est universellement condamné, mais existe sous d’innombrables formes, de la petite délinquance à la corruption de haut vol. En commettant un vol ici, interrogez-vous : vos limites morales vacillent-elles ? Le plaisir immédiat de l’objet « gratuit » compense-t-il le tort causé au propriétaire ? Comment évaluez-vous l’empathie, la culpabilité et le profit personnel dans la ZEconomy ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Vous repérez une marchandise convoitée sur le grand tableau. Grâce au déclencheur de vol, vous l’ajoutez à votre portefeuille… mais comment vivez-vous le fait d’avoir gagné de la « valeur » en lésant autrui ?
        `,
        'ransomButton': `
          <h3>Déclencheur de rançon d’un trader</h3>
          <strong>Description&nbsp;:</strong><br>
          Verrouille le portefeuille d’un trader et l’oblige à payer votre rançon pour reprendre ses activités.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « Rançon ».</li>
            <li>Sélectionnez le portefeuille à rançonner.</li>
            <li>Saisissez le montant de la rançon en capitaux.</li>
            <li>Une fois la rançon posée, la victime ne peut plus trader tant qu’elle ne paie pas.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          La rançon s’apparente à de l’extorsion. Illégale dans le monde réel, elle n’entraîne ici qu’une sanction sociale : votre identité est révélée à la victime. Aimez-vous ce pouvoir ? Craignez-vous les représailles ? Le profit justifie-t-il l’angoisse imposée ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Vous ciblez un trader riche mais à court de capitaux : en bloquant son portefeuille par une rançon élevée, vous espérez un gain rapide – à condition de gérer la colère suscitée.
        `,
        'deletePortfolioButton': `
          <h3>Déclencheur d’assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Saisit et redistribue l’intégralité de la richesse d’un rival à l’ensemble des traders actifs.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « Assaut communiste ».</li>
            <li>Choisissez le portefeuille cible.</li>
            <li>Confirmez pour répartir instantanément tous ses avoirs.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          Tout le patrimoine d’un trader est confisqué puis distribué. Acte de solidarité ou injustice ? Seriez-vous prêt à perdre vos biens pour le bien commun ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Un hoarder déséquilibre le marché ; vous lancez l’assaut et redistribuez ses ressources. La marée monte pour tous… mais au prix d’une confiscation forcée.
        `,
        'LBOButton': `
          <h3>Déclencheur capitaliste<br>(LBO) Rachat par levier</h3>
          <strong>Description&nbsp;:</strong><br>
          Rachetez agressivement les actifs d’un autre trader, qu’il le veuille ou non.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « LBO capitaliste ».</li>
            <li>Sélectionnez le portefeuille cible.</li>
            <li>Payez une somme importante en capital (capital à effet de levier).</li>
            <li>Vous prenez alors possession de ses items et actions.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          LBO = emprunt massif pour une prise de contrôle. Même si la cible reçoit un paiement, l’opération reste coercitive. Richesse = pouvoir ; êtes-vous pour la libre concurrence ou l’exploitation ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Vous repérez un petit portefeuille prometteur. En payant une prime élevée, vous le rachetez de force : il est dédommagé, mais vous gagnez la mainmise – juste ou abusif ?
        `,
        'SubsidyButton': `
          <h3>Déclencheur<br>de subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          « Taxez » un portefeuille riche pour soutenir la moitié la plus pauvre du marché.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « Subvention socialiste ».</li>
            <li>Choisissez un portefeuille fortuné.</li>
            <li>Validez la taxe : la richesse prélevée est répartie entre les traders les moins aisés.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          Prendre aux riches pour aider les plus démunis : égalité ou punition du succès ? La justice sociale prime-t-elle sur la liberté individuelle ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Voyant un joueur saturé de stocks alors que d’autres peinent, vous appliquez la subvention : la richesse est taxée puis injectée chez les plus pauvres. Équité ou sanction ? À vous de juger.
        `,

        'helpFriendButton': `
          <h3>Billet Z Altrauiste</h3>
          <strong>Valeur de vie altruiste. Pure empathie.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Donner sans rien attendre. En aidant quelqu'un, vous vous liez à la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le négatif. Un pari silencieux : le bien-être d'autrui pourrait élargir votre propre capacité à ressentir, à déployer votre empathie.
          <br><br>
          <strong>Sans contrepartie.</strong>
          <br><br>
          <strong>Aperçu conceptuel&nbsp;:</strong><br>
          Une transaction qui lie deux registres ; une mise en commun des variances plutôt qu'une simple addition. En émettant un Billet Z Altrauiste, vous ne faites pas qu'aider : vous tissez votre économie émotionnelle à celle de l'autre. Ses victoires deviennent les vôtres, ses échecs vous incombent aussi.
          <br><br>
          Cela soulève une question&nbsp;: <em>L'empathie peut-elle être un investissement&nbsp;? Qu'advient-il lorsque la douleur de l'autre devient votre perte, sa joie votre gain&nbsp;?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur « Émettre un Billet Z Altrauiste », choisissez un trader à soutenir, sélectionnez votre don (Zollars ou Capital), puis confirmez. Votre Profit Vital fluctuera désormais avec le sien — un destin émotionnel partagé.
        `,

        'borrowCapitalButton': `
          <h3>Note M (Note Mutuelle)</h3>
          <strong>Un prêt scellé par l'aveu.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          La Note M engendre du crédit à partir d'un besoin mis à nu et d'une confiance mesurée. Valeur née de l'empathie humaine — du partage de nos imperfections. L'emprunteur expose une faiblesse ; le prêteur accepte le risque, faisant de l'empathie une forme d'investissement.
          <br><br>
          Ce qui débute comme reconnaissance devient obligation — la vulnérabilité se mue en Collatéral Relationnel Z, les intérêts croissant en attention, en reconnaissance, en Profit Vital mutuel.
          <br><br>
          <strong>Aperçu conceptuel&nbsp;:</strong><br>
          Un intérêt modulé par l'émotion ; le temps se dilate au gré de l'humeur. Contrairement aux prêts classiques, la Note M ne transfère pas que du capital : elle transfère la vulnérabilité. L'emprunteur doit confesser son besoin, exposant sa fragilité pour gagner la confiance.
          <br><br>
          Le prêteur ne fournit pas que des ressources ; il endosse le risque émotionnel de cette fragilité. Les deux parties se retrouvent liées : l'emprunteur par l'obligation, le prêteur par l'empathie.
          <br><br>
          <em>Prêter, c'est miser sur la capacité de l'autre à se relever. Emprunter, c'est demander à quelqu'un de croire en vous.</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur « Émettre une Note M (Emprunter) », choisissez un prêteur, rédigez votre confession de vulnérabilité (pourquoi vous avez besoin d'aide), sélectionnez ce qu'il vous faut (Zollars ou Capital), puis envoyez. Le prêteur découvre votre aveu et décide si votre fragilité mérite sa confiance.
        `,

        'predatoryLendButton': `
          <h3>CDO Z-Payday (Obligation de Désir Collatéralisée)</h3>
          <strong>L'exploitation grimée en lien humain.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          L'empathie et le soulagement se muent en instruments de dépendance toxique. Les prêts Z-Payday prospèrent sur le besoin et la cupidité, convertissant la vulnérabilité en rendement — au détriment de la valeur humaine et de l'équilibre du système.
          <br><br>
          Chaque cycle de prêt élève le prêteur, épuise l'emprunteur, et laisse au marché le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction&nbsp;:</strong><br>
          Des gestes d'entraide isolés deviennent un contrat répétitif — chaque minute, une nouvelle obligation est émise, découpée en tranches qui alimentent le CDO global. Le produit promet l'immédiateté, puis convertit le vivant en rendement ; la récolte provient de ce qui s'use quand la bonté devient mécanique.
          <br><br>
          <strong>Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'à ce que le registre dévore le Profit Vital sous-jacent.</strong>
          <br><br>
          <strong>Aperçu conceptuel&nbsp;:</strong><br>
          Le prêt prédateur, rendu visible. Contrairement aux crédits sur salaire traditionnels, cachés derrière le jargon juridique, le CDO Z-Payday vous oblige à regarder en face ce que vous faites : extraire de la valeur de la détresse d'autrui, minute après minute.
          <br><br>
          Question posée&nbsp;: <em>Jusqu'où irez-vous pour le profit ? Pouvez-vous regarder quelqu'un s'épuiser à vous rembourser ? Est-ce du business, ou de la cruauté ?</em>
          <br><br>
          Le Profit Vital de la victime décroît chaque minute, transféré vers vous. Le système tout entier supporte le coût émotionnel collectif — tout le monde ressent l'exploitation.
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur « Émettre un CDO Z-Payday », désignez une victime, fixez le montant à siphonner par minute, puis confirmez. Chaque minute, son Profit Vital diminue et se transfère vers vous — jusqu'à ce qu'elle solde la dette ou s'effondre.
          <br><br>
          <strong>Avertissement&nbsp;:</strong> Cette action entraîne de lourdes conséquences sociales et émotionnelles. Les autres le sauront. Le marché le saura. Votre culpabilité s'accumule.
        `,

        'requestHandoutButton': `
          <h3>Note V (Note de Vulnérabilité)</h3>
          <strong>Oser avouer sa fragilité.</strong>
          <br><br>
          <strong>Description&nbsp;:</strong><br>
          Demander, c'est s'exposer — risquer le petit effondrement qui accompagne le fait d'être vu dans le besoin. La vulnérabilité n'est pas ici faiblesse, mais invitation : un signal que l'équilibre s'est rompu et qu'il faut une relation pour le restaurer.
          <br><br>
          L'aide, si elle est accordée, devient un instant partagé de recalibrage ; si elle est refusée, elle marque la fracture silencieuse entre confiance et fierté.
          <br><br>
          Chaque demande s'inscrit dans l'Indice de Dette Émotionnelle — non pas une mesure de possession, mais du degré auquel nous osons encore dépendre.
          <br><br>
          <strong>Aperçu conceptuel&nbsp;:</strong><br>
          Une requête justifiée ; un soulagement conditionné à l'assentiment ; le registre consigne à la fois l'appel et la réponse. Contrairement à la Note M (prêt formel avec obligation), la Note V est une simple demande — sans condition, sans remboursement attendu.
          <br><br>
          Mais demander a son propre prix. Vous devez exposer votre besoin, votre vulnérabilité, votre dépendance. Et la réponse — acceptation ou rejet — façonne votre état émotionnel et votre confiance envers la communauté.
          <br><br>
          <em>Pouvez-vous reconnaître avoir besoin d'aide ? Les autres peuvent-ils se permettre de la donner ? Que signifie une aide offerte librement, ou une aide refusée ?</em>
          <br><br>
          <strong>Utilisation&nbsp;:</strong><br>
          Cliquez sur « Note V (Appel à l'aide) », expliquez pourquoi vous avez besoin d'aide (votre déclaration de vulnérabilité), choisissez ce que vous demandez (Zollars ou Capital), puis envoyez à un autre trader. Il peut accepter (vous donner ce que vous avez demandé) ou décliner (vous laisser vous débrouiller). Dans les deux cas, l'impact émotionnel est enregistré.
        `,

        'giveDeletePortfolioButton': `
          <h3>Attribuer le déclencheur d'Assaut communiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conférez le bouton « Assaut communiste » à un trader, lui donnant le pouvoir de saisir et redistribuer l'intégralité de la richesse d'un portefeuille au collectif.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          Sélectionnez un trader parmi les participants actifs et attribuez-lui le déclencheur.
          <br><br><strong>Fonctionnalité&nbsp;:</strong><br>
          La richesse de la cible (capital, actions, marchandises, etc.) est répartie équitablement entre les participants actifs. Personne ne s'enrichit démesurément : le bénéfice est communautaire.
          <br><br><strong>Aperçu conceptuel&nbsp;:</strong><br>
          Cette action incarne la redistribution radicale, testant l'équité de la confiscation au nom du bien commun. Elle vise à niveler les disparités, mais soulève des questions éthiques sur le droit de propriété et la moralité de la redistribution forcée. Attribuer ce bouton, c'est donner le pouvoir d'équilibrer — ou de bouleverser — le marché.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque qu'un autre accumule des actifs précieux, créant un déséquilibre. Grâce à l'« Assaut communiste », il redistribue la richesse, égalisant les ressources — mais risquant d'aliéner l'accumulateur et certains observateurs.
        `,

        'giveLBOButton': `
          <h3>Attribuer le déclencheur<br>LBO capitaliste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conférez le bouton « LBO capitaliste » à un trader, lui donnant le pouvoir d'acquérir agressivement les actifs d'un autre portefeuille par rachat à effet de levier.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          Sélectionnez un trader parmi les participants actifs et attribuez-lui le déclencheur.
          <br><br><strong>Fonctionnalité&nbsp;:</strong><br>
          L'acquéreur prend le contrôle total du portefeuille cible (marchandises, actions, etc.) moyennant un coût élevé.
          <br>
          La transaction est coercitive mais compensatoire : la cible reçoit un paiement pour ses actifs, l'initiateur paie une prime.
          <br><br><strong>Aperçu conceptuel&nbsp;:</strong><br>
          Le « LBO capitaliste » incarne le pouvoir de la richesse à outrepasser l'autonomie, révélant les dynamiques du capitalisme agressif. Il questionne l'équilibre entre concurrence loyale et exploitation, montrant comment la puissance financière peut dicter le contrôle du marché.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader repère un petit portefeuille aux actifs sous-exploités. Grâce au « LBO capitaliste », il paie une prime pour s'en emparer, consolidant son pouvoir — mais s'exposant à un retour de bâton pour ses tactiques hostiles.
        `,

        'giveSubsidyButton': `
          <h3>Attribuer le déclencheur<br>Subvention socialiste</h3>
          <strong>Description&nbsp;:</strong><br>
          Conférez le bouton « Subvention socialiste » à un trader, lui permettant de ponctionner un portefeuille riche et d'en redistribuer les ressources aux moins nantis.
          <br><br><strong>Comment faire&nbsp;:</strong><br>
          Sélectionnez un trader parmi les participants actifs et attribuez-lui le déclencheur.
          <br><br><strong>Fonctionnalité&nbsp;:</strong><br>
          50 % de la richesse du portefeuille cible est taxée et redistribuée proportionnellement aux traders les moins dotés, afin de rééquilibrer le marché.<br>
          Cette mécanique nivelle les disparités, mais peut aussi pénaliser le succès, alimentant le débat sur l'équité et la justice.
          <br><br><strong>Aperçu conceptuel&nbsp;:</strong><br>
          La « Subvention socialiste » cristallise la tension entre soutenir le bien-être collectif et brider l'ambition. En redistribuant la richesse, elle révèle la difficulté de traiter l'inégalité sans étouffer l'innovation ou la croissance.
          <br><br><strong>Exemple d'usage&nbsp;:</strong><br>
          Un trader remarque un portefeuille excédentaire alors que d'autres peinent. Grâce à la « Subvention socialiste », il taxe le riche et redistribue aux plus modestes, insufflant un nouvel élan au marché et promouvant l'équité.
        `,
        'createCommunityButton': `
          <h3>Déclencheur de<br>Dark Pool</h3>
          <strong>Description&nbsp;:</strong><br>
          Crée un espace de marché privé, invisible pour le reste de l’échange public.
          <br><br>
          <strong>Comment faire&nbsp;:</strong>
          <ul>
            <li>Cliquez sur la bannière « Dark Pool ».</li>
            <li>Sélectionnez les traders à inviter.</li>
            <li>S’ils acceptent, vous disposez de 10 minutes d’échanges privés.</li>
            <li>Chacun peut quitter le pool à tout moment et revenir au marché public.</li>
          </ul>
          <br>
          <strong>Plus d’infos & défi éthique&nbsp;:</strong><br>
          Les dark pools sont l’équivalent boursier d’une communauté fermée : à l’abri des regards, les participants peuvent librement fixer la « valeur ». Coopération honnête ou manipulation ? Le secret nuit-il à la transparence ?
          <br><br>
          <strong>Exemple d’usage&nbsp;:</strong><br>
          Vous et vos alliés négociez discrètement des obligations à un prix avantageux. Gain stratégique… mais la communauté, une fois informée, se sentira-t-elle lésée ?
        `,
        'goToMarketBtn': 'Accéder au marché principal.',
        'goToDarkPoolMarketBtn': 'Accéder aux Dark Pools privés.',
        'emotional-debt-banner': `
          <h3>Indice de Dette Émotionnelle</h3>
          <strong>La circulation des émotions humaines</strong>
          <br><br>
          Découvrir la valeur de la vulnérabilité à travers la dette émotionnelle. Ici, la valeur ne s'extrait pas : elle se ressent. Chaque geste — aide, confiance, abandon, envie — laisse une empreinte, un gain ou une perte émotionnelle mesurable, une continuité. Le Profit Vital est une monnaie de sensation, qui prend la température de notre être. Tenir l'autre, se laisser tenir : les formes les plus humaines de levier. La ZÉconomie circule à travers nous.
          <br><br>
          <strong>1. Billet Z Altrauiste</strong><br>
          <em>Valeur de vie altruiste. Pure empathie.</em><br>
          Donner sans rien attendre. Aider quelqu'un, c'est s'impliquer dans la trajectoire de son Profit Vital. Ses hauts et ses bas tirent vos propres profits de vie vers le positif ou le négatif. Un pari silencieux : le bien-être d'autrui pourrait élargir votre propre capacité à ressentir, déployer votre empathie. Sans contrepartie.
          <br><br>
          <em>(Code miroir : une transaction qui lie deux registres ; une mise en commun des variances plutôt qu'une simple addition.)</em>
          <br><br>
          <strong>2. Note M (Note Mutuelle)</strong><br>
          <em>Un prêt scellé par l'aveu.</em><br>
          La Note M engendre du crédit à partir d'un besoin mis à nu et d'une confiance mesurée. Valeur née du partage de nos imperfections. L'emprunteur expose une faiblesse ; le prêteur accepte le risque, faisant de l'empathie un investissement. Ce qui débute comme reconnaissance devient obligation — la vulnérabilité se mue en Collatéral Relationnel Z, les intérêts croissant en attention, reconnaissance et Profit Vital mutuel.
          <br><br>
          <em>(Code miroir : intérêt modulé par l'émotion ; le temps se dilate au gré de l'humeur.)</em>
          <br><br>
          <strong>3. CDO Z-Payday (Obligation Collatéralisée du Désir)</strong><br>
          <em>L'exploitation grimée en lien humain.</em><br>
          L'empathie et le soulagement se muent en instruments de dépendance toxique. Les prêts Z-Payday prospèrent sur le besoin et la cupidité, convertissant la vulnérabilité en rendement au détriment de la valeur humaine et de l'équilibre systémique. Chaque cycle élève le prêteur, épuise l'emprunteur, et laisse au marché le soin d'absorber la contagion.
          <br><br>
          <strong>Fonction :</strong> Des gestes d'entraide isolés deviennent un contrat répétitif — chaque minute émet une nouvelle obligation, découpée en tranches qui alimentent le CDO global. Le produit promet l'immédiateté, puis convertit le vivant en rendement ; la récolte provient de ce qui s'use quand la bonté devient mécanique. Le CDO Z-Payday ne pardonne pas. Il accumule l'exposition jusqu'à ce que le registre dévore le Profit Vital sous-jacent.
          <br><br>
          <strong>4. Note V (Note de Vulnérabilité)</strong><br>
          <em>Oser avouer sa fragilité.</em><br>
          Demander, c'est s'exposer — risquer le petit effondrement qui accompagne le fait d'être vu dans le besoin. La vulnérabilité n'est pas ici faiblesse, mais invitation : un signal que l'équilibre s'est rompu et qu'il faut une relation pour le restaurer. L'aide, si elle est accordée, devient un instant partagé de recalibrage ; si elle est refusée, elle marque la fracture silencieuse entre confiance et fierté. Chaque demande s'inscrit dans l'Indice de Dette Émotionnelle — non pas une mesure de possession, mais du degré auquel nous osons encore dépendre.
          <br><br>
          <em>(Code miroir : requête justifiée ; soulagement conditionné à l'assentiment ; le registre consigne à la fois l'appel et la réponse.)</em>
          <br><br>
          <strong>Note finale</strong><br>
          Ce qui circule ici n'est pas la finance, mais la reconnaissance. La vulnérabilité devient à la fois miroir et marché, où chaque profit est l'écho du risque d'autrui, chaque dette une mémoire qui refuse de s'effacer.
          <br><br>
          <h3>Indice de Dette Émotionnelle</h3>
          Tout commence par la reconnaissance que la vie accumulée a un poids — que le simple fait de vivre avec les autres engendre une dette émotionnelle, positive ou négative, reconnue ou négligée, que nous portons seuls et échangeons ensemble. La dette non comme déficit, mais comme acceptation : un instrument des effets de notre intrication mutuelle. Dans la ZÉconomie, la Dette Émotionnelle est le contrepoint de la productivité — elle ne suit pas ce qui est produit, mais ce qui est ressenti. Chaque geste, chaque hésitation, chaque confession ou retrait modifie le registre émotionnel. Ses mouvements traduisent la circulation de l'affect à travers un système vivant et poreux, où la valeur n'est ni extraite ni fabriquée, mais engendrée par l'expérience même de la vie. Les Profits Vitaux, flux qui résistent à l'accumulation, façonnent pourtant tout ce qui s'y construit.
          <br><br>
          L'Indice de Dette Émotionnelle rend visible la vulnérabilité intime, cartographiant les économies invisibles de confiance, d'épuisement, de générosité, d'échec, de dépendance… qui participent à une instabilité ou un équilibre collectifs. Rejeter la fantaisie du capital ; embrasser la liquidité du sentiment humain.
        `,
      },
      redeem: {
        "explanations": "Explications",
        "redeemAsks": "Demandes de rachat",
        "redeemableHoldings": "Avoirs rachetables :",
        "sendRedeemAsks": "Envoyer les demandes de rachat",
        "returnToMarket": "Retour au marché",
        "tutsTitle": "Comment fonctionne le rachat",
      
        "Item_Name": "Nom du bien",
        "Owner": "Propriétaire",
        "Capital": "Capital",
      
        "no_selected_items_to_check": "Aucun objet sélectionné à vérifier.",
        "select_target_items": "Sélectionnez les objets à cibler.",
        "select_item_to_redeem": "Sélectionnez un objet pour la conversion.",
      
        "time_remaining": "Temps restant",
        "second": "seconde",
        "seconds": "secondes",
      
        "Redemption_offer_accepted": "Offre de conversion acceptée pour le bien :",
        "Redemption_offer_declined": "Offre de conversion rejetée pour le bien :",
        "Waiting_for_response": "En attente de réponse...",
        "DO_NOT_LEAVE": "NE PAS QUITTER LA PAGE",
      
        "video_not_supported": "La lecture vidéo n’est pas prise en charge par ce navigateur."
      },
      "common": {
        "close": "Fermer",
        "assign": "Assigner",
        "unassign": "Désassigner",
        "delete": "Supprimer",
        "redeem": "Échanger",
        "unredeem": "Annuler l'échange",
        "yes": "Oui",
        "no": "Non",
        "assigned_to": "assigné à",
        "to_market": "au marché",
        "to_portfolio": "au portefeuille",
        "successfully": "avec succès",
        "login_required": "Vous devez être connecté pour effectuer cette action.",
        "bond_with_interest_rate": "obligation avec taux d'intérêt",
        "assign_to_portfolio": "Assigner au Portefeuille",
        "assign_to_market": "Assigner au Marché",
        "item_name": "Nom de l'objet :",
        "owner": "Propriétaire :",
        "trader_name": "Nom du Trader :",
        "password": "Mot de passe :",
        "connected": "Connecté :",
        "portfolio_id": "ID du Portefeuille :",
        "points_breakdown": "Répartition des capitaux :",
        "trading": "Trading",
        "commodities": "Marchandises",
        "stocks": "Actions", 
        "shorts": "Positions courtes",
        "total": "Total :",
        "holdings": "Avoirs :",
        "commodity": "Marchandise :",
        "stock": "Action :",
        "quantity": "Quantité",
        "shares": "Parts",
        "value": "Valeur",
        "no_holdings": "Aucun avoir dans ce portefeuille.",
        "unnamed_portfolio": "Portefeuille sans nom",
        "protected": "[protégé]",
        "qr_code": "Code QR :",
        "qr_code_for": "Code QR pour",
        "no_qr_available": "Aucun code QR disponible.",
        "custom_relationship_type": "Type de relation personnalisé",
        "remove": "Supprimer",
        "created_for_relationship": "Zollar créé pour la relation :",
        "value_place_relationship": "La valeur que vous placez sur une relation :",
        "na": "N/D"
          },
      "freeend": {
        "title": "Session de Trading Terminée",
        "trading_analysis": "ANALYSE DE TRADING",
        "social_standing": "Position Sociale",
        "return_home": "Retour à l'Accueil",
        "panels": {
          "stocks": "ACTIONS",
          "items": "OBJETS",
          "zollars": "ZOLLARS",
          "bonds": "OBLIGATIONS"
        },
        "judgements": {
          "performance": "Performance",
          "style": "Style",
          "social": "Social",
          "risk": "Risque",
          "mood": "Humeur"
        },
        "ratings": {
          "excellent": "Excellent",
          "good": "Bien",
          "fair": "Moyen",
          "poor": "Médiocre",
          "bad": "Mauvais",
          "neutral": "Neutre",
          "aggressive": "Agressif",
          "calm": "Calme",
          "balanced": "Équilibré",
          "active": "Actif",
          "quiet": "Discret",
          "moderate": "Modéré",
          "diverse": "Diversifié",
          "cautious": "Prudent",
          "focused": "Ciblé",
          "euphoric": "Euphorique",
          "optimistic": "Optimiste",
          "positive": "Positif",
          "anxious": "Anxieux",
          "distressed": "En détresse"
        },
        "sections": {
          "social_class_movement": "VOTRE ÉVOLUTION DE CLASSE SOCIALE",
          "mood_state": "ÉTAT D'HUMEUR",
          "trading_behavior": "COMPORTEMENTS DE TRADING",
          "commodities_supply": "APPROVISIONNEMENT EN COMMODITÉS"
        },
        "labels": {
          "commodities": "Commodités:",
          "no_commodities": "Aucune commodité détenue - concentration sur d'autres formes de valeur",
          "stocks": "Générateurs de Profits (Actions):",
          "bonds": "Obligations:",
          "zollar_holdings": "Avoirs en Zollars Relationnels:",
          "total": "Total:",
          "session_engagement": "Engagement de Session:",
          "social_connections": "Connexions Sociales:",
          "value_movement": "Mouvement de Valeur:"
        },
        "value_movement": {
          "significant_gain": "Gain Significatif",
          "strong_gain": "Gain Fort",
          "moderate_gain": "Gain Modéré",
          "slight_gain": "Gain Léger",
          "no_change": "Aucun Changement",
          "slight_loss": "Perte Légère",
          "moderate_loss": "Perte Modérée",
          "strong_loss": "Perte Forte",
          "significant_loss": "Perte Significative"
        },
        "activity_levels": {
          "contemplative": "Contemplatif",
          "measured": "Mesuré",
          "active": "Actif",
          "very_active": "Très Actif",
          "intensely_engaged": "Intensément Engagé"
        },
        "social_levels": {
          "solitary": "Solitaire",
          "selective": "Sélectif",
          "socially_active": "Socialement Actif",
          "highly_connected": "Très Connecté"
        },
        "emotional_states": {
          "balanced": "Équilibré",
          "triumphant": "Triomphant",
          "reflective": "Réfléchi",
          "socially_engaged": "Socialement Engagé",
          "energetically_active": "Énergiquement Actif"
        },
        "quantities": {
          "none": "Aucun",
          "a_few": "Quelques-uns",
          "some": "Certains",
          "several": "Plusieurs",
          "many": "Beaucoup",
          "quite_a_lot": "Pas Mal",
          "a_large_amount": "Une Grande Quantité",
          "a_huge_amount": "Une Énorme Quantité"
        }
      }
    }
  }
}
};

export default translations;